(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6c3a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6c3a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bUIrX", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function func(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function Plugin() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function func1(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function ease(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function ease(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function setter(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("01lc4", function(module, exports) {
"use strict";

});

parcelRegister("5iYY9", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $dvYFb = parcelRequire("dvYFb");

var $elAXS = parcelRequire("elAXS");
"use strict";
function $3dcded641668f226$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3dcded641668f226$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3dcded641668f226$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3dcded641668f226$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $elAXS.cwd();
                path = cwd;
            }
            $3dcded641668f226$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3dcded641668f226$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3dcded641668f226$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3dcded641668f226$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3dcded641668f226$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3dcded641668f226$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3dcded641668f226$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3dcded641668f226$var$assertPath(from);
        $3dcded641668f226$var$assertPath(to);
        if (from === to) return "";
        from = $3dcded641668f226$var$posix.resolve(from);
        to = $3dcded641668f226$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3dcded641668f226$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3dcded641668f226$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3dcded641668f226$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + (typeof pathObject === "undefined" ? "undefined" : (0, $dvYFb._)(pathObject)));
        return $3dcded641668f226$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3dcded641668f226$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3dcded641668f226$var$posix.posix = $3dcded641668f226$var$posix;
module.exports = $3dcded641668f226$var$posix;

});
parcelRegister("dvYFb", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $9d6d3a12581f8329$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $9d6d3a12581f8329$export$5f0017c582d45a2d; });
function $9d6d3a12581f8329$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("elAXS", function(module, exports) {
// shim for using process in browser
var $a71fb34bf332a9c2$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $a71fb34bf332a9c2$var$cachedSetTimeout;
var $a71fb34bf332a9c2$var$cachedClearTimeout;
function $a71fb34bf332a9c2$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $a71fb34bf332a9c2$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $a71fb34bf332a9c2$var$cachedSetTimeout = setTimeout;
        else $a71fb34bf332a9c2$var$cachedSetTimeout = $a71fb34bf332a9c2$var$defaultSetTimout;
    } catch (e) {
        $a71fb34bf332a9c2$var$cachedSetTimeout = $a71fb34bf332a9c2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $a71fb34bf332a9c2$var$cachedClearTimeout = clearTimeout;
        else $a71fb34bf332a9c2$var$cachedClearTimeout = $a71fb34bf332a9c2$var$defaultClearTimeout;
    } catch (e) {
        $a71fb34bf332a9c2$var$cachedClearTimeout = $a71fb34bf332a9c2$var$defaultClearTimeout;
    }
})();
function $a71fb34bf332a9c2$var$runTimeout(fun) {
    if ($a71fb34bf332a9c2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($a71fb34bf332a9c2$var$cachedSetTimeout === $a71fb34bf332a9c2$var$defaultSetTimout || !$a71fb34bf332a9c2$var$cachedSetTimeout) && setTimeout) {
        $a71fb34bf332a9c2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a71fb34bf332a9c2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $a71fb34bf332a9c2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $a71fb34bf332a9c2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $a71fb34bf332a9c2$var$runClearTimeout(marker) {
    if ($a71fb34bf332a9c2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($a71fb34bf332a9c2$var$cachedClearTimeout === $a71fb34bf332a9c2$var$defaultClearTimeout || !$a71fb34bf332a9c2$var$cachedClearTimeout) && clearTimeout) {
        $a71fb34bf332a9c2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a71fb34bf332a9c2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $a71fb34bf332a9c2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $a71fb34bf332a9c2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $a71fb34bf332a9c2$var$queue = [];
var $a71fb34bf332a9c2$var$draining = false;
var $a71fb34bf332a9c2$var$currentQueue;
var $a71fb34bf332a9c2$var$queueIndex = -1;
function $a71fb34bf332a9c2$var$cleanUpNextTick() {
    if (!$a71fb34bf332a9c2$var$draining || !$a71fb34bf332a9c2$var$currentQueue) return;
    $a71fb34bf332a9c2$var$draining = false;
    if ($a71fb34bf332a9c2$var$currentQueue.length) $a71fb34bf332a9c2$var$queue = $a71fb34bf332a9c2$var$currentQueue.concat($a71fb34bf332a9c2$var$queue);
    else $a71fb34bf332a9c2$var$queueIndex = -1;
    if ($a71fb34bf332a9c2$var$queue.length) $a71fb34bf332a9c2$var$drainQueue();
}
function $a71fb34bf332a9c2$var$drainQueue() {
    if ($a71fb34bf332a9c2$var$draining) return;
    var timeout = $a71fb34bf332a9c2$var$runTimeout($a71fb34bf332a9c2$var$cleanUpNextTick);
    $a71fb34bf332a9c2$var$draining = true;
    var len = $a71fb34bf332a9c2$var$queue.length;
    while(len){
        $a71fb34bf332a9c2$var$currentQueue = $a71fb34bf332a9c2$var$queue;
        $a71fb34bf332a9c2$var$queue = [];
        while(++$a71fb34bf332a9c2$var$queueIndex < len)if ($a71fb34bf332a9c2$var$currentQueue) $a71fb34bf332a9c2$var$currentQueue[$a71fb34bf332a9c2$var$queueIndex].run();
        $a71fb34bf332a9c2$var$queueIndex = -1;
        len = $a71fb34bf332a9c2$var$queue.length;
    }
    $a71fb34bf332a9c2$var$currentQueue = null;
    $a71fb34bf332a9c2$var$draining = false;
    $a71fb34bf332a9c2$var$runClearTimeout(timeout);
}
$a71fb34bf332a9c2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $a71fb34bf332a9c2$var$queue.push(new $a71fb34bf332a9c2$var$Item(fun, args));
    if ($a71fb34bf332a9c2$var$queue.length === 1 && !$a71fb34bf332a9c2$var$draining) $a71fb34bf332a9c2$var$runTimeout($a71fb34bf332a9c2$var$drainQueue);
};
// v8 likes predictible objects
function $a71fb34bf332a9c2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$a71fb34bf332a9c2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$a71fb34bf332a9c2$var$process.title = "browser";
$a71fb34bf332a9c2$var$process.browser = true;
$a71fb34bf332a9c2$var$process.env = {};
$a71fb34bf332a9c2$var$process.argv = [];
$a71fb34bf332a9c2$var$process.version = ""; // empty string to avoid regexp issues
$a71fb34bf332a9c2$var$process.versions = {};
function $a71fb34bf332a9c2$var$noop() {}
$a71fb34bf332a9c2$var$process.on = $a71fb34bf332a9c2$var$noop;
$a71fb34bf332a9c2$var$process.addListener = $a71fb34bf332a9c2$var$noop;
$a71fb34bf332a9c2$var$process.once = $a71fb34bf332a9c2$var$noop;
$a71fb34bf332a9c2$var$process.off = $a71fb34bf332a9c2$var$noop;
$a71fb34bf332a9c2$var$process.removeListener = $a71fb34bf332a9c2$var$noop;
$a71fb34bf332a9c2$var$process.removeAllListeners = $a71fb34bf332a9c2$var$noop;
$a71fb34bf332a9c2$var$process.emit = $a71fb34bf332a9c2$var$noop;
$a71fb34bf332a9c2$var$process.prependListener = $a71fb34bf332a9c2$var$noop;
$a71fb34bf332a9c2$var$process.prependOnceListener = $a71fb34bf332a9c2$var$noop;
$a71fb34bf332a9c2$var$process.listeners = function(name) {
    return [];
};
$a71fb34bf332a9c2$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$a71fb34bf332a9c2$var$process.cwd = function() {
    return "/";
};
$a71fb34bf332a9c2$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$a71fb34bf332a9c2$var$process.umask = function() {
    return 0;
};

});


parcelRegister("5VYNn", function(module, exports) {
/********************************************************************************
 vCards-js, Eric J Nesser, November 2014,
 ********************************************************************************/ /*jslint node: true */ "use strict";
/**
 * vCard formatter for formatting vCards in VCF format
 */ (function vCardFormatter() {
    var majorVersion = "3";
    /**
	 * Encode string
	 * @param  {String}     value to encode
	 * @return {String}     encoded string
	 */ function e(value) {
        if (value) {
            if (typeof value !== "string") value = "" + value;
            return value.replace(/\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;");
        }
        return "";
    }
    /**
	 * Return new line characters
	 * @return {String} new line characters
	 */ function nl() {
        return "\r\n";
    }
    /**
	 * Get formatted photo
	 * @param  {String} photoType       Photo type (PHOTO, LOGO)
	 * @param  {String} url             URL to attach photo from
	 * @param  {String} mediaType       Media-type of photo (JPEG, PNG, GIF)
	 * @return {String}                 Formatted photo
	 */ function getFormattedPhoto(photoType, url, mediaType, base64) {
        var params;
        if (majorVersion >= 4) params = base64 ? ";ENCODING=b;MEDIATYPE=image/" : ";MEDIATYPE=image/";
        else if (majorVersion === 3) params = base64 ? ";ENCODING=b;TYPE=" : ";TYPE=";
        else params = base64 ? ";ENCODING=BASE64;" : ";";
        var formattedPhoto = photoType + params + mediaType + ":" + e(url) + nl();
        return formattedPhoto;
    }
    /**
	 * Get formatted address
	 * @param  {object}         address
	 * @param  {object}         encoding prefix
	 * @return {String}         Formatted address
	 */ function getFormattedAddress(encodingPrefix, address) {
        var formattedAddress = "";
        if (address.details.label || address.details.street || address.details.city || address.details.stateProvince || address.details.postalCode || address.details.countryRegion) {
            if (majorVersion >= 4) formattedAddress = "ADR" + encodingPrefix + ";TYPE=" + address.type + (address.details.label ? ';LABEL="' + e(address.details.label) + '"' : "") + ":;;" + e(address.details.street) + ";" + e(address.details.city) + ";" + e(address.details.stateProvince) + ";" + e(address.details.postalCode) + ";" + e(address.details.countryRegion) + nl();
            else {
                if (address.details.label) formattedAddress = "LABEL" + encodingPrefix + ";TYPE=" + address.type + ":" + e(address.details.label) + nl();
                formattedAddress += "ADR" + encodingPrefix + ";TYPE=" + address.type + ":;;" + e(address.details.street) + ";" + e(address.details.city) + ";" + e(address.details.stateProvince) + ";" + e(address.details.postalCode) + ";" + e(address.details.countryRegion) + nl();
            }
        }
        return formattedAddress;
    }
    /**
	 * Convert date to YYYYMMDD format
	 * @param  {Date}       date to encode
	 * @return {String}     encoded date
	 */ function YYYYMMDD(date) {
        return date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2);
    }
    module.exports = {
        /**
		 * Get formatted vCard in VCF format
		 * @param  {object}     vCard object
		 * @return {String}     Formatted vCard in VCF format
		 */ getFormattedString: function getFormattedString(vCard) {
            majorVersion = vCard.getMajorVersion();
            var formattedVCardString = "";
            formattedVCardString += "BEGIN:VCARD" + nl();
            formattedVCardString += "VERSION:" + vCard.version + nl();
            var encodingPrefix = majorVersion >= 4 ? "" : ";CHARSET=UTF-8";
            var formattedName = vCard.formattedName;
            if (!formattedName) {
                formattedName = "";
                [
                    vCard.firstName,
                    vCard.middleName,
                    vCard.lastName
                ].forEach(function(name) {
                    if (name) {
                        if (formattedName) formattedName += " ";
                    }
                    formattedName += name;
                });
            }
            formattedVCardString += "FN" + encodingPrefix + ":" + e(formattedName) + nl();
            formattedVCardString += "N" + encodingPrefix + ":" + e(vCard.lastName) + ";" + e(vCard.firstName) + ";" + e(vCard.middleName) + ";" + e(vCard.namePrefix) + ";" + e(vCard.nameSuffix) + nl();
            if (vCard.nickname && majorVersion >= 3) formattedVCardString += "NICKNAME" + encodingPrefix + ":" + e(vCard.nickname) + nl();
            if (vCard.gender) formattedVCardString += "GENDER:" + e(vCard.gender) + nl();
            if (vCard.uid) formattedVCardString += "UID" + encodingPrefix + ":" + e(vCard.uid) + nl();
            if (vCard.birthday) formattedVCardString += "BDAY:" + YYYYMMDD(vCard.birthday) + nl();
            if (vCard.anniversary) formattedVCardString += "ANNIVERSARY:" + YYYYMMDD(vCard.anniversary) + nl();
            if (vCard.email) {
                if (!Array.isArray(vCard.email)) vCard.email = [
                    vCard.email
                ];
                vCard.email.forEach(function(address) {
                    if (majorVersion >= 4) formattedVCardString += "EMAIL" + encodingPrefix + ";type=HOME:" + e(address) + nl();
                    else if (majorVersion >= 3 && majorVersion < 4) formattedVCardString += "EMAIL" + encodingPrefix + ";type=HOME,INTERNET:" + e(address) + nl();
                    else formattedVCardString += "EMAIL" + encodingPrefix + ";HOME;INTERNET:" + e(address) + nl();
                });
            }
            if (vCard.workEmail) {
                if (!Array.isArray(vCard.workEmail)) vCard.workEmail = [
                    vCard.workEmail
                ];
                vCard.workEmail.forEach(function(address) {
                    if (majorVersion >= 4) formattedVCardString += "EMAIL" + encodingPrefix + ";type=WORK:" + e(address) + nl();
                    else if (majorVersion >= 3 && majorVersion < 4) formattedVCardString += "EMAIL" + encodingPrefix + ";type=WORK,INTERNET:" + e(address) + nl();
                    else formattedVCardString += "EMAIL" + encodingPrefix + ";WORK;INTERNET:" + e(address) + nl();
                });
            }
            if (vCard.otherEmail) {
                if (!Array.isArray(vCard.otherEmail)) vCard.otherEmail = [
                    vCard.otherEmail
                ];
                vCard.otherEmail.forEach(function(address) {
                    if (majorVersion >= 4) formattedVCardString += "EMAIL" + encodingPrefix + ";type=OTHER:" + e(address) + nl();
                    else if (majorVersion >= 3 && majorVersion < 4) formattedVCardString += "EMAIL" + encodingPrefix + ";type=OTHER,INTERNET:" + e(address) + nl();
                    else formattedVCardString += "EMAIL" + encodingPrefix + ";OTHER;INTERNET:" + e(address) + nl();
                });
            }
            if (vCard.logo.url) formattedVCardString += getFormattedPhoto("LOGO", vCard.logo.url, vCard.logo.mediaType, vCard.logo.base64);
            if (vCard.photo.url) formattedVCardString += getFormattedPhoto("PHOTO", vCard.photo.url, vCard.photo.mediaType, vCard.photo.base64);
            if (vCard.cellPhone) {
                if (!Array.isArray(vCard.cellPhone)) vCard.cellPhone = [
                    vCard.cellPhone
                ];
                vCard.cellPhone.forEach(function(number) {
                    if (majorVersion >= 4) formattedVCardString += 'TEL;VALUE=uri;TYPE="voice,cell":tel:' + e(number) + nl();
                    else formattedVCardString += "TEL;TYPE=CELL:" + e(number) + nl();
                });
            }
            if (vCard.pagerPhone) {
                if (!Array.isArray(vCard.pagerPhone)) vCard.pagerPhone = [
                    vCard.pagerPhone
                ];
                vCard.pagerPhone.forEach(function(number) {
                    if (majorVersion >= 4) formattedVCardString += 'TEL;VALUE=uri;TYPE="pager,cell":tel:' + e(number) + nl();
                    else formattedVCardString += "TEL;TYPE=PAGER:" + e(number) + nl();
                });
            }
            if (vCard.homePhone) {
                if (!Array.isArray(vCard.homePhone)) vCard.homePhone = [
                    vCard.homePhone
                ];
                vCard.homePhone.forEach(function(number) {
                    if (majorVersion >= 4) formattedVCardString += 'TEL;VALUE=uri;TYPE="voice,home":tel:' + e(number) + nl();
                    else formattedVCardString += "TEL;TYPE=HOME,VOICE:" + e(number) + nl();
                });
            }
            if (vCard.workPhone) {
                if (!Array.isArray(vCard.workPhone)) vCard.workPhone = [
                    vCard.workPhone
                ];
                vCard.workPhone.forEach(function(number) {
                    if (majorVersion >= 4) formattedVCardString += 'TEL;VALUE=uri;TYPE="voice,work":tel:' + e(number) + nl();
                    else formattedVCardString += "TEL;TYPE=WORK,VOICE:" + e(number) + nl();
                });
            }
            if (vCard.homeFax) {
                if (!Array.isArray(vCard.homeFax)) vCard.homeFax = [
                    vCard.homeFax
                ];
                vCard.homeFax.forEach(function(number) {
                    if (majorVersion >= 4) formattedVCardString += 'TEL;VALUE=uri;TYPE="fax,home":tel:' + e(number) + nl();
                    else formattedVCardString += "TEL;TYPE=HOME,FAX:" + e(number) + nl();
                });
            }
            if (vCard.workFax) {
                if (!Array.isArray(vCard.workFax)) vCard.workFax = [
                    vCard.workFax
                ];
                vCard.workFax.forEach(function(number) {
                    if (majorVersion >= 4) formattedVCardString += 'TEL;VALUE=uri;TYPE="fax,work":tel:' + e(number) + nl();
                    else formattedVCardString += "TEL;TYPE=WORK,FAX:" + e(number) + nl();
                });
            }
            if (vCard.otherPhone) {
                if (!Array.isArray(vCard.otherPhone)) vCard.otherPhone = [
                    vCard.otherPhone
                ];
                vCard.otherPhone.forEach(function(number) {
                    if (majorVersion >= 4) formattedVCardString += 'TEL;VALUE=uri;TYPE="voice,other":tel:' + e(number) + nl();
                    else formattedVCardString += "TEL;TYPE=OTHER:" + e(number) + nl();
                });
            }
            [
                {
                    details: vCard.homeAddress,
                    type: "HOME"
                },
                {
                    details: vCard.workAddress,
                    type: "WORK"
                }
            ].forEach(function(address) {
                formattedVCardString += getFormattedAddress(encodingPrefix, address);
            });
            if (vCard.title) formattedVCardString += "TITLE" + encodingPrefix + ":" + e(vCard.title) + nl();
            if (vCard.role) formattedVCardString += "ROLE" + encodingPrefix + ":" + e(vCard.role) + nl();
            if (vCard.organization) formattedVCardString += "ORG" + encodingPrefix + ":" + e(vCard.organization) + nl();
            if (vCard.url) formattedVCardString += "URL" + encodingPrefix + ":" + e(vCard.url) + nl();
            if (vCard.workUrl) formattedVCardString += "URL;type=WORK" + encodingPrefix + ":" + e(vCard.workUrl) + nl();
            if (vCard.note) formattedVCardString += "NOTE" + encodingPrefix + ":" + e(vCard.note) + nl();
            if (vCard.socialUrls) {
                for(var key in vCard.socialUrls)if (vCard.socialUrls.hasOwnProperty(key) && vCard.socialUrls[key]) formattedVCardString += "X-SOCIALPROFILE" + encodingPrefix + ";TYPE=" + key + ":" + e(vCard.socialUrls[key]) + nl();
            }
            if (vCard.source) formattedVCardString += "SOURCE" + encodingPrefix + ":" + e(vCard.source) + nl();
            formattedVCardString += "REV:" + new Date().toISOString() + nl();
            if (vCard.isOrganization) formattedVCardString += "X-ABShowAs:COMPANY" + nl();
            formattedVCardString += "END:VCARD" + nl();
            return formattedVCardString;
        }
    };
})();

});

/** Imports */ /** Green Sock - Import */ 
var $bUIrX = parcelRequire("bUIrX");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $dvYFb = parcelRequire("dvYFb");

var $bUIrX = parcelRequire("bUIrX");
var $232d81b02af77115$var$_win, $232d81b02af77115$var$_doc, $232d81b02af77115$var$_docElement, $232d81b02af77115$var$_pluginInitted, $232d81b02af77115$var$_tempDiv, $232d81b02af77115$var$_tempDivStyler, $232d81b02af77115$var$_recentSetterPlugin, $232d81b02af77115$var$_reverting, $232d81b02af77115$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $232d81b02af77115$var$_transformProps = {}, $232d81b02af77115$var$_RAD2DEG = 180 / Math.PI, $232d81b02af77115$var$_DEG2RAD = Math.PI / 180, $232d81b02af77115$var$_atan2 = Math.atan2, $232d81b02af77115$var$_bigNum = 1e8, $232d81b02af77115$var$_capsExp = /([A-Z])/g, $232d81b02af77115$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $232d81b02af77115$var$_complexExp = /[\s,\(]\S/, $232d81b02af77115$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $232d81b02af77115$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $232d81b02af77115$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $232d81b02af77115$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$232d81b02af77115$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $232d81b02af77115$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $232d81b02af77115$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $232d81b02af77115$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $232d81b02af77115$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $232d81b02af77115$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $232d81b02af77115$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $232d81b02af77115$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $232d81b02af77115$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $232d81b02af77115$var$_transformProp = "transform", $232d81b02af77115$var$_transformOriginProp = $232d81b02af77115$var$_transformProp + "Origin", $232d81b02af77115$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $232d81b02af77115$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $232d81b02af77115$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $232d81b02af77115$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $232d81b02af77115$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $232d81b02af77115$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $232d81b02af77115$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($232d81b02af77115$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($232d81b02af77115$var$_transformOriginProp, isNotCSS, "");
        }
        property = $232d81b02af77115$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $232d81b02af77115$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $232d81b02af77115$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($232d81b02af77115$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $232d81b02af77115$var$_reverting();
        if ((!i || !i.isStart) && !style[$232d81b02af77115$var$_transformProp]) {
            $232d81b02af77115$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$232d81b02af77115$var$_transformOriginProp]) {
                style[$232d81b02af77115$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $232d81b02af77115$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $232d81b02af77115$var$_revertStyle,
        save: $232d81b02af77115$var$_saveStyle
    };
    target._gsap || (0, $bUIrX.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $232d81b02af77115$var$_supports3D, $232d81b02af77115$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $232d81b02af77115$var$_doc.createElementNS ? $232d81b02af77115$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $232d81b02af77115$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $232d81b02af77115$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $232d81b02af77115$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($232d81b02af77115$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $232d81b02af77115$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $232d81b02af77115$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $232d81b02af77115$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $232d81b02af77115$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($232d81b02af77115$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $232d81b02af77115$var$_prefixes[i] : "") + property;
}, $232d81b02af77115$var$_initCore = function _initCore() {
    if ($232d81b02af77115$var$_windowExists() && window.document) {
        $232d81b02af77115$var$_win = window;
        $232d81b02af77115$var$_doc = $232d81b02af77115$var$_win.document;
        $232d81b02af77115$var$_docElement = $232d81b02af77115$var$_doc.documentElement;
        $232d81b02af77115$var$_tempDiv = $232d81b02af77115$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $232d81b02af77115$var$_tempDivStyler = $232d81b02af77115$export$a232bb0480ae674a("div");
        $232d81b02af77115$var$_transformProp = $232d81b02af77115$export$8cbef5dd49a09c8b($232d81b02af77115$var$_transformProp);
        $232d81b02af77115$var$_transformOriginProp = $232d81b02af77115$var$_transformProp + "Origin";
        $232d81b02af77115$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $232d81b02af77115$var$_supports3D = !!$232d81b02af77115$export$8cbef5dd49a09c8b("perspective");
        $232d81b02af77115$var$_reverting = (0, $bUIrX.gsap).core.reverting;
        $232d81b02af77115$var$_pluginInitted = 1;
    }
}, $232d81b02af77115$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $232d81b02af77115$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $232d81b02af77115$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $232d81b02af77115$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $232d81b02af77115$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $232d81b02af77115$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $232d81b02af77115$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $232d81b02af77115$var$_getBBoxHack || (bounds = $232d81b02af77115$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$232d81b02af77115$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$232d81b02af77115$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $232d81b02af77115$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $232d81b02af77115$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$232d81b02af77115$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $232d81b02af77115$var$_transformProps && property !== $232d81b02af77115$var$_transformOriginProp) property = $232d81b02af77115$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($232d81b02af77115$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $232d81b02af77115$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $bUIrX.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $232d81b02af77115$var$_renderNonTweeningValueOnlyAtEnd : $232d81b02af77115$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $232d81b02af77115$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $232d81b02af77115$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$232d81b02af77115$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $232d81b02af77115$var$_tempDiv.style, horizontal = $232d81b02af77115$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $232d81b02af77115$var$_nonConvertibleUnits[unit] || $232d81b02af77115$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $232d81b02af77115$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($232d81b02af77115$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $bUIrX._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $232d81b02af77115$var$_doc || !parent.appendChild) parent = $232d81b02af77115$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $bUIrX._ticker).time && !cache.uncache) return (0, $bUIrX._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $232d81b02af77115$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$232d81b02af77115$var$_nonStandardLayouts[$232d81b02af77115$var$_getComputedProperty(parent, "display")] && (style.position = $232d81b02af77115$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($232d81b02af77115$var$_tempDiv);
            px = $232d81b02af77115$var$_tempDiv[measureProperty];
            parent.removeChild($232d81b02af77115$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $bUIrX._getCache)(parent);
            cache.time = (0, $bUIrX._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $bUIrX._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $232d81b02af77115$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $232d81b02af77115$var$_pluginInitted || $232d81b02af77115$var$_initCore();
    if (property in $232d81b02af77115$var$_propertyAliases && property !== "transform") {
        property = $232d81b02af77115$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($232d81b02af77115$var$_transformProps[property] && property !== "transform") {
        value = $232d81b02af77115$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $232d81b02af77115$var$_firstTwoOnly($232d81b02af77115$var$_getComputedProperty(target, $232d81b02af77115$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $232d81b02af77115$var$_specialProps[property] && $232d81b02af77115$var$_specialProps[property](target, property, unit) || $232d81b02af77115$var$_getComputedProperty(target, property) || (0, $bUIrX._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $232d81b02af77115$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $232d81b02af77115$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $232d81b02af77115$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $232d81b02af77115$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $232d81b02af77115$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $bUIrX.PropTween)(this._pt, target.style, prop, 0, 1, (0, $bUIrX._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $232d81b02af77115$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $232d81b02af77115$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $bUIrX._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $bUIrX._numWithUnitExp)) || [];
    endValues = end.match((0, $bUIrX._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $bUIrX._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $bUIrX._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $bUIrX._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $bUIrX._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $232d81b02af77115$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $232d81b02af77115$var$_renderNonTweeningValueOnlyAtEnd : $232d81b02af77115$var$_renderNonTweeningValue;
    (0, $bUIrX._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $232d81b02af77115$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $232d81b02af77115$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $232d81b02af77115$var$_keywordToPercent[x] || x;
    split[1] = $232d81b02af77115$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $232d81b02af77115$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($232d81b02af77115$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $232d81b02af77115$var$_transformOriginProp : $232d81b02af77115$var$_transformProp;
                }
                $232d81b02af77115$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $232d81b02af77115$var$_removeProperty(target, $232d81b02af77115$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $232d81b02af77115$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $232d81b02af77115$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$232d81b02af77115$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $bUIrX.PropTween)(plugin._pt, target, property, 0, 0, $232d81b02af77115$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $232d81b02af77115$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $232d81b02af77115$var$_rotationalProperties = {}, $232d81b02af77115$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $232d81b02af77115$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $232d81b02af77115$var$_getComputedProperty(target, $232d81b02af77115$var$_transformProp);
    return $232d81b02af77115$var$_isNullTransform(matrixString) ? $232d81b02af77115$var$_identity2DMatrix : matrixString.substr(7).match((0, $bUIrX._numExp)).map((0, $bUIrX._round));
}, $232d81b02af77115$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $bUIrX._getCache)(target), style = target.style, matrix = $232d81b02af77115$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $232d81b02af77115$var$_identity2DMatrix : matrix;
    } else if (matrix === $232d81b02af77115$var$_identity2DMatrix && !target.offsetParent && target !== $232d81b02af77115$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $232d81b02af77115$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $232d81b02af77115$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $232d81b02af77115$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $232d81b02af77115$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $232d81b02af77115$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $232d81b02af77115$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $232d81b02af77115$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $232d81b02af77115$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$232d81b02af77115$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $232d81b02af77115$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $232d81b02af77115$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $232d81b02af77115$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $232d81b02af77115$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $232d81b02af77115$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $bUIrX.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $232d81b02af77115$var$_getComputedProperty(target, $232d81b02af77115$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $232d81b02af77115$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$232d81b02af77115$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$232d81b02af77115$var$_transformProp] !== "none" ? cs[$232d81b02af77115$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $232d81b02af77115$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $232d81b02af77115$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $232d81b02af77115$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $232d81b02af77115$var$_atan2(b, a) * $232d81b02af77115$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $232d81b02af77115$var$_atan2(c, d) * $232d81b02af77115$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $232d81b02af77115$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $232d81b02af77115$var$_atan2(a32, a33);
            rotationX = angle * $232d81b02af77115$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $232d81b02af77115$var$_atan2(-c, a33);
            rotationY = angle * $232d81b02af77115$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $232d81b02af77115$var$_atan2(b, a);
            rotation = angle * $232d81b02af77115$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $bUIrX._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $bUIrX._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $232d81b02af77115$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $232d81b02af77115$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$232d81b02af77115$var$_isNullTransform($232d81b02af77115$var$_getComputedProperty(target, $232d81b02af77115$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $bUIrX._round)(scaleX);
    cache.scaleY = (0, $bUIrX._round)(scaleY);
    cache.rotation = (0, $bUIrX._round)(rotation) + deg;
    cache.rotationX = (0, $bUIrX._round)(rotationX) + deg;
    cache.rotationY = (0, $bUIrX._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$232d81b02af77115$var$_transformOriginProp] = $232d81b02af77115$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $bUIrX._config).force3D;
    cache.renderTransform = cache.svg ? $232d81b02af77115$var$_renderSVGTransforms : $232d81b02af77115$var$_supports3D ? $232d81b02af77115$var$_renderCSSTransforms : $232d81b02af77115$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $232d81b02af77115$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$232d81b02af77115$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $bUIrX.getUnit)(start);
    return (0, $bUIrX._round)(parseFloat(start) + parseFloat($232d81b02af77115$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $232d81b02af77115$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $232d81b02af77115$var$_renderCSSTransforms(ratio, cache);
}, $232d81b02af77115$var$_zeroDeg = "0deg", $232d81b02af77115$var$_zeroPx = "0px", $232d81b02af77115$var$_endParenthesis = ") ", $232d81b02af77115$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $232d81b02af77115$var$_zeroDeg || rotationY !== $232d81b02af77115$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $232d81b02af77115$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $232d81b02af77115$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $232d81b02af77115$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $232d81b02af77115$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $232d81b02af77115$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $232d81b02af77115$var$_zeroPx) transforms += "perspective(" + transformPerspective + $232d81b02af77115$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $232d81b02af77115$var$_zeroPx || y !== $232d81b02af77115$var$_zeroPx || z !== $232d81b02af77115$var$_zeroPx) transforms += z !== $232d81b02af77115$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $232d81b02af77115$var$_endParenthesis;
    if (rotation !== $232d81b02af77115$var$_zeroDeg) transforms += "rotate(" + rotation + $232d81b02af77115$var$_endParenthesis;
    if (rotationY !== $232d81b02af77115$var$_zeroDeg) transforms += "rotateY(" + rotationY + $232d81b02af77115$var$_endParenthesis;
    if (rotationX !== $232d81b02af77115$var$_zeroDeg) transforms += "rotateX(" + rotationX + $232d81b02af77115$var$_endParenthesis;
    if (skewX !== $232d81b02af77115$var$_zeroDeg || skewY !== $232d81b02af77115$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $232d81b02af77115$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $232d81b02af77115$var$_endParenthesis;
    target.style[$232d81b02af77115$var$_transformProp] = transforms || "translate(0, 0)";
}, $232d81b02af77115$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $232d81b02af77115$var$_DEG2RAD;
        skewX *= $232d81b02af77115$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $232d81b02af77115$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $bUIrX._round)(a11);
        a21 = (0, $bUIrX._round)(a21);
        a12 = (0, $bUIrX._round)(a12);
        a22 = (0, $bUIrX._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $232d81b02af77115$var$_convertToUnit(target, "x", x, "px");
        ty = $232d81b02af77115$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $bUIrX._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $bUIrX._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $bUIrX._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $bUIrX._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$232d81b02af77115$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $232d81b02af77115$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $bUIrX._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $232d81b02af77115$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $232d81b02af77115$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $232d81b02af77115$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $bUIrX.PropTween)(plugin._pt, target, property, startNum, change, $232d81b02af77115$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $232d81b02af77115$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $232d81b02af77115$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $232d81b02af77115$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$232d81b02af77115$var$_transformProp] = transforms;
        endCache = $232d81b02af77115$var$_parseTransform(target, 1);
        $232d81b02af77115$var$_removeProperty(target, $232d81b02af77115$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$232d81b02af77115$var$_transformProp];
        style[$232d81b02af77115$var$_transformProp] = transforms;
        endCache = $232d81b02af77115$var$_parseTransform(target, 1);
        style[$232d81b02af77115$var$_transformProp] = startValue;
    }
    for(p in $232d81b02af77115$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $bUIrX.getUnit)(startValue);
            endUnit = (0, $bUIrX.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $232d81b02af77115$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $bUIrX.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $232d81b02af77115$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $232d81b02af77115$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $bUIrX._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $232d81b02af77115$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $232d81b02af77115$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $232d81b02af77115$export$855822f522f18eef = {
    name: "css",
    register: $232d81b02af77115$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $232d81b02af77115$var$_pluginInitted || $232d81b02af77115$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $232d81b02af77115$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $bUIrX._plugins)[p] && (0, $bUIrX._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue === "undefined" ? "undefined" : (0, $dvYFb._)(endValue);
            specialProp = $232d81b02af77115$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue === "undefined" ? "undefined" : (0, $dvYFb._)(endValue);
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $bUIrX._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $bUIrX._colorExp).lastIndex = 0;
                if (!(0, $bUIrX._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $bUIrX.getUnit)(startValue);
                    endUnit = (0, $bUIrX.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $232d81b02af77115$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $bUIrX._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $bUIrX._replaceRandom)(startValue));
                    (0, $bUIrX.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $bUIrX._config).units[p] || (0, $bUIrX.getUnit)($232d81b02af77115$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $232d81b02af77115$var$_get(target, p)); // can't work with relative values
                } else startValue = $232d81b02af77115$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $232d81b02af77115$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $232d81b02af77115$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $232d81b02af77115$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $232d81b02af77115$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $232d81b02af77115$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $232d81b02af77115$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $bUIrX.PropTween)(this._pt, style, $232d81b02af77115$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $bUIrX.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $bUIrX._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $232d81b02af77115$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($232d81b02af77115$var$_transformOriginProp, 0, style[$232d81b02af77115$var$_transformOriginProp]);
                        endValue = $232d81b02af77115$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $232d81b02af77115$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $232d81b02af77115$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $232d81b02af77115$var$_addNonTweeningPT(this, style, p, $232d81b02af77115$var$_firstTwoOnly(startValue), $232d81b02af77115$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $232d81b02af77115$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $232d81b02af77115$var$_rotationalProperties) {
                        $232d81b02af77115$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $bUIrX._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $232d81b02af77115$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $232d81b02af77115$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $232d81b02af77115$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$232d81b02af77115$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $bUIrX.getUnit)(endValue) || (p in (0, $bUIrX._config).units ? (0, $bUIrX._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $232d81b02af77115$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $bUIrX.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $bUIrX._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $232d81b02af77115$var$_renderRoundedCSSProp : $232d81b02af77115$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $232d81b02af77115$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $bUIrX._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $232d81b02af77115$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $bUIrX._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$232d81b02af77115$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $232d81b02af77115$var$_get,
    aliases: $232d81b02af77115$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $232d81b02af77115$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $232d81b02af77115$var$_transformProps && property !== $232d81b02af77115$var$_transformOriginProp && (target._gsap.x || $232d81b02af77115$var$_get(target, "x")) ? plugin && $232d81b02af77115$var$_recentSetterPlugin === plugin ? property === "scale" ? $232d81b02af77115$var$_setterScale : $232d81b02af77115$var$_setterTransform : ($232d81b02af77115$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $232d81b02af77115$var$_setterScaleWithRender : $232d81b02af77115$var$_setterTransformWithRender) : target.style && !(0, $bUIrX._isUndefined)(target.style[property]) ? $232d81b02af77115$var$_setterCSSStyle : ~property.indexOf("-") ? $232d81b02af77115$var$_setterCSSProp : (0, $bUIrX._getSetter)(target, property);
    },
    core: {
        _removeProperty: $232d81b02af77115$var$_removeProperty,
        _getMatrix: $232d81b02af77115$var$_getMatrix
    }
};
(0, $bUIrX.gsap).utils.checkPrefix = $232d81b02af77115$export$8cbef5dd49a09c8b;
(0, $bUIrX.gsap).core.getStyleSaver = $232d81b02af77115$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $bUIrX._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $232d81b02af77115$var$_transformProps[name] = 1;
    });
    (0, $bUIrX._forEachName)(rotation, function(name) {
        (0, $bUIrX._config).units[name] = "deg";
        $232d81b02af77115$var$_rotationalProperties[name] = 1;
    });
    $232d81b02af77115$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $bUIrX._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $232d81b02af77115$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $bUIrX._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $bUIrX._config).units[name] = "px";
});
(0, $bUIrX.gsap).registerPlugin($232d81b02af77115$export$855822f522f18eef);


var $77002f56502ab80f$export$99ee26438460406a = (0, $bUIrX.gsap).registerPlugin((0, $232d81b02af77115$export$855822f522f18eef)) || (0, $bUIrX.gsap), // to protect from tree shaking
$77002f56502ab80f$export$7b23975ad686bf91 = $77002f56502ab80f$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $920f4bd866a3dda7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $920f4bd866a3dda7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $920f4bd866a3dda7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $920f4bd866a3dda7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $920f4bd866a3dda7$var$gsap, $920f4bd866a3dda7$var$_coreInitted, $920f4bd866a3dda7$var$_clamp, $920f4bd866a3dda7$var$_win, $920f4bd866a3dda7$var$_doc, $920f4bd866a3dda7$var$_docEl, $920f4bd866a3dda7$var$_body, $920f4bd866a3dda7$var$_isTouch, $920f4bd866a3dda7$var$_pointerType, $920f4bd866a3dda7$var$ScrollTrigger, $920f4bd866a3dda7$var$_root, $920f4bd866a3dda7$var$_normalizer, $920f4bd866a3dda7$var$_eventTypes, $920f4bd866a3dda7$var$_context, $920f4bd866a3dda7$var$_getGSAP = function _getGSAP() {
    return $920f4bd866a3dda7$var$gsap || typeof window !== "undefined" && ($920f4bd866a3dda7$var$gsap = window.gsap) && $920f4bd866a3dda7$var$gsap.registerPlugin && $920f4bd866a3dda7$var$gsap;
}, $920f4bd866a3dda7$var$_startup = 1, $920f4bd866a3dda7$var$_observers = [], $920f4bd866a3dda7$export$3cd1cee43d19b683 = [], $920f4bd866a3dda7$export$d8e56d510a804d0a = [], $920f4bd866a3dda7$var$_getTime = Date.now, $920f4bd866a3dda7$var$_bridge = function _bridge(name, value) {
    return value;
}, $920f4bd866a3dda7$var$_integrate = function _integrate() {
    var core = $920f4bd866a3dda7$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $920f4bd866a3dda7$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $920f4bd866a3dda7$export$d8e56d510a804d0a);
    $920f4bd866a3dda7$export$3cd1cee43d19b683 = scrollers;
    $920f4bd866a3dda7$export$d8e56d510a804d0a = proxies;
    $920f4bd866a3dda7$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $920f4bd866a3dda7$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$920f4bd866a3dda7$export$d8e56d510a804d0a.indexOf(element) && $920f4bd866a3dda7$export$d8e56d510a804d0a[$920f4bd866a3dda7$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $920f4bd866a3dda7$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$920f4bd866a3dda7$var$_root.indexOf(el);
}, $920f4bd866a3dda7$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $920f4bd866a3dda7$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $920f4bd866a3dda7$var$_scrollLeft = "scrollLeft", $920f4bd866a3dda7$var$_scrollTop = "scrollTop", $920f4bd866a3dda7$var$_onScroll = function _onScroll() {
    return $920f4bd866a3dda7$var$_normalizer && $920f4bd866a3dda7$var$_normalizer.isPressed || $920f4bd866a3dda7$export$3cd1cee43d19b683.cache++;
}, $920f4bd866a3dda7$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $920f4bd866a3dda7$var$_startup && ($920f4bd866a3dda7$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $920f4bd866a3dda7$var$_normalizer && $920f4bd866a3dda7$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($920f4bd866a3dda7$var$_normalizer && $920f4bd866a3dda7$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $920f4bd866a3dda7$export$3cd1cee43d19b683.cache;
            isNormalizing && $920f4bd866a3dda7$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $920f4bd866a3dda7$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $920f4bd866a3dda7$var$_bridge("ref")) {
            cachingFunc.cacheID = $920f4bd866a3dda7$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $920f4bd866a3dda7$export$b2cabb342cb0ebe1 = {
    s: $920f4bd866a3dda7$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $920f4bd866a3dda7$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $920f4bd866a3dda7$var$_win.scrollTo(value, $920f4bd866a3dda7$export$8e40fc98ff518e9d.sc()) : $920f4bd866a3dda7$var$_win.pageXOffset || $920f4bd866a3dda7$var$_doc[$920f4bd866a3dda7$var$_scrollLeft] || $920f4bd866a3dda7$var$_docEl[$920f4bd866a3dda7$var$_scrollLeft] || $920f4bd866a3dda7$var$_body[$920f4bd866a3dda7$var$_scrollLeft] || 0;
    })
}, $920f4bd866a3dda7$export$8e40fc98ff518e9d = {
    s: $920f4bd866a3dda7$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $920f4bd866a3dda7$export$b2cabb342cb0ebe1,
    sc: $920f4bd866a3dda7$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $920f4bd866a3dda7$var$_win.scrollTo($920f4bd866a3dda7$export$b2cabb342cb0ebe1.sc(), value) : $920f4bd866a3dda7$var$_win.pageYOffset || $920f4bd866a3dda7$var$_doc[$920f4bd866a3dda7$var$_scrollTop] || $920f4bd866a3dda7$var$_docEl[$920f4bd866a3dda7$var$_scrollTop] || $920f4bd866a3dda7$var$_body[$920f4bd866a3dda7$var$_scrollTop] || 0;
    })
}, $920f4bd866a3dda7$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $920f4bd866a3dda7$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $920f4bd866a3dda7$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $920f4bd866a3dda7$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $920f4bd866a3dda7$export$4330f3a92e5d2e94(element) && (element = $920f4bd866a3dda7$var$_doc.scrollingElement || $920f4bd866a3dda7$var$_docEl);
    var i = $920f4bd866a3dda7$export$3cd1cee43d19b683.indexOf(element), offset = sc === $920f4bd866a3dda7$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $920f4bd866a3dda7$export$3cd1cee43d19b683.push(element) - 1);
    $920f4bd866a3dda7$export$3cd1cee43d19b683[i + offset] || $920f4bd866a3dda7$var$_addListener(element, "scroll", $920f4bd866a3dda7$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $920f4bd866a3dda7$export$3cd1cee43d19b683[i + offset], func = prev || ($920f4bd866a3dda7$export$3cd1cee43d19b683[i + offset] = $920f4bd866a3dda7$var$_scrollCacheFunc($920f4bd866a3dda7$export$6078f1ef08b38af9(element, s), true) || ($920f4bd866a3dda7$export$4330f3a92e5d2e94(element) ? sc : $920f4bd866a3dda7$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $920f4bd866a3dda7$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $920f4bd866a3dda7$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $920f4bd866a3dda7$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $920f4bd866a3dda7$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $920f4bd866a3dda7$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $920f4bd866a3dda7$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $920f4bd866a3dda7$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $920f4bd866a3dda7$var$_setScrollTrigger = function _setScrollTrigger() {
    $920f4bd866a3dda7$var$ScrollTrigger = $920f4bd866a3dda7$var$gsap.core.globals().ScrollTrigger;
    $920f4bd866a3dda7$var$ScrollTrigger && $920f4bd866a3dda7$var$ScrollTrigger.core && $920f4bd866a3dda7$var$_integrate();
}, $920f4bd866a3dda7$var$_initCore = function _initCore(core) {
    $920f4bd866a3dda7$var$gsap = core || $920f4bd866a3dda7$var$_getGSAP();
    if (!$920f4bd866a3dda7$var$_coreInitted && $920f4bd866a3dda7$var$gsap && typeof document !== "undefined" && document.body) {
        $920f4bd866a3dda7$var$_win = window;
        $920f4bd866a3dda7$var$_doc = document;
        $920f4bd866a3dda7$var$_docEl = $920f4bd866a3dda7$var$_doc.documentElement;
        $920f4bd866a3dda7$var$_body = $920f4bd866a3dda7$var$_doc.body;
        $920f4bd866a3dda7$var$_root = [
            $920f4bd866a3dda7$var$_win,
            $920f4bd866a3dda7$var$_doc,
            $920f4bd866a3dda7$var$_docEl,
            $920f4bd866a3dda7$var$_body
        ];
        $920f4bd866a3dda7$var$_clamp = $920f4bd866a3dda7$var$gsap.utils.clamp;
        $920f4bd866a3dda7$var$_context = $920f4bd866a3dda7$var$gsap.core.context || function() {};
        $920f4bd866a3dda7$var$_pointerType = "onpointerenter" in $920f4bd866a3dda7$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $920f4bd866a3dda7$var$_isTouch = $920f4bd866a3dda7$export$c1cbdee04e18ea8b.isTouch = $920f4bd866a3dda7$var$_win.matchMedia && $920f4bd866a3dda7$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $920f4bd866a3dda7$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $920f4bd866a3dda7$var$_eventTypes = $920f4bd866a3dda7$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $920f4bd866a3dda7$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $920f4bd866a3dda7$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $920f4bd866a3dda7$var$_startup = 0;
        }, 500);
        $920f4bd866a3dda7$var$_setScrollTrigger();
        $920f4bd866a3dda7$var$_coreInitted = 1;
    }
    return $920f4bd866a3dda7$var$_coreInitted;
};
$920f4bd866a3dda7$export$b2cabb342cb0ebe1.op = $920f4bd866a3dda7$export$8e40fc98ff518e9d;
$920f4bd866a3dda7$export$3cd1cee43d19b683.cache = 0;
var $920f4bd866a3dda7$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $920f4bd866a3dda7$var$_coreInitted || $920f4bd866a3dda7$var$_initCore($920f4bd866a3dda7$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $920f4bd866a3dda7$var$ScrollTrigger || $920f4bd866a3dda7$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $920f4bd866a3dda7$export$937374fea3f88711(target) || $920f4bd866a3dda7$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $920f4bd866a3dda7$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($920f4bd866a3dda7$var$_win.getComputedStyle($920f4bd866a3dda7$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault, scrollFuncX = $920f4bd866a3dda7$export$8665aac53dad5647(target, $920f4bd866a3dda7$export$b2cabb342cb0ebe1), scrollFuncY = $920f4bd866a3dda7$export$8665aac53dad5647(target, $920f4bd866a3dda7$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $920f4bd866a3dda7$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $920f4bd866a3dda7$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $920f4bd866a3dda7$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $920f4bd866a3dda7$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $920f4bd866a3dda7$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $920f4bd866a3dda7$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $920f4bd866a3dda7$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function _onPress(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $920f4bd866a3dda7$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $920f4bd866a3dda7$var$_addListener(isNormalizer ? target : ownerDoc, $920f4bd866a3dda7$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function _onRelease(e) {
            if (_ignoreCheck(e, 1)) return;
            $920f4bd866a3dda7$var$_removeListener(isNormalizer ? target : ownerDoc, $920f4bd866a3dda7$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $920f4bd866a3dda7$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $920f4bd866a3dda7$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($920f4bd866a3dda7$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $920f4bd866a3dda7$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $920f4bd866a3dda7$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $920f4bd866a3dda7$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $920f4bd866a3dda7$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $920f4bd866a3dda7$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $920f4bd866a3dda7$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $920f4bd866a3dda7$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $920f4bd866a3dda7$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $920f4bd866a3dda7$var$_addListener(isViewport ? ownerDoc : target, "scroll", $920f4bd866a3dda7$var$_onScroll);
                type.indexOf("scroll") >= 0 && $920f4bd866a3dda7$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $920f4bd866a3dda7$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $920f4bd866a3dda7$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $920f4bd866a3dda7$var$_addListener(target, $920f4bd866a3dda7$var$_eventTypes[0], _onPress, passive, capture);
                    $920f4bd866a3dda7$var$_addListener(ownerDoc, $920f4bd866a3dda7$var$_eventTypes[2], _onRelease);
                    $920f4bd866a3dda7$var$_addListener(ownerDoc, $920f4bd866a3dda7$var$_eventTypes[3], _onRelease);
                    allowClicks && $920f4bd866a3dda7$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $920f4bd866a3dda7$var$_addListener(target, "click", _onClick);
                    onGestureStart && $920f4bd866a3dda7$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $920f4bd866a3dda7$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $920f4bd866a3dda7$var$_addListener(target, $920f4bd866a3dda7$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $920f4bd866a3dda7$var$_addListener(target, $920f4bd866a3dda7$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $920f4bd866a3dda7$var$_addListener(target, $920f4bd866a3dda7$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $920f4bd866a3dda7$var$_observers.filter(function(o) {
                    return o !== self && $920f4bd866a3dda7$export$4330f3a92e5d2e94(o.target);
                }).length || $920f4bd866a3dda7$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $920f4bd866a3dda7$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $920f4bd866a3dda7$var$_removeListener(isNormalizer ? target : ownerDoc, $920f4bd866a3dda7$var$_eventTypes[1], _onDrag, true);
                }
                $920f4bd866a3dda7$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $920f4bd866a3dda7$var$_removeListener(target, "wheel", _onWheel, capture);
                $920f4bd866a3dda7$var$_removeListener(target, $920f4bd866a3dda7$var$_eventTypes[0], _onPress, capture);
                $920f4bd866a3dda7$var$_removeListener(ownerDoc, $920f4bd866a3dda7$var$_eventTypes[2], _onRelease);
                $920f4bd866a3dda7$var$_removeListener(ownerDoc, $920f4bd866a3dda7$var$_eventTypes[3], _onRelease);
                $920f4bd866a3dda7$var$_removeListener(target, "click", clickCapture, true);
                $920f4bd866a3dda7$var$_removeListener(target, "click", _onClick);
                $920f4bd866a3dda7$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $920f4bd866a3dda7$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $920f4bd866a3dda7$var$_removeListener(target, $920f4bd866a3dda7$var$_pointerType + "enter", _onHover);
                $920f4bd866a3dda7$var$_removeListener(target, $920f4bd866a3dda7$var$_pointerType + "leave", _onHoverEnd);
                $920f4bd866a3dda7$var$_removeListener(target, $920f4bd866a3dda7$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $920f4bd866a3dda7$var$_observers.indexOf(self);
            i >= 0 && $920f4bd866a3dda7$var$_observers.splice(i, 1);
            $920f4bd866a3dda7$var$_normalizer === self && ($920f4bd866a3dda7$var$_normalizer = 0);
        };
        $920f4bd866a3dda7$var$_observers.push(self);
        isNormalizer && $920f4bd866a3dda7$export$4330f3a92e5d2e94(target) && ($920f4bd866a3dda7$var$_normalizer = self);
        self.enable(event);
    };
    $920f4bd866a3dda7$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$920f4bd866a3dda7$export$c1cbdee04e18ea8b.version = "3.12.5";
$920f4bd866a3dda7$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $920f4bd866a3dda7$export$c1cbdee04e18ea8b(vars);
};
$920f4bd866a3dda7$export$c1cbdee04e18ea8b.register = $920f4bd866a3dda7$var$_initCore;
$920f4bd866a3dda7$export$c1cbdee04e18ea8b.getAll = function() {
    return $920f4bd866a3dda7$var$_observers.slice();
};
$920f4bd866a3dda7$export$c1cbdee04e18ea8b.getById = function(id) {
    return $920f4bd866a3dda7$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$920f4bd866a3dda7$var$_getGSAP() && $920f4bd866a3dda7$var$gsap.registerPlugin($920f4bd866a3dda7$export$c1cbdee04e18ea8b);


var $4977a4034a1b06e7$var$gsap, $4977a4034a1b06e7$var$_coreInitted, $4977a4034a1b06e7$var$_win, $4977a4034a1b06e7$var$_doc, $4977a4034a1b06e7$var$_docEl, $4977a4034a1b06e7$var$_body, $4977a4034a1b06e7$var$_root, $4977a4034a1b06e7$var$_resizeDelay, $4977a4034a1b06e7$var$_toArray, $4977a4034a1b06e7$var$_clamp, $4977a4034a1b06e7$var$_time2, $4977a4034a1b06e7$var$_syncInterval, $4977a4034a1b06e7$var$_refreshing, $4977a4034a1b06e7$var$_pointerIsDown, $4977a4034a1b06e7$var$_transformProp, $4977a4034a1b06e7$var$_i, $4977a4034a1b06e7$var$_prevWidth, $4977a4034a1b06e7$var$_prevHeight, $4977a4034a1b06e7$var$_autoRefresh, $4977a4034a1b06e7$var$_sort, $4977a4034a1b06e7$var$_suppressOverwrites, $4977a4034a1b06e7$var$_ignoreResize, $4977a4034a1b06e7$var$_normalizer, $4977a4034a1b06e7$var$_ignoreMobileResize, $4977a4034a1b06e7$var$_baseScreenHeight, $4977a4034a1b06e7$var$_baseScreenWidth, $4977a4034a1b06e7$var$_fixIOSBug, $4977a4034a1b06e7$var$_context, $4977a4034a1b06e7$var$_scrollRestoration, $4977a4034a1b06e7$var$_div100vh, $4977a4034a1b06e7$var$_100vh, $4977a4034a1b06e7$var$_isReverted, $4977a4034a1b06e7$var$_clampingMax, $4977a4034a1b06e7$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$4977a4034a1b06e7$var$_startup = 1, $4977a4034a1b06e7$var$_getTime = Date.now, $4977a4034a1b06e7$var$_time1 = $4977a4034a1b06e7$var$_getTime(), $4977a4034a1b06e7$var$_lastScrollTime = 0, $4977a4034a1b06e7$var$_enabled = 0, $4977a4034a1b06e7$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $4977a4034a1b06e7$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $4977a4034a1b06e7$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$4977a4034a1b06e7$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $4977a4034a1b06e7$var$_rafBugFix = function _rafBugFix() {
    return $4977a4034a1b06e7$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$4977a4034a1b06e7$var$_pointerDownHandler = function _pointerDownHandler() {
    return $4977a4034a1b06e7$var$_pointerIsDown = 1;
}, $4977a4034a1b06e7$var$_pointerUpHandler = function _pointerUpHandler() {
    return $4977a4034a1b06e7$var$_pointerIsDown = 0;
}, $4977a4034a1b06e7$var$_passThrough = function _passThrough(v) {
    return v;
}, $4977a4034a1b06e7$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $4977a4034a1b06e7$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $4977a4034a1b06e7$var$_getGSAP = function _getGSAP() {
    return $4977a4034a1b06e7$var$gsap || $4977a4034a1b06e7$var$_windowExists() && ($4977a4034a1b06e7$var$gsap = window.gsap) && $4977a4034a1b06e7$var$gsap.registerPlugin && $4977a4034a1b06e7$var$gsap;
}, $4977a4034a1b06e7$var$_isViewport = function _isViewport(e) {
    return !!~$4977a4034a1b06e7$var$_root.indexOf(e);
}, $4977a4034a1b06e7$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $4977a4034a1b06e7$var$_100vh : $4977a4034a1b06e7$var$_win["inner" + dimensionProperty]) || $4977a4034a1b06e7$var$_docEl["client" + dimensionProperty] || $4977a4034a1b06e7$var$_body["client" + dimensionProperty];
}, $4977a4034a1b06e7$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $920f4bd866a3dda7$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($4977a4034a1b06e7$var$_isViewport(element) ? function() {
        $4977a4034a1b06e7$var$_winOffsets.width = $4977a4034a1b06e7$var$_win.innerWidth;
        $4977a4034a1b06e7$var$_winOffsets.height = $4977a4034a1b06e7$var$_100vh;
        return $4977a4034a1b06e7$var$_winOffsets;
    } : function() {
        return $4977a4034a1b06e7$var$_getBounds(element);
    });
}, $4977a4034a1b06e7$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $920f4bd866a3dda7$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $4977a4034a1b06e7$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $4977a4034a1b06e7$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $920f4bd866a3dda7$export$d8e56d510a804d0a).indexOf(element) ? $4977a4034a1b06e7$var$_getBoundsFunc(element) : function() {
        return $4977a4034a1b06e7$var$_winOffsets;
    };
}, $4977a4034a1b06e7$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $920f4bd866a3dda7$export$6078f1ef08b38af9)(element, s)) ? a() - $4977a4034a1b06e7$var$_getBoundsFunc(element)()[d] : $4977a4034a1b06e7$var$_isViewport(element) ? ($4977a4034a1b06e7$var$_docEl[s] || $4977a4034a1b06e7$var$_body[s]) - $4977a4034a1b06e7$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $4977a4034a1b06e7$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $4977a4034a1b06e7$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($4977a4034a1b06e7$var$_autoRefresh[i + 1])) && func($4977a4034a1b06e7$var$_autoRefresh[i], $4977a4034a1b06e7$var$_autoRefresh[i + 1], $4977a4034a1b06e7$var$_autoRefresh[i + 2]);
}, $4977a4034a1b06e7$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $4977a4034a1b06e7$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $4977a4034a1b06e7$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $4977a4034a1b06e7$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $4977a4034a1b06e7$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $4977a4034a1b06e7$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self);
        }) : func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $4977a4034a1b06e7$var$_abs = Math.abs, $4977a4034a1b06e7$var$_left = "left", $4977a4034a1b06e7$var$_top = "top", $4977a4034a1b06e7$var$_right = "right", $4977a4034a1b06e7$var$_bottom = "bottom", $4977a4034a1b06e7$var$_width = "width", $4977a4034a1b06e7$var$_height = "height", $4977a4034a1b06e7$var$_Right = "Right", $4977a4034a1b06e7$var$_Left = "Left", $4977a4034a1b06e7$var$_Top = "Top", $4977a4034a1b06e7$var$_Bottom = "Bottom", $4977a4034a1b06e7$var$_padding = "padding", $4977a4034a1b06e7$var$_margin = "margin", $4977a4034a1b06e7$var$_Width = "Width", $4977a4034a1b06e7$var$_Height = "Height", $4977a4034a1b06e7$var$_px = "px", $4977a4034a1b06e7$var$_getComputedStyle = function _getComputedStyle(element) {
    return $4977a4034a1b06e7$var$_win.getComputedStyle(element);
}, $4977a4034a1b06e7$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $4977a4034a1b06e7$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $4977a4034a1b06e7$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $4977a4034a1b06e7$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $4977a4034a1b06e7$var$_getComputedStyle(element)[$4977a4034a1b06e7$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $4977a4034a1b06e7$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $4977a4034a1b06e7$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $4977a4034a1b06e7$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $4977a4034a1b06e7$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $4977a4034a1b06e7$var$gsap.utils.snap($4977a4034a1b06e7$var$_getLabelRatioArray(animation), value);
    };
}, $4977a4034a1b06e7$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $4977a4034a1b06e7$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $4977a4034a1b06e7$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $4977a4034a1b06e7$var$_snapDirectional($4977a4034a1b06e7$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $4977a4034a1b06e7$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $4977a4034a1b06e7$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $4977a4034a1b06e7$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $4977a4034a1b06e7$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $4977a4034a1b06e7$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $4977a4034a1b06e7$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $4977a4034a1b06e7$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $4977a4034a1b06e7$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($4977a4034a1b06e7$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $4977a4034a1b06e7$var$_keywords ? $4977a4034a1b06e7$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $4977a4034a1b06e7$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $4977a4034a1b06e7$var$_doc.createElement("div"), useFixedPosition = $4977a4034a1b06e7$var$_isViewport(container) || (0, $920f4bd866a3dda7$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $4977a4034a1b06e7$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d) ? $4977a4034a1b06e7$var$_right : $4977a4034a1b06e7$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $4977a4034a1b06e7$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $4977a4034a1b06e7$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $4977a4034a1b06e7$var$_Width] = 1;
    vars["border" + oppositeSide + $4977a4034a1b06e7$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $4977a4034a1b06e7$var$gsap.set(marker, vars);
}, $4977a4034a1b06e7$var$_triggers = [], $4977a4034a1b06e7$var$_ids = {}, $4977a4034a1b06e7$var$_rafID, $4977a4034a1b06e7$var$_sync = function _sync() {
    return $4977a4034a1b06e7$var$_getTime() - $4977a4034a1b06e7$var$_lastScrollTime > 34 && ($4977a4034a1b06e7$var$_rafID || ($4977a4034a1b06e7$var$_rafID = requestAnimationFrame($4977a4034a1b06e7$var$_updateAll)));
}, $4977a4034a1b06e7$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$4977a4034a1b06e7$var$_normalizer || !$4977a4034a1b06e7$var$_normalizer.isPressed || $4977a4034a1b06e7$var$_normalizer.startX > $4977a4034a1b06e7$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).cache++;
        if ($4977a4034a1b06e7$var$_normalizer) $4977a4034a1b06e7$var$_rafID || ($4977a4034a1b06e7$var$_rafID = requestAnimationFrame($4977a4034a1b06e7$var$_updateAll));
        else $4977a4034a1b06e7$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $4977a4034a1b06e7$var$_lastScrollTime || $4977a4034a1b06e7$var$_dispatch("scrollStart");
        $4977a4034a1b06e7$var$_lastScrollTime = $4977a4034a1b06e7$var$_getTime();
    }
}, $4977a4034a1b06e7$var$_setBaseDimensions = function _setBaseDimensions() {
    $4977a4034a1b06e7$var$_baseScreenWidth = $4977a4034a1b06e7$var$_win.innerWidth;
    $4977a4034a1b06e7$var$_baseScreenHeight = $4977a4034a1b06e7$var$_win.innerHeight;
}, $4977a4034a1b06e7$var$_onResize = function _onResize() {
    (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).cache++;
    !$4977a4034a1b06e7$var$_refreshing && !$4977a4034a1b06e7$var$_ignoreResize && !$4977a4034a1b06e7$var$_doc.fullscreenElement && !$4977a4034a1b06e7$var$_doc.webkitFullscreenElement && (!$4977a4034a1b06e7$var$_ignoreMobileResize || $4977a4034a1b06e7$var$_baseScreenWidth !== $4977a4034a1b06e7$var$_win.innerWidth || Math.abs($4977a4034a1b06e7$var$_win.innerHeight - $4977a4034a1b06e7$var$_baseScreenHeight) > $4977a4034a1b06e7$var$_win.innerHeight * 0.25) && $4977a4034a1b06e7$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$4977a4034a1b06e7$var$_listeners = {}, $4977a4034a1b06e7$var$_emptyArray = [], $4977a4034a1b06e7$var$_softRefresh = function _softRefresh() {
    return $4977a4034a1b06e7$var$_removeListener($4977a4034a1b06e7$export$875bcbe48555930, "scrollEnd", _softRefresh) || $4977a4034a1b06e7$var$_refreshAll(true);
}, $4977a4034a1b06e7$var$_dispatch = function _dispatch(type) {
    return $4977a4034a1b06e7$var$_listeners[type] && $4977a4034a1b06e7$var$_listeners[type].map(function(f) {
        return f();
    }) || $4977a4034a1b06e7$var$_emptyArray;
}, $4977a4034a1b06e7$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$4977a4034a1b06e7$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $4977a4034a1b06e7$var$_savedStyles.length; i += 5)if (!media || $4977a4034a1b06e7$var$_savedStyles[i + 4] && $4977a4034a1b06e7$var$_savedStyles[i + 4].query === media) {
        $4977a4034a1b06e7$var$_savedStyles[i].style.cssText = $4977a4034a1b06e7$var$_savedStyles[i + 1];
        $4977a4034a1b06e7$var$_savedStyles[i].getBBox && $4977a4034a1b06e7$var$_savedStyles[i].setAttribute("transform", $4977a4034a1b06e7$var$_savedStyles[i + 2] || "");
        $4977a4034a1b06e7$var$_savedStyles[i + 3].uncache = 1;
    }
}, $4977a4034a1b06e7$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($4977a4034a1b06e7$var$_i = 0; $4977a4034a1b06e7$var$_i < $4977a4034a1b06e7$var$_triggers.length; $4977a4034a1b06e7$var$_i++){
        trigger = $4977a4034a1b06e7$var$_triggers[$4977a4034a1b06e7$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $4977a4034a1b06e7$var$_isReverted = true;
    media && $4977a4034a1b06e7$var$_revertRecorded(media);
    media || $4977a4034a1b06e7$var$_dispatch("revert");
}, $4977a4034a1b06e7$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).cache++;
    (force || !$4977a4034a1b06e7$var$_refreshingAll) && (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).forEach(function(obj) {
        return $4977a4034a1b06e7$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $4977a4034a1b06e7$var$_isString(scrollRestoration) && ($4977a4034a1b06e7$var$_win.history.scrollRestoration = $4977a4034a1b06e7$var$_scrollRestoration = scrollRestoration);
}, $4977a4034a1b06e7$var$_refreshingAll, $4977a4034a1b06e7$var$_refreshID = 0, $4977a4034a1b06e7$var$_queueRefreshID, $4977a4034a1b06e7$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($4977a4034a1b06e7$var$_queueRefreshID !== $4977a4034a1b06e7$var$_refreshID) {
        var id = $4977a4034a1b06e7$var$_queueRefreshID = $4977a4034a1b06e7$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $4977a4034a1b06e7$var$_refreshID && $4977a4034a1b06e7$var$_refreshAll(true);
        });
    }
}, $4977a4034a1b06e7$var$_refresh100vh = function _refresh100vh() {
    $4977a4034a1b06e7$var$_body.appendChild($4977a4034a1b06e7$var$_div100vh);
    $4977a4034a1b06e7$var$_100vh = !$4977a4034a1b06e7$var$_normalizer && $4977a4034a1b06e7$var$_div100vh.offsetHeight || $4977a4034a1b06e7$var$_win.innerHeight;
    $4977a4034a1b06e7$var$_body.removeChild($4977a4034a1b06e7$var$_div100vh);
}, $4977a4034a1b06e7$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $4977a4034a1b06e7$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $4977a4034a1b06e7$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($4977a4034a1b06e7$var$_lastScrollTime && !force && !$4977a4034a1b06e7$var$_isReverted) {
        $4977a4034a1b06e7$var$_addListener($4977a4034a1b06e7$export$875bcbe48555930, "scrollEnd", $4977a4034a1b06e7$var$_softRefresh);
        return;
    }
    $4977a4034a1b06e7$var$_refresh100vh();
    $4977a4034a1b06e7$var$_refreshingAll = $4977a4034a1b06e7$export$875bcbe48555930.isRefreshing = true;
    (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).forEach(function(obj) {
        return $4977a4034a1b06e7$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $4977a4034a1b06e7$var$_dispatch("refreshInit");
    $4977a4034a1b06e7$var$_sort && $4977a4034a1b06e7$export$875bcbe48555930.sort();
    skipRevert || $4977a4034a1b06e7$var$_revertAll();
    (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($4977a4034a1b06e7$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $4977a4034a1b06e7$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $4977a4034a1b06e7$var$_isReverted = false;
    $4977a4034a1b06e7$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $4977a4034a1b06e7$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $4977a4034a1b06e7$var$_hideAllMarkers(true);
    $4977a4034a1b06e7$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $4977a4034a1b06e7$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $4977a4034a1b06e7$var$_hideAllMarkers(false);
    $4977a4034a1b06e7$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($4977a4034a1b06e7$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $4977a4034a1b06e7$var$_clearScrollMemory($4977a4034a1b06e7$var$_scrollRestoration, 1);
    $4977a4034a1b06e7$var$_resizeDelay.pause();
    $4977a4034a1b06e7$var$_refreshID++;
    $4977a4034a1b06e7$var$_refreshingAll = 2;
    $4977a4034a1b06e7$var$_updateAll(2);
    $4977a4034a1b06e7$var$_triggers.forEach(function(t) {
        return $4977a4034a1b06e7$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $4977a4034a1b06e7$var$_refreshingAll = $4977a4034a1b06e7$export$875bcbe48555930.isRefreshing = false;
    $4977a4034a1b06e7$var$_dispatch("refresh");
}, $4977a4034a1b06e7$var$_lastScroll = 0, $4977a4034a1b06e7$var$_direction = 1, $4977a4034a1b06e7$var$_primary, $4977a4034a1b06e7$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$4977a4034a1b06e7$var$_refreshingAll && !$4977a4034a1b06e7$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $4977a4034a1b06e7$export$875bcbe48555930.isUpdating = true;
        $4977a4034a1b06e7$var$_primary && $4977a4034a1b06e7$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $4977a4034a1b06e7$var$_triggers.length, time = $4977a4034a1b06e7$var$_getTime(), recordVelocity = time - $4977a4034a1b06e7$var$_time1 >= 50, scroll = l && $4977a4034a1b06e7$var$_triggers[0].scroll();
        $4977a4034a1b06e7$var$_direction = $4977a4034a1b06e7$var$_lastScroll > scroll ? -1 : 1;
        $4977a4034a1b06e7$var$_refreshingAll || ($4977a4034a1b06e7$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($4977a4034a1b06e7$var$_lastScrollTime && !$4977a4034a1b06e7$var$_pointerIsDown && time - $4977a4034a1b06e7$var$_lastScrollTime > 200) {
                $4977a4034a1b06e7$var$_lastScrollTime = 0;
                $4977a4034a1b06e7$var$_dispatch("scrollEnd");
            }
            $4977a4034a1b06e7$var$_time2 = $4977a4034a1b06e7$var$_time1;
            $4977a4034a1b06e7$var$_time1 = time;
        }
        if ($4977a4034a1b06e7$var$_direction < 0) {
            $4977a4034a1b06e7$var$_i = l;
            while($4977a4034a1b06e7$var$_i-- > 0)$4977a4034a1b06e7$var$_triggers[$4977a4034a1b06e7$var$_i] && $4977a4034a1b06e7$var$_triggers[$4977a4034a1b06e7$var$_i].update(0, recordVelocity);
            $4977a4034a1b06e7$var$_direction = 1;
        } else for($4977a4034a1b06e7$var$_i = 0; $4977a4034a1b06e7$var$_i < l; $4977a4034a1b06e7$var$_i++)$4977a4034a1b06e7$var$_triggers[$4977a4034a1b06e7$var$_i] && $4977a4034a1b06e7$var$_triggers[$4977a4034a1b06e7$var$_i].update(0, recordVelocity);
        $4977a4034a1b06e7$export$875bcbe48555930.isUpdating = false;
    }
    $4977a4034a1b06e7$var$_rafID = 0;
}, $4977a4034a1b06e7$var$_propNamesToCopy = [
    $4977a4034a1b06e7$var$_left,
    $4977a4034a1b06e7$var$_top,
    $4977a4034a1b06e7$var$_bottom,
    $4977a4034a1b06e7$var$_right,
    $4977a4034a1b06e7$var$_margin + $4977a4034a1b06e7$var$_Bottom,
    $4977a4034a1b06e7$var$_margin + $4977a4034a1b06e7$var$_Right,
    $4977a4034a1b06e7$var$_margin + $4977a4034a1b06e7$var$_Top,
    $4977a4034a1b06e7$var$_margin + $4977a4034a1b06e7$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $4977a4034a1b06e7$var$_stateProps = $4977a4034a1b06e7$var$_propNamesToCopy.concat([
    $4977a4034a1b06e7$var$_width,
    $4977a4034a1b06e7$var$_height,
    "boxSizing",
    "max" + $4977a4034a1b06e7$var$_Width,
    "max" + $4977a4034a1b06e7$var$_Height,
    "position",
    $4977a4034a1b06e7$var$_margin,
    $4977a4034a1b06e7$var$_padding,
    $4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Top,
    $4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Right,
    $4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Bottom,
    $4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Left
]), $4977a4034a1b06e7$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $4977a4034a1b06e7$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $4977a4034a1b06e7$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $4977a4034a1b06e7$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $4977a4034a1b06e7$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $4977a4034a1b06e7$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$4977a4034a1b06e7$var$_bottom] = pinStyle[$4977a4034a1b06e7$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$4977a4034a1b06e7$var$_width] = $4977a4034a1b06e7$var$_getSize(pin, (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1)) + $4977a4034a1b06e7$var$_px;
        spacerStyle[$4977a4034a1b06e7$var$_height] = $4977a4034a1b06e7$var$_getSize(pin, (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d)) + $4977a4034a1b06e7$var$_px;
        spacerStyle[$4977a4034a1b06e7$var$_padding] = pinStyle[$4977a4034a1b06e7$var$_margin] = pinStyle[$4977a4034a1b06e7$var$_top] = pinStyle[$4977a4034a1b06e7$var$_left] = "0";
        $4977a4034a1b06e7$var$_setState(spacerState);
        pinStyle[$4977a4034a1b06e7$var$_width] = pinStyle["max" + $4977a4034a1b06e7$var$_Width] = cs[$4977a4034a1b06e7$var$_width];
        pinStyle[$4977a4034a1b06e7$var$_height] = pinStyle["max" + $4977a4034a1b06e7$var$_Height] = cs[$4977a4034a1b06e7$var$_height];
        pinStyle[$4977a4034a1b06e7$var$_padding] = cs[$4977a4034a1b06e7$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $4977a4034a1b06e7$var$_capsExp = /([A-Z])/g, $4977a4034a1b06e7$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $4977a4034a1b06e7$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($4977a4034a1b06e7$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $4977a4034a1b06e7$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $4977a4034a1b06e7$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($4977a4034a1b06e7$var$_stateProps[i], style[$4977a4034a1b06e7$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $4977a4034a1b06e7$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $4977a4034a1b06e7$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$4977a4034a1b06e7$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $4977a4034a1b06e7$var$_isFunction(value) && (value = value(self));
    if ($4977a4034a1b06e7$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $4977a4034a1b06e7$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$4977a4034a1b06e7$var$_isNumber(value)) {
        $4977a4034a1b06e7$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $920f4bd866a3dda7$export$937374fea3f88711)(trigger, self) || $4977a4034a1b06e7$var$_body;
        bounds = $4977a4034a1b06e7$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $4977a4034a1b06e7$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $4977a4034a1b06e7$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $4977a4034a1b06e7$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $4977a4034a1b06e7$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $4977a4034a1b06e7$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $4977a4034a1b06e7$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $4977a4034a1b06e7$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $4977a4034a1b06e7$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($4977a4034a1b06e7$var$_body[p1], $4977a4034a1b06e7$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $4977a4034a1b06e7$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $4977a4034a1b06e7$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $4977a4034a1b06e7$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $4977a4034a1b06e7$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $4977a4034a1b06e7$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $4977a4034a1b06e7$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $4977a4034a1b06e7$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $4977a4034a1b06e7$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$4977a4034a1b06e7$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $4977a4034a1b06e7$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $4977a4034a1b06e7$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $4977a4034a1b06e7$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $4977a4034a1b06e7$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$4977a4034a1b06e7$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $920f4bd866a3dda7$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $4977a4034a1b06e7$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).cache++;
            getTween.tween && $4977a4034a1b06e7$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $4977a4034a1b06e7$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $4977a4034a1b06e7$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $4977a4034a1b06e7$export$875bcbe48555930.isTouch && $4977a4034a1b06e7$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $4977a4034a1b06e7$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $4977a4034a1b06e7$var$_coreInitted || ScrollTrigger.register($4977a4034a1b06e7$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $4977a4034a1b06e7$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$4977a4034a1b06e7$var$_enabled) {
            this.update = this.refresh = this.kill = $4977a4034a1b06e7$var$_passThrough;
            return;
        }
        vars = $4977a4034a1b06e7$var$_setDefaults($4977a4034a1b06e7$var$_isString(vars) || $4977a4034a1b06e7$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $4977a4034a1b06e7$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1) : (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $920f4bd866a3dda7$export$937374fea3f88711)(vars.scroller || $4977a4034a1b06e7$var$_win), scrollerCache = $4977a4034a1b06e7$var$gsap.core.getCache(scroller), isViewport = $4977a4034a1b06e7$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $920f4bd866a3dda7$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $4977a4034a1b06e7$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($4977a4034a1b06e7$var$_getComputedStyle(scroller)["border" + direction.p2 + $4977a4034a1b06e7$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $4977a4034a1b06e7$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $4977a4034a1b06e7$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $920f4bd866a3dda7$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $4977a4034a1b06e7$var$_sort = 1;
            vars.refreshPriority === -9999 && ($4977a4034a1b06e7$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $4977a4034a1b06e7$var$_getTweenCreator(scroller, (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d)),
            left: $4977a4034a1b06e7$var$_getTweenCreator(scroller, (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $4977a4034a1b06e7$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $4977a4034a1b06e7$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$4977a4034a1b06e7$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $4977a4034a1b06e7$var$_body.style && $4977a4034a1b06e7$var$gsap.set(isViewport ? [
                $4977a4034a1b06e7$var$_body,
                $4977a4034a1b06e7$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).forEach(function(o) {
                return $4977a4034a1b06e7$var$_isFunction(o) && o.target === (isViewport ? $4977a4034a1b06e7$var$_doc.scrollingElement || $4977a4034a1b06e7$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $4977a4034a1b06e7$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $4977a4034a1b06e7$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $4977a4034a1b06e7$var$_getLabelAtDirection(animation) : snap.directional !== false ? function snapFunc(value, st) {
                return $4977a4034a1b06e7$var$_snapDirectional(snap.snapTo)(value, $4977a4034a1b06e7$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $4977a4034a1b06e7$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $4977a4034a1b06e7$var$_isObject(snapDurClamp) ? $4977a4034a1b06e7$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $4977a4034a1b06e7$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $4977a4034a1b06e7$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $4977a4034a1b06e7$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$4977a4034a1b06e7$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($4977a4034a1b06e7$var$_getTime() - $4977a4034a1b06e7$var$_time2) * 1000 || 0, change1 = $4977a4034a1b06e7$var$gsap.utils.clamp(-progress, 1 - progress, $4977a4034a1b06e7$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $4977a4034a1b06e7$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.round(start + endValue * change);
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $4977a4034a1b06e7$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($4977a4034a1b06e7$var$_abs(Math.max($4977a4034a1b06e7$var$_abs(naturalEnd - totalProgress), $4977a4034a1b06e7$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $4977a4034a1b06e7$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($4977a4034a1b06e7$var$_ids[id] = self);
        trigger = self.trigger = (0, $920f4bd866a3dda7$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $920f4bd866a3dda7$export$937374fea3f88711)(pin);
        $4977a4034a1b06e7$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $4977a4034a1b06e7$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $4977a4034a1b06e7$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $4977a4034a1b06e7$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $4977a4034a1b06e7$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $920f4bd866a3dda7$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $4977a4034a1b06e7$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $4977a4034a1b06e7$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $4977a4034a1b06e7$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $4977a4034a1b06e7$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $4977a4034a1b06e7$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $4977a4034a1b06e7$var$gsap.getProperty(pin);
            pinSetter = $4977a4034a1b06e7$var$gsap.quickSetter(pin, direction.a, $4977a4034a1b06e7$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $4977a4034a1b06e7$var$_swapPinIn(pin, spacer, cs);
            pinState = $4977a4034a1b06e7$var$_getState(pin);
        }
        if (markers) {
            markerVars = $4977a4034a1b06e7$var$_isObject(markers) ? $4977a4034a1b06e7$var$_setDefaults(markers, $4977a4034a1b06e7$var$_markerDefaults) : $4977a4034a1b06e7$var$_markerDefaults;
            markerStartTrigger = $4977a4034a1b06e7$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $4977a4034a1b06e7$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $920f4bd866a3dda7$export$937374fea3f88711)((0, $920f4bd866a3dda7$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $4977a4034a1b06e7$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $4977a4034a1b06e7$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $4977a4034a1b06e7$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $4977a4034a1b06e7$var$_px));
            if (!useFixedPosition && !((0, $920f4bd866a3dda7$export$d8e56d510a804d0a).length && (0, $920f4bd866a3dda7$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $4977a4034a1b06e7$var$_makePositionable(isViewport ? $4977a4034a1b06e7$var$_body : scroller);
                $4977a4034a1b06e7$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $4977a4034a1b06e7$var$gsap.quickSetter(markerStartTrigger, direction.a, $4977a4034a1b06e7$var$_px);
                markerEndSetter = $4977a4034a1b06e7$var$gsap.quickSetter(markerEndTrigger, direction.a, $4977a4034a1b06e7$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $4977a4034a1b06e7$var$_triggers[$4977a4034a1b06e7$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $4977a4034a1b06e7$var$_triggers[$4977a4034a1b06e7$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $4977a4034a1b06e7$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $4977a4034a1b06e7$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $4977a4034a1b06e7$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $4977a4034a1b06e7$var$_swapPinIn(pin, spacer, $4977a4034a1b06e7$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $4977a4034a1b06e7$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($4977a4034a1b06e7$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $4977a4034a1b06e7$var$_lastScrollTime) {
                $4977a4034a1b06e7$var$_addListener(ScrollTrigger, "scrollEnd", $4977a4034a1b06e7$var$_softRefresh);
                return;
            }
            !$4977a4034a1b06e7$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $4977a4034a1b06e7$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $4977a4034a1b06e7$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $4977a4034a1b06e7$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $4977a4034a1b06e7$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $920f4bd866a3dda7$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $4977a4034a1b06e7$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $4977a4034a1b06e7$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $4977a4034a1b06e7$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $4977a4034a1b06e7$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $4977a4034a1b06e7$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($4977a4034a1b06e7$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $4977a4034a1b06e7$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $4977a4034a1b06e7$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $4977a4034a1b06e7$var$_parseClamp(parsedStart, "start", self);
            start = $4977a4034a1b06e7$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $4977a4034a1b06e7$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($4977a4034a1b06e7$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($4977a4034a1b06e7$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $4977a4034a1b06e7$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $4977a4034a1b06e7$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $4977a4034a1b06e7$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $4977a4034a1b06e7$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $4977a4034a1b06e7$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $4977a4034a1b06e7$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$4977a4034a1b06e7$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $4977a4034a1b06e7$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $4977a4034a1b06e7$var$gsap.utils.clamp(0, 1, $4977a4034a1b06e7$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $4977a4034a1b06e7$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($4977a4034a1b06e7$var$_clampingMax && self.end >= $4977a4034a1b06e7$var$_maxScroll(scroller, direction))) {
                cs = $4977a4034a1b06e7$var$_getComputedStyle(pin);
                isVertical = direction === (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $4977a4034a1b06e7$var$_doc.scrollingElement || $4977a4034a1b06e7$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $4977a4034a1b06e7$var$_getComputedStyle($4977a4034a1b06e7$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $4977a4034a1b06e7$var$_swapPinIn(pin, spacer, cs);
                pinState = $4977a4034a1b06e7$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $4977a4034a1b06e7$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $920f4bd866a3dda7$export$8665aac53dad5647)(scroller, isVertical ? (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1) : (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $4977a4034a1b06e7$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $4977a4034a1b06e7$var$_padding ? $4977a4034a1b06e7$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $4977a4034a1b06e7$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $4977a4034a1b06e7$var$_px);
                    }
                    $4977a4034a1b06e7$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $4977a4034a1b06e7$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $4977a4034a1b06e7$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $4977a4034a1b06e7$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $4977a4034a1b06e7$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $4977a4034a1b06e7$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$4977a4034a1b06e7$var$_width] = override["max" + $4977a4034a1b06e7$var$_Width] = Math.ceil(bounds.width) + $4977a4034a1b06e7$var$_px;
                    override[$4977a4034a1b06e7$var$_height] = override["max" + $4977a4034a1b06e7$var$_Height] = Math.ceil(bounds.height) + $4977a4034a1b06e7$var$_px;
                    override[$4977a4034a1b06e7$var$_margin] = override[$4977a4034a1b06e7$var$_margin + $4977a4034a1b06e7$var$_Top] = override[$4977a4034a1b06e7$var$_margin + $4977a4034a1b06e7$var$_Right] = override[$4977a4034a1b06e7$var$_margin + $4977a4034a1b06e7$var$_Bottom] = override[$4977a4034a1b06e7$var$_margin + $4977a4034a1b06e7$var$_Left] = "0";
                    override[$4977a4034a1b06e7$var$_padding] = cs[$4977a4034a1b06e7$var$_padding];
                    override[$4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Top] = cs[$4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Top];
                    override[$4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Right] = cs[$4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Right];
                    override[$4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Bottom] = cs[$4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Bottom];
                    override[$4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Left] = cs[$4977a4034a1b06e7$var$_padding + $4977a4034a1b06e7$var$_Left];
                    pinActiveState = $4977a4034a1b06e7$var$_copyState(pinOriginalState, override, pinReparent);
                    $4977a4034a1b06e7$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $4977a4034a1b06e7$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $4977a4034a1b06e7$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $4977a4034a1b06e7$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $4977a4034a1b06e7$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$4977a4034a1b06e7$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $4977a4034a1b06e7$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $4977a4034a1b06e7$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $4977a4034a1b06e7$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $4977a4034a1b06e7$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $4977a4034a1b06e7$var$gsap.getProperty(markerEndTrigger, direction.p);
                $4977a4034a1b06e7$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $4977a4034a1b06e7$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $4977a4034a1b06e7$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $4977a4034a1b06e7$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$4977a4034a1b06e7$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$4977a4034a1b06e7$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($4977a4034a1b06e7$var$_getTime() - $4977a4034a1b06e7$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $4977a4034a1b06e7$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $4977a4034a1b06e7$var$_endAnimation(animation, animation.reversed()) : isToggle || $4977a4034a1b06e7$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $4977a4034a1b06e7$var$_triggers.indexOf(self), a = self.direction > 0 ? $4977a4034a1b06e7$var$_triggers.slice(0, i).reverse() : $4977a4034a1b06e7$var$_triggers.slice(i + 1);
            return ($4977a4034a1b06e7$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $4977a4034a1b06e7$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$4977a4034a1b06e7$var$_refreshing && !$4977a4034a1b06e7$var$_startup && $4977a4034a1b06e7$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($4977a4034a1b06e7$var$_getTime() - $4977a4034a1b06e7$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($4977a4034a1b06e7$var$_getTime() - $4977a4034a1b06e7$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$4977a4034a1b06e7$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($4977a4034a1b06e7$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$4977a4034a1b06e7$var$_refreshing && !$4977a4034a1b06e7$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($4977a4034a1b06e7$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($4977a4034a1b06e7$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $4977a4034a1b06e7$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $4977a4034a1b06e7$var$_getBounds(pin, true), _offset = scroll - start;
                                $4977a4034a1b06e7$var$_reparent(pin, $4977a4034a1b06e7$var$_body, bounds.top + (direction === (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d) ? _offset : 0) + $4977a4034a1b06e7$var$_px, bounds.left + (direction === (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d) ? 0 : _offset) + $4977a4034a1b06e7$var$_px);
                            } else $4977a4034a1b06e7$var$_reparent(pin, spacer);
                        }
                        $4977a4034a1b06e7$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$4977a4034a1b06e7$var$_refreshing && !$4977a4034a1b06e7$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$4977a4034a1b06e7$var$_limitCallbacks)) && $4977a4034a1b06e7$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$4977a4034a1b06e7$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$4977a4034a1b06e7$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $4977a4034a1b06e7$var$_callback(self, onToggle);
                        callbacks[toggleState] && $4977a4034a1b06e7$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $4977a4034a1b06e7$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($4977a4034a1b06e7$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $4977a4034a1b06e7$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $4977a4034a1b06e7$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$4977a4034a1b06e7$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $4977a4034a1b06e7$var$_addListener(scroller, "resize", $4977a4034a1b06e7$var$_onResize);
                isViewport || $4977a4034a1b06e7$var$_addListener(scroller, "scroll", $4977a4034a1b06e7$var$_onScroll);
                onRefreshInit && $4977a4034a1b06e7$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $4977a4034a1b06e7$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $4977a4034a1b06e7$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $4977a4034a1b06e7$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $4977a4034a1b06e7$var$_px;
                $4977a4034a1b06e7$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $4977a4034a1b06e7$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $4977a4034a1b06e7$var$_triggers.length;
                    while(i--){
                        if ($4977a4034a1b06e7$var$_triggers[i].scroller === scroller && $4977a4034a1b06e7$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $4977a4034a1b06e7$var$_removeListener(scroller, "resize", $4977a4034a1b06e7$var$_onResize);
                    isViewport || $4977a4034a1b06e7$var$_removeListener(scroller, "scroll", $4977a4034a1b06e7$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $4977a4034a1b06e7$var$_ids[id];
            var i = $4977a4034a1b06e7$var$_triggers.indexOf(self);
            i >= 0 && $4977a4034a1b06e7$var$_triggers.splice(i, 1);
            i === $4977a4034a1b06e7$var$_i && $4977a4034a1b06e7$var$_direction > 0 && $4977a4034a1b06e7$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $4977a4034a1b06e7$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $4977a4034a1b06e7$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $4977a4034a1b06e7$var$_primary === self && ($4977a4034a1b06e7$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $4977a4034a1b06e7$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $4977a4034a1b06e7$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $4977a4034a1b06e7$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $4977a4034a1b06e7$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$4977a4034a1b06e7$var$_coreInitted) {
            $4977a4034a1b06e7$var$gsap = core || $4977a4034a1b06e7$var$_getGSAP();
            $4977a4034a1b06e7$var$_windowExists() && window.document && ScrollTrigger.enable();
            $4977a4034a1b06e7$var$_coreInitted = $4977a4034a1b06e7$var$_enabled;
        }
        return $4977a4034a1b06e7$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$4977a4034a1b06e7$var$_defaults[p] = config[p];
        return $4977a4034a1b06e7$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $4977a4034a1b06e7$var$_enabled = 0;
        $4977a4034a1b06e7$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $4977a4034a1b06e7$var$_removeListener($4977a4034a1b06e7$var$_win, "wheel", $4977a4034a1b06e7$var$_onScroll);
        $4977a4034a1b06e7$var$_removeListener($4977a4034a1b06e7$var$_doc, "scroll", $4977a4034a1b06e7$var$_onScroll);
        clearInterval($4977a4034a1b06e7$var$_syncInterval);
        $4977a4034a1b06e7$var$_removeListener($4977a4034a1b06e7$var$_doc, "touchcancel", $4977a4034a1b06e7$var$_passThrough);
        $4977a4034a1b06e7$var$_removeListener($4977a4034a1b06e7$var$_body, "touchstart", $4977a4034a1b06e7$var$_passThrough);
        $4977a4034a1b06e7$var$_multiListener($4977a4034a1b06e7$var$_removeListener, $4977a4034a1b06e7$var$_doc, "pointerdown,touchstart,mousedown", $4977a4034a1b06e7$var$_pointerDownHandler);
        $4977a4034a1b06e7$var$_multiListener($4977a4034a1b06e7$var$_removeListener, $4977a4034a1b06e7$var$_doc, "pointerup,touchend,mouseup", $4977a4034a1b06e7$var$_pointerUpHandler);
        $4977a4034a1b06e7$var$_resizeDelay.kill();
        $4977a4034a1b06e7$var$_iterateAutoRefresh($4977a4034a1b06e7$var$_removeListener);
        for(var i = 0; i < (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).length; i += 3){
            $4977a4034a1b06e7$var$_wheelListener($4977a4034a1b06e7$var$_removeListener, (0, $920f4bd866a3dda7$export$3cd1cee43d19b683)[i], (0, $920f4bd866a3dda7$export$3cd1cee43d19b683)[i + 1]);
            $4977a4034a1b06e7$var$_wheelListener($4977a4034a1b06e7$var$_removeListener, (0, $920f4bd866a3dda7$export$3cd1cee43d19b683)[i], (0, $920f4bd866a3dda7$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $4977a4034a1b06e7$var$_win = window;
        $4977a4034a1b06e7$var$_doc = document;
        $4977a4034a1b06e7$var$_docEl = $4977a4034a1b06e7$var$_doc.documentElement;
        $4977a4034a1b06e7$var$_body = $4977a4034a1b06e7$var$_doc.body;
        if ($4977a4034a1b06e7$var$gsap) {
            $4977a4034a1b06e7$var$_toArray = $4977a4034a1b06e7$var$gsap.utils.toArray;
            $4977a4034a1b06e7$var$_clamp = $4977a4034a1b06e7$var$gsap.utils.clamp;
            $4977a4034a1b06e7$var$_context = $4977a4034a1b06e7$var$gsap.core.context || $4977a4034a1b06e7$var$_passThrough;
            $4977a4034a1b06e7$var$_suppressOverwrites = $4977a4034a1b06e7$var$gsap.core.suppressOverwrites || $4977a4034a1b06e7$var$_passThrough;
            $4977a4034a1b06e7$var$_scrollRestoration = $4977a4034a1b06e7$var$_win.history.scrollRestoration || "auto";
            $4977a4034a1b06e7$var$_lastScroll = $4977a4034a1b06e7$var$_win.pageYOffset;
            $4977a4034a1b06e7$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($4977a4034a1b06e7$var$_body) {
                $4977a4034a1b06e7$var$_enabled = 1;
                $4977a4034a1b06e7$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $4977a4034a1b06e7$var$_div100vh.style.height = "100vh";
                $4977a4034a1b06e7$var$_div100vh.style.position = "absolute";
                $4977a4034a1b06e7$var$_refresh100vh();
                $4977a4034a1b06e7$var$_rafBugFix();
                (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b).register($4977a4034a1b06e7$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b).isTouch;
                $4977a4034a1b06e7$var$_fixIOSBug = (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $4977a4034a1b06e7$var$_ignoreMobileResize = (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b).isTouch === 1;
                $4977a4034a1b06e7$var$_addListener($4977a4034a1b06e7$var$_win, "wheel", $4977a4034a1b06e7$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $4977a4034a1b06e7$var$_root = [
                    $4977a4034a1b06e7$var$_win,
                    $4977a4034a1b06e7$var$_doc,
                    $4977a4034a1b06e7$var$_docEl,
                    $4977a4034a1b06e7$var$_body
                ];
                if ($4977a4034a1b06e7$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $4977a4034a1b06e7$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $4977a4034a1b06e7$var$gsap.addEventListener("matchMediaInit", function() {
                        return $4977a4034a1b06e7$var$_revertAll();
                    });
                    $4977a4034a1b06e7$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $4977a4034a1b06e7$var$_revertRecorded();
                    });
                    $4977a4034a1b06e7$var$gsap.addEventListener("matchMedia", function() {
                        $4977a4034a1b06e7$var$_refreshAll(0, 1);
                        $4977a4034a1b06e7$var$_dispatch("matchMedia");
                    });
                    $4977a4034a1b06e7$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $4977a4034a1b06e7$var$_setBaseDimensions();
                        return $4977a4034a1b06e7$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $4977a4034a1b06e7$var$_setBaseDimensions();
                $4977a4034a1b06e7$var$_addListener($4977a4034a1b06e7$var$_doc, "scroll", $4977a4034a1b06e7$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $4977a4034a1b06e7$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $4977a4034a1b06e7$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $4977a4034a1b06e7$var$_getBounds($4977a4034a1b06e7$var$_body);
                (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $4977a4034a1b06e7$var$_syncInterval = setInterval($4977a4034a1b06e7$var$_sync, 250);
                $4977a4034a1b06e7$var$gsap.delayedCall(0.5, function() {
                    return $4977a4034a1b06e7$var$_startup = 0;
                });
                $4977a4034a1b06e7$var$_addListener($4977a4034a1b06e7$var$_doc, "touchcancel", $4977a4034a1b06e7$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $4977a4034a1b06e7$var$_addListener($4977a4034a1b06e7$var$_body, "touchstart", $4977a4034a1b06e7$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $4977a4034a1b06e7$var$_multiListener($4977a4034a1b06e7$var$_addListener, $4977a4034a1b06e7$var$_doc, "pointerdown,touchstart,mousedown", $4977a4034a1b06e7$var$_pointerDownHandler);
                $4977a4034a1b06e7$var$_multiListener($4977a4034a1b06e7$var$_addListener, $4977a4034a1b06e7$var$_doc, "pointerup,touchend,mouseup", $4977a4034a1b06e7$var$_pointerUpHandler);
                $4977a4034a1b06e7$var$_transformProp = $4977a4034a1b06e7$var$gsap.utils.checkPrefix("transform");
                $4977a4034a1b06e7$var$_stateProps.push($4977a4034a1b06e7$var$_transformProp);
                $4977a4034a1b06e7$var$_coreInitted = $4977a4034a1b06e7$var$_getTime();
                $4977a4034a1b06e7$var$_resizeDelay = $4977a4034a1b06e7$var$gsap.delayedCall(0.2, $4977a4034a1b06e7$var$_refreshAll).pause();
                $4977a4034a1b06e7$var$_autoRefresh = [
                    $4977a4034a1b06e7$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $4977a4034a1b06e7$var$_win.innerWidth, h = $4977a4034a1b06e7$var$_win.innerHeight;
                        if ($4977a4034a1b06e7$var$_doc.hidden) {
                            $4977a4034a1b06e7$var$_prevWidth = w;
                            $4977a4034a1b06e7$var$_prevHeight = h;
                        } else if ($4977a4034a1b06e7$var$_prevWidth !== w || $4977a4034a1b06e7$var$_prevHeight !== h) $4977a4034a1b06e7$var$_onResize();
                    },
                    $4977a4034a1b06e7$var$_doc,
                    "DOMContentLoaded",
                    $4977a4034a1b06e7$var$_refreshAll,
                    $4977a4034a1b06e7$var$_win,
                    "load",
                    $4977a4034a1b06e7$var$_refreshAll,
                    $4977a4034a1b06e7$var$_win,
                    "resize",
                    $4977a4034a1b06e7$var$_onResize
                ];
                $4977a4034a1b06e7$var$_iterateAutoRefresh($4977a4034a1b06e7$var$_addListener);
                $4977a4034a1b06e7$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).length; i += 3){
                    $4977a4034a1b06e7$var$_wheelListener($4977a4034a1b06e7$var$_removeListener, (0, $920f4bd866a3dda7$export$3cd1cee43d19b683)[i], (0, $920f4bd866a3dda7$export$3cd1cee43d19b683)[i + 1]);
                    $4977a4034a1b06e7$var$_wheelListener($4977a4034a1b06e7$var$_removeListener, (0, $920f4bd866a3dda7$export$3cd1cee43d19b683)[i], (0, $920f4bd866a3dda7$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($4977a4034a1b06e7$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($4977a4034a1b06e7$var$_syncInterval) || ($4977a4034a1b06e7$var$_syncInterval = ms) && setInterval($4977a4034a1b06e7$var$_sync, ms);
        "ignoreMobileResize" in vars && ($4977a4034a1b06e7$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $4977a4034a1b06e7$var$_iterateAutoRefresh($4977a4034a1b06e7$var$_removeListener) || $4977a4034a1b06e7$var$_iterateAutoRefresh($4977a4034a1b06e7$var$_addListener, vars.autoRefreshEvents || "none");
            $4977a4034a1b06e7$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $920f4bd866a3dda7$export$937374fea3f88711)(target), i = (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).indexOf(t), isViewport = $4977a4034a1b06e7$var$_isViewport(t);
        if (~i) (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $920f4bd866a3dda7$export$d8e56d510a804d0a).unshift($4977a4034a1b06e7$var$_win, vars, $4977a4034a1b06e7$var$_body, vars, $4977a4034a1b06e7$var$_docEl, vars) : (0, $920f4bd866a3dda7$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $4977a4034a1b06e7$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($4977a4034a1b06e7$var$_isString(element) ? (0, $920f4bd866a3dda7$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $4977a4034a1b06e7$var$_width : $4977a4034a1b06e7$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $4977a4034a1b06e7$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $4977a4034a1b06e7$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $4977a4034a1b06e7$var$_isString(element) && (element = (0, $920f4bd866a3dda7$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $4977a4034a1b06e7$var$_width : $4977a4034a1b06e7$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $4977a4034a1b06e7$var$_keywords ? $4977a4034a1b06e7$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $4977a4034a1b06e7$var$_win.innerWidth : (bounds.top + offset) / $4977a4034a1b06e7$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $4977a4034a1b06e7$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $4977a4034a1b06e7$var$_listeners.killAll || [];
            $4977a4034a1b06e7$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$4977a4034a1b06e7$export$875bcbe48555930.version = "3.12.5";
$4977a4034a1b06e7$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $4977a4034a1b06e7$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $4977a4034a1b06e7$var$_savedStyles.indexOf(target);
            i >= 0 && $4977a4034a1b06e7$var$_savedStyles.splice(i, 5);
            $4977a4034a1b06e7$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $4977a4034a1b06e7$var$gsap.core.getCache(target), $4977a4034a1b06e7$var$_context());
        }
    }) : $4977a4034a1b06e7$var$_savedStyles;
};
$4977a4034a1b06e7$export$875bcbe48555930.revert = function(soft, media) {
    return $4977a4034a1b06e7$var$_revertAll(!soft, media);
};
$4977a4034a1b06e7$export$875bcbe48555930.create = function(vars, animation) {
    return new $4977a4034a1b06e7$export$875bcbe48555930(vars, animation);
};
$4977a4034a1b06e7$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $4977a4034a1b06e7$var$_onResize() : ($4977a4034a1b06e7$var$_coreInitted || $4977a4034a1b06e7$export$875bcbe48555930.register()) && $4977a4034a1b06e7$var$_refreshAll(true);
};
$4977a4034a1b06e7$export$875bcbe48555930.update = function(force) {
    return ++(0, $920f4bd866a3dda7$export$3cd1cee43d19b683).cache && $4977a4034a1b06e7$var$_updateAll(force === true ? 2 : 0);
};
$4977a4034a1b06e7$export$875bcbe48555930.clearScrollMemory = $4977a4034a1b06e7$var$_clearScrollMemory;
$4977a4034a1b06e7$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $4977a4034a1b06e7$var$_maxScroll(element, horizontal ? (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1) : (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d));
};
$4977a4034a1b06e7$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $920f4bd866a3dda7$export$8665aac53dad5647)((0, $920f4bd866a3dda7$export$937374fea3f88711)(element), horizontal ? (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1) : (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d));
};
$4977a4034a1b06e7$export$875bcbe48555930.getById = function(id) {
    return $4977a4034a1b06e7$var$_ids[id];
};
$4977a4034a1b06e7$export$875bcbe48555930.getAll = function() {
    return $4977a4034a1b06e7$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$4977a4034a1b06e7$export$875bcbe48555930.isScrolling = function() {
    return !!$4977a4034a1b06e7$var$_lastScrollTime;
};
$4977a4034a1b06e7$export$875bcbe48555930.snapDirectional = $4977a4034a1b06e7$var$_snapDirectional;
$4977a4034a1b06e7$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $4977a4034a1b06e7$var$_listeners[type] || ($4977a4034a1b06e7$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$4977a4034a1b06e7$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $4977a4034a1b06e7$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$4977a4034a1b06e7$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $4977a4034a1b06e7$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $4977a4034a1b06e7$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($4977a4034a1b06e7$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $4977a4034a1b06e7$var$_addListener($4977a4034a1b06e7$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $4977a4034a1b06e7$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($4977a4034a1b06e7$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $4977a4034a1b06e7$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $4977a4034a1b06e7$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $4977a4034a1b06e7$var$_docEl && _allowNativePanning($4977a4034a1b06e7$var$_body, direction);
}, $4977a4034a1b06e7$var$_overflow = {
    auto: 1,
    scroll: 1
}, $4977a4034a1b06e7$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $4977a4034a1b06e7$var$gsap.core.getCache(node), time = $4977a4034a1b06e7$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $4977a4034a1b06e7$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($4977a4034a1b06e7$var$_overflow[(cs = $4977a4034a1b06e7$var$_getComputedStyle(node)).overflowY] || $4977a4034a1b06e7$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$4977a4034a1b06e7$var$_isViewport(node) && ($4977a4034a1b06e7$var$_overflow[(cs = $4977a4034a1b06e7$var$_getComputedStyle(node)).overflowY] || $4977a4034a1b06e7$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$4977a4034a1b06e7$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $4977a4034a1b06e7$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $4977a4034a1b06e7$var$_addListener($4977a4034a1b06e7$var$_doc, (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b).eventTypes[0], $4977a4034a1b06e7$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $4977a4034a1b06e7$var$_removeListener($4977a4034a1b06e7$var$_doc, (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b).eventTypes[0], $4977a4034a1b06e7$var$_captureInputs, true);
        }
    });
}, $4977a4034a1b06e7$var$_inputExp = /(input|label|select|textarea)/i, $4977a4034a1b06e7$var$_inputIsFocused, $4977a4034a1b06e7$var$_captureInputs = function _captureInputs(e) {
    var isInput = $4977a4034a1b06e7$var$_inputExp.test(e.target.tagName);
    if (isInput || $4977a4034a1b06e7$var$_inputIsFocused) {
        e._gsapAllow = true;
        $4977a4034a1b06e7$var$_inputIsFocused = isInput;
    }
}, $4977a4034a1b06e7$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $4977a4034a1b06e7$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $920f4bd866a3dda7$export$937374fea3f88711)(vars.target) || $4977a4034a1b06e7$var$_docEl, smoother = $4977a4034a1b06e7$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $4977a4034a1b06e7$var$_fixIOSBug && (vars.content && (0, $920f4bd866a3dda7$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $920f4bd866a3dda7$export$8665aac53dad5647)(target, (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d)), scrollFuncX = (0, $920f4bd866a3dda7$export$8665aac53dad5647)(target, (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b).isTouch && $4977a4034a1b06e7$var$_win.visualViewport ? $4977a4034a1b06e7$var$_win.visualViewport.scale * $4977a4034a1b06e7$var$_win.visualViewport.width : $4977a4034a1b06e7$var$_win.outerWidth) / $4977a4034a1b06e7$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $4977a4034a1b06e7$var$_isFunction(momentum) ? function resolveMomentumDuration() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $4977a4034a1b06e7$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $4977a4034a1b06e7$var$_passThrough, scrollClampY = $4977a4034a1b06e7$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $4977a4034a1b06e7$var$_maxScroll(target, (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d));
        scrollClampY = $4977a4034a1b06e7$var$_clamp($4977a4034a1b06e7$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $4977a4034a1b06e7$var$_clamp(0, $4977a4034a1b06e7$var$_maxScroll(target, (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1))));
        lastRefreshID = $4977a4034a1b06e7$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $4977a4034a1b06e7$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $4977a4034a1b06e7$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $4977a4034a1b06e7$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).cache;
                $4977a4034a1b06e7$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $4977a4034a1b06e7$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $4977a4034a1b06e7$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $4977a4034a1b06e7$var$_round(($4977a4034a1b06e7$var$_win.visualViewport && $4977a4034a1b06e7$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $4977a4034a1b06e7$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $4977a4034a1b06e7$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $920f4bd866a3dda7$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $4977a4034a1b06e7$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $4977a4034a1b06e7$var$_maxScroll(target, (0, $920f4bd866a3dda7$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $4977a4034a1b06e7$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $4977a4034a1b06e7$var$_maxScroll(target, (0, $920f4bd866a3dda7$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($4977a4034a1b06e7$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $4977a4034a1b06e7$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($4977a4034a1b06e7$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $4977a4034a1b06e7$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $4977a4034a1b06e7$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $4977a4034a1b06e7$var$_updateAll();
    };
    vars.onEnable = function() {
        $4977a4034a1b06e7$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $4977a4034a1b06e7$export$875bcbe48555930.addEventListener("refresh", onResize);
        $4977a4034a1b06e7$var$_addListener($4977a4034a1b06e7$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $4977a4034a1b06e7$var$_allowNativePanning(target, true);
        $4977a4034a1b06e7$var$_removeListener($4977a4034a1b06e7$var$_win, "resize", onResize);
        $4977a4034a1b06e7$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $4977a4034a1b06e7$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $4977a4034a1b06e7$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $4977a4034a1b06e7$var$_fixIOSBug && $4977a4034a1b06e7$var$gsap.ticker.add($4977a4034a1b06e7$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $4977a4034a1b06e7$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $4977a4034a1b06e7$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $4977a4034a1b06e7$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$4977a4034a1b06e7$export$875bcbe48555930.sort = function(func) {
    return $4977a4034a1b06e7$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$4977a4034a1b06e7$export$875bcbe48555930.observe = function(vars) {
    return new (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b)(vars);
};
$4977a4034a1b06e7$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $4977a4034a1b06e7$var$_normalizer;
    if (vars === true && $4977a4034a1b06e7$var$_normalizer) return $4977a4034a1b06e7$var$_normalizer.enable();
    if (vars === false) {
        $4977a4034a1b06e7$var$_normalizer && $4977a4034a1b06e7$var$_normalizer.kill();
        $4977a4034a1b06e7$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $920f4bd866a3dda7$export$c1cbdee04e18ea8b) ? vars : $4977a4034a1b06e7$var$_getScrollNormalizer(vars);
    $4977a4034a1b06e7$var$_normalizer && $4977a4034a1b06e7$var$_normalizer.target === normalizer.target && $4977a4034a1b06e7$var$_normalizer.kill();
    $4977a4034a1b06e7$var$_isViewport(normalizer.target) && ($4977a4034a1b06e7$var$_normalizer = normalizer);
    return normalizer;
};
$4977a4034a1b06e7$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $920f4bd866a3dda7$export$5de019f4480f0f8d),
    _inputObserver: $4977a4034a1b06e7$var$_inputObserver,
    _scrollers: (0, $920f4bd866a3dda7$export$3cd1cee43d19b683),
    _proxies: (0, $920f4bd866a3dda7$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $4977a4034a1b06e7$var$_lastScrollTime || $4977a4034a1b06e7$var$_dispatch("scrollStart");
            $4977a4034a1b06e7$var$_lastScrollTime = $4977a4034a1b06e7$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $4977a4034a1b06e7$var$_refreshing;
        }
    }
};
$4977a4034a1b06e7$var$_getGSAP() && $4977a4034a1b06e7$var$gsap.registerPlugin($4977a4034a1b06e7$export$875bcbe48555930);


var $a05981d36a658dfc$exports = {};
function $7417b380464c38c1$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $6194eebaf067e4d1$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $0b881900a1aeb6fe$export$c2c98ac76e997b63(o, p) {
    $0b881900a1aeb6fe$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0b881900a1aeb6fe$export$c2c98ac76e997b63(o, p);
}


function $cdf6b0397ffac486$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $0b881900a1aeb6fe$export$c2c98ac76e997b63)(subClass, superClass);
}


function $67fa0ccdaa4347f0$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $a185b452d3e253f6$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $67fa0ccdaa4347f0$export$79e617b1955a2616)(arr);
}


function $c7ccf52f37db4126$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $e9429c1bd6fe93fb$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $1f1189da1ae074e0$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $67fa0ccdaa4347f0$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $67fa0ccdaa4347f0$export$79e617b1955a2616)(o, minLen);
}


function $eb3e8a8ee265ba96$export$1b5e630bc3aea29f(arr) {
    return (0, $a185b452d3e253f6$export$7e0947b5ad3404e2)(arr) || (0, $c7ccf52f37db4126$export$1eb58a6e75231000)(arr) || (0, $1f1189da1ae074e0$export$a5be06335b3a083c)(arr) || (0, $e9429c1bd6fe93fb$export$e6f3c4780d19eb2b)();
}



var $dvYFb = parcelRequire("dvYFb");
function $5ef16d409dbf6610$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $1b84e43f64f42d09$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $5ef16d409dbf6610$export$685354647fba1516)()) $1b84e43f64f42d09$export$2d841144c5f8c4ab = Reflect.construct;
    else $1b84e43f64f42d09$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $0b881900a1aeb6fe$export$c2c98ac76e997b63)(instance, Class.prototype);
        return instance;
    };
    return $1b84e43f64f42d09$export$2d841144c5f8c4ab.apply(null, arguments);
}


function $f35a8e455e15bfdc$export$f09211a7d3c496a1(o) {
    $f35a8e455e15bfdc$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f35a8e455e15bfdc$export$f09211a7d3c496a1(o);
}


function $1af182b0b4420845$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $cdcde981a6d4bbcf$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $cdcde981a6d4bbcf$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $1af182b0b4420845$export$514eda94019f4334)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $1b84e43f64f42d09$export$2d841144c5f8c4ab)(Class, arguments, (0, $f35a8e455e15bfdc$export$f09211a7d3c496a1)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $0b881900a1aeb6fe$export$c2c98ac76e997b63)(Wrapper, Class);
    };
    return $cdcde981a6d4bbcf$export$2466d533fda16e33(Class);
}




function $611fea1b3c02f9bd$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $dvYFb = parcelRequire("dvYFb");
function $d463395515ae1209$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $dvYFb._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $611fea1b3c02f9bd$export$f3b8ed2e4a5d10b8)(self);
}


function $df57a1ce707e56d0$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $5ef16d409dbf6610$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $f35a8e455e15bfdc$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $f35a8e455e15bfdc$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $d463395515ae1209$export$ef97c660ca164e52)(this, result);
    };
}


(function webpackUniversalModuleDefinition(root, factory) {
    $a05981d36a658dfc$exports = factory();
})(undefined, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return __WEBPACK_DEFAULT_EXPORT__;
                    }
                });
                var Rive = function() {
                    var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : undefined;
                    return function() {
                        var moduleArg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        var h = moduleArg, aa, ba;
                        h.ready = new Promise(function(b, a) {
                            aa = b;
                            ba = a;
                        });
                        function ca() {
                            function b(m) {
                                var l = d;
                                c = a = 0;
                                d = new Map;
                                l.forEach(function(n) {
                                    try {
                                        n(m);
                                    } catch (k) {
                                        console.error(k);
                                    }
                                });
                                this.hb();
                                e && e.Fb();
                            }
                            var a = 0, c = 0, d = new Map, e = null, g = null;
                            this.requestAnimationFrame = function(m) {
                                a || (a = requestAnimationFrame(b.bind(this)));
                                var l = ++c;
                                d.set(l, m);
                                return l;
                            };
                            this.cancelAnimationFrame = function(m) {
                                d.delete(m);
                                a && 0 == d.size && (cancelAnimationFrame(a), a = 0);
                            };
                            this.Db = function(m) {
                                g && (document.body.remove(g), g = null);
                                m || (g = document.createElement("div"), g.style.backgroundColor = "black", g.style.position = "fixed", g.style.right = 0, g.style.top = 0, g.style.color = "white", g.style.padding = "4px", g.innerHTML = "RIVE FPS", m = function m(l) {
                                    g.innerHTML = "RIVE FPS " + l.toFixed(1);
                                }, document.body.appendChild(g));
                                e = new function() {
                                    var l = 0, n = 0;
                                    this.Fb = function() {
                                        var k = performance.now();
                                        n ? (++l, k -= n, 1E3 < k && (m(1E3 * l / k), l = n = 0)) : (n = k, l = 0);
                                    };
                                };
                            };
                            this.Ab = function() {
                                g && (document.body.remove(g), g = null);
                                e = null;
                            };
                            this.hb = function() {};
                        }
                        function da(b) {
                            console.assert(!0);
                            var a = new Map;
                            var c = -Infinity;
                            this.push = function(d) {
                                d = d + ((1 << b) - 1) >> b;
                                a.has(d) && clearTimeout(a.get(d));
                                a.set(d, setTimeout(function() {
                                    var _Math;
                                    a.delete(d);
                                    0 == a.length ? c = -Infinity : d == c && (c = (_Math = Math).max.apply(_Math, (0, $eb3e8a8ee265ba96$export$1b5e630bc3aea29f)(a.keys())), console.assert(c < d));
                                }, 1E3));
                                c = Math.max(d, c);
                                return c << b;
                            };
                        }
                        var ea = "createConicGradient createImageData createLinearGradient createPattern createRadialGradient getContextAttributes getImageData getLineDash getTransform isContextLost isPointInPath isPointInStroke measureText".split(" "), fa = new function() {
                            function b() {
                                if (!a) {
                                    var G = function G(D, u, I) {
                                        u = q.createShader(u);
                                        q.shaderSource(u, I);
                                        q.compileShader(u);
                                        I = q.getShaderInfoLog(u);
                                        if (0 < (I || "").length) throw I;
                                        q.attachShader(D, u);
                                    };
                                    var f = document.createElement("canvas"), r = {
                                        alpha: 1,
                                        depth: 0,
                                        stencil: 0,
                                        antialias: 0,
                                        premultipliedAlpha: 1,
                                        preserveDrawingBuffer: 0,
                                        preferLowPowerToHighPerformance: 0,
                                        failIfMajorPerformanceCaveat: 0,
                                        enableExtensionsByDefault: 1,
                                        explicitSwapControl: 1,
                                        renderViaOffscreenBackBuffer: 1
                                    };
                                    var q;
                                    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                                        if (q = f.getContext("webgl", r), c = 1, !q) return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    } else if (q = f.getContext("webgl2", r)) c = 2;
                                    else if (q = f.getContext("webgl", r)) c = 1;
                                    else return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    q = new Proxy(q, {
                                        get: function(D, u) {
                                            if (D.isContextLost()) {
                                                if (n || (console.error("Cannot render the mesh because the GL Context was lost. Tried to invoke ", u), n = !0), "function" === typeof D[u]) return function() {};
                                            } else return "function" === typeof D[u] ? function() {
                                                for(var _len = arguments.length, I = new Array(_len), _key = 0; _key < _len; _key++){
                                                    I[_key] = arguments[_key];
                                                }
                                                return D[u].apply(D, I);
                                            } : D[u];
                                        },
                                        set: function(D, u, I) {
                                            if (D.isContextLost()) n || (console.error("Cannot render the mesh because the GL Context was lost. Tried to set property " + u), n = !0);
                                            else return D[u] = I, !0;
                                        }
                                    });
                                    d = Math.min(q.getParameter(q.MAX_RENDERBUFFER_SIZE), q.getParameter(q.MAX_TEXTURE_SIZE));
                                    f = q.createProgram();
                                    G(f, q.VERTEX_SHADER, "attribute vec2 vertex;\n                attribute vec2 uv;\n                uniform vec4 mat;\n                uniform vec2 translate;\n                varying vec2 st;\n                void main() {\n                    st = uv;\n                    gl_Position = vec4(mat2(mat) * vertex + translate, 0, 1);\n                }");
                                    G(f, q.FRAGMENT_SHADER, "precision highp float;\n                uniform sampler2D image;\n                varying vec2 st;\n                void main() {\n                    gl_FragColor = texture2D(image, st);\n                }");
                                    q.bindAttribLocation(f, 0, "vertex");
                                    q.bindAttribLocation(f, 1, "uv");
                                    q.linkProgram(f);
                                    r = q.getProgramInfoLog(f);
                                    if (0 < (r || "").trim().length) throw r;
                                    e = q.getUniformLocation(f, "mat");
                                    g = q.getUniformLocation(f, "translate");
                                    q.useProgram(f);
                                    q.bindBuffer(q.ARRAY_BUFFER, q.createBuffer());
                                    q.enableVertexAttribArray(0);
                                    q.enableVertexAttribArray(1);
                                    q.bindBuffer(q.ELEMENT_ARRAY_BUFFER, q.createBuffer());
                                    q.uniform1i(q.getUniformLocation(f, "image"), 0);
                                    q.pixelStorei(q.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0);
                                    a = q;
                                }
                                return !0;
                            }
                            var a = null, c = 0, d = 0, e = null, g = null, m = 0, l = 0, n = !1;
                            b();
                            this.Ob = function() {
                                b();
                                return d;
                            };
                            this.yb = function(f) {
                                a.deleteTexture && a.deleteTexture(f);
                            };
                            this.wb = function(f) {
                                if (!b()) return null;
                                var r = a.createTexture();
                                if (!r) return null;
                                a.bindTexture(a.TEXTURE_2D, r);
                                a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, f);
                                a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE);
                                a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE);
                                a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, a.LINEAR);
                                2 == c ? (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR_MIPMAP_LINEAR), a.generateMipmap(a.TEXTURE_2D)) : a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR);
                                return r;
                            };
                            var k = new da(8), t = new da(8), v = new da(10), x = new da(10);
                            this.Cb = function(f, r, q, G, D) {
                                if (b()) {
                                    var u = k.push(f), I = t.push(r);
                                    if (a.canvas) {
                                        if (a.canvas.width != u || a.canvas.height != I) a.canvas.width = u, a.canvas.height = I;
                                        a.viewport(0, I - r, f, r);
                                        a.disable(a.SCISSOR_TEST);
                                        a.clearColor(0, 0, 0, 0);
                                        a.clear(a.COLOR_BUFFER_BIT);
                                        a.enable(a.SCISSOR_TEST);
                                        q.sort(function(A, W) {
                                            return W.lb - A.lb;
                                        });
                                        u = v.push(G);
                                        m != u && (a.bufferData(a.ARRAY_BUFFER, 8 * u, a.DYNAMIC_DRAW), m = u);
                                        u = 0;
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = q[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var O = _step.value;
                                                a.bufferSubData(a.ARRAY_BUFFER, u, O.Sa), u += 4 * O.Sa.length;
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        console.assert(u == 4 * G);
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = q[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var X = _step1.value;
                                                a.bufferSubData(a.ARRAY_BUFFER, u, X.ob), u += 4 * X.ob.length;
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                        console.assert(u == 8 * G);
                                        u = x.push(D);
                                        l != u && (a.bufferData(a.ELEMENT_ARRAY_BUFFER, 2 * u, a.DYNAMIC_DRAW), l = u);
                                        O = 0;
                                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                        try {
                                            for(var _iterator2 = q[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                var ia = _step2.value;
                                                a.bufferSubData(a.ELEMENT_ARRAY_BUFFER, O, ia.indices), O += 2 * ia.indices.length;
                                            }
                                        } catch (err) {
                                            _didIteratorError2 = true;
                                            _iteratorError2 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                    _iterator2.return();
                                                }
                                            } finally{
                                                if (_didIteratorError2) {
                                                    throw _iteratorError2;
                                                }
                                            }
                                        }
                                        console.assert(O == 2 * D);
                                        ia = 0;
                                        X = !0;
                                        u = O = 0;
                                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                        try {
                                            for(var _iterator3 = q[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                                var A = _step3.value;
                                                A.image.Na != ia && (a.bindTexture(a.TEXTURE_2D, A.image.Ma || null), ia = A.image.Na);
                                                A.Rb ? (a.scissor(A.Xa, I - A.Ya - A.fb, A.bc, A.fb), X = !0) : X && (a.scissor(0, I - r, f, r), X = !1);
                                                q = 2 / f;
                                                var W = -2 / r;
                                                a.uniform4f(e, A.xa[0] * q * A.Ga, A.xa[1] * W * A.Ha, A.xa[2] * q * A.Ga, A.xa[3] * W * A.Ha);
                                                a.uniform2f(g, A.xa[4] * q * A.Ga + q * (A.Xa - A.Pb * A.Ga) - 1, A.xa[5] * W * A.Ha + W * (A.Ya - A.Qb * A.Ha) + 1);
                                                a.vertexAttribPointer(0, 2, a.FLOAT, !1, 0, u);
                                                a.vertexAttribPointer(1, 2, a.FLOAT, !1, 0, u + 4 * G);
                                                a.drawElements(a.TRIANGLES, A.indices.length, a.UNSIGNED_SHORT, O);
                                                u += 4 * A.Sa.length;
                                                O += 2 * A.indices.length;
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                    _iterator3.return();
                                                }
                                            } finally{
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                        console.assert(u == 4 * G);
                                        console.assert(O == 2 * D);
                                    }
                                }
                            };
                            this.canvas = function() {
                                return b() && a.canvas;
                            };
                        }, ha = h.onRuntimeInitialized;
                        h.onRuntimeInitialized = function() {
                            function b(p) {
                                switch(p){
                                    case k.srcOver:
                                        return "source-over";
                                    case k.screen:
                                        return "screen";
                                    case k.overlay:
                                        return "overlay";
                                    case k.darken:
                                        return "darken";
                                    case k.lighten:
                                        return "lighten";
                                    case k.colorDodge:
                                        return "color-dodge";
                                    case k.colorBurn:
                                        return "color-burn";
                                    case k.hardLight:
                                        return "hard-light";
                                    case k.softLight:
                                        return "soft-light";
                                    case k.difference:
                                        return "difference";
                                    case k.exclusion:
                                        return "exclusion";
                                    case k.multiply:
                                        return "multiply";
                                    case k.hue:
                                        return "hue";
                                    case k.saturation:
                                        return "saturation";
                                    case k.color:
                                        return "color";
                                    case k.luminosity:
                                        return "luminosity";
                                }
                            }
                            function a(p) {
                                return "rgba(" + ((16711680 & p) >>> 16) + "," + ((65280 & p) >>> 8) + "," + ((255 & p) >>> 0) + "," + ((4278190080 & p) >>> 24) / 255 + ")";
                            }
                            function c() {
                                0 < I.length && (fa.Cb(u.drawWidth(), u.drawHeight(), I, O, X), I = [], X = O = 0, u.reset(512, 512));
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = D[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var p = _step.value;
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = p.ja[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var w = _step1.value;
                                                w();
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                        p.ja = [];
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                D.clear();
                            }
                            ha && ha();
                            var d = h.RenderPaintStyle;
                            var e = h.RenderPath, g = h.RenderPaint, m = h.Renderer, l = h.StrokeCap, n = h.StrokeJoin, k = h.BlendMode, t = d.fill, v = d.stroke, x = h.FillRule.evenOdd;
                            var f = 1;
                            var r = h.RenderImage.extend("CanvasRenderImage", {
                                __construct: function __construct() {
                                    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, p = _ref.Aa, w = _ref.Fa;
                                    this.__parent.__construct.call(this);
                                    this.Na = f;
                                    f = f + 1 & 2147483647 || 1;
                                    this.Aa = p;
                                    this.Fa = w;
                                },
                                __destruct: function __destruct() {
                                    this.Ma && (fa.yb(this.Ma), URL.revokeObjectURL(this.Va));
                                    this.__parent.__destruct.call(this);
                                },
                                decode: function decode(p) {
                                    var w = this;
                                    w.Fa && w.Fa(w);
                                    var B = new Image;
                                    w.Va = URL.createObjectURL(new Blob([
                                        p
                                    ], {
                                        type: "image/png"
                                    }));
                                    B.src = w.Va;
                                    B.onload = function() {
                                        w.qb = B;
                                        w.Ma = fa.wb(B);
                                        w.size(B.width, B.height);
                                        w.Aa && w.Aa(w);
                                    };
                                }
                            }), q = e.extend("CanvasRenderPath", {
                                __construct: function __construct() {
                                    this.__parent.__construct.call(this);
                                    this.pa = new Path2D;
                                },
                                rewind: function rewind() {
                                    this.pa = new Path2D;
                                },
                                addPath: function addPath(p, w, B, C, z, E, F) {
                                    var H = this.pa, T = H.addPath;
                                    p = p.pa;
                                    var K = new DOMMatrix;
                                    K.a = w;
                                    K.b = B;
                                    K.c = C;
                                    K.d = z;
                                    K.e = E;
                                    K.f = F;
                                    T.call(H, p, K);
                                },
                                fillRule: function fillRule(p) {
                                    this.Ua = p;
                                },
                                moveTo: function moveTo(p, w) {
                                    this.pa.moveTo(p, w);
                                },
                                lineTo: function lineTo(p, w) {
                                    this.pa.lineTo(p, w);
                                },
                                cubicTo: function cubicTo(p, w, B, C, z, E) {
                                    this.pa.bezierCurveTo(p, w, B, C, z, E);
                                },
                                close: function close() {
                                    this.pa.closePath();
                                }
                            }), G = g.extend("CanvasRenderPaint", {
                                color: function color(p) {
                                    this.Wa = a(p);
                                },
                                thickness: function thickness(p) {
                                    this.tb = p;
                                },
                                join: function join(p) {
                                    switch(p){
                                        case n.miter:
                                            this.La = "miter";
                                            break;
                                        case n.round:
                                            this.La = "round";
                                            break;
                                        case n.bevel:
                                            this.La = "bevel";
                                    }
                                },
                                cap: function cap(p) {
                                    switch(p){
                                        case l.butt:
                                            this.Ka = "butt";
                                            break;
                                        case l.round:
                                            this.Ka = "round";
                                            break;
                                        case l.square:
                                            this.Ka = "square";
                                    }
                                },
                                style: function style(p) {
                                    this.sb = p;
                                },
                                blendMode: function blendMode(p) {
                                    this.pb = b(p);
                                },
                                clearGradient: function clearGradient() {
                                    this.za = null;
                                },
                                linearGradient: function linearGradient(p, w, B, C) {
                                    this.za = {
                                        mb: p,
                                        nb: w,
                                        ab: B,
                                        bb: C,
                                        Qa: []
                                    };
                                },
                                radialGradient: function radialGradient(p, w, B, C) {
                                    this.za = {
                                        mb: p,
                                        nb: w,
                                        ab: B,
                                        bb: C,
                                        Qa: [],
                                        Mb: !0
                                    };
                                },
                                addStop: function addStop(p, w) {
                                    this.za.Qa.push({
                                        color: p,
                                        stop: w
                                    });
                                },
                                completeGradient: function completeGradient() {},
                                draw: function draw(p, w, B) {
                                    var C = this.sb;
                                    var z = this.Wa, E = this.za;
                                    p.globalCompositeOperation = this.pb;
                                    if (null != E) {
                                        z = E.mb;
                                        var F = E.nb;
                                        var T = E.ab;
                                        var H = E.bb;
                                        var K = E.Qa;
                                        E.Mb ? (E = T - z, H -= F, z = p.createRadialGradient(z, F, 0, z, F, Math.sqrt(E * E + H * H))) : z = p.createLinearGradient(z, F, T, H);
                                        for(var Y = 0, N = K.length; Y < N; Y++)F = K[Y], z.addColorStop(F.stop, a(F.color));
                                        this.Wa = z;
                                        this.za = null;
                                    }
                                    switch(C){
                                        case v:
                                            p.strokeStyle = z;
                                            p.lineWidth = this.tb;
                                            p.lineCap = this.Ka;
                                            p.lineJoin = this.La;
                                            p.stroke(w);
                                            break;
                                        case t:
                                            p.fillStyle = z, p.fill(w, B);
                                    }
                                }
                            });
                            var D = new Set;
                            var u = null, I = [], O = 0, X = 0;
                            var ia = h.CanvasRenderer = m.extend("Renderer", {
                                __construct: function __construct(p) {
                                    this.__parent.__construct.call(this);
                                    this.oa = [
                                        1,
                                        0,
                                        0,
                                        1,
                                        0,
                                        0
                                    ];
                                    this.ha = p.getContext("2d");
                                    this.Ta = p;
                                    this.ja = [];
                                },
                                save: function save() {
                                    var _this_oa;
                                    (_this_oa = this.oa).push.apply(_this_oa, (0, $eb3e8a8ee265ba96$export$1b5e630bc3aea29f)(this.oa.slice(this.oa.length - 6)));
                                    this.ja.push(this.ha.save.bind(this.ha));
                                },
                                restore: function restore() {
                                    var p = this.oa.length - 6;
                                    if (6 > p) throw "restore() called without matching save().";
                                    this.oa.splice(p);
                                    this.ja.push(this.ha.restore.bind(this.ha));
                                },
                                transform: function transform(p, w, B, C, z, E) {
                                    var F = this.oa, H = F.length - 6;
                                    F.splice(H, 6, F[H] * p + F[H + 2] * w, F[H + 1] * p + F[H + 3] * w, F[H] * B + F[H + 2] * C, F[H + 1] * B + F[H + 3] * C, F[H] * z + F[H + 2] * E + F[H + 4], F[H + 1] * z + F[H + 3] * E + F[H + 5]);
                                    this.ja.push(this.ha.transform.bind(this.ha, p, w, B, C, z, E));
                                },
                                rotate: function rotate(p) {
                                    var w = Math.sin(p);
                                    p = Math.cos(p);
                                    this.transform(p, w, -w, p, 0, 0);
                                },
                                _drawPath: function _drawPath(p, w) {
                                    this.ja.push(w.draw.bind(w, this.ha, p.pa, p.Ua === x ? "evenodd" : "nonzero"));
                                },
                                _drawRiveImage: function _drawRiveImage(p, w, B) {
                                    var C = p.qb;
                                    if (C) {
                                        var z = this.ha, E = b(w);
                                        this.ja.push(function() {
                                            z.globalCompositeOperation = E;
                                            z.globalAlpha = B;
                                            z.drawImage(C, 0, 0);
                                            z.globalAlpha = 1;
                                        });
                                    }
                                },
                                _getMatrix: function _getMatrix(p) {
                                    var w = this.oa, B = w.length - 6;
                                    for(var C = 0; 6 > C; ++C)p[C] = w[B + C];
                                },
                                _drawImageMesh: function _drawImageMesh(p, w, B, C, z, E, F, H, T, K) {
                                    var Y = this.ha.canvas.width, N = this.ha.canvas.height;
                                    var sb = T - F, tb = K - H;
                                    F = Math.max(F, 0);
                                    H = Math.max(H, 0);
                                    T = Math.min(T, Y);
                                    K = Math.min(K, N);
                                    var wa = T - F, xa = K - H;
                                    console.assert(wa <= Math.min(sb, Y));
                                    console.assert(xa <= Math.min(tb, N));
                                    if (!(0 >= wa || 0 >= xa)) {
                                        T = wa < sb || xa < tb;
                                        Y = K = 1;
                                        var ja = Math.ceil(wa * K), ka = Math.ceil(xa * Y);
                                        N = fa.Ob();
                                        ja > N && (K *= N / ja, ja = N);
                                        ka > N && (Y *= N / ka, ka = N);
                                        u || (u = new h.DynamicRectanizer(N), u.reset(512, 512));
                                        N = u.addRect(ja, ka);
                                        0 > N && (c(), D.add(this), N = u.addRect(ja, ka), console.assert(0 <= N));
                                        var ub = N & 65535, vb = N >> 16;
                                        I.push({
                                            xa: this.oa.slice(this.oa.length - 6),
                                            image: p,
                                            Xa: ub,
                                            Ya: vb,
                                            Pb: F,
                                            Qb: H,
                                            bc: ja,
                                            fb: ka,
                                            Ga: K,
                                            Ha: Y,
                                            Sa: new Float32Array(C),
                                            ob: new Float32Array(z),
                                            indices: new Uint16Array(E),
                                            Rb: T,
                                            lb: p.Na << 1 | (T ? 1 : 0)
                                        });
                                        O += C.length;
                                        X += E.length;
                                        var pa = this.ha, lc = b(w);
                                        this.ja.push(function() {
                                            pa.save();
                                            pa.resetTransform();
                                            pa.globalCompositeOperation = lc;
                                            pa.globalAlpha = B;
                                            var wb = fa.canvas();
                                            wb && pa.drawImage(wb, ub, vb, ja, ka, F, H, wa, xa);
                                            pa.restore();
                                        });
                                    }
                                },
                                _clipPath: function _clipPath(p) {
                                    this.ja.push(this.ha.clip.bind(this.ha, p.pa, p.Ua === x ? "evenodd" : "nonzero"));
                                },
                                clear: function clear() {
                                    D.add(this);
                                    this.ja.push(this.ha.clearRect.bind(this.ha, 0, 0, this.Ta.width, this.Ta.height));
                                },
                                flush: function flush() {},
                                translate: function translate(p, w) {
                                    this.transform(1, 0, 0, 1, p, w);
                                }
                            });
                            h.makeRenderer = function(p) {
                                var w = new ia(p), B = w.ha;
                                return new Proxy(w, {
                                    get: function(C, z) {
                                        if ("function" === typeof C[z]) return function() {
                                            for(var _len = arguments.length, E = new Array(_len), _key = 0; _key < _len; _key++){
                                                E[_key] = arguments[_key];
                                            }
                                            return C[z].apply(C, E);
                                        };
                                        if ("function" === typeof B[z]) {
                                            if (-1 < ea.indexOf(z)) throw Error("RiveException: Method call to '" + z + "()' is not allowed, as the renderer cannot immediately pass through the return                 values of any canvas 2d context methods.");
                                            return function() {
                                                for(var _len = arguments.length, E = new Array(_len), _key = 0; _key < _len; _key++){
                                                    E[_key] = arguments[_key];
                                                }
                                                var _B_z;
                                                w.ja.push((_B_z = B[z]).bind.apply(_B_z, [
                                                    B
                                                ].concat((0, $eb3e8a8ee265ba96$export$1b5e630bc3aea29f)(E))));
                                            };
                                        }
                                        return C[z];
                                    },
                                    set: function(C, z, E) {
                                        if (z in B) return B[z] = E, !0;
                                    }
                                });
                            };
                            h.decodeImage = function(p, w) {
                                new r({
                                    Aa: w
                                }).decode(p);
                            };
                            h.renderFactory = {
                                makeRenderPaint: function makeRenderPaint() {
                                    return new G;
                                },
                                makeRenderPath: function makeRenderPath() {
                                    return new q;
                                },
                                makeRenderImage: function makeRenderImage() {
                                    var p = W;
                                    return new r({
                                        Fa: function() {
                                            p.total++;
                                        },
                                        Aa: function() {
                                            p.loaded++;
                                            if (p.loaded === p.total) {
                                                var w = p.ready;
                                                w && (w(), p.ready = null);
                                            }
                                        }
                                    });
                                }
                            };
                            var A = h.load, W = null;
                            h.load = function(p, w) {
                                var B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                                var C = new h.FallbackFileAssetLoader;
                                void 0 !== w && C.addLoader(w);
                                B && (w = new h.CDNFileAssetLoader, C.addLoader(w));
                                return new Promise(function(z) {
                                    var E = null;
                                    W = {
                                        total: 0,
                                        loaded: 0,
                                        ready: function ready() {
                                            z(E);
                                        }
                                    };
                                    E = A(p, C);
                                    0 == W.total && z(E);
                                });
                            };
                            d = new ca;
                            h.requestAnimationFrame = d.requestAnimationFrame.bind(d);
                            h.cancelAnimationFrame = d.cancelAnimationFrame.bind(d);
                            h.enableFPSCounter = d.Db.bind(d);
                            h.disableFPSCounter = d.Ab;
                            d.hb = c;
                            h.resolveAnimationFrame = c;
                            h.cleanup = function() {
                                u && u.delete();
                            };
                        };
                        var la = h.onRuntimeInitialized;
                        h.onRuntimeInitialized = function() {
                            la && la();
                            var b = h.decodeFont;
                            h.decodeFont = function(c, d) {
                                c = b(c);
                                d(c);
                            };
                            var a = h.FileAssetLoader;
                            h.ptrToAsset = function(c) {
                                var d = h.ptrToFileAsset(c);
                                return d.isImage ? h.ptrToImageAsset(c) : d.isFont ? h.ptrToFontAsset(c) : d;
                            };
                            h.CustomFileAssetLoader = a.extend("CustomFileAssetLoader", {
                                __construct: function __construct(param) {
                                    var c = param.loadContents;
                                    this.__parent.__construct.call(this);
                                    this.rb = c;
                                },
                                loadContents: function loadContents(c, d) {
                                    c = h.ptrToAsset(c);
                                    return this.rb(c, d);
                                }
                            });
                            h.CDNFileAssetLoader = a.extend("CDNFileAssetLoader", {
                                __construct: function __construct() {
                                    this.__parent.__construct.call(this);
                                },
                                loadContents: function loadContents(c) {
                                    var d = h.ptrToAsset(c);
                                    c = d.cdnUuid;
                                    if ("" === c) return !1;
                                    (function(e, g) {
                                        var m = new XMLHttpRequest;
                                        m.responseType = "arraybuffer";
                                        m.onreadystatechange = function() {
                                            4 == m.readyState && 200 == m.status && g(m);
                                        };
                                        m.open("GET", e, !0);
                                        m.send(null);
                                    })(d.cdnBaseUrl + "/" + c, function(e) {
                                        d.decode(new Uint8Array(e.response));
                                    });
                                    return !0;
                                }
                            });
                            h.FallbackFileAssetLoader = a.extend("FallbackFileAssetLoader", {
                                __construct: function __construct() {
                                    this.__parent.__construct.call(this);
                                    this.gb = [];
                                },
                                addLoader: function addLoader(c) {
                                    this.gb.push(c);
                                },
                                loadContents: function loadContents(c, d) {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = this.gb[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var e = _step.value;
                                            if (e.loadContents(c, d)) return !0;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return !1;
                                }
                            });
                        };
                        var ma = Object.assign({}, h), na = "./this.program", oa = "object" == typeof window, qa = "function" == typeof importScripts, y = "", ra, sa;
                        if (oa || qa) qa ? y = self.location.href : "undefined" != typeof document && document.currentScript && (y = document.currentScript.src), _scriptDir && (y = _scriptDir), 0 !== y.indexOf("blob:") ? y = y.substr(0, y.replace(/[?#].*/, "").lastIndexOf("/") + 1) : y = "", qa && (sa = function(b) {
                            var a = new XMLHttpRequest;
                            a.open("GET", b, !1);
                            a.responseType = "arraybuffer";
                            a.send(null);
                            return new Uint8Array(a.response);
                        }), ra = function(b, a, c) {
                            var d = new XMLHttpRequest;
                            d.open("GET", b, !0);
                            d.responseType = "arraybuffer";
                            d.onload = function() {
                                200 == d.status || 0 == d.status && d.response ? a(d.response) : c();
                            };
                            d.onerror = c;
                            d.send(null);
                        };
                        var ta = h.print || console.log.bind(console), ua = h.printErr || console.error.bind(console);
                        Object.assign(h, ma);
                        ma = null;
                        h.thisProgram && (na = h.thisProgram);
                        var va;
                        h.wasmBinary && (va = h.wasmBinary);
                        var noExitRuntime = h.noExitRuntime || !0;
                        "object" != typeof WebAssembly && ya("no native wasm support detected");
                        var za, J, Aa = !1, Ba, L, Ca, Da, M, P, Ea, Fa;
                        function Ga() {
                            var b = za.buffer;
                            h.HEAP8 = Ba = new Int8Array(b);
                            h.HEAP16 = Ca = new Int16Array(b);
                            h.HEAP32 = M = new Int32Array(b);
                            h.HEAPU8 = L = new Uint8Array(b);
                            h.HEAPU16 = Da = new Uint16Array(b);
                            h.HEAPU32 = P = new Uint32Array(b);
                            h.HEAPF32 = Ea = new Float32Array(b);
                            h.HEAPF64 = Fa = new Float64Array(b);
                        }
                        var Ha, Ia = [], Ja = [], Ka = [];
                        function La() {
                            var b = h.preRun.shift();
                            Ia.unshift(b);
                        }
                        var Ma = 0, Na = null, Oa = null;
                        function ya(b) {
                            if (h.onAbort) h.onAbort(b);
                            b = "Aborted(" + b + ")";
                            ua(b);
                            Aa = !0;
                            b = new WebAssembly.RuntimeError(b + ". Build with -sASSERTIONS for more info.");
                            ba(b);
                            throw b;
                        }
                        function Pa(b) {
                            return b.startsWith("data:application/octet-stream;base64,");
                        }
                        var Qa;
                        Qa = "canvas_advanced.wasm";
                        if (!Pa(Qa)) {
                            var Ra = Qa;
                            Qa = h.locateFile ? h.locateFile(Ra, y) : y + Ra;
                        }
                        function Sa(b) {
                            if (b == Qa && va) return new Uint8Array(va);
                            if (sa) return sa(b);
                            throw "both async and sync fetching of the wasm failed";
                        }
                        function Ta(b) {
                            if (!va && (oa || qa)) {
                                if ("function" == typeof fetch && !b.startsWith("file://")) return fetch(b, {
                                    credentials: "same-origin"
                                }).then(function(a) {
                                    if (!a.ok) throw "failed to load wasm binary file at '" + b + "'";
                                    return a.arrayBuffer();
                                }).catch(function() {
                                    return Sa(b);
                                });
                                if (ra) return new Promise(function(a, c) {
                                    ra(b, function(d) {
                                        return a(new Uint8Array(d));
                                    }, c);
                                });
                            }
                            return Promise.resolve().then(function() {
                                return Sa(b);
                            });
                        }
                        function Ua(b, a, c) {
                            return Ta(b).then(function(d) {
                                return WebAssembly.instantiate(d, a);
                            }).then(function(d) {
                                return d;
                            }).then(c, function(d) {
                                ua("failed to asynchronously prepare wasm: " + d);
                                ya(d);
                            });
                        }
                        function Va(b, a) {
                            var c = Qa;
                            return va || "function" != typeof WebAssembly.instantiateStreaming || Pa(c) || c.startsWith("file://") || "function" != typeof fetch ? Ua(c, b, a) : fetch(c, {
                                credentials: "same-origin"
                            }).then(function(d) {
                                return WebAssembly.instantiateStreaming(d, b).then(a, function(e) {
                                    ua("wasm streaming compile failed: " + e);
                                    ua("falling back to ArrayBuffer instantiation");
                                    return Ua(c, b, a);
                                });
                            });
                        }
                        var Wa = function(b) {
                            for(; 0 < b.length;)b.shift()(h);
                        };
                        function Xa(b) {
                            if (void 0 === b) return "_unknown";
                            b = b.replace(/[^a-zA-Z0-9_]/g, "$");
                            var a = b.charCodeAt(0);
                            return 48 <= a && 57 >= a ? "_".concat(b) : b;
                        }
                        function Ya(b, a) {
                            b = Xa(b);
                            return (0, $6194eebaf067e4d1$export$1e71eb4bef00f6b0)({}, b, function() {
                                return a.apply(this, arguments);
                            })[b];
                        }
                        function Za() {
                            this.qa = [
                                void 0
                            ];
                            this.eb = [];
                        }
                        var Q = new Za, $a = void 0;
                        function R(b) {
                            throw new $a(b);
                        }
                        var S = function(b) {
                            b || R("Cannot use deleted val. handle = " + b);
                            return Q.get(b).value;
                        }, ab = function(b) {
                            switch(b){
                                case void 0:
                                    return 1;
                                case null:
                                    return 2;
                                case !0:
                                    return 3;
                                case !1:
                                    return 4;
                                default:
                                    return Q.ub({
                                        kb: 1,
                                        value: b
                                    });
                            }
                        };
                        function bb(b) {
                            var a = Error, c = Ya(b, function(d) {
                                this.name = b;
                                this.message = d;
                                d = Error(d).stack;
                                void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
                            });
                            c.prototype = Object.create(a.prototype);
                            c.prototype.constructor = c;
                            c.prototype.toString = function() {
                                return void 0 === this.message ? this.name : "".concat(this.name, ": ").concat(this.message);
                            };
                            return c;
                        }
                        var cb = void 0, db = void 0;
                        function U(b) {
                            for(var a = ""; L[b];)a += db[L[b++]];
                            return a;
                        }
                        var eb = [];
                        function fb() {
                            for(; eb.length;){
                                var b = eb.pop();
                                b.ba.wa = !1;
                                b["delete"]();
                            }
                        }
                        var gb = void 0, hb = {};
                        function ib(b, a) {
                            for(void 0 === a && R("ptr should not be undefined"); b.fa;)a = b.Ba(a), b = b.fa;
                            return a;
                        }
                        var jb = {};
                        function kb(b) {
                            b = lb(b);
                            var a = U(b);
                            mb(b);
                            return a;
                        }
                        function nb(b, a) {
                            var c = jb[b];
                            void 0 === c && R(a + " has unknown type " + kb(b));
                            return c;
                        }
                        function ob() {}
                        var pb = !1;
                        function qb(b) {
                            --b.count.value;
                            0 === b.count.value && (b.ia ? b.la.ra(b.ia) : b.ea.ca.ra(b.da));
                        }
                        function rb(b, a, c) {
                            if (a === c) return b;
                            if (void 0 === c.fa) return null;
                            b = rb(b, a, c.fa);
                            return null === b ? null : c.Bb(b);
                        }
                        var xb = {};
                        function yb(b, a) {
                            a = ib(b, a);
                            return hb[a];
                        }
                        var zb = void 0;
                        function Ab(b) {
                            throw new zb(b);
                        }
                        function Bb(b, a) {
                            a.ea && a.da || Ab("makeClassHandle requires ptr and ptrType");
                            !!a.la !== !!a.ia && Ab("Both smartPtrType and smartPtr must be specified");
                            a.count = {
                                value: 1
                            };
                            return Cb(Object.create(b, {
                                ba: {
                                    value: a
                                }
                            }));
                        }
                        function Cb(b) {
                            if ("undefined" === typeof FinalizationRegistry) return Cb = function(a) {
                                return a;
                            }, b;
                            pb = new FinalizationRegistry(function(a) {
                                qb(a.ba);
                            });
                            Cb = function(a) {
                                var c = a.ba;
                                c.ia && pb.register(a, {
                                    ba: c
                                }, a);
                                return a;
                            };
                            ob = function(a) {
                                pb.unregister(a);
                            };
                            return Cb(b);
                        }
                        var Db = {};
                        function Eb(b) {
                            for(; b.length;){
                                var a = b.pop();
                                b.pop()(a);
                            }
                        }
                        function Fb(b) {
                            return this.fromWireType(M[b >> 2]);
                        }
                        var Gb = {}, Hb = {};
                        function V(b, a, c) {
                            function d(l) {
                                l = c(l);
                                l.length !== b.length && Ab("Mismatched type converter count");
                                for(var n = 0; n < b.length; ++n)Ib(b[n], l[n]);
                            }
                            b.forEach(function(l) {
                                Hb[l] = a;
                            });
                            var e = Array(a.length), g = [], m = 0;
                            a.forEach(function(l, n) {
                                jb.hasOwnProperty(l) ? e[n] = jb[l] : (g.push(l), Gb.hasOwnProperty(l) || (Gb[l] = []), Gb[l].push(function() {
                                    e[n] = jb[l];
                                    ++m;
                                    m === g.length && d(e);
                                }));
                            });
                            0 === g.length && d(e);
                        }
                        function Jb(b) {
                            switch(b){
                                case 1:
                                    return 0;
                                case 2:
                                    return 1;
                                case 4:
                                    return 2;
                                case 8:
                                    return 3;
                                default:
                                    throw new TypeError("Unknown type size: ".concat(b));
                            }
                        }
                        function Kb(b, a) {
                            var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                            var d = a.name;
                            b || R('type "'.concat(d, '" must have a positive integer typeid pointer'));
                            if (jb.hasOwnProperty(b)) {
                                if (c.Lb) return;
                                R("Cannot register type '".concat(d, "' twice"));
                            }
                            jb[b] = a;
                            delete Hb[b];
                            Gb.hasOwnProperty(b) && (a = Gb[b], delete Gb[b], a.forEach(function(e) {
                                return e();
                            }));
                        }
                        function Ib(b, a) {
                            var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                            if (!("argPackAdvance" in a)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
                            Kb(b, a, c);
                        }
                        function Lb(b) {
                            R(b.ba.ea.ca.name + " instance already deleted");
                        }
                        function Mb() {}
                        function Nb(b, a, c) {
                            if (void 0 === b[a].ga) {
                                var d = b[a];
                                b[a] = function() {
                                    b[a].ga.hasOwnProperty(arguments.length) || R("Function '".concat(c, "' called with an invalid number of arguments (").concat(arguments.length, ") - expects one of (").concat(b[a].ga, ")!"));
                                    return b[a].ga[arguments.length].apply(this, arguments);
                                };
                                b[a].ga = [];
                                b[a].ga[d.va] = d;
                            }
                        }
                        function Ob(b, a, c) {
                            h.hasOwnProperty(b) ? ((void 0 === c || void 0 !== h[b].ga && void 0 !== h[b].ga[c]) && R("Cannot register public name '".concat(b, "' twice")), Nb(h, b, b), h.hasOwnProperty(c) && R("Cannot register multiple overloads of a function with the same number of arguments (".concat(c, ")!")), h[b].ga[c] = a) : (h[b] = a, void 0 !== c && (h[b].cc = c));
                        }
                        function Pb(b, a, c, d, e, g, m, l) {
                            this.name = b;
                            this.constructor = a;
                            this.ma = c;
                            this.ra = d;
                            this.fa = e;
                            this.Gb = g;
                            this.Ba = m;
                            this.Bb = l;
                            this.ib = [];
                        }
                        function Qb(b, a, c) {
                            for(; a !== c;)a.Ba || R("Expected null or instance of ".concat(c.name, ", got an instance of ").concat(a.name)), b = a.Ba(b), a = a.fa;
                            return b;
                        }
                        function Rb(b, a) {
                            if (null === a) return this.Oa && R("null is not a valid ".concat(this.name)), 0;
                            a.ba || R('Cannot pass "'.concat(Sb(a), '" as a ').concat(this.name));
                            a.ba.da || R("Cannot pass deleted object as a pointer of type ".concat(this.name));
                            return Qb(a.ba.da, a.ba.ea.ca, this.ca);
                        }
                        function Tb(b, a) {
                            if (null === a) {
                                this.Oa && R("null is not a valid ".concat(this.name));
                                if (this.Ea) {
                                    var c = this.Pa();
                                    null !== b && b.push(this.ra, c);
                                    return c;
                                }
                                return 0;
                            }
                            a.ba || R('Cannot pass "'.concat(Sb(a), '" as a ').concat(this.name));
                            a.ba.da || R("Cannot pass deleted object as a pointer of type ".concat(this.name));
                            !this.Da && a.ba.ea.Da && R("Cannot convert argument of type ".concat(a.ba.la ? a.ba.la.name : a.ba.ea.name, " to parameter type ").concat(this.name));
                            c = Qb(a.ba.da, a.ba.ea.ca, this.ca);
                            if (this.Ea) switch(void 0 === a.ba.ia && R("Passing raw pointer to smart pointer is illegal"), this.Xb){
                                case 0:
                                    a.ba.la === this ? c = a.ba.ia : R("Cannot convert argument of type ".concat(a.ba.la ? a.ba.la.name : a.ba.ea.name, " to parameter type ").concat(this.name));
                                    break;
                                case 1:
                                    c = a.ba.ia;
                                    break;
                                case 2:
                                    if (a.ba.la === this) c = a.ba.ia;
                                    else {
                                        var d = a.clone();
                                        c = this.Tb(c, ab(function() {
                                            d["delete"]();
                                        }));
                                        null !== b && b.push(this.ra, c);
                                    }
                                    break;
                                default:
                                    R("Unsupporting sharing policy");
                            }
                            return c;
                        }
                        function Ub(b, a) {
                            if (null === a) return this.Oa && R("null is not a valid ".concat(this.name)), 0;
                            a.ba || R('Cannot pass "'.concat(Sb(a), '" as a ').concat(this.name));
                            a.ba.da || R("Cannot pass deleted object as a pointer of type ".concat(this.name));
                            a.ba.ea.Da && R("Cannot convert argument of type ".concat(a.ba.ea.name, " to parameter type ").concat(this.name));
                            return Qb(a.ba.da, a.ba.ea.ca, this.ca);
                        }
                        function Vb(b, a, c, d) {
                            this.name = b;
                            this.ca = a;
                            this.Oa = c;
                            this.Da = d;
                            this.Ea = !1;
                            this.ra = this.Tb = this.Pa = this.jb = this.Xb = this.Sb = void 0;
                            void 0 !== a.fa ? this.toWireType = Tb : (this.toWireType = d ? Rb : Ub, this.ka = null);
                        }
                        function Wb(b, a, c) {
                            h.hasOwnProperty(b) || Ab("Replacing nonexistant public symbol");
                            void 0 !== h[b].ga && void 0 !== c ? h[b].ga[c] = a : (h[b] = a, h[b].va = c);
                        }
                        var Xb = function(b, a) {
                            var c = [];
                            return function Xb() {
                                c.length = 0;
                                Object.assign(c, arguments);
                                if (b.includes("j")) {
                                    var d = h["dynCall_" + b];
                                    d = c && c.length ? d.apply(null, [
                                        a
                                    ].concat(c)) : d.call(null, a);
                                } else d = Ha.get(a).apply(null, c);
                                return d;
                            };
                        };
                        function Z(b, a) {
                            b = U(b);
                            var c = b.includes("j") ? Xb(b, a) : Ha.get(a);
                            "function" != typeof c && R("unknown function pointer with signature ".concat(b, ": ").concat(a));
                            return c;
                        }
                        var Yb = void 0;
                        function Zb(b, a) {
                            function c(g) {
                                e[g] || jb[g] || (Hb[g] ? Hb[g].forEach(c) : (d.push(g), e[g] = !0));
                            }
                            var d = [], e = {};
                            a.forEach(c);
                            throw new Yb("".concat(b, ": ") + d.map(kb).join([
                                ", "
                            ]));
                        }
                        function $b(b, a, c, d, e) {
                            var g = a.length;
                            2 > g && R("argTypes array size mismatch! Must at least get return value and 'this' types!");
                            var m = null !== a[1] && null !== c, l = !1;
                            for(c = 1; c < a.length; ++c)if (null !== a[c] && void 0 === a[c].ka) {
                                l = !0;
                                break;
                            }
                            var n = "void" !== a[0].name, k = g - 2, t = Array(k), v = [], x = [];
                            return function() {
                                arguments.length !== k && R("function ".concat(b, " called with ").concat(arguments.length, " arguments, expected ").concat(k, " args!"));
                                x.length = 0;
                                v.length = m ? 2 : 1;
                                v[0] = e;
                                if (m) {
                                    var f = a[1].toWireType(x, this);
                                    v[1] = f;
                                }
                                for(var r = 0; r < k; ++r)t[r] = a[r + 2].toWireType(x, arguments[r]), v.push(t[r]);
                                r = d.apply(null, v);
                                if (l) Eb(x);
                                else for(var q = m ? 1 : 2; q < a.length; q++){
                                    var G = 1 === q ? f : t[q - 2];
                                    null !== a[q].ka && a[q].ka(G);
                                }
                                f = n ? a[0].fromWireType(r) : void 0;
                                return f;
                            };
                        }
                        function ac(b, a) {
                            for(var c = [], d = 0; d < b; d++)c.push(P[a + 4 * d >> 2]);
                            return c;
                        }
                        function bc(b, a, c) {
                            b instanceof Object || R("".concat(c, ' with invalid "this": ').concat(b));
                            b instanceof a.ca.constructor || R("".concat(c, ' incompatible with "this" of type ').concat(b.constructor.name));
                            b.ba.da || R("cannot call emscripten binding method ".concat(c, " on deleted object"));
                            return Qb(b.ba.da, b.ba.ea.ca, a.ca);
                        }
                        function cc(b) {
                            b >= Q.Za && 0 === --Q.get(b).kb && Q.xb(b);
                        }
                        function dc(b, a, c) {
                            switch(a){
                                case 0:
                                    return function(d) {
                                        return this.fromWireType((c ? Ba : L)[d]);
                                    };
                                case 1:
                                    return function(d) {
                                        return this.fromWireType((c ? Ca : Da)[d >> 1]);
                                    };
                                case 2:
                                    return function(d) {
                                        return this.fromWireType((c ? M : P)[d >> 2]);
                                    };
                                default:
                                    throw new TypeError("Unknown integer type: " + b);
                            }
                        }
                        function Sb(b) {
                            if (null === b) return "null";
                            var a = typeof b === "undefined" ? "undefined" : (0, $dvYFb._)(b);
                            return "object" === a || "array" === a || "function" === a ? b.toString() : "" + b;
                        }
                        function ec(b, a) {
                            switch(a){
                                case 2:
                                    return function(c) {
                                        return this.fromWireType(Ea[c >> 2]);
                                    };
                                case 3:
                                    return function(c) {
                                        return this.fromWireType(Fa[c >> 3]);
                                    };
                                default:
                                    throw new TypeError("Unknown float type: " + b);
                            }
                        }
                        function fc(b, a, c) {
                            switch(a){
                                case 0:
                                    return c ? function(d) {
                                        return Ba[d];
                                    } : function(d) {
                                        return L[d];
                                    };
                                case 1:
                                    return c ? function(d) {
                                        return Ca[d >> 1];
                                    } : function(d) {
                                        return Da[d >> 1];
                                    };
                                case 2:
                                    return c ? function(d) {
                                        return M[d >> 2];
                                    } : function(d) {
                                        return P[d >> 2];
                                    };
                                default:
                                    throw new TypeError("Unknown integer type: " + b);
                            }
                        }
                        var gc = function(b, a, c, d) {
                            if (0 < d) {
                                d = c + d - 1;
                                for(var e = 0; e < b.length; ++e){
                                    var g = b.charCodeAt(e);
                                    if (55296 <= g && 57343 >= g) {
                                        var m = b.charCodeAt(++e);
                                        g = 65536 + ((g & 1023) << 10) | m & 1023;
                                    }
                                    if (127 >= g) {
                                        if (c >= d) break;
                                        a[c++] = g;
                                    } else {
                                        if (2047 >= g) {
                                            if (c + 1 >= d) break;
                                            a[c++] = 192 | g >> 6;
                                        } else {
                                            if (65535 >= g) {
                                                if (c + 2 >= d) break;
                                                a[c++] = 224 | g >> 12;
                                            } else {
                                                if (c + 3 >= d) break;
                                                a[c++] = 240 | g >> 18;
                                                a[c++] = 128 | g >> 12 & 63;
                                            }
                                            a[c++] = 128 | g >> 6 & 63;
                                        }
                                        a[c++] = 128 | g & 63;
                                    }
                                }
                                a[c] = 0;
                            }
                        }, hc = function(b) {
                            for(var a = 0, c = 0; c < b.length; ++c){
                                var d = b.charCodeAt(c);
                                127 >= d ? a++ : 2047 >= d ? a += 2 : 55296 <= d && 57343 >= d ? (a += 4, ++c) : a += 3;
                            }
                            return a;
                        }, ic = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, jc = function(b, a, c) {
                            var d = a + c;
                            for(c = a; b[c] && !(c >= d);)++c;
                            if (16 < c - a && b.buffer && ic) return ic.decode(b.subarray(a, c));
                            for(d = ""; a < c;){
                                var e = b[a++];
                                if (e & 128) {
                                    var g = b[a++] & 63;
                                    if (192 == (e & 224)) d += String.fromCharCode((e & 31) << 6 | g);
                                    else {
                                        var m = b[a++] & 63;
                                        e = 224 == (e & 240) ? (e & 15) << 12 | g << 6 | m : (e & 7) << 18 | g << 12 | m << 6 | b[a++] & 63;
                                        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
                                    }
                                } else d += String.fromCharCode(e);
                            }
                            return d;
                        }, kc = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, mc = function(b, a) {
                            var c = b >> 1;
                            for(var d = c + a / 2; !(c >= d) && Da[c];)++c;
                            c <<= 1;
                            if (32 < c - b && kc) return kc.decode(L.subarray(b, c));
                            c = "";
                            for(d = 0; !(d >= a / 2); ++d){
                                var e = Ca[b + 2 * d >> 1];
                                if (0 == e) break;
                                c += String.fromCharCode(e);
                            }
                            return c;
                        }, nc = function(b, a, c) {
                            void 0 === c && (c = 2147483647);
                            if (2 > c) return 0;
                            c -= 2;
                            var d = a;
                            c = c < 2 * b.length ? c / 2 : b.length;
                            for(var e = 0; e < c; ++e)Ca[a >> 1] = b.charCodeAt(e), a += 2;
                            Ca[a >> 1] = 0;
                            return a - d;
                        }, oc = function(b) {
                            return 2 * b.length;
                        }, pc = function(b, a) {
                            for(var c = 0, d = ""; !(c >= a / 4);){
                                var e = M[b + 4 * c >> 2];
                                if (0 == e) break;
                                ++c;
                                65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
                            }
                            return d;
                        }, qc = function(b, a, c) {
                            void 0 === c && (c = 2147483647);
                            if (4 > c) return 0;
                            var d = a;
                            c = d + c - 4;
                            for(var e = 0; e < b.length; ++e){
                                var g = b.charCodeAt(e);
                                if (55296 <= g && 57343 >= g) {
                                    var m = b.charCodeAt(++e);
                                    g = 65536 + ((g & 1023) << 10) | m & 1023;
                                }
                                M[a >> 2] = g;
                                a += 4;
                                if (a + 4 > c) break;
                            }
                            M[a >> 2] = 0;
                            return a - d;
                        }, rc = function(b) {
                            for(var a = 0, c = 0; c < b.length; ++c){
                                var d = b.charCodeAt(c);
                                55296 <= d && 57343 >= d && ++c;
                                a += 4;
                            }
                            return a;
                        }, sc = {};
                        function tc(b) {
                            var a = sc[b];
                            return void 0 === a ? U(b) : a;
                        }
                        var uc = [];
                        function vc(b) {
                            var a = uc.length;
                            uc.push(b);
                            return a;
                        }
                        function wc(b, a) {
                            for(var c = Array(b), d = 0; d < b; ++d)c[d] = nb(P[a + 4 * d >> 2], "parameter " + d);
                            return c;
                        }
                        var xc = [], yc = {}, Ac = function() {
                            if (!zc) {
                                var b = {
                                    USER: "web_user",
                                    LOGNAME: "web_user",
                                    PATH: "/",
                                    PWD: "/",
                                    HOME: "/home/web_user",
                                    LANG: ("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                                    _: na || "./this.program"
                                }, a;
                                for(a in yc)void 0 === yc[a] ? delete b[a] : b[a] = yc[a];
                                var c = [];
                                for(a in b)c.push("".concat(a, "=").concat(b[a]));
                                zc = c;
                            }
                            return zc;
                        }, zc, Bc = [
                            null,
                            [],
                            []
                        ], Cc = function(b) {
                            return 0 === b % 4 && (0 !== b % 100 || 0 === b % 400);
                        }, Dc = [
                            31,
                            29,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Ec = [
                            31,
                            28,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ];
                        function Fc(b) {
                            var a = Array(hc(b) + 1);
                            gc(b, a, 0, a.length);
                            return a;
                        }
                        var Gc = function(b, a, c, d) {
                            var e = function e(f, r, q) {
                                for(f = "number" == typeof f ? f.toString() : f || ""; f.length < r;)f = q[0] + f;
                                return f;
                            };
                            var g = function g(f, r) {
                                return e(f, r, "0");
                            };
                            var m = function m(f, r) {
                                function q(D) {
                                    return 0 > D ? -1 : 0 < D ? 1 : 0;
                                }
                                var G;
                                0 === (G = q(f.getFullYear() - r.getFullYear())) && 0 === (G = q(f.getMonth() - r.getMonth())) && (G = q(f.getDate() - r.getDate()));
                                return G;
                            };
                            var l = function l(f) {
                                switch(f.getDay()){
                                    case 0:
                                        return new Date(f.getFullYear() - 1, 11, 29);
                                    case 1:
                                        return f;
                                    case 2:
                                        return new Date(f.getFullYear(), 0, 3);
                                    case 3:
                                        return new Date(f.getFullYear(), 0, 2);
                                    case 4:
                                        return new Date(f.getFullYear(), 0, 1);
                                    case 5:
                                        return new Date(f.getFullYear() - 1, 11, 31);
                                    case 6:
                                        return new Date(f.getFullYear() - 1, 11, 30);
                                }
                            };
                            var n = function n(f) {
                                var r = f.ta;
                                for(f = new Date(new Date(f.ua + 1900, 0, 1).getTime()); 0 < r;){
                                    var q = f.getMonth(), G = (Cc(f.getFullYear()) ? Dc : Ec)[q];
                                    if (r > G - f.getDate()) r -= G - f.getDate() + 1, f.setDate(1), 11 > q ? f.setMonth(q + 1) : (f.setMonth(0), f.setFullYear(f.getFullYear() + 1));
                                    else {
                                        f.setDate(f.getDate() + r);
                                        break;
                                    }
                                }
                                q = new Date(f.getFullYear() + 1, 0, 4);
                                r = l(new Date(f.getFullYear(), 0, 4));
                                q = l(q);
                                return 0 >= m(r, f) ? 0 >= m(q, f) ? f.getFullYear() + 1 : f.getFullYear() : f.getFullYear() - 1;
                            };
                            var k = M[d + 40 >> 2];
                            d = {
                                $b: M[d >> 2],
                                Zb: M[d + 4 >> 2],
                                Ia: M[d + 8 >> 2],
                                Ra: M[d + 12 >> 2],
                                Ja: M[d + 16 >> 2],
                                ua: M[d + 20 >> 2],
                                na: M[d + 24 >> 2],
                                ta: M[d + 28 >> 2],
                                dc: M[d + 32 >> 2],
                                Yb: M[d + 36 >> 2],
                                ac: k ? k ? jc(L, k) : "" : ""
                            };
                            c = c ? jc(L, c) : "";
                            k = {
                                "%c": "%a %b %d %H:%M:%S %Y",
                                "%D": "%m/%d/%y",
                                "%F": "%Y-%m-%d",
                                "%h": "%b",
                                "%r": "%I:%M:%S %p",
                                "%R": "%H:%M",
                                "%T": "%H:%M:%S",
                                "%x": "%m/%d/%y",
                                "%X": "%H:%M:%S",
                                "%Ec": "%c",
                                "%EC": "%C",
                                "%Ex": "%m/%d/%y",
                                "%EX": "%H:%M:%S",
                                "%Ey": "%y",
                                "%EY": "%Y",
                                "%Od": "%d",
                                "%Oe": "%e",
                                "%OH": "%H",
                                "%OI": "%I",
                                "%Om": "%m",
                                "%OM": "%M",
                                "%OS": "%S",
                                "%Ou": "%u",
                                "%OU": "%U",
                                "%OV": "%V",
                                "%Ow": "%w",
                                "%OW": "%W",
                                "%Oy": "%y"
                            };
                            for(var t in k)c = c.replace(new RegExp(t, "g"), k[t]);
                            var v = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), x = "January February March April May June July August September October November December".split(" ");
                            k = {
                                "%a": function(f) {
                                    return v[f.na].substring(0, 3);
                                },
                                "%A": function(f) {
                                    return v[f.na];
                                },
                                "%b": function(f) {
                                    return x[f.Ja].substring(0, 3);
                                },
                                "%B": function(f) {
                                    return x[f.Ja];
                                },
                                "%C": function(f) {
                                    return g((f.ua + 1900) / 100 | 0, 2);
                                },
                                "%d": function(f) {
                                    return g(f.Ra, 2);
                                },
                                "%e": function(f) {
                                    return e(f.Ra, 2, " ");
                                },
                                "%g": function(f) {
                                    return n(f).toString().substring(2);
                                },
                                "%G": function(f) {
                                    return n(f);
                                },
                                "%H": function(f) {
                                    return g(f.Ia, 2);
                                },
                                "%I": function(f) {
                                    f = f.Ia;
                                    0 == f ? f = 12 : 12 < f && (f -= 12);
                                    return g(f, 2);
                                },
                                "%j": function(f) {
                                    for(var r = 0, q = 0; q <= f.Ja - 1; r += (Cc(f.ua + 1900) ? Dc : Ec)[q++]);
                                    return g(f.Ra + r, 3);
                                },
                                "%m": function(f) {
                                    return g(f.Ja + 1, 2);
                                },
                                "%M": function(f) {
                                    return g(f.Zb, 2);
                                },
                                "%n": function() {
                                    return "\n";
                                },
                                "%p": function(f) {
                                    return 0 <= f.Ia && 12 > f.Ia ? "AM" : "PM";
                                },
                                "%S": function(f) {
                                    return g(f.$b, 2);
                                },
                                "%t": function() {
                                    return "	";
                                },
                                "%u": function(f) {
                                    return f.na || 7;
                                },
                                "%U": function(f) {
                                    return g(Math.floor((f.ta + 7 - f.na) / 7), 2);
                                },
                                "%V": function(f) {
                                    var r = Math.floor((f.ta + 7 - (f.na + 6) % 7) / 7);
                                    2 >= (f.na + 371 - f.ta - 2) % 7 && r++;
                                    if (r) 53 == r && (q = (f.na + 371 - f.ta) % 7, 4 == q || 3 == q && Cc(f.ua) || (r = 1));
                                    else {
                                        r = 52;
                                        var q = (f.na + 7 - f.ta - 1) % 7;
                                        (4 == q || 5 == q && Cc(f.ua % 400 - 1)) && r++;
                                    }
                                    return g(r, 2);
                                },
                                "%w": function(f) {
                                    return f.na;
                                },
                                "%W": function(f) {
                                    return g(Math.floor((f.ta + 7 - (f.na + 6) % 7) / 7), 2);
                                },
                                "%y": function(f) {
                                    return (f.ua + 1900).toString().substring(2);
                                },
                                "%Y": function(f) {
                                    return f.ua + 1900;
                                },
                                "%z": function(f) {
                                    f = f.Yb;
                                    var r = 0 <= f;
                                    f = Math.abs(f) / 60;
                                    return (r ? "+" : "-") + String("0000" + (f / 60 * 100 + f % 60)).slice(-4);
                                },
                                "%Z": function(f) {
                                    return f.ac;
                                },
                                "%%": function() {
                                    return "%";
                                }
                            };
                            c = c.replace(/%%/g, "\x00\x00");
                            for(t in k)c.includes(t) && (c = c.replace(new RegExp(t, "g"), k[t](d)));
                            c = c.replace(/\0\0/g, "%");
                            t = Fc(c);
                            if (t.length > a) return 0;
                            Ba.set(t, b);
                            return t.length - 1;
                        };
                        Object.assign(Za.prototype, {
                            get: function(b) {
                                return this.qa[b];
                            },
                            has: function(b) {
                                return void 0 !== this.qa[b];
                            },
                            ub: function(b) {
                                var a = this.eb.pop() || this.qa.length;
                                this.qa[a] = b;
                                return a;
                            },
                            xb: function(b) {
                                this.qa[b] = void 0;
                                this.eb.push(b);
                            }
                        });
                        $a = h.BindingError = /*#__PURE__*/ function(Error1) {
                            (0, $cdf6b0397ffac486$export$7e4530ad35d3bb8)(_class, Error1);
                            var _super = (0, $df57a1ce707e56d0$export$8dd05c13f5255580)(_class);
                            function _class(b) {
                                (0, $7417b380464c38c1$export$2996f80ef42b8419)(this, _class);
                                var _this;
                                _this = _super.call(this, b);
                                _this.name = "BindingError";
                                return _this;
                            }
                            return _class;
                        }((0, $cdcde981a6d4bbcf$export$2466d533fda16e33)(Error));
                        Q.qa.push({
                            value: void 0
                        }, {
                            value: null
                        }, {
                            value: !0
                        }, {
                            value: !1
                        });
                        Q.Za = Q.qa.length;
                        h.count_emval_handles = function() {
                            for(var b = 0, a = Q.Za; a < Q.qa.length; ++a)void 0 !== Q.qa[a] && ++b;
                            return b;
                        };
                        cb = h.PureVirtualError = bb("PureVirtualError");
                        for(var Hc = Array(256), Ic = 0; 256 > Ic; ++Ic)Hc[Ic] = String.fromCharCode(Ic);
                        db = Hc;
                        h.getInheritedInstanceCount = function() {
                            return Object.keys(hb).length;
                        };
                        h.getLiveInheritedInstances = function() {
                            var b = [], a;
                            for(a in hb)hb.hasOwnProperty(a) && b.push(hb[a]);
                            return b;
                        };
                        h.flushPendingDeletes = fb;
                        h.setDelayFunction = function(b) {
                            gb = b;
                            eb.length && gb && gb(fb);
                        };
                        zb = h.InternalError = /*#__PURE__*/ function(Error1) {
                            (0, $cdf6b0397ffac486$export$7e4530ad35d3bb8)(_class, Error1);
                            var _super = (0, $df57a1ce707e56d0$export$8dd05c13f5255580)(_class);
                            function _class(b) {
                                (0, $7417b380464c38c1$export$2996f80ef42b8419)(this, _class);
                                var _this;
                                _this = _super.call(this, b);
                                _this.name = "InternalError";
                                return _this;
                            }
                            return _class;
                        }((0, $cdcde981a6d4bbcf$export$2466d533fda16e33)(Error));
                        Mb.prototype.isAliasOf = function(b) {
                            if (!(this instanceof Mb && b instanceof Mb)) return !1;
                            var a = this.ba.ea.ca, c = this.ba.da, d = b.ba.ea.ca;
                            for(b = b.ba.da; a.fa;)c = a.Ba(c), a = a.fa;
                            for(; d.fa;)b = d.Ba(b), d = d.fa;
                            return a === d && c === b;
                        };
                        Mb.prototype.clone = function() {
                            this.ba.da || Lb(this);
                            if (this.ba.ya) return this.ba.count.value += 1, this;
                            var b = Cb, a = Object, c = a.create, d = Object.getPrototypeOf(this), e = this.ba;
                            b = b(c.call(a, d, {
                                ba: {
                                    value: {
                                        count: e.count,
                                        wa: e.wa,
                                        ya: e.ya,
                                        da: e.da,
                                        ea: e.ea,
                                        ia: e.ia,
                                        la: e.la
                                    }
                                }
                            }));
                            b.ba.count.value += 1;
                            b.ba.wa = !1;
                            return b;
                        };
                        Mb.prototype["delete"] = function() {
                            this.ba.da || Lb(this);
                            this.ba.wa && !this.ba.ya && R("Object already scheduled for deletion");
                            ob(this);
                            qb(this.ba);
                            this.ba.ya || (this.ba.ia = void 0, this.ba.da = void 0);
                        };
                        Mb.prototype.isDeleted = function() {
                            return !this.ba.da;
                        };
                        Mb.prototype.deleteLater = function() {
                            this.ba.da || Lb(this);
                            this.ba.wa && !this.ba.ya && R("Object already scheduled for deletion");
                            eb.push(this);
                            1 === eb.length && gb && gb(fb);
                            this.ba.wa = !0;
                            return this;
                        };
                        Vb.prototype.Hb = function(b) {
                            this.jb && (b = this.jb(b));
                            return b;
                        };
                        Vb.prototype.$a = function(b) {
                            this.ra && this.ra(b);
                        };
                        Vb.prototype.argPackAdvance = 8;
                        Vb.prototype.readValueFromPointer = Fb;
                        Vb.prototype.deleteObject = function(b) {
                            if (null !== b) b["delete"]();
                        };
                        Vb.prototype.fromWireType = function(b) {
                            function a() {
                                return this.Ea ? Bb(this.ca.ma, {
                                    ea: this.Sb,
                                    da: c,
                                    la: this,
                                    ia: b
                                }) : Bb(this.ca.ma, {
                                    ea: this,
                                    da: b
                                });
                            }
                            var c = this.Hb(b);
                            if (!c) return this.$a(b), null;
                            var d = yb(this.ca, c);
                            if (void 0 !== d) {
                                if (0 === d.ba.count.value) return d.ba.da = c, d.ba.ia = b, d.clone();
                                d = d.clone();
                                this.$a(b);
                                return d;
                            }
                            d = this.ca.Gb(c);
                            d = xb[d];
                            if (!d) return a.call(this);
                            d = this.Da ? d.vb : d.pointerType;
                            var e = rb(c, this.ca, d.ca);
                            return null === e ? a.call(this) : this.Ea ? Bb(d.ca.ma, {
                                ea: d,
                                da: e,
                                la: this,
                                ia: b
                            }) : Bb(d.ca.ma, {
                                ea: d,
                                da: e
                            });
                        };
                        Yb = h.UnboundTypeError = bb("UnboundTypeError");
                        var Kc = {
                            N: function N(b, a, c) {
                                b = U(b);
                                a = nb(a, "wrapper");
                                c = S(c);
                                var d = [].slice, e = a.ca, g = e.ma, m = e.fa.ma, l = e.fa.constructor;
                                b = Ya(b, function() {
                                    e.fa.ib.forEach((function(k) {
                                        if (this[k] === m[k]) throw new cb("Pure virtual function ".concat(k, " must be implemented in JavaScript"));
                                    }).bind(this));
                                    Object.defineProperty(this, "__parent", {
                                        value: g
                                    });
                                    this.__construct.apply(this, d.call(arguments));
                                });
                                g.__construct = function() {
                                    this === g && R("Pass correct 'this' to __construct");
                                    var k = l.implement.apply(void 0, [
                                        this
                                    ].concat(d.call(arguments)));
                                    ob(k);
                                    var t = k.ba;
                                    k.notifyOnDestruction();
                                    t.ya = !0;
                                    Object.defineProperties(this, {
                                        ba: {
                                            value: t
                                        }
                                    });
                                    Cb(this);
                                    k = t.da;
                                    k = ib(e, k);
                                    hb.hasOwnProperty(k) ? R("Tried to register registered instance: ".concat(k)) : hb[k] = this;
                                };
                                g.__destruct = function() {
                                    this === g && R("Pass correct 'this' to __destruct");
                                    ob(this);
                                    var k = this.ba.da;
                                    k = ib(e, k);
                                    hb.hasOwnProperty(k) ? delete hb[k] : R("Tried to unregister unregistered instance: ".concat(k));
                                };
                                b.prototype = Object.create(g);
                                for(var n in c)b.prototype[n] = c[n];
                                return ab(b);
                            },
                            O: function O(b) {
                                var a = Db[b];
                                delete Db[b];
                                var c = a.Pa, d = a.ra, e = a.cb, g = e.map(function(m) {
                                    return m.Kb;
                                }).concat(e.map(function(m) {
                                    return m.Vb;
                                }));
                                V([
                                    b
                                ], g, function(m) {
                                    var l = {};
                                    e.forEach(function(n, k) {
                                        var t = m[k], v = n.Ib, x = n.Jb, f = m[k + e.length], r = n.Ub, q = n.Wb;
                                        l[n.Eb] = {
                                            read: function(G) {
                                                return t.fromWireType(v(x, G));
                                            },
                                            write: function(G, D) {
                                                var u = [];
                                                r(q, G, f.toWireType(u, D));
                                                Eb(u);
                                            }
                                        };
                                    });
                                    return [
                                        {
                                            name: a.name,
                                            fromWireType: function fromWireType(n) {
                                                var k = {}, t;
                                                for(t in l)k[t] = l[t].read(n);
                                                d(n);
                                                return k;
                                            },
                                            toWireType: function toWireType(n, k) {
                                                for(var t in l)if (!(t in k)) throw new TypeError('Missing field: "'.concat(t, '"'));
                                                var v = c();
                                                for(t in l)l[t].write(v, k[t]);
                                                null !== n && n.push(d, v);
                                                return v;
                                            },
                                            argPackAdvance: 8,
                                            readValueFromPointer: Fb,
                                            ka: d
                                        }
                                    ];
                                });
                            },
                            C: function C() {},
                            K: function K(b, a, c, d, e) {
                                var g = Jb(c);
                                a = U(a);
                                Ib(b, {
                                    name: a,
                                    fromWireType: function fromWireType(m) {
                                        return !!m;
                                    },
                                    toWireType: function toWireType(m, l) {
                                        return l ? d : e;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: function readValueFromPointer(m) {
                                        if (1 === c) var l = Ba;
                                        else if (2 === c) l = Ca;
                                        else if (4 === c) l = M;
                                        else throw new TypeError("Unknown boolean type size: " + a);
                                        return this.fromWireType(l[m >> g]);
                                    },
                                    ka: null
                                });
                            },
                            f: function f(b, a, c, d, e, g, m, l, n, k, t, v, x) {
                                t = U(t);
                                g = Z(e, g);
                                l && (l = Z(m, l));
                                k && (k = Z(n, k));
                                x = Z(v, x);
                                var f = Xa(t);
                                Ob(f, function() {
                                    Zb("Cannot construct ".concat(t, " due to unbound types"), [
                                        d
                                    ]);
                                });
                                V([
                                    b,
                                    a,
                                    c
                                ], d ? [
                                    d
                                ] : [], function(r) {
                                    r = r[0];
                                    if (d) {
                                        var q = r.ca;
                                        var G = q.ma;
                                    } else G = Mb.prototype;
                                    r = Ya(f, function() {
                                        if (Object.getPrototypeOf(this) !== D) throw new $a("Use 'new' to construct " + t);
                                        if (void 0 === u.sa) throw new $a(t + " has no accessible constructor");
                                        var O = u.sa[arguments.length];
                                        if (void 0 === O) throw new $a("Tried to invoke ctor of ".concat(t, " with invalid number of parameters (").concat(arguments.length, ") - expected (").concat(Object.keys(u.sa).toString(), ") parameters instead!"));
                                        return O.apply(this, arguments);
                                    });
                                    var D = Object.create(G, {
                                        constructor: {
                                            value: r
                                        }
                                    });
                                    r.prototype = D;
                                    var u = new Pb(t, r, D, x, q, g, l, k);
                                    u.fa && (void 0 === u.fa.Ca && (u.fa.Ca = []), u.fa.Ca.push(u));
                                    q = new Vb(t, u, !0, !1);
                                    G = new Vb(t + "*", u, !1, !1);
                                    var I = new Vb(t + " const*", u, !1, !0);
                                    xb[b] = {
                                        pointerType: G,
                                        vb: I
                                    };
                                    Wb(f, r);
                                    return [
                                        q,
                                        G,
                                        I
                                    ];
                                });
                            },
                            j: function j(b, a, c, d, e, g, m) {
                                var l = ac(c, d);
                                a = U(a);
                                g = Z(e, g);
                                V([], [
                                    b
                                ], function(n) {
                                    function k() {
                                        Zb("Cannot call ".concat(t, " due to unbound types"), l);
                                    }
                                    n = n[0];
                                    var t = "".concat(n.name, ".").concat(a);
                                    a.startsWith("@@") && (a = Symbol[a.substring(2)]);
                                    var v = n.ca.constructor;
                                    void 0 === v[a] ? (k.va = c - 1, v[a] = k) : (Nb(v, a, t), v[a].ga[c - 1] = k);
                                    V([], l, function(x) {
                                        x = $b(t, [
                                            x[0],
                                            null
                                        ].concat(x.slice(1)), null, g, m);
                                        void 0 === v[a].ga ? (x.va = c - 1, v[a] = x) : v[a].ga[c - 1] = x;
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        if (n.ca.Ca) try {
                                            for(var _iterator = n.ca.Ca[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var f = _step.value;
                                                f.constructor.hasOwnProperty(a) || (f.constructor[a] = x);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            x: function x(b, a, c, d, e, g, m, l) {
                                a = U(a);
                                g = Z(e, g);
                                V([], [
                                    b
                                ], function(n) {
                                    n = n[0];
                                    var k = "".concat(n.name, ".").concat(a), t = {
                                        get: function() {
                                            Zb("Cannot access ".concat(k, " due to unbound types"), [
                                                c
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    t.set = l ? function() {
                                        Zb("Cannot access ".concat(k, " due to unbound types"), [
                                            c
                                        ]);
                                    } : function() {
                                        R("".concat(k, " is a read-only property"));
                                    };
                                    Object.defineProperty(n.ca.constructor, a, t);
                                    V([], [
                                        c
                                    ], function(v) {
                                        v = v[0];
                                        var x = {
                                            get: function() {
                                                return v.fromWireType(g(d));
                                            },
                                            enumerable: !0
                                        };
                                        l && (l = Z(m, l), x.set = function(f) {
                                            var r = [];
                                            l(d, v.toWireType(r, f));
                                            Eb(r);
                                        });
                                        Object.defineProperty(n.ca.constructor, a, x);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            s: function s(b, a, c, d, e, g) {
                                var m = ac(a, c);
                                e = Z(d, e);
                                V([], [
                                    b
                                ], function(l) {
                                    l = l[0];
                                    var n = "constructor ".concat(l.name);
                                    void 0 === l.ca.sa && (l.ca.sa = []);
                                    if (void 0 !== l.ca.sa[a - 1]) throw new $a("Cannot register multiple constructors with identical number of parameters (".concat(a - 1, ") for class '").concat(l.name, "'! Overload resolution is currently only performed using the parameter count, not actual type info!"));
                                    l.ca.sa[a - 1] = function() {
                                        Zb("Cannot construct ".concat(l.name, " due to unbound types"), m);
                                    };
                                    V([], m, function(k) {
                                        k.splice(1, 0, null);
                                        l.ca.sa[a - 1] = $b(n, k, null, e, g);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            a: function a(b, a, c, d, e, g, m, l) {
                                var n = ac(c, d);
                                a = U(a);
                                g = Z(e, g);
                                V([], [
                                    b
                                ], function(k) {
                                    function t() {
                                        Zb("Cannot call ".concat(v, " due to unbound types"), n);
                                    }
                                    k = k[0];
                                    var v = "".concat(k.name, ".").concat(a);
                                    a.startsWith("@@") && (a = Symbol[a.substring(2)]);
                                    l && k.ca.ib.push(a);
                                    var x = k.ca.ma, f = x[a];
                                    void 0 === f || void 0 === f.ga && f.className !== k.name && f.va === c - 2 ? (t.va = c - 2, t.className = k.name, x[a] = t) : (Nb(x, a, v), x[a].ga[c - 2] = t);
                                    V([], n, function(r) {
                                        r = $b(v, r, k, g, m);
                                        void 0 === x[a].ga ? (r.va = c - 2, x[a] = r) : x[a].ga[c - 2] = r;
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            e: function e(b, a, c, d, e, g, m, l, n, k) {
                                a = U(a);
                                e = Z(d, e);
                                V([], [
                                    b
                                ], function(t) {
                                    t = t[0];
                                    var v = "".concat(t.name, ".").concat(a), x = {
                                        get: function() {
                                            Zb("Cannot access ".concat(v, " due to unbound types"), [
                                                c,
                                                m
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    x.set = n ? function() {
                                        Zb("Cannot access ".concat(v, " due to unbound types"), [
                                            c,
                                            m
                                        ]);
                                    } : function() {
                                        R(v + " is a read-only property");
                                    };
                                    Object.defineProperty(t.ca.ma, a, x);
                                    V([], n ? [
                                        c,
                                        m
                                    ] : [
                                        c
                                    ], function(f) {
                                        var r = f[0], q = {
                                            get: function() {
                                                var D = bc(this, t, v + " getter");
                                                return r.fromWireType(e(g, D));
                                            },
                                            enumerable: !0
                                        };
                                        if (n) {
                                            n = Z(l, n);
                                            var G = f[1];
                                            q.set = function(D) {
                                                var u = bc(this, t, v + " setter"), I = [];
                                                n(k, u, G.toWireType(I, D));
                                                Eb(I);
                                            };
                                        }
                                        Object.defineProperty(t.ca.ma, a, q);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            J: function J(b, a) {
                                a = U(a);
                                Ib(b, {
                                    name: a,
                                    fromWireType: function fromWireType(c) {
                                        var d = S(c);
                                        cc(c);
                                        return d;
                                    },
                                    toWireType: function toWireType(c, d) {
                                        return ab(d);
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Fb,
                                    ka: null
                                });
                            },
                            p: function p(b, a, c, d) {
                                function e() {}
                                c = Jb(c);
                                a = U(a);
                                e.values = {};
                                Ib(b, {
                                    name: a,
                                    constructor: e,
                                    fromWireType: function fromWireType(g) {
                                        return this.constructor.values[g];
                                    },
                                    toWireType: function toWireType(g, m) {
                                        return m.value;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: dc(a, c, d),
                                    ka: null
                                });
                                Ob(a, e);
                            },
                            d: function d(b, a, c) {
                                var d = nb(b, "enum");
                                a = U(a);
                                b = d.constructor;
                                d = Object.create(d.constructor.prototype, {
                                    value: {
                                        value: c
                                    },
                                    constructor: {
                                        value: Ya("".concat(d.name, "_").concat(a), function() {})
                                    }
                                });
                                b.values[c] = d;
                                b[a] = d;
                            },
                            y: function y(b, a, c) {
                                c = Jb(c);
                                a = U(a);
                                Ib(b, {
                                    name: a,
                                    fromWireType: function fromWireType(d) {
                                        return d;
                                    },
                                    toWireType: function toWireType(d, e) {
                                        return e;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: ec(a, c),
                                    ka: null
                                });
                            },
                            m: function m(b, a, c, d, e, g) {
                                var m = ac(a, c);
                                b = U(b);
                                e = Z(d, e);
                                Ob(b, function() {
                                    Zb("Cannot call ".concat(b, " due to unbound types"), m);
                                }, a - 1);
                                V([], m, function(l) {
                                    Wb(b, $b(b, [
                                        l[0],
                                        null
                                    ].concat(l.slice(1)), null, e, g), a - 1);
                                    return [];
                                });
                            },
                            l: function l(b, a, c, d, e) {
                                a = U(a);
                                -1 === e && (e = 4294967295);
                                e = Jb(c);
                                var g = function(l) {
                                    return l;
                                };
                                if (0 === d) {
                                    var m = 32 - 8 * c;
                                    g = function(l) {
                                        return l << m >>> m;
                                    };
                                }
                                c = a.includes("unsigned") ? function c(l, n) {
                                    return n >>> 0;
                                } : function(l, n) {
                                    return n;
                                };
                                Ib(b, {
                                    name: a,
                                    fromWireType: g,
                                    toWireType: c,
                                    argPackAdvance: 8,
                                    readValueFromPointer: fc(a, e, 0 !== d),
                                    ka: null
                                });
                            },
                            g: function g(b, a, c) {
                                function d(g) {
                                    g >>= 2;
                                    var m = P;
                                    return new e(m.buffer, m[g + 1], m[g]);
                                }
                                var e = [
                                    Int8Array,
                                    Uint8Array,
                                    Int16Array,
                                    Uint16Array,
                                    Int32Array,
                                    Uint32Array,
                                    Float32Array,
                                    Float64Array
                                ][a];
                                c = U(c);
                                Ib(b, {
                                    name: c,
                                    fromWireType: d,
                                    argPackAdvance: 8,
                                    readValueFromPointer: d
                                }, {
                                    Lb: !0
                                });
                            },
                            z: function z(b, a) {
                                a = U(a);
                                var c = "std::string" === a;
                                Ib(b, {
                                    name: a,
                                    fromWireType: function fromWireType(d) {
                                        var e = P[d >> 2], g = d + 4;
                                        if (c) for(var m = g, l = 0; l <= e; ++l){
                                            var n = g + l;
                                            if (l == e || 0 == L[n]) {
                                                m = m ? jc(L, m, n - m) : "";
                                                if (void 0 === k) var k = m;
                                                else k += String.fromCharCode(0), k += m;
                                                m = n + 1;
                                            }
                                        }
                                        else {
                                            k = Array(e);
                                            for(l = 0; l < e; ++l)k[l] = String.fromCharCode(L[g + l]);
                                            k = k.join("");
                                        }
                                        mb(d);
                                        return k;
                                    },
                                    toWireType: function toWireType(d, e) {
                                        e instanceof ArrayBuffer && (e = new Uint8Array(e));
                                        var g = "string" == typeof e;
                                        g || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array || R("Cannot pass non-string to std::string");
                                        var m = c && g ? hc(e) : e.length;
                                        var l = Jc(4 + m + 1), n = l + 4;
                                        P[l >> 2] = m;
                                        if (c && g) gc(e, L, n, m + 1);
                                        else if (g) for(g = 0; g < m; ++g){
                                            var k = e.charCodeAt(g);
                                            255 < k && (mb(n), R("String has UTF-16 code units that do not fit in 8 bits"));
                                            L[n + g] = k;
                                        }
                                        else for(g = 0; g < m; ++g)L[n + g] = e[g];
                                        null !== d && d.push(mb, l);
                                        return l;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Fb,
                                    ka: function ka(d) {
                                        mb(d);
                                    }
                                });
                            },
                            u: function u(b, a, c) {
                                c = U(c);
                                if (2 === a) {
                                    var d = mc;
                                    var e = nc;
                                    var g = oc;
                                    var m = function() {
                                        return Da;
                                    };
                                    var l = 1;
                                } else 4 === a && (d = pc, e = qc, g = rc, m = function() {
                                    return P;
                                }, l = 2);
                                Ib(b, {
                                    name: c,
                                    fromWireType: function fromWireType(n) {
                                        for(var k = P[n >> 2], t = m(), v, x = n + 4, f = 0; f <= k; ++f){
                                            var r = n + 4 + f * a;
                                            if (f == k || 0 == t[r >> l]) x = d(x, r - x), void 0 === v ? v = x : (v += String.fromCharCode(0), v += x), x = r + a;
                                        }
                                        mb(n);
                                        return v;
                                    },
                                    toWireType: function toWireType(n, k) {
                                        "string" != typeof k && R("Cannot pass non-string to C++ string type ".concat(c));
                                        var t = g(k), v = Jc(4 + t + a);
                                        P[v >> 2] = t >> l;
                                        e(k, v + 4, t + a);
                                        null !== n && n.push(mb, v);
                                        return v;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Fb,
                                    ka: function ka(n) {
                                        mb(n);
                                    }
                                });
                            },
                            Q: function Q(b, a, c, d, e, g) {
                                Db[b] = {
                                    name: U(a),
                                    Pa: Z(c, d),
                                    ra: Z(e, g),
                                    cb: []
                                };
                            },
                            P: function P(b, a, c, d, e, g, m, l, n, k) {
                                Db[b].cb.push({
                                    Eb: U(a),
                                    Kb: c,
                                    Ib: Z(d, e),
                                    Jb: g,
                                    Vb: m,
                                    Ub: Z(l, n),
                                    Wb: k
                                });
                            },
                            L: function L(b, a) {
                                a = U(a);
                                Ib(b, {
                                    Nb: !0,
                                    name: a,
                                    argPackAdvance: 0,
                                    fromWireType: function fromWireType() {},
                                    toWireType: function toWireType() {}
                                });
                            },
                            v: function v(b, a, c) {
                                b = S(b);
                                a = nb(a, "emval::as");
                                var d = [], e = ab(d);
                                P[c >> 2] = e;
                                return a.toWireType(d, b);
                            },
                            w: function w(b, a, c, d, e) {
                                b = uc[b];
                                a = S(a);
                                c = tc(c);
                                var g = [];
                                P[d >> 2] = ab(g);
                                return b(a, c, g, e);
                            },
                            i: function i(b, a, c, d) {
                                b = uc[b];
                                a = S(a);
                                c = tc(c);
                                b(a, c, null, d);
                            },
                            c: cc,
                            h: function h(b, a) {
                                var c = wc(b, a), d = c[0];
                                a = d.name + "_$" + c.slice(1).map(function(m) {
                                    return m.name;
                                }).join("_") + "$";
                                var e = xc[a];
                                if (void 0 !== e) return e;
                                var g = Array(b - 1);
                                e = vc(function(m, l, n, k) {
                                    for(var t = 0, v = 0; v < b - 1; ++v)g[v] = c[v + 1].readValueFromPointer(k + t), t += c[v + 1].argPackAdvance;
                                    m = m[l].apply(m, g);
                                    for(v = 0; v < b - 1; ++v)c[v + 1].zb && c[v + 1].zb(g[v]);
                                    if (!d.Nb) return d.toWireType(n, m);
                                });
                                return xc[a] = e;
                            },
                            t: function t(b) {
                                b = tc(b);
                                return ab(h[b]);
                            },
                            M: function M(b, a) {
                                b = S(b);
                                a = S(a);
                                return ab(b[a]);
                            },
                            n: function n(b) {
                                4 < b && (Q.get(b).kb += 1);
                            },
                            o: function o(b) {
                                return ab(tc(b));
                            },
                            A: function A() {
                                return ab({});
                            },
                            q: function q(b) {
                                var a = S(b);
                                Eb(a);
                                cc(b);
                            },
                            k: function k(b, a, c) {
                                b = S(b);
                                a = S(a);
                                c = S(c);
                                b[a] = c;
                            },
                            r: function r(b, a) {
                                b = nb(b, "_emval_take_value");
                                b = b.readValueFromPointer(a);
                                return ab(b);
                            },
                            b: function() {
                                ya("");
                            },
                            E: function(b) {
                                var a = L.length;
                                b >>>= 0;
                                if (2147483648 < b) return !1;
                                for(var c = 1; 4 >= c; c *= 2){
                                    var d = a * (1 + .2 / c);
                                    d = Math.min(d, b + 100663296);
                                    var e = Math;
                                    d = Math.max(b, d);
                                    a: {
                                        e = e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - za.buffer.byteLength + 65535 >>> 16;
                                        try {
                                            za.grow(e);
                                            Ga();
                                            var g = 1;
                                            break a;
                                        } catch (m) {}
                                        g = void 0;
                                    }
                                    if (g) return !0;
                                }
                                return !1;
                            },
                            F: function(b, a) {
                                var c = 0;
                                Ac().forEach(function(d, e) {
                                    var g = a + c;
                                    e = P[b + 4 * e >> 2] = g;
                                    for(g = 0; g < d.length; ++g)Ba[e++ >> 0] = d.charCodeAt(g);
                                    Ba[e >> 0] = 0;
                                    c += d.length + 1;
                                });
                                return 0;
                            },
                            G: function(b, a) {
                                var c = Ac();
                                P[b >> 2] = c.length;
                                var d = 0;
                                c.forEach(function(e) {
                                    d += e.length + 1;
                                });
                                P[a >> 2] = d;
                                return 0;
                            },
                            H: function() {
                                return 52;
                            },
                            B: function B() {
                                return 70;
                            },
                            I: function(b, a, c, d) {
                                for(var e = 0, g = 0; g < c; g++){
                                    var m = P[a >> 2], l = P[a + 4 >> 2];
                                    a += 8;
                                    for(var n = 0; n < l; n++){
                                        var k = L[m + n], t = Bc[b];
                                        0 === k || 10 === k ? ((1 === b ? ta : ua)(jc(t, 0)), t.length = 0) : t.push(k);
                                    }
                                    e += l;
                                }
                                P[d >> 2] = e;
                                return 0;
                            },
                            D: function(b, a, c, d) {
                                return Gc(b, a, c, d);
                            }
                        };
                        (function() {
                            function b(c) {
                                J = c = c.exports;
                                za = J.R;
                                Ga();
                                Ha = J.X;
                                Ja.unshift(J.S);
                                Ma--;
                                h.monitorRunDependencies && h.monitorRunDependencies(Ma);
                                if (0 == Ma && (null !== Na && (clearInterval(Na), Na = null), Oa)) {
                                    var d = Oa;
                                    Oa = null;
                                    d();
                                }
                                return c;
                            }
                            var a = {
                                a: Kc
                            };
                            Ma++;
                            h.monitorRunDependencies && h.monitorRunDependencies(Ma);
                            if (h.instantiateWasm) try {
                                return h.instantiateWasm(a, b);
                            } catch (c) {
                                ua("Module.instantiateWasm callback failed with error: " + c), ba(c);
                            }
                            Va(a, function(c) {
                                b(c.instance);
                            }).catch(ba);
                            return {};
                        })();
                        var mb = function(b) {
                            return (mb = J.T)(b);
                        }, Jc = function(b) {
                            return (Jc = J.U)(b);
                        }, lb = function(b) {
                            return (lb = J.V)(b);
                        };
                        h.__embind_initialize_bindings = function() {
                            return (h.__embind_initialize_bindings = J.W)();
                        };
                        h.dynCall_jiji = function(b, a, c, d, e) {
                            return (h.dynCall_jiji = J.Y)(b, a, c, d, e);
                        };
                        h.dynCall_viijii = function(b, a, c, d, e, g, m) {
                            return (h.dynCall_viijii = J.Z)(b, a, c, d, e, g, m);
                        };
                        h.dynCall_iiiiij = function(b, a, c, d, e, g, m) {
                            return (h.dynCall_iiiiij = J._)(b, a, c, d, e, g, m);
                        };
                        h.dynCall_iiiiijj = function(b, a, c, d, e, g, m, l, n) {
                            return (h.dynCall_iiiiijj = J.$)(b, a, c, d, e, g, m, l, n);
                        };
                        h.dynCall_iiiiiijj = function(b, a, c, d, e, g, m, l, n, k) {
                            return (h.dynCall_iiiiiijj = J.aa)(b, a, c, d, e, g, m, l, n, k);
                        };
                        var Lc;
                        Oa = function Mc() {
                            Lc || Nc();
                            Lc || (Oa = Mc);
                        };
                        function Nc() {
                            function b() {
                                if (!Lc && (Lc = !0, h.calledRun = !0, !Aa)) {
                                    Wa(Ja);
                                    aa(h);
                                    if (h.onRuntimeInitialized) h.onRuntimeInitialized();
                                    if (h.postRun) for("function" == typeof h.postRun && (h.postRun = [
                                        h.postRun
                                    ]); h.postRun.length;){
                                        var a = h.postRun.shift();
                                        Ka.unshift(a);
                                    }
                                    Wa(Ka);
                                }
                            }
                            if (!(0 < Ma)) {
                                if (h.preRun) for("function" == typeof h.preRun && (h.preRun = [
                                    h.preRun
                                ]); h.preRun.length;)La();
                                Wa(Ia);
                                0 < Ma || (h.setStatus ? (h.setStatus("Running..."), setTimeout(function() {
                                    setTimeout(function() {
                                        h.setStatus("");
                                    }, 1);
                                    b();
                                }, 1)) : b());
                            }
                        }
                        if (h.preInit) for("function" == typeof h.preInit && (h.preInit = [
                            h.preInit
                        ]); 0 < h.preInit.length;)h.preInit.pop()();
                        Nc();
                        return moduleArg.ready;
                    };
                }();
                /* harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = Rive;
            /***/ },
            /* 2 */ /***/ function(module1) {
                module1.exports = JSON.parse('{"name":"@rive-app/canvas-lite","version":"2.10.1","description":"A lite version of Rive\'s canvas based web api.","main":"rive.js","homepage":"https://rive.app","repository":{"type":"git","url":"https://github.com/rive-app/rive-wasm/tree/master/js"},"keywords":["rive","animation"],"author":"Rive","contributors":["Luigi Rosso <luigi@rive.app> (https://rive.app)","Maxwell Talbot <max@rive.app> (https://rive.app)","Arthur Vivian <arthur@rive.app> (https://rive.app)","Umberto Sonnino <umberto@rive.app> (https://rive.app)","Matthew Sullivan <matt.j.sullivan@gmail.com> (mailto:matt.j.sullivan@gmail.com)"],"license":"MIT","files":["rive.js","rive.js.map","rive.wasm","rive.d.ts","rive_advanced.mjs.d.ts"],"typings":"rive.d.ts","dependencies":{},"browser":{"fs":false,"path":false}}');
            /***/ },
            /* 3 */ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: function() {
                        return /* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.BLANK_URL;
                    },
                    /* harmony export */ registerTouchInteractions: function() {
                        return /* reexport safe */ _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__.registerTouchInteractions;
                    },
                    /* harmony export */ sanitizeUrl: function() {
                        return /* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.sanitizeUrl;
                    }
                });
                /* harmony import */ var _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
                /* harmony import */ var _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
            /***/ },
            /* 4 */ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ registerTouchInteractions: function() {
                        return /* binding */ registerTouchInteractions;
                    }
                });
                var _this = undefined;
                /**
 * Returns the clientX and clientY properties from touch or mouse events. Also
 * calls preventDefault() on the event if it is a touchstart or touchmove to prevent
 * scrolling the page on mobile devices
 * @param event - Either a TouchEvent or a MouseEvent
 * @returns - Coordinates of the clientX and clientY properties from the touch/mouse event
 */ var getClientCoordinates = function getClientCoordinates(event) {
                    var _a, _b;
                    if ([
                        "touchstart",
                        "touchmove"
                    ].indexOf(event.type) > -1 && ((_a = event.touches) === null || _a === void 0 ? void 0 : _a.length)) {
                        event.preventDefault();
                        return {
                            clientX: event.touches[0].clientX,
                            clientY: event.touches[0].clientY
                        };
                    } else if (event.type === "touchend" && ((_b = event.changedTouches) === null || _b === void 0 ? void 0 : _b.length)) return {
                        clientX: event.changedTouches[0].clientX,
                        clientY: event.changedTouches[0].clientY
                    };
                    else return {
                        clientX: event.clientX,
                        clientY: event.clientY
                    };
                };
                /**
 * Registers mouse move/up/down callback handlers on the canvas to send meaningful coordinates to
 * the state machine pointer move/up/down functions based on cursor interaction
 */ var registerTouchInteractions = function registerTouchInteractions(_a) {
                    var canvas = _a.canvas, artboard = _a.artboard, _b = _a.stateMachines, stateMachines = _b === void 0 ? [] : _b, renderer = _a.renderer, rive = _a.rive, fit = _a.fit, alignment = _a.alignment;
                    if (!canvas || !stateMachines.length || !renderer || !rive || !artboard || typeof window === "undefined") return null;
                    var processEventCallback = function processEventCallback(event) {
                        var boundingRect = event.currentTarget.getBoundingClientRect();
                        var _$_a = getClientCoordinates(event), clientX = _$_a.clientX, clientY = _$_a.clientY;
                        if (!clientX && !clientY) return;
                        var canvasX = clientX - boundingRect.left;
                        var canvasY = clientY - boundingRect.top;
                        var forwardMatrix = rive.computeAlignment(fit, alignment, {
                            minX: 0,
                            minY: 0,
                            maxX: boundingRect.width,
                            maxY: boundingRect.height
                        }, artboard.bounds);
                        var invertedMatrix = new rive.Mat2D();
                        forwardMatrix.invert(invertedMatrix);
                        var canvasCoordinatesVector = new rive.Vec2D(canvasX, canvasY);
                        var transformedVector = rive.mapXY(invertedMatrix, canvasCoordinatesVector);
                        var transformedX = transformedVector.x();
                        var transformedY = transformedVector.y();
                        transformedVector.delete();
                        invertedMatrix.delete();
                        canvasCoordinatesVector.delete();
                        forwardMatrix.delete();
                        switch(event.type){
                            /**
             * There's a 2px buffer for a hitRadius when translating the pointer coordinates
             * down to the state machine. In cases where the hitbox is about that much away
             * from the Artboard border, we don't have exact precision on determining pointer
             * exit. We're therefore adding to the translated coordinates on mouseout of a canvas
             * to ensure that we report the mouse has truly exited the hitarea.
             * https://github.com/rive-app/rive-cpp/blob/master/src/animation/state_machine_instance.cpp#L336
             *
             * We add/subtract 10000 to account for when the graphic goes beyond the canvas bound
             * due to for example, a fit: 'cover'. Not perfect, but helps reliably (for now) ensure
             * we report going out of bounds when the mouse is out of the canvas
             */ case "mouseout":
                                for(var _i = 0, stateMachines_1 = stateMachines; _i < stateMachines_1.length; _i++){
                                    var stateMachine = stateMachines_1[_i];
                                    stateMachine.pointerMove(transformedX < 0 ? transformedX - 10000 : transformedX + 10000, transformedY < 0 ? transformedY - 10000 : transformedY + 10000);
                                }
                                break;
                            // Pointer moving/hovering on the canvas
                            case "touchmove":
                            case "mouseover":
                            case "mousemove":
                                for(var _b = 0, stateMachines_2 = stateMachines; _b < stateMachines_2.length; _b++){
                                    var stateMachine = stateMachines_2[_b];
                                    stateMachine.pointerMove(transformedX, transformedY);
                                }
                                break;
                            // Pointer click initiated but not released yet on the canvas
                            case "touchstart":
                            case "mousedown":
                                for(var _c = 0, stateMachines_3 = stateMachines; _c < stateMachines_3.length; _c++){
                                    var stateMachine = stateMachines_3[_c];
                                    stateMachine.pointerDown(transformedX, transformedY);
                                }
                                break;
                            // Pointer click released on the canvas
                            case "touchend":
                            case "mouseup":
                                for(var _d = 0, stateMachines_4 = stateMachines; _d < stateMachines_4.length; _d++){
                                    var stateMachine = stateMachines_4[_d];
                                    stateMachine.pointerUp(transformedX, transformedY);
                                }
                                break;
                            default:
                        }
                    };
                    var callback = processEventCallback.bind(_this);
                    canvas.addEventListener("mouseover", callback);
                    canvas.addEventListener("mouseout", callback);
                    canvas.addEventListener("mousemove", callback);
                    canvas.addEventListener("mousedown", callback);
                    canvas.addEventListener("mouseup", callback);
                    canvas.addEventListener("touchmove", callback);
                    canvas.addEventListener("touchstart", callback);
                    canvas.addEventListener("touchend", callback);
                    return function() {
                        canvas.removeEventListener("mouseover", callback);
                        canvas.removeEventListener("mouseout", callback);
                        canvas.removeEventListener("mousemove", callback);
                        canvas.removeEventListener("mousedown", callback);
                        canvas.removeEventListener("mouseup", callback);
                        canvas.removeEventListener("touchmove", callback);
                        canvas.removeEventListener("touchstart", callback);
                        canvas.removeEventListener("touchend", callback);
                    };
                };
            /***/ },
            /* 5 */ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                var isRelativeUrlWithoutProtocol = function isRelativeUrlWithoutProtocol(url) {
                    return relativeFirstCharacters.indexOf(url[0]) > -1;
                };
                var decodeHtmlCharacters = // adapted from https://stackoverflow.com/a/29824550/2601552
                function decodeHtmlCharacters(str) {
                    var removedNullByte = str.replace(ctrlCharactersRegex, "");
                    return removedNullByte.replace(htmlEntitiesRegex, function(match, dec) {
                        return String.fromCharCode(dec);
                    });
                };
                var sanitizeUrl = function sanitizeUrl(url) {
                    if (!url) return BLANK_URL;
                    var sanitizedUrl = decodeHtmlCharacters(url).replace(htmlCtrlEntityRegex, "").replace(ctrlCharactersRegex, "").trim();
                    if (!sanitizedUrl) return BLANK_URL;
                    if (isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
                    var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
                    if (!urlSchemeParseResults) return sanitizedUrl;
                    var urlScheme = urlSchemeParseResults[0];
                    if (invalidProtocolRegex.test(urlScheme)) return BLANK_URL;
                    return sanitizedUrl;
                };
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: function() {
                        return /* binding */ BLANK_URL;
                    },
                    /* harmony export */ sanitizeUrl: function() {
                        return /* binding */ sanitizeUrl;
                    }
                });
                // Reference: https://github.com/braintree/sanitize-url/tree/main
                var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
                var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
                var htmlCtrlEntityRegex = /&(newline|tab);/gi;
                var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
                var urlSchemeRegex = /^.+(:|&colon;)/gim;
                var relativeFirstCharacters = [
                    ".",
                    "/"
                ];
                var BLANK_URL = "about:blank";
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (function() {
            __webpack_require__.r(__webpack_exports__);
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ Alignment: function() {
                    return /* binding */ Alignment;
                },
                /* harmony export */ EventType: function() {
                    return /* binding */ EventType;
                },
                /* harmony export */ Fit: function() {
                    return /* binding */ Fit;
                },
                /* harmony export */ Layout: function() {
                    return /* binding */ Layout;
                },
                /* harmony export */ LoopType: function() {
                    return /* binding */ LoopType;
                },
                /* harmony export */ Rive: function() {
                    return /* binding */ Rive;
                },
                /* harmony export */ RiveEventType: function() {
                    return /* binding */ RiveEventType;
                },
                /* harmony export */ RuntimeLoader: function() {
                    return /* binding */ RuntimeLoader;
                },
                /* harmony export */ StateMachineInput: function() {
                    return /* binding */ StateMachineInput;
                },
                /* harmony export */ StateMachineInputType: function() {
                    return /* binding */ StateMachineInputType;
                },
                /* harmony export */ Testing: function() {
                    return /* binding */ Testing;
                },
                /* harmony export */ decodeFont: function() {
                    return /* binding */ decodeFont;
                },
                /* harmony export */ decodeImage: function() {
                    return /* binding */ decodeImage;
                }
            });
            /* harmony import */ var _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
            /* harmony import */ var package_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
            /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
            var __awaiter = function __awaiter(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = function __generator(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function sent() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g;
                return g = {
                    next: verb(0),
                    "throw": verb(1),
                    "return": verb(2)
                }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            // #region layout
            // Fit options for the canvas
            var Fit;
            (function(Fit) {
                Fit["Cover"] = "cover";
                Fit["Contain"] = "contain";
                Fit["Fill"] = "fill";
                Fit["FitWidth"] = "fitWidth";
                Fit["FitHeight"] = "fitHeight";
                Fit["None"] = "none";
                Fit["ScaleDown"] = "scaleDown";
            })(Fit || (Fit = {}));
            // Alignment options for the canvas
            var Alignment;
            (function(Alignment) {
                Alignment["Center"] = "center";
                Alignment["TopLeft"] = "topLeft";
                Alignment["TopCenter"] = "topCenter";
                Alignment["TopRight"] = "topRight";
                Alignment["CenterLeft"] = "centerLeft";
                Alignment["CenterRight"] = "centerRight";
                Alignment["BottomLeft"] = "bottomLeft";
                Alignment["BottomCenter"] = "bottomCenter";
                Alignment["BottomRight"] = "bottomRight";
            })(Alignment || (Alignment = {}));
            // Alignment options for Rive animations in a HTML canvas
            var Layout = /** @class */ function() {
                function Layout(params) {
                    var _a, _b, _c, _d, _e, _f;
                    this.fit = (_a = params === null || params === void 0 ? void 0 : params.fit) !== null && _a !== void 0 ? _a : Fit.Contain;
                    this.alignment = (_b = params === null || params === void 0 ? void 0 : params.alignment) !== null && _b !== void 0 ? _b : Alignment.Center;
                    this.minX = (_c = params === null || params === void 0 ? void 0 : params.minX) !== null && _c !== void 0 ? _c : 0;
                    this.minY = (_d = params === null || params === void 0 ? void 0 : params.minY) !== null && _d !== void 0 ? _d : 0;
                    this.maxX = (_e = params === null || params === void 0 ? void 0 : params.maxX) !== null && _e !== void 0 ? _e : 0;
                    this.maxY = (_f = params === null || params === void 0 ? void 0 : params.maxY) !== null && _f !== void 0 ? _f : 0;
                }
                // Alternative constructor to build a Layout from an interface/object
                Layout.new = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    console.warn("This function is deprecated: please use `new Layout({})` instead");
                    return new Layout({
                        fit: fit,
                        alignment: alignment,
                        minX: minX,
                        minY: minY,
                        maxX: maxX,
                        maxY: maxY
                    });
                };
                /**
     * Makes a copy of the layout, replacing any specified parameters
     */ Layout.prototype.copyWith = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    return new Layout({
                        fit: fit !== null && fit !== void 0 ? fit : this.fit,
                        alignment: alignment !== null && alignment !== void 0 ? alignment : this.alignment,
                        minX: minX !== null && minX !== void 0 ? minX : this.minX,
                        minY: minY !== null && minY !== void 0 ? minY : this.minY,
                        maxX: maxX !== null && maxX !== void 0 ? maxX : this.maxX,
                        maxY: maxY !== null && maxY !== void 0 ? maxY : this.maxY
                    });
                };
                // Returns fit for the Wasm runtime format
                Layout.prototype.runtimeFit = function(rive) {
                    if (this.cachedRuntimeFit) return this.cachedRuntimeFit;
                    var fit;
                    if (this.fit === Fit.Cover) fit = rive.Fit.cover;
                    else if (this.fit === Fit.Contain) fit = rive.Fit.contain;
                    else if (this.fit === Fit.Fill) fit = rive.Fit.fill;
                    else if (this.fit === Fit.FitWidth) fit = rive.Fit.fitWidth;
                    else if (this.fit === Fit.FitHeight) fit = rive.Fit.fitHeight;
                    else if (this.fit === Fit.ScaleDown) fit = rive.Fit.scaleDown;
                    else fit = rive.Fit.none;
                    this.cachedRuntimeFit = fit;
                    return fit;
                };
                // Returns alignment for the Wasm runtime format
                Layout.prototype.runtimeAlignment = function(rive) {
                    if (this.cachedRuntimeAlignment) return this.cachedRuntimeAlignment;
                    var alignment;
                    if (this.alignment === Alignment.TopLeft) alignment = rive.Alignment.topLeft;
                    else if (this.alignment === Alignment.TopCenter) alignment = rive.Alignment.topCenter;
                    else if (this.alignment === Alignment.TopRight) alignment = rive.Alignment.topRight;
                    else if (this.alignment === Alignment.CenterLeft) alignment = rive.Alignment.centerLeft;
                    else if (this.alignment === Alignment.CenterRight) alignment = rive.Alignment.centerRight;
                    else if (this.alignment === Alignment.BottomLeft) alignment = rive.Alignment.bottomLeft;
                    else if (this.alignment === Alignment.BottomCenter) alignment = rive.Alignment.bottomCenter;
                    else if (this.alignment === Alignment.BottomRight) alignment = rive.Alignment.bottomRight;
                    else alignment = rive.Alignment.center;
                    this.cachedRuntimeAlignment = alignment;
                    return alignment;
                };
                return Layout;
            }();
            // Runtime singleton; use getInstance to provide a callback that returns the
            // Rive runtime
            var RuntimeLoader = /** @class */ function() {
                // Class is never instantiated
                function RuntimeLoader() {}
                // Loads the runtime
                RuntimeLoader.loadRuntime = function() {
                    _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__["default"]({
                        // Loads Wasm bundle
                        locateFile: function locateFile() {
                            return RuntimeLoader.wasmURL;
                        }
                    }).then(function(rive) {
                        var _a;
                        RuntimeLoader.runtime = rive;
                        // Fire all the callbacks
                        while(RuntimeLoader.callBackQueue.length > 0)(_a = RuntimeLoader.callBackQueue.shift()) === null || _a === void 0 || _a(RuntimeLoader.runtime);
                    }).catch(function() {
                        // In case unpkg fails or goes down, we should try to load from jsdelivr
                        var backupJsdelivrUrl = "https://cdn.jsdelivr.net/npm/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive.wasm");
                        if (RuntimeLoader.wasmURL.toLowerCase() !== backupJsdelivrUrl) {
                            console.warn("Failed to load WASM from ".concat(RuntimeLoader.wasmURL, ", trying jsdelivr as a backup"));
                            RuntimeLoader.setWasmUrl(backupJsdelivrUrl);
                            RuntimeLoader.loadRuntime();
                        } else console.error("Could not load Rive WASM file from unpkg or jsdelivr, network connection may be down, or         you may need to call set a new WASM source via RuntimeLoader.setWasmUrl() and call         RuntimeLoader.loadRuntime() again");
                    });
                };
                // Provides a runtime instance via a callback
                RuntimeLoader.getInstance = function(callback) {
                    // If it's not loading, start loading runtime
                    if (!RuntimeLoader.isLoading) {
                        RuntimeLoader.isLoading = true;
                        RuntimeLoader.loadRuntime();
                    }
                    if (!RuntimeLoader.runtime) RuntimeLoader.callBackQueue.push(callback);
                    else callback(RuntimeLoader.runtime);
                };
                // Provides a runtime instance via a promise
                RuntimeLoader.awaitInstance = function() {
                    return new Promise(function(resolve) {
                        return RuntimeLoader.getInstance(function(rive) {
                            return resolve(rive);
                        });
                    });
                };
                // Manually sets the wasm url
                RuntimeLoader.setWasmUrl = function(url) {
                    RuntimeLoader.wasmURL = url;
                };
                // Flag to indicate that loading has started/completed
                RuntimeLoader.isLoading = false;
                // List of callbacks for the runtime that come in while loading
                RuntimeLoader.callBackQueue = [];
                // Path to the Wasm file; default path works for testing only;
                // if embedded wasm is used then this is never used.
                RuntimeLoader.wasmURL = "https://unpkg.com/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive.wasm");
                return RuntimeLoader;
            }();
            // #endregion
            // #region animations
            // Wraps animations and instances from the runtime and keeps track of playback
            // state
            var Animation = /** @class */ function() {
                /**
     * Constructs a new animation
     * @constructor
     * @param {any} animation: runtime animation object
     * @param {any} instance: runtime animation instance object
     */ function Animation(animation, artboard, runtime, playing) {
                    this.animation = animation;
                    this.artboard = artboard;
                    this.playing = playing;
                    this.loopCount = 0;
                    // Time to which the animation should move to on the next render
                    this.scrubTo = null;
                    this.instance = new runtime.LinearAnimationInstance(animation, artboard);
                }
                Object.defineProperty(Animation.prototype, "name", {
                    // Returns the animation's name
                    get: function get() {
                        return this.animation.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animation.prototype, "time", {
                    // Returns the animation's current time
                    get: function get() {
                        return this.instance.time;
                    },
                    // Sets the animation's current time
                    set: function set(value) {
                        this.instance.time = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animation.prototype, "loopValue", {
                    // Returns the animation's loop type
                    get: function get() {
                        return this.animation.loopValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Advances the animation by the give time. If the animation needs scrubbing,
     * time is ignored and the stored scrub value is used.
     * @param time the time to advance the animation by if no scrubbing required
     */ Animation.prototype.advance = function(time) {
                    if (this.scrubTo === null) this.instance.advance(time);
                    else {
                        this.instance.time = 0;
                        this.instance.advance(this.scrubTo);
                        this.scrubTo = null;
                    }
                };
                /**
     * Apply interpolated keyframe values to the artboard. This should be called after calling
     * .advance() on an animation instance so that new values are applied to properties.
     *
     * Note: This does not advance the artboard, which updates all objects on the artboard
     * @param mix - Mix value for the animation from 0 to 1
     */ Animation.prototype.apply = function(mix) {
                    this.instance.apply(mix);
                };
                Object.defineProperty(Animation.prototype, "needsScrub", {
                    get: function get() {
                        return this.scrubTo !== null;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Deletes the backing Wasm animation instance; once this is called, this
     * animation is no more.
     */ Animation.prototype.cleanup = function() {
                    this.instance.delete();
                };
                return Animation;
            }();
            // #endregion
            // #region state machines
            var StateMachineInputType;
            (function(StateMachineInputType) {
                StateMachineInputType[StateMachineInputType["Number"] = 56] = "Number";
                StateMachineInputType[StateMachineInputType["Trigger"] = 58] = "Trigger";
                StateMachineInputType[StateMachineInputType["Boolean"] = 59] = "Boolean";
            })(StateMachineInputType || (StateMachineInputType = {}));
            /**
 * An input for a state machine
 */ var StateMachineInput = /** @class */ function() {
                function StateMachineInput(type, runtimeInput) {
                    this.type = type;
                    this.runtimeInput = runtimeInput;
                }
                Object.defineProperty(StateMachineInput.prototype, "name", {
                    /**
         * Returns the name of the input
         */ get: function get() {
                        return this.runtimeInput.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachineInput.prototype, "value", {
                    /**
         * Returns the current value of the input
         */ get: function get() {
                        return this.runtimeInput.value;
                    },
                    /**
         * Sets the value of the input
         */ set: function set(value) {
                        this.runtimeInput.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Fires a trigger; does nothing on Number or Boolean input types
     */ StateMachineInput.prototype.fire = function() {
                    if (this.type === StateMachineInputType.Trigger) this.runtimeInput.fire();
                };
                return StateMachineInput;
            }();
            var RiveEventType;
            (function(RiveEventType) {
                RiveEventType[RiveEventType["General"] = 128] = "General";
                RiveEventType[RiveEventType["OpenUrl"] = 131] = "OpenUrl";
            })(RiveEventType || (RiveEventType = {}));
            var StateMachine = /** @class */ function() {
                /**
     * @constructor
     * @param stateMachine runtime state machine object
     * @param instance runtime state machine instance object
     */ function StateMachine(stateMachine, runtime, playing, artboard) {
                    this.stateMachine = stateMachine;
                    this.playing = playing;
                    this.artboard = artboard;
                    /**
         * Caches the inputs from the runtime
         */ this.inputs = [];
                    this.instance = new runtime.StateMachineInstance(stateMachine, artboard);
                    this.initInputs(runtime);
                }
                Object.defineProperty(StateMachine.prototype, "name", {
                    get: function get() {
                        return this.stateMachine.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachine.prototype, "statesChanged", {
                    /**
         * Returns a list of state names that have changed on this frame
         */ get: function get() {
                        var names = [];
                        for(var i = 0; i < this.instance.stateChangedCount(); i++)names.push(this.instance.stateChangedNameByIndex(i));
                        return names;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Advances the state machine instance by a given time.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advance = function(time) {
                    this.instance.advance(time);
                };
                /**
     * Returns the number of events reported from the last advance call
     * @returns Number of events reported
     */ StateMachine.prototype.reportedEventCount = function() {
                    return this.instance.reportedEventCount();
                };
                /**
     * Returns a RiveEvent object emitted from the last advance call at the given index
     * of a list of potentially multiple events. If an event at the index is not found,
     * undefined is returned.
     * @param i index of the event reported in a list of potentially multiple events
     * @returns RiveEvent or extended RiveEvent object returned, or undefined
     */ StateMachine.prototype.reportedEventAt = function(i) {
                    return this.instance.reportedEventAt(i);
                };
                /**
     * Fetches references to the state machine's inputs and caches them
     * @param runtime an instance of the runtime; needed for the SMIInput types
     */ StateMachine.prototype.initInputs = function(runtime) {
                    // Fetch the inputs from the runtime if we don't have them
                    for(var i = 0; i < this.instance.inputCount(); i++){
                        var input = this.instance.input(i);
                        this.inputs.push(this.mapRuntimeInput(input, runtime));
                    }
                };
                /**
     * Maps a runtime input to it's appropriate type
     * @param input
     */ StateMachine.prototype.mapRuntimeInput = function(input, runtime) {
                    if (input.type === runtime.SMIInput.bool) return new StateMachineInput(StateMachineInputType.Boolean, input.asBool());
                    else if (input.type === runtime.SMIInput.number) return new StateMachineInput(StateMachineInputType.Number, input.asNumber());
                    else if (input.type === runtime.SMIInput.trigger) return new StateMachineInput(StateMachineInputType.Trigger, input.asTrigger());
                };
                /**
     * Deletes the backing Wasm state machine instance; once this is called, this
     * state machine is no more.
     */ StateMachine.prototype.cleanup = function() {
                    this.instance.delete();
                };
                return StateMachine;
            }();
            // #endregion
            // #region animator
            /**
 * Manages animation
 */ var Animator = /** @class */ function() {
                /**
     * Constructs a new animator
     * @constructor
     * @param runtime Rive runtime; needed to instance animations & state machines
     * @param artboard the artboard that holds all animations and state machines
     * @param animations optional list of animations
     * @param stateMachines optional list of state machines
     */ function Animator(runtime, artboard, eventManager, animations, stateMachines) {
                    if (animations === void 0) animations = [];
                    if (stateMachines === void 0) stateMachines = [];
                    this.runtime = runtime;
                    this.artboard = artboard;
                    this.eventManager = eventManager;
                    this.animations = animations;
                    this.stateMachines = stateMachines;
                }
                /**
     * Adds animations and state machines by their names. If names are shared
     * between animations & state machines, then the first one found will be
     * created. Best not to use the same names for these in your Rive file.
     * @param animatable the name(s) of animations and state machines to add
     * @returns a list of names of the playing animations and state machines
     */ Animator.prototype.add = function(animatables, playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    animatables = mapToStringArray(animatables);
                    // If animatables is empty, play or pause everything
                    if (animatables.length === 0) {
                        this.animations.forEach(function(a) {
                            return a.playing = playing;
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.playing = playing;
                        });
                    } else {
                        // Play/pause already instanced items, or create new instances
                        var instancedAnimationNames = this.animations.map(function(a) {
                            return a.name;
                        });
                        var instancedMachineNames = this.stateMachines.map(function(m) {
                            return m.name;
                        });
                        for(var i = 0; i < animatables.length; i++){
                            var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                            var mIndex = instancedMachineNames.indexOf(animatables[i]);
                            if (aIndex >= 0 || mIndex >= 0) {
                                if (aIndex >= 0) // Animation is instanced, play/pause it
                                this.animations[aIndex].playing = playing;
                                else // State machine is instanced, play/pause it
                                this.stateMachines[mIndex].playing = playing;
                            } else {
                                // Try to create a new animation instance
                                var anim = this.artboard.animationByName(animatables[i]);
                                if (anim) {
                                    var newAnimation = new Animation(anim, this.artboard, this.runtime, playing);
                                    // Display the first frame of the specified animation
                                    newAnimation.advance(0);
                                    newAnimation.apply(1.0);
                                    this.animations.push(newAnimation);
                                } else {
                                    // Try to create a new state machine instance
                                    var sm = this.artboard.stateMachineByName(animatables[i]);
                                    if (sm) {
                                        var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                        this.stateMachines.push(newStateMachine);
                                    }
                                }
                            }
                        }
                    }
                    // Fire play/paused events for animations
                    if (fireEvent) {
                        if (playing) this.eventManager.fire({
                            type: EventType.Play,
                            data: this.playing
                        });
                        else this.eventManager.fire({
                            type: EventType.Pause,
                            data: this.paused
                        });
                    }
                    return playing ? this.playing : this.paused;
                };
                /**
     * Adds linear animations by their names.
     * @param animatables the name(s) of animations to add
     * @param playing whether animations should play on instantiation
     */ Animator.prototype.initLinearAnimations = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedAnimationNames = this.animations.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.animations[aIndex].playing = playing;
                        else {
                            // Try to create a new animation instance
                            var anim = this.artboard.animationByName(animatables[i]);
                            if (anim) {
                                var newAnimation = new Animation(anim, this.artboard, this.runtime, playing);
                                // Display the first frame of the specified animation
                                newAnimation.advance(0);
                                newAnimation.apply(1.0);
                                this.animations.push(newAnimation);
                            }
                        }
                    }
                };
                /**
     * Adds state machines by their names.
     * @param animatables the name(s) of state machines to add
     * @param playing whether state machines should play on instantiation
     */ Animator.prototype.initStateMachines = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedStateMachineNames = this.stateMachines.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedStateMachineNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.stateMachines[aIndex].playing = playing;
                        else {
                            // Try to create a new state machine instance
                            var sm = this.artboard.stateMachineByName(animatables[i]);
                            if (sm) {
                                var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                this.stateMachines.push(newStateMachine);
                            } else // In order to maintain compatibility with current behavior, if a state machine is not found
                            // we look for an animation with the same name
                            this.initLinearAnimations([
                                animatables[i]
                            ], playing);
                        }
                    }
                };
                /**
     * Play the named animations/state machines
     * @param animatables the names of the animations/machines to play; plays all if empty
     * @returns a list of the playing items
     */ Animator.prototype.play = function(animatables) {
                    return this.add(animatables, true);
                };
                /**
     * Pauses named animations and state machines, or everything if nothing is
     * specified
     * @param animatables names of the animations and state machines to pause
     * @returns a list of names of the animations and state machines paused
     */ Animator.prototype.pause = function(animatables) {
                    return this.add(animatables, false);
                };
                /**
     * Set time of named animations
     * @param animations names of the animations to scrub
     * @param value time scrub value, a floating point number to which the playhead is jumped
     * @returns a list of names of the animations that were scrubbed
     */ Animator.prototype.scrub = function(animatables, value) {
                    var forScrubbing = this.animations.filter(function(a) {
                        return animatables.includes(a.name);
                    });
                    forScrubbing.forEach(function(a) {
                        return a.scrubTo = value;
                    });
                    return forScrubbing.map(function(a) {
                        return a.name;
                    });
                };
                Object.defineProperty(Animator.prototype, "playing", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * playing
         */ get: function get() {
                        return this.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "paused", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * paused
         */ get: function get() {
                        return this.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Stops and removes all named animations and state machines
     * @param animatables animations and state machines to remove
     * @returns a list of names of removed items
     */ Animator.prototype.stop = function(animatables) {
                    var _this = this;
                    animatables = mapToStringArray(animatables);
                    // If nothing's specified, wipe them out, all of them
                    var removedNames = [];
                    // Stop everything
                    if (animatables.length === 0) {
                        removedNames = this.animations.map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.map(function(m) {
                            return m.name;
                        }));
                        // Clean up before emptying the arrays
                        this.animations.forEach(function(a) {
                            return a.cleanup();
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.cleanup();
                        });
                        // Empty out the arrays
                        this.animations.splice(0, this.animations.length);
                        this.stateMachines.splice(0, this.stateMachines.length);
                    } else {
                        // Remove only the named animations/state machines
                        var animationsToRemove = this.animations.filter(function(a) {
                            return animatables.includes(a.name);
                        });
                        animationsToRemove.forEach(function(a) {
                            a.cleanup();
                            _this.animations.splice(_this.animations.indexOf(a), 1);
                        });
                        var machinesToRemove = this.stateMachines.filter(function(m) {
                            return animatables.includes(m.name);
                        });
                        machinesToRemove.forEach(function(m) {
                            m.cleanup();
                            _this.stateMachines.splice(_this.stateMachines.indexOf(m), 1);
                        });
                        removedNames = animationsToRemove.map(function(a) {
                            return a.name;
                        }).concat(machinesToRemove.map(function(m) {
                            return m.name;
                        }));
                    }
                    this.eventManager.fire({
                        type: EventType.Stop,
                        data: removedNames
                    });
                    // Return the list of animations removed
                    return removedNames;
                };
                Object.defineProperty(Animator.prototype, "isPlaying", {
                    /**
         * Returns true if at least one animation is active
         */ get: function get() {
                        return this.animations.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false) || this.stateMachines.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isPaused", {
                    /**
         * Returns true if all animations are paused and there's at least one animation
         */ get: function get() {
                        return !this.isPlaying && (this.animations.length > 0 || this.stateMachines.length > 0);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isStopped", {
                    /**
         * Returns true if there are no playing or paused animations/state machines
         */ get: function get() {
                        return this.animations.length === 0 && this.stateMachines.length === 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * If there are no animations or state machines, add the first one found
     * @returns the name of the animation or state machine instanced
     */ Animator.prototype.atLeastOne = function(playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    var instancedName;
                    if (this.animations.length === 0 && this.stateMachines.length === 0) {
                        if (this.artboard.animationCount() > 0) // Add the first animation
                        this.add([
                            instancedName = this.artboard.animationByIndex(0).name
                        ], playing, fireEvent);
                        else if (this.artboard.stateMachineCount() > 0) // Add the first state machine
                        this.add([
                            instancedName = this.artboard.stateMachineByIndex(0).name
                        ], playing, fireEvent);
                    }
                    return instancedName;
                };
                /**
     * Checks if any animations have looped and if so, fire the appropriate event
     */ Animator.prototype.handleLooping = function() {
                    for(var _i = 0, _a = this.animations.filter(function(a) {
                        return a.playing;
                    }); _i < _a.length; _i++){
                        var animation = _a[_i];
                        // Emit if the animation looped
                        if (animation.loopValue === 0 && animation.loopCount) {
                            animation.loopCount = 0;
                            // This is a one-shot; if it has ended, delete the instance
                            this.stop(animation.name);
                        } else if (animation.loopValue === 1 && animation.loopCount) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.Loop
                                }
                            });
                            animation.loopCount = 0;
                        } else if (animation.loopValue === 2 && animation.loopCount > 1) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.PingPong
                                }
                            });
                            animation.loopCount = 0;
                        }
                    }
                };
                /**
     * Checks if states have changed in state machines and fires a statechange
     * event
     */ Animator.prototype.handleStateChanges = function() {
                    var statesChanged = [];
                    for(var _i = 0, _a = this.stateMachines.filter(function(sm) {
                        return sm.playing;
                    }); _i < _a.length; _i++){
                        var stateMachine = _a[_i];
                        statesChanged.push.apply(statesChanged, stateMachine.statesChanged);
                    }
                    if (statesChanged.length > 0) this.eventManager.fire({
                        type: EventType.StateChange,
                        data: statesChanged
                    });
                };
                Animator.prototype.handleAdvancing = function(time) {
                    this.eventManager.fire({
                        type: EventType.Advance,
                        data: time
                    });
                };
                return Animator;
            }();
            // #endregion
            // #region events
            /**
 * Supported event types triggered in Rive
 */ var EventType;
            (function(EventType) {
                EventType["Load"] = "load";
                EventType["LoadError"] = "loaderror";
                EventType["Play"] = "play";
                EventType["Pause"] = "pause";
                EventType["Stop"] = "stop";
                EventType["Loop"] = "loop";
                EventType["Draw"] = "draw";
                EventType["Advance"] = "advance";
                EventType["StateChange"] = "statechange";
                EventType["RiveEvent"] = "riveevent";
            })(EventType || (EventType = {}));
            /**
 * Looping types: one-shot, loop, and ping-pong
 */ var LoopType;
            (function(LoopType) {
                LoopType["OneShot"] = "oneshot";
                LoopType["Loop"] = "loop";
                LoopType["PingPong"] = "pingpong";
            })(LoopType || (LoopType = {}));
            // Manages Rive events and listeners
            var EventManager = /** @class */ function() {
                function EventManager(listeners) {
                    if (listeners === void 0) listeners = [];
                    this.listeners = listeners;
                }
                // Gets listeners of specified type
                EventManager.prototype.getListeners = function(type) {
                    return this.listeners.filter(function(e) {
                        return e.type === type;
                    });
                };
                // Adds a listener
                EventManager.prototype.add = function(listener) {
                    if (!this.listeners.includes(listener)) this.listeners.push(listener);
                };
                /**
     * Removes a listener
     * @param listener the listener with the callback to be removed
     */ EventManager.prototype.remove = function(listener) {
                    // We can't simply look for the listener as it'll be a different instance to
                    // one originally subscribed. Find all the listeners of the right type and
                    // then check their callbacks which should match.
                    for(var i = 0; i < this.listeners.length; i++){
                        var currentListener = this.listeners[i];
                        if (currentListener.type === listener.type) {
                            if (currentListener.callback === listener.callback) {
                                this.listeners.splice(i, 1);
                                break;
                            }
                        }
                    }
                };
                /**
     * Clears all listeners of specified type, or every listener if no type is
     * specified
     * @param type the type of listeners to clear, or all listeners if not
     * specified
     */ EventManager.prototype.removeAll = function(type) {
                    var _this = this;
                    if (!type) this.listeners.splice(0, this.listeners.length);
                    else this.listeners.filter(function(l) {
                        return l.type === type;
                    }).forEach(function(l) {
                        return _this.remove(l);
                    });
                };
                // Fires an event
                EventManager.prototype.fire = function(event) {
                    var eventListeners = this.getListeners(event.type);
                    eventListeners.forEach(function(listener) {
                        return listener.callback(event);
                    });
                };
                return EventManager;
            }();
            // Manages a queue of tasks
            var TaskQueueManager = /** @class */ function() {
                function TaskQueueManager(eventManager) {
                    this.eventManager = eventManager;
                    this.queue = [];
                }
                // Adds a task top the queue
                TaskQueueManager.prototype.add = function(task) {
                    this.queue.push(task);
                };
                // Processes all tasks in the queue
                TaskQueueManager.prototype.process = function() {
                    while(this.queue.length > 0){
                        var task = this.queue.shift();
                        if (task === null || task === void 0 ? void 0 : task.action) task.action();
                        if (task === null || task === void 0 ? void 0 : task.event) this.eventManager.fire(task.event);
                    }
                };
                return TaskQueueManager;
            }();
            var Rive = /** @class */ function() {
                function Rive(params) {
                    var _a;
                    // Tracks if a Rive file is loaded
                    this.loaded = false;
                    /**
         * Tracks if a Rive file is loaded; we need this in addition to loaded as some
         * commands (e.g. contents) can be called as soon as the file is loaded.
         * However, playback commands need to be queued and run in order once initial
         * animations and autoplay has been sorted out. This applies to play, pause,
         * and start.
         */ this.readyForPlaying = false;
                    // Runtime artboard
                    this.artboard = null;
                    // place to clear up event listeners
                    this.eventCleanup = null;
                    this.shouldDisableRiveListeners = false;
                    this.automaticallyHandleEvents = false;
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    // Durations to generate a frame for the last second. Used for performance profiling.
                    this.durations = [];
                    this.frameTimes = [];
                    this.frameCount = 0;
                    /**
         * Used be draw to track when a second of active rendering time has passed.
         * Used for debugging purposes
         */ this.renderSecondTimer = 0;
                    this.canvas = params.canvas;
                    this.src = params.src;
                    this.buffer = params.buffer;
                    this.layout = (_a = params.layout) !== null && _a !== void 0 ? _a : new Layout();
                    this.shouldDisableRiveListeners = !!params.shouldDisableRiveListeners;
                    this.automaticallyHandleEvents = !!params.automaticallyHandleEvents;
                    this.enableRiveAssetCDN = params.enableRiveAssetCDN === undefined ? true : params.enableRiveAssetCDN;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                    if (params.onPlay) this.on(EventType.Play, params.onPlay);
                    if (params.onPause) this.on(EventType.Pause, params.onPause);
                    if (params.onStop) this.on(EventType.Stop, params.onStop);
                    if (params.onLoop) this.on(EventType.Loop, params.onLoop);
                    if (params.onStateChange) this.on(EventType.StateChange, params.onStateChange);
                    if (params.onAdvance) this.on(EventType.Advance, params.onAdvance);
                    /**
         * @deprecated Use camelCase'd versions instead.
         */ if (params.onload && !params.onLoad) this.on(EventType.Load, params.onload);
                    if (params.onloaderror && !params.onLoadError) this.on(EventType.LoadError, params.onloaderror);
                    if (params.onplay && !params.onPlay) this.on(EventType.Play, params.onplay);
                    if (params.onpause && !params.onPause) this.on(EventType.Pause, params.onpause);
                    if (params.onstop && !params.onStop) this.on(EventType.Stop, params.onstop);
                    if (params.onloop && !params.onLoop) this.on(EventType.Loop, params.onloop);
                    if (params.onstatechange && !params.onStateChange) this.on(EventType.StateChange, params.onstatechange);
                    /**
         * Asset loading
         */ if (params.assetLoader) this.assetLoader = params.assetLoader;
                    // Hook up the task queue
                    this.taskQueue = new TaskQueueManager(this.eventManager);
                    this.init({
                        src: this.src,
                        buffer: this.buffer,
                        autoplay: params.autoplay,
                        animations: params.animations,
                        stateMachines: params.stateMachines,
                        artboard: params.artboard,
                        useOffscreenRenderer: params.useOffscreenRenderer
                    });
                }
                // Alternative constructor to build a Rive instance from an interface/object
                Rive.new = function(params) {
                    console.warn("This function is deprecated: please use `new Rive({})` instead");
                    return new Rive(params);
                };
                // Initializes the Rive object either from constructor or load()
                Rive.prototype.init = function(_a) {
                    var _this = this;
                    var src = _a.src, buffer = _a.buffer, animations = _a.animations, stateMachines = _a.stateMachines, artboard = _a.artboard, _b = _a.autoplay, autoplay = _b === void 0 ? false : _b, _c = _a.useOffscreenRenderer, useOffscreenRenderer = _c === void 0 ? false : _c;
                    this.src = src;
                    this.buffer = buffer;
                    // If no source file url specified, it's a bust
                    if (!this.src && !this.buffer) throw new Error(Rive.missingErrorMessage);
                    // List of animations that should be initialized.
                    var startingAnimationNames = mapToStringArray(animations);
                    // List of state machines that should be initialized
                    var startingStateMachineNames = mapToStringArray(stateMachines);
                    // Ensure loaded is marked as false if loading new file
                    this.loaded = false;
                    this.readyForPlaying = false;
                    // Ensure the runtime is loaded
                    RuntimeLoader.awaitInstance().then(function(runtime) {
                        _this.runtime = runtime;
                        // Get the canvas where you want to render the animation and create a renderer
                        _this.renderer = _this.runtime.makeRenderer(_this.canvas, useOffscreenRenderer);
                        // Initial size adjustment based on devicePixelRatio if no width/height are
                        // specified explicitly
                        if (!(_this.canvas.width || _this.canvas.height)) _this.resizeDrawingSurfaceToCanvas();
                        // Load Rive data from a source uri or a data buffer
                        _this.initData(artboard, startingAnimationNames, startingStateMachineNames, autoplay).then(function() {
                            return _this.setupRiveListeners();
                        }).catch(function(e) {
                            console.error(e);
                        });
                    }).catch(function(e) {
                        console.error(e);
                    });
                };
                Rive.prototype.setupRiveListeners = function() {
                    var _this = this;
                    if (!this.shouldDisableRiveListeners) {
                        var activeStateMachines = (this.animator.stateMachines || []).filter(function(sm) {
                            return sm.playing && _this.runtime.hasListeners(sm.instance);
                        }).map(function(sm) {
                            return sm.instance;
                        });
                        this.eventCleanup = (0, _utils__WEBPACK_IMPORTED_MODULE_2__.registerTouchInteractions)({
                            canvas: this.canvas,
                            artboard: this.artboard,
                            stateMachines: activeStateMachines,
                            renderer: this.renderer,
                            rive: this.runtime,
                            fit: this._layout.runtimeFit(this.runtime),
                            alignment: this._layout.runtimeAlignment(this.runtime)
                        });
                    }
                };
                // Initializes runtime with Rive data and preps for playing
                Rive.prototype.initData = function(artboardName, animationNames, stateMachineNames, autoplay) {
                    var _a;
                    return __awaiter(this, void 0, void 0, function() {
                        var _b, loader, _c, msg;
                        return __generator(this, function(_d) {
                            switch(_d.label){
                                case 0:
                                    if (!this.src) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    _b = this;
                                    return [
                                        4 /*yield*/ ,
                                        loadRiveFile(this.src)
                                    ];
                                case 1:
                                    _b.buffer = _d.sent();
                                    _d.label = 2;
                                case 2:
                                    if (this.assetLoader) loader = new this.runtime.CustomFileAssetLoader({
                                        loadContents: this.assetLoader
                                    });
                                    // Load the Rive file
                                    _c = this;
                                    return [
                                        4 /*yield*/ ,
                                        this.runtime.load(new Uint8Array(this.buffer), loader, this.enableRiveAssetCDN)
                                    ];
                                case 3:
                                    // Load the Rive file
                                    _c.file = _d.sent();
                                    if (this.file) {
                                        // Initialize and draw frame
                                        this.initArtboard(artboardName, animationNames, stateMachineNames, autoplay);
                                        // Everything's set up, emit a load event
                                        this.loaded = true;
                                        this.eventManager.fire({
                                            type: EventType.Load,
                                            data: (_a = this.src) !== null && _a !== void 0 ? _a : "buffer"
                                        });
                                        // Flag ready for playback commands and clear the task queue; this order
                                        // is important or it may infinitely recurse
                                        this.readyForPlaying = true;
                                        this.taskQueue.process();
                                        this.drawFrame();
                                        return [
                                            2 /*return*/ ,
                                            Promise.resolve()
                                        ];
                                    } else {
                                        msg = "Problem loading file; may be corrupt!";
                                        console.warn(msg);
                                        this.eventManager.fire({
                                            type: EventType.LoadError,
                                            data: msg
                                        });
                                        return [
                                            2 /*return*/ ,
                                            Promise.reject(msg)
                                        ];
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                // Initialize for playback
                Rive.prototype.initArtboard = function(artboardName, animationNames, stateMachineNames, autoplay) {
                    // Fetch the artboard
                    var rootArtboard = artboardName ? this.file.artboardByName(artboardName) : this.file.defaultArtboard();
                    // Check we have a working artboard
                    if (!rootArtboard) {
                        var msg = "Invalid artboard name or no default artboard";
                        console.warn(msg);
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        return;
                    }
                    this.artboard = rootArtboard;
                    // Check that the artboard has at least 1 animation
                    if (this.artboard.animationCount() < 1) {
                        var msg = "Artboard has no animations";
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        throw msg;
                    }
                    // Initialize the animator
                    this.animator = new Animator(this.runtime, this.artboard, this.eventManager);
                    // Initialize the animations; as loaded hasn't happened yet, we need to
                    // suppress firing the play/pause events until the load event has fired. To
                    // do this we tell the animator to suppress firing events, and add event
                    // firing to the task queue.
                    var instanceNames;
                    if (animationNames.length > 0 || stateMachineNames.length > 0) {
                        instanceNames = animationNames.concat(stateMachineNames);
                        this.animator.initLinearAnimations(animationNames, autoplay);
                        this.animator.initStateMachines(stateMachineNames, autoplay);
                    } else instanceNames = [
                        this.animator.atLeastOne(autoplay, false)
                    ];
                    // Queue up firing the playback events
                    this.taskQueue.add({
                        event: {
                            type: autoplay ? EventType.Play : EventType.Pause,
                            data: instanceNames
                        }
                    });
                };
                // Draws the current artboard frame
                Rive.prototype.drawFrame = function() {
                    this.startRendering();
                };
                /**
     * Draw rendering loop; renders animation frames at the correct time interval.
     * @param time the time at which to render a frame
     */ Rive.prototype.draw = function(time, onSecond) {
                    var before = performance.now();
                    // Clear the frameRequestId, as we're now rendering a fresh frame
                    this.frameRequestId = null;
                    // On the first pass, make sure lastTime has a valid value
                    if (!this.lastRenderTime) this.lastRenderTime = time;
                    // Handle the onSecond callback
                    this.renderSecondTimer += time - this.lastRenderTime;
                    if (this.renderSecondTimer > 5000) {
                        this.renderSecondTimer = 0;
                        onSecond === null || onSecond === void 0 || onSecond();
                    }
                    // Calculate the elapsed time between frames in seconds
                    var elapsedTime = (time - this.lastRenderTime) / 1000;
                    this.lastRenderTime = time;
                    // - Advance non-paused animations by the elapsed number of seconds
                    // - Advance any animations that require scrubbing
                    // - Advance to the first frame even when autoplay is false
                    var activeAnimations = this.animator.animations.filter(function(a) {
                        return a.playing || a.needsScrub;
                    })// The scrubbed animations must be applied first to prevent weird artifacts
                    // if the playing animations conflict with the scrubbed animating attribuates.
                    .sort(function(first) {
                        return first.needsScrub ? -1 : 1;
                    });
                    for(var _i = 0, activeAnimations_1 = activeAnimations; _i < activeAnimations_1.length; _i++){
                        var animation = activeAnimations_1[_i];
                        animation.advance(elapsedTime);
                        if (animation.instance.didLoop) animation.loopCount += 1;
                        animation.apply(1.0);
                    }
                    // - Advance non-paused state machines by the elapsed number of seconds
                    // - Advance to the first frame even when autoplay is false
                    var activeStateMachines = this.animator.stateMachines.filter(function(a) {
                        return a.playing;
                    });
                    for(var _a = 0, activeStateMachines_1 = activeStateMachines; _a < activeStateMachines_1.length; _a++){
                        var stateMachine = activeStateMachines_1[_a];
                        // Check for events before the current frame's state machine advance
                        var numEventsReported = stateMachine.reportedEventCount();
                        if (numEventsReported) for(var i = 0; i < numEventsReported; i++){
                            var event_1 = stateMachine.reportedEventAt(i);
                            if (event_1) {
                                if (event_1.type === RiveEventType.OpenUrl) {
                                    this.eventManager.fire({
                                        type: EventType.RiveEvent,
                                        data: event_1
                                    });
                                    // Handle the event side effect if explicitly enabled
                                    if (this.automaticallyHandleEvents) {
                                        var newAnchorTag = document.createElement("a");
                                        var _b = event_1, url = _b.url, target = _b.target;
                                        var sanitizedUrl = (0, _utils__WEBPACK_IMPORTED_MODULE_2__.sanitizeUrl)(url);
                                        url && newAnchorTag.setAttribute("href", sanitizedUrl);
                                        target && newAnchorTag.setAttribute("target", target);
                                        if (sanitizedUrl && sanitizedUrl !== _utils__WEBPACK_IMPORTED_MODULE_2__.BLANK_URL) newAnchorTag.click();
                                    }
                                } else this.eventManager.fire({
                                    type: EventType.RiveEvent,
                                    data: event_1
                                });
                            }
                        }
                        stateMachine.advance(elapsedTime);
                    // stateMachine.instance.apply(this.artboard);
                    }
                    // Once the animations have been applied to the artboard, advance it
                    // by the elapsed time.
                    this.artboard.advance(elapsedTime);
                    var renderer = this.renderer;
                    // Canvas must be wiped to prevent artifacts
                    renderer.clear();
                    renderer.save();
                    // Update the renderer alignment if necessary
                    this.alignRenderer();
                    this.artboard.draw(renderer);
                    renderer.restore();
                    renderer.flush();
                    // Check for any animations that looped
                    this.animator.handleLooping();
                    // Check for any state machines that had a state change
                    this.animator.handleStateChanges();
                    // Report advanced time
                    this.animator.handleAdvancing(elapsedTime);
                    // Add duration to create frame to durations array
                    this.frameCount++;
                    var after = performance.now();
                    this.frameTimes.push(after);
                    this.durations.push(after - before);
                    while(this.frameTimes[0] <= after - 1000){
                        this.frameTimes.shift();
                        this.durations.shift();
                    }
                    // Calling requestAnimationFrame will rerun draw() at the correct rate:
                    // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Basic_animations
                    if (this.animator.isPlaying) // Request a new rendering frame
                    this.startRendering();
                    else if (this.animator.isPaused) // Reset the end time so on playback it starts at the correct frame
                    this.lastRenderTime = 0;
                    else if (this.animator.isStopped) // Reset animation instances, artboard and time
                    // TODO: implement this properly when we have instancing
                    // this.initArtboard();
                    // this.drawFrame();
                    this.lastRenderTime = 0;
                };
                /**
     * Align the renderer
     */ Rive.prototype.alignRenderer = function() {
                    var _a = this, renderer = _a.renderer, runtime = _a.runtime, _layout = _a._layout, artboard = _a.artboard;
                    // Align things up safe in the knowledge we can restore if changed
                    renderer.align(_layout.runtimeFit(runtime), _layout.runtimeAlignment(runtime), {
                        minX: _layout.minX,
                        minY: _layout.minY,
                        maxX: _layout.maxX,
                        maxY: _layout.maxY
                    }, artboard.bounds);
                };
                Object.defineProperty(Rive.prototype, "fps", {
                    get: function get() {
                        return this.durations.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "frameTime", {
                    get: function get() {
                        if (this.durations.length === 0) return 0;
                        return (this.durations.reduce(function(a, b) {
                            return a + b;
                        }, 0) / this.durations.length).toFixed(4);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Cleans up all Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances,
     * renderer instance, file and runtime.
     *
     * Once this is called, you will need to initialise a new instance of the
     * Rive class
     */ Rive.prototype.cleanup = function() {
                    var _a, _b, _c;
                    // Stop the renderer if it hasn't already been stopped.
                    this.stopRendering();
                    // Clean up any artboard, animation or state machine instances.
                    this.cleanupInstances();
                    // Only CanvasRenderer needs a delete for now, not WebGL.. might be a better
                    // way to detect this in the future 
                    if ((_a = this.runtime) === null || _a === void 0 ? void 0 : _a.CanvasRenderer) (_b = this.renderer) === null || _b === void 0 || _b.delete();
                    this.renderer = null;
                    // Delete the rive file
                    (_c = this.file) === null || _c === void 0 || _c.delete();
                    this.file = null;
                };
                /**
     * Cleans up any Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances.
     *
     * Once this is called, things will need to be reinitialized or bad things
     * might happen.
     */ Rive.prototype.cleanupInstances = function() {
                    if (this.eventCleanup !== null) this.eventCleanup();
                    // Delete all animation and state machine instances
                    this.stop();
                    if (this.artboard) {
                        this.artboard.delete();
                        this.artboard = null;
                    }
                };
                /**
     * Tries to query the setup Artboard for a text run node with the given name.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - TextValueRun node or undefined if the text run cannot be queried
     */ Rive.prototype.retrieveTextRun = function(textRunName) {
                    var _a;
                    if (!textRunName) {
                        console.warn("No text run name provided");
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text run, but the Artboard is null");
                        return;
                    }
                    var textRun = this.artboard.textRun(textRunName);
                    if (!textRun) {
                        console.warn("Could not access a text run with name '".concat(textRunName, "' in the '").concat((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.name, "' Artboard. Note that you must rename a text run node in the Rive editor to make it queryable at runtime."));
                        return;
                    }
                    return textRun;
                };
                /**
     * Returns a string from a given text run node name, or undefined if the text run
     * cannot be queried.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - String value of the text run node or undefined
     */ Rive.prototype.getTextRunValue = function(textRunName) {
                    var textRun = this.retrieveTextRun(textRunName);
                    return textRun ? textRun.text : undefined;
                };
                /**
     * Sets a text value for a given text run node name if possible
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @param textRunValue - String value to set on the text run node
     */ Rive.prototype.setTextRunValue = function(textRunName, textRunValue) {
                    var textRun = this.retrieveTextRun(textRunName);
                    if (textRun) textRun.text = textRunValue;
                };
                // Plays specified animations; if none specified, it unpauses everything.
                Rive.prototype.play = function(animationNames, autoplay) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, queue up the play
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function action() {
                                return _this.play(animationNames, autoplay);
                            }
                        });
                        return;
                    }
                    this.animator.play(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                    this.setupRiveListeners();
                    this.startRendering();
                };
                // Pauses specified animations; if none specified, pauses all.
                Rive.prototype.pause = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function action() {
                                return _this.pause(animationNames);
                            }
                        });
                        return;
                    }
                    if (this.eventCleanup) this.eventCleanup();
                    this.animator.pause(animationNames);
                };
                Rive.prototype.scrub = function(animationNames, value) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function action() {
                                return _this.scrub(animationNames, value);
                            }
                        });
                        return;
                    }
                    // Scrub the animation time; we draw a single frame here so that if
                    // nothing's currently playing, the scrubbed animation is still rendered/
                    this.animator.scrub(animationNames, value || 0);
                    this.drawFrame();
                };
                // Stops specified animations; if none specifies, stops them all.
                Rive.prototype.stop = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function action() {
                                return _this.stop(animationNames);
                            }
                        });
                        return;
                    }
                    this.animator.stop(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                };
                /**
     * Resets the animation
     * @param artboard the name of the artboard, or default if none given
     * @param animations the names of animations for playback
     * @param stateMachines the names of state machines for playback
     * @param autoplay whether to autoplay when reset, defaults to false
     *
     */ Rive.prototype.reset = function(params) {
                    var _a;
                    // Get the current artboard, animations, state machines, and playback states
                    var artBoardName = params === null || params === void 0 ? void 0 : params.artboard;
                    var animationNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.animations);
                    var stateMachineNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.stateMachines);
                    var autoplay = (_a = params === null || params === void 0 ? void 0 : params.autoplay) !== null && _a !== void 0 ? _a : false;
                    // Stop everything and clean up
                    this.cleanupInstances();
                    // Reinitialize an artboard instance with the state
                    this.initArtboard(artBoardName, animationNames, stateMachineNames, autoplay);
                    this.taskQueue.process();
                };
                // Loads a new Rive file, keeping listeners in place
                Rive.prototype.load = function(params) {
                    // Stop all animations
                    this.stop();
                    // Reinitialize
                    this.init(params);
                };
                Object.defineProperty(Rive.prototype, "layout", {
                    /**
         * Returns the current layout. Note that layout should be treated as
         * immutable. If you want to change the layout, create a new one use the
         * layout setter
         */ get: function get() {
                        return this._layout;
                    },
                    // Sets a new layout
                    set: function set(layout) {
                        this._layout = layout;
                        // If the maxX or maxY are 0, then set them to the canvas width and height
                        if (!layout.maxX || !layout.maxY) this.resizeToCanvas();
                        if (this.loaded && !this.animator.isPlaying) this.drawFrame();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets the layout bounds to the current canvas size; this is typically called
     * when the canvas is resized
     */ Rive.prototype.resizeToCanvas = function() {
                    this._layout = this.layout.copyWith({
                        minX: 0,
                        minY: 0,
                        maxX: this.canvas.width,
                        maxY: this.canvas.height
                    });
                };
                /**
     * Accounts for devicePixelRatio as a multiplier to render the size of the canvas drawing surface.
     * Uses the size of the backing canvas to set new width/height attributes. Need to re-render
     * and resize the layout to match the new drawing surface afterwards.
     * Useful function for consumers to include in a window resize listener
     */ Rive.prototype.resizeDrawingSurfaceToCanvas = function(customDevicePixelRatio) {
                    if (this.canvas instanceof HTMLCanvasElement && !!window) {
                        var _a = this.canvas.getBoundingClientRect(), width = _a.width, height = _a.height;
                        var dpr = customDevicePixelRatio || window.devicePixelRatio || 1;
                        this.canvas.width = dpr * width;
                        this.canvas.height = dpr * height;
                        this.startRendering();
                        this.resizeToCanvas();
                    }
                };
                Object.defineProperty(Rive.prototype, "source", {
                    // Returns the animation source, which may be undefined
                    get: function get() {
                        return this.src;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "activeArtboard", {
                    /**
         * Returns the name of the active artboard
         */ get: function get() {
                        return this.artboard ? this.artboard.name : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "animationNames", {
                    // Returns a list of animation names on the chosen artboard
                    get: function get() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        var animationNames = [];
                        for(var i = 0; i < this.artboard.animationCount(); i++)animationNames.push(this.artboard.animationByIndex(i).name);
                        return animationNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "stateMachineNames", {
                    /**
         * Returns a list of state machine names from the current artboard
         */ get: function get() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        var stateMachineNames = [];
                        for(var i = 0; i < this.artboard.stateMachineCount(); i++)stateMachineNames.push(this.artboard.stateMachineByIndex(i).name);
                        return stateMachineNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns the inputs for the specified instanced state machine, or an empty
     * list if the name is invalid or the state machine is not instanced
     * @param name the state machine name
     * @returns the inputs for the named state machine
     */ Rive.prototype.stateMachineInputs = function(name) {
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.loaded) return;
                    var stateMachine = this.animator.stateMachines.find(function(m) {
                        return m.name === name;
                    });
                    return stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.inputs;
                };
                Object.defineProperty(Rive.prototype, "playingStateMachineNames", {
                    // Returns a list of playing machine names
                    get: function get() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "playingAnimationNames", {
                    // Returns a list of playing animation names
                    get: function get() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedAnimationNames", {
                    // Returns a list of paused animation names
                    get: function get() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedStateMachineNames", {
                    /**
         *  Returns a list of paused machine names
         * @returns a list of state machine names that are paused
         */ get: function get() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPlaying", {
                    /**
         * @returns true if any animation is playing
         */ get: function get() {
                        return this.animator.isPlaying;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPaused", {
                    /**
         * @returns true if all instanced animations are paused
         */ get: function get() {
                        return this.animator.isPaused;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isStopped", {
                    /**
         * @returns true if no animations are playing or paused
         */ get: function get() {
                        return this.animator.isStopped;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "bounds", {
                    /**
         * @returns the bounds of the current artboard, or undefined if the artboard
         * isn't loaded yet.
         */ get: function get() {
                        return this.artboard ? this.artboard.bounds : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ Rive.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ Rive.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @deprecated
     * @param callback the callback to unsubscribe from
     */ Rive.prototype.unsubscribe = function(type, callback) {
                    console.warn("This function is deprecated: please use `off()` instead.");
                    this.off(type, callback);
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                /**
     * Unsubscribes all listeners from an event type, or everything if no type is
     * given
     * @deprecated
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.unsubscribeAll = function(type) {
                    console.warn("This function is deprecated: please use `removeAllRiveEventListeners()` instead.");
                    this.removeAllRiveEventListeners(type);
                };
                /**
     * Stops the rendering loop; this is different from pausing in that it doesn't
     * change the state of any animation. It stops rendering from occurring. This
     * is designed for situations such as when Rive isn't visible.
     *
     * The only way to start rendering again is to call `startRendering`.
     * Animations that are marked as playing will start from the position that
     * they would have been at if rendering had not been stopped.
     */ Rive.prototype.stopRendering = function() {
                    if (this.loaded && this.frameRequestId) {
                        if (this.runtime.cancelAnimationFrame) this.runtime.cancelAnimationFrame(this.frameRequestId);
                        else cancelAnimationFrame(this.frameRequestId);
                        this.frameRequestId = null;
                    }
                };
                /**
     * Starts the rendering loop if it has been previously stopped. If the
     * renderer is already active, then this will have zero effect.
     */ Rive.prototype.startRendering = function() {
                    if (this.loaded && this.artboard && !this.frameRequestId) {
                        if (this.runtime.requestAnimationFrame) this.frameRequestId = this.runtime.requestAnimationFrame(this.draw.bind(this));
                        else this.frameRequestId = requestAnimationFrame(this.draw.bind(this));
                    }
                };
                /**
     * Enables frames-per-second (FPS) reporting for the runtime
     * If no callback is provided, Rive will append a fixed-position div at the top-right corner of
     * the page with the FPS reading
     * @param fpsCallback - Callback from the runtime during the RAF loop that supplies the FPS value
     */ Rive.prototype.enableFPSCounter = function(fpsCallback) {
                    this.runtime.enableFPSCounter(fpsCallback);
                };
                /**
     * Disables frames-per-second (FPS) reporting for the runtime
     */ Rive.prototype.disableFPSCounter = function() {
                    this.runtime.disableFPSCounter();
                };
                Object.defineProperty(Rive.prototype, "contents", {
                    /**
         * Returns the contents of a Rive file: the artboards, animations, and state machines
         */ get: function get() {
                        if (!this.loaded) return undefined;
                        var riveContents = {
                            artboards: []
                        };
                        for(var i = 0; i < this.file.artboardCount(); i++){
                            var artboard = this.file.artboardByIndex(i);
                            var artboardContents = {
                                name: artboard.name,
                                animations: [],
                                stateMachines: []
                            };
                            for(var j = 0; j < artboard.animationCount(); j++){
                                var animation = artboard.animationByIndex(j);
                                artboardContents.animations.push(animation.name);
                            }
                            for(var k = 0; k < artboard.stateMachineCount(); k++){
                                var stateMachine = artboard.stateMachineByIndex(k);
                                var name_1 = stateMachine.name;
                                var instance = new this.runtime.StateMachineInstance(stateMachine, artboard);
                                var inputContents = [];
                                for(var l = 0; l < instance.inputCount(); l++){
                                    var input = instance.input(l);
                                    inputContents.push({
                                        name: input.name,
                                        type: input.type
                                    });
                                }
                                artboardContents.stateMachines.push({
                                    name: name_1,
                                    inputs: inputContents
                                });
                            }
                            riveContents.artboards.push(artboardContents);
                        }
                        return riveContents;
                    },
                    enumerable: false,
                    configurable: true
                });
                // Error message for missing source or buffer
                Rive.missingErrorMessage = "Rive source file or data buffer required";
                return Rive;
            }();
            // Loads Rive data from a URI via fetch.
            var loadRiveFile = function loadRiveFile(src) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var req, res, buffer;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                req = new Request(src);
                                return [
                                    4 /*yield*/ ,
                                    fetch(req)
                                ];
                            case 1:
                                res = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    res.arrayBuffer()
                                ];
                            case 2:
                                buffer = _a.sent();
                                return [
                                    2 /*return*/ ,
                                    buffer
                                ];
                        }
                    });
                });
            };
            // #endregion
            // #region utility functions
            /*
 * Utility function to ensure an object is a string array
 */ var mapToStringArray = function mapToStringArray(obj) {
                if (typeof obj === "string") return [
                    obj
                ];
                else if (obj instanceof Array) return obj;
                // If obj is undefined, return empty array
                return [];
            };
            // #endregion
            // #region testing utilities
            // Exports to only be used for tests
            var Testing = {
                EventManager: EventManager,
                TaskQueueManager: TaskQueueManager
            };
            // #endregion
            // #region asset loaders
            /**
 * Decodes bytes into an image.
 *
 * Be sure to call `.dispose()` on the image once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeImage = function decodeImage(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeImage(bytes, resolve);
                    });
                });
            };
            /**
 * Decodes bytes into a font.
 *
 * Be sure to call `.dispose()` on the font once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeFont = function decodeFont(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeFont(bytes, resolve);
                    });
                });
            };
        // #endregion
        })();
        /******/ return __webpack_exports__;
    /******/ }();
});



var $dvYFb = parcelRequire("dvYFb");
function $cd28a1f5cb50cf60$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cd28a1f5cb50cf60$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cd28a1f5cb50cf60$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cd28a1f5cb50cf60$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $cd28a1f5cb50cf60$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $cd28a1f5cb50cf60$var$CREATED = 1;
var $cd28a1f5cb50cf60$var$MOUNTED = 2;
var $cd28a1f5cb50cf60$var$IDLE = 3;
var $cd28a1f5cb50cf60$var$MOVING = 4;
var $cd28a1f5cb50cf60$var$SCROLLING = 5;
var $cd28a1f5cb50cf60$var$DRAGGING = 6;
var $cd28a1f5cb50cf60$var$DESTROYED = 7;
var $cd28a1f5cb50cf60$var$STATES = {
    CREATED: $cd28a1f5cb50cf60$var$CREATED,
    MOUNTED: $cd28a1f5cb50cf60$var$MOUNTED,
    IDLE: $cd28a1f5cb50cf60$var$IDLE,
    MOVING: $cd28a1f5cb50cf60$var$MOVING,
    SCROLLING: $cd28a1f5cb50cf60$var$SCROLLING,
    DRAGGING: $cd28a1f5cb50cf60$var$DRAGGING,
    DESTROYED: $cd28a1f5cb50cf60$var$DESTROYED
};
function $cd28a1f5cb50cf60$var$empty(array) {
    array.length = 0;
}
function $cd28a1f5cb50cf60$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $cd28a1f5cb50cf60$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($cd28a1f5cb50cf60$var$slice(arguments, 1)));
}
var $cd28a1f5cb50cf60$var$nextTick = setTimeout;
var $cd28a1f5cb50cf60$var$noop = function noop() {};
function $cd28a1f5cb50cf60$var$raf(func) {
    return requestAnimationFrame(func);
}
function $cd28a1f5cb50cf60$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $dvYFb._)(subject)) === type;
}
function $cd28a1f5cb50cf60$var$isObject(subject) {
    return !$cd28a1f5cb50cf60$var$isNull(subject) && $cd28a1f5cb50cf60$var$typeOf("object", subject);
}
var $cd28a1f5cb50cf60$var$isArray = Array.isArray;
var $cd28a1f5cb50cf60$var$isFunction = $cd28a1f5cb50cf60$var$apply($cd28a1f5cb50cf60$var$typeOf, "function");
var $cd28a1f5cb50cf60$var$isString = $cd28a1f5cb50cf60$var$apply($cd28a1f5cb50cf60$var$typeOf, "string");
var $cd28a1f5cb50cf60$var$isUndefined = $cd28a1f5cb50cf60$var$apply($cd28a1f5cb50cf60$var$typeOf, "undefined");
function $cd28a1f5cb50cf60$var$isNull(subject) {
    return subject === null;
}
function $cd28a1f5cb50cf60$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $cd28a1f5cb50cf60$var$toArray(value) {
    return $cd28a1f5cb50cf60$var$isArray(value) ? value : [
        value
    ];
}
function $cd28a1f5cb50cf60$var$forEach(values, iteratee) {
    $cd28a1f5cb50cf60$var$toArray(values).forEach(iteratee);
}
function $cd28a1f5cb50cf60$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $cd28a1f5cb50cf60$var$push(array, items) {
    array.push.apply(array, $cd28a1f5cb50cf60$var$toArray(items));
    return array;
}
function $cd28a1f5cb50cf60$var$toggleClass(elm, classes, add) {
    if (elm) $cd28a1f5cb50cf60$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $cd28a1f5cb50cf60$var$addClass(elm, classes) {
    $cd28a1f5cb50cf60$var$toggleClass(elm, $cd28a1f5cb50cf60$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $cd28a1f5cb50cf60$var$append(parent, children) {
    $cd28a1f5cb50cf60$var$forEach(children, parent.appendChild.bind(parent));
}
function $cd28a1f5cb50cf60$var$before(nodes, ref) {
    $cd28a1f5cb50cf60$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $cd28a1f5cb50cf60$var$matches(elm, selector) {
    return $cd28a1f5cb50cf60$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $cd28a1f5cb50cf60$var$children(parent, selector) {
    var children2 = parent ? $cd28a1f5cb50cf60$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $cd28a1f5cb50cf60$var$matches(child, selector);
    }) : children2;
}
function $cd28a1f5cb50cf60$var$child(parent, selector) {
    return selector ? $cd28a1f5cb50cf60$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $cd28a1f5cb50cf60$var$ownKeys = Object.keys;
function $cd28a1f5cb50cf60$var$forOwn(object, iteratee, right) {
    if (object) (right ? $cd28a1f5cb50cf60$var$ownKeys(object).reverse() : $cd28a1f5cb50cf60$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $cd28a1f5cb50cf60$var$assign(object) {
    $cd28a1f5cb50cf60$var$slice(arguments, 1).forEach(function(source) {
        $cd28a1f5cb50cf60$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $cd28a1f5cb50cf60$var$merge(object) {
    $cd28a1f5cb50cf60$var$slice(arguments, 1).forEach(function(source) {
        $cd28a1f5cb50cf60$var$forOwn(source, function(value, key) {
            if ($cd28a1f5cb50cf60$var$isArray(value)) object[key] = value.slice();
            else if ($cd28a1f5cb50cf60$var$isObject(value)) object[key] = $cd28a1f5cb50cf60$var$merge({}, $cd28a1f5cb50cf60$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $cd28a1f5cb50cf60$var$omit(object, keys) {
    $cd28a1f5cb50cf60$var$forEach(keys || $cd28a1f5cb50cf60$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $cd28a1f5cb50cf60$var$removeAttribute(elms, attrs) {
    $cd28a1f5cb50cf60$var$forEach(elms, function(elm) {
        $cd28a1f5cb50cf60$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $cd28a1f5cb50cf60$var$setAttribute(elms, attrs, value) {
    if ($cd28a1f5cb50cf60$var$isObject(attrs)) $cd28a1f5cb50cf60$var$forOwn(attrs, function(value2, name) {
        $cd28a1f5cb50cf60$var$setAttribute(elms, name, value2);
    });
    else $cd28a1f5cb50cf60$var$forEach(elms, function(elm) {
        $cd28a1f5cb50cf60$var$isNull(value) || value === "" ? $cd28a1f5cb50cf60$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $cd28a1f5cb50cf60$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $cd28a1f5cb50cf60$var$isString(attrs) ? $cd28a1f5cb50cf60$var$addClass(elm, attrs) : $cd28a1f5cb50cf60$var$setAttribute(elm, attrs);
    parent && $cd28a1f5cb50cf60$var$append(parent, elm);
    return elm;
}
function $cd28a1f5cb50cf60$var$style(elm, prop, value) {
    if ($cd28a1f5cb50cf60$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$cd28a1f5cb50cf60$var$isNull(value)) elm.style[prop] = "" + value;
}
function $cd28a1f5cb50cf60$var$display(elm, display2) {
    $cd28a1f5cb50cf60$var$style(elm, "display", display2);
}
function $cd28a1f5cb50cf60$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $cd28a1f5cb50cf60$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $cd28a1f5cb50cf60$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $cd28a1f5cb50cf60$var$rect(target) {
    return target.getBoundingClientRect();
}
function $cd28a1f5cb50cf60$var$remove(nodes) {
    $cd28a1f5cb50cf60$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $cd28a1f5cb50cf60$var$parseHtml(html) {
    return $cd28a1f5cb50cf60$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $cd28a1f5cb50cf60$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $cd28a1f5cb50cf60$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $cd28a1f5cb50cf60$var$queryAll(parent, selector) {
    return selector ? $cd28a1f5cb50cf60$var$slice(parent.querySelectorAll(selector)) : [];
}
function $cd28a1f5cb50cf60$var$removeClass(elm, classes) {
    $cd28a1f5cb50cf60$var$toggleClass(elm, classes, false);
}
function $cd28a1f5cb50cf60$var$timeOf(e) {
    return e.timeStamp;
}
function $cd28a1f5cb50cf60$var$unit(value) {
    return $cd28a1f5cb50cf60$var$isString(value) ? value : value ? value + "px" : "";
}
var $cd28a1f5cb50cf60$var$PROJECT_CODE = "splide";
var $cd28a1f5cb50cf60$var$DATA_ATTRIBUTE = "data-" + $cd28a1f5cb50cf60$var$PROJECT_CODE;
function $cd28a1f5cb50cf60$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $cd28a1f5cb50cf60$var$PROJECT_CODE + "] " + (message || ""));
}
var $cd28a1f5cb50cf60$var$min = Math.min, $cd28a1f5cb50cf60$var$max = Math.max, $cd28a1f5cb50cf60$var$floor = Math.floor, $cd28a1f5cb50cf60$var$ceil = Math.ceil, $cd28a1f5cb50cf60$var$abs = Math.abs;
function $cd28a1f5cb50cf60$var$approximatelyEqual(x, y, epsilon) {
    return $cd28a1f5cb50cf60$var$abs(x - y) < epsilon;
}
function $cd28a1f5cb50cf60$var$between(number, x, y, exclusive) {
    var minimum = $cd28a1f5cb50cf60$var$min(x, y);
    var maximum = $cd28a1f5cb50cf60$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $cd28a1f5cb50cf60$var$clamp(number, x, y) {
    var minimum = $cd28a1f5cb50cf60$var$min(x, y);
    var maximum = $cd28a1f5cb50cf60$var$max(x, y);
    return $cd28a1f5cb50cf60$var$min($cd28a1f5cb50cf60$var$max(minimum, number), maximum);
}
function $cd28a1f5cb50cf60$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $cd28a1f5cb50cf60$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $cd28a1f5cb50cf60$var$format(string, replacements) {
    $cd28a1f5cb50cf60$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $cd28a1f5cb50cf60$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $cd28a1f5cb50cf60$var$ids = {};
function $cd28a1f5cb50cf60$var$uniqueId(prefix) {
    return "" + prefix + $cd28a1f5cb50cf60$var$pad($cd28a1f5cb50cf60$var$ids[prefix] = ($cd28a1f5cb50cf60$var$ids[prefix] || 0) + 1);
}
function $cd28a1f5cb50cf60$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $cd28a1f5cb50cf60$var$forEach(targets, function(target) {
            target && $cd28a1f5cb50cf60$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $cd28a1f5cb50cf60$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $cd28a1f5cb50cf60$export$d300dc1a2634364b = "mounted";
var $cd28a1f5cb50cf60$export$d8dac49b4532735a = "ready";
var $cd28a1f5cb50cf60$export$2aa493d7c3275167 = "move";
var $cd28a1f5cb50cf60$export$fe5802204b967f0d = "moved";
var $cd28a1f5cb50cf60$export$5adb665701eda1ce = "click";
var $cd28a1f5cb50cf60$export$92e3eae133acac4c = "active";
var $cd28a1f5cb50cf60$export$6bcbb81035c12cea = "inactive";
var $cd28a1f5cb50cf60$export$6a5b3445e4066a53 = "visible";
var $cd28a1f5cb50cf60$export$8c5c7a21d54563e9 = "hidden";
var $cd28a1f5cb50cf60$export$7f4701ac5e05e39f = "refresh";
var $cd28a1f5cb50cf60$export$db40ab7c0855fa5c = "updated";
var $cd28a1f5cb50cf60$export$7e019dae5103a285 = "resize";
var $cd28a1f5cb50cf60$export$d637eba1e9e28482 = "resized";
var $cd28a1f5cb50cf60$export$e84bf5065c9087ac = "drag";
var $cd28a1f5cb50cf60$export$8e9f636d2c722196 = "dragging";
var $cd28a1f5cb50cf60$export$90ea576bd3fdeb60 = "dragged";
var $cd28a1f5cb50cf60$export$49801896908b5e33 = "scroll";
var $cd28a1f5cb50cf60$export$ff8164bff3202b9 = "scrolled";
var $cd28a1f5cb50cf60$export$6cbac5b662a31e1b = "overflow";
var $cd28a1f5cb50cf60$export$88c4cf7419e470cd = "destroy";
var $cd28a1f5cb50cf60$export$8647f6b043e04e9d = "arrows:mounted";
var $cd28a1f5cb50cf60$export$d467f9343b961f75 = "arrows:updated";
var $cd28a1f5cb50cf60$export$bf89a4e4349c9778 = "pagination:mounted";
var $cd28a1f5cb50cf60$export$eb2019082ed6de0b = "pagination:updated";
var $cd28a1f5cb50cf60$export$84015c33508f94ec = "navigation:mounted";
var $cd28a1f5cb50cf60$export$23663268a31b79e2 = "autoplay:play";
var $cd28a1f5cb50cf60$export$185723258309b608 = "autoplay:playing";
var $cd28a1f5cb50cf60$export$16a1e4f3d0368265 = "autoplay:pause";
var $cd28a1f5cb50cf60$export$9f64346e17f0ec8e = "lazyload:loaded";
var $cd28a1f5cb50cf60$export$6d5af59619d10e6a = "sk";
var $cd28a1f5cb50cf60$export$f0af896383d5adff = "sh";
var $cd28a1f5cb50cf60$export$28dea85f216954dc = "ei";
function $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $cd28a1f5cb50cf60$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $cd28a1f5cb50cf60$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $cd28a1f5cb50cf60$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $cd28a1f5cb50cf60$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($cd28a1f5cb50cf60$export$88c4cf7419e470cd, binder.destroy);
    return $cd28a1f5cb50cf60$var$assign(binder, {
        bus: bus,
        on: on,
        off: $cd28a1f5cb50cf60$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $cd28a1f5cb50cf60$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $cd28a1f5cb50cf60$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $cd28a1f5cb50cf60$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $cd28a1f5cb50cf60$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $cd28a1f5cb50cf60$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $cd28a1f5cb50cf60$var$includes($cd28a1f5cb50cf60$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $cd28a1f5cb50cf60$export$efff0f5979573c99(func, duration) {
    var interval = $cd28a1f5cb50cf60$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $cd28a1f5cb50cf60$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $cd28a1f5cb50cf60$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $cd28a1f5cb50cf60$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $cd28a1f5cb50cf60$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($cd28a1f5cb50cf60$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $cd28a1f5cb50cf60$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $cd28a1f5cb50cf60$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($cd28a1f5cb50cf60$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $cd28a1f5cb50cf60$var$merge(options, reducedMotion) : $cd28a1f5cb50cf60$var$omit(options, $cd28a1f5cb50cf60$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $cd28a1f5cb50cf60$var$merge(options, opts);
        base && $cd28a1f5cb50cf60$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($cd28a1f5cb50cf60$var$CREATED)) Splide2.emit($cd28a1f5cb50cf60$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $cd28a1f5cb50cf60$var$ARROW = "Arrow";
var $cd28a1f5cb50cf60$var$ARROW_LEFT = $cd28a1f5cb50cf60$var$ARROW + "Left";
var $cd28a1f5cb50cf60$var$ARROW_RIGHT = $cd28a1f5cb50cf60$var$ARROW + "Right";
var $cd28a1f5cb50cf60$var$ARROW_UP = $cd28a1f5cb50cf60$var$ARROW + "Up";
var $cd28a1f5cb50cf60$var$ARROW_DOWN = $cd28a1f5cb50cf60$var$ARROW + "Down";
var $cd28a1f5cb50cf60$export$373e92e0788ff06e = "ltr";
var $cd28a1f5cb50cf60$export$850f7749a2909601 = "rtl";
var $cd28a1f5cb50cf60$export$97170d9824b89709 = "ttb";
var $cd28a1f5cb50cf60$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $cd28a1f5cb50cf60$var$ARROW_UP,
        $cd28a1f5cb50cf60$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $cd28a1f5cb50cf60$var$ARROW_DOWN,
        $cd28a1f5cb50cf60$var$ARROW_LEFT
    ]
};
function $cd28a1f5cb50cf60$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $cd28a1f5cb50cf60$export$850f7749a2909601 && !axisOnly ? 1 : direction === $cd28a1f5cb50cf60$export$97170d9824b89709 ? 0 : -1;
        return $cd28a1f5cb50cf60$var$ORIENTATION_MAP[prop] && $cd28a1f5cb50cf60$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $cd28a1f5cb50cf60$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $cd28a1f5cb50cf60$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $cd28a1f5cb50cf60$var$ROLE = "role";
var $cd28a1f5cb50cf60$var$TAB_INDEX = "tabindex";
var $cd28a1f5cb50cf60$var$DISABLED = "disabled";
var $cd28a1f5cb50cf60$var$ARIA_PREFIX = "aria-";
var $cd28a1f5cb50cf60$var$ARIA_CONTROLS = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "controls";
var $cd28a1f5cb50cf60$var$ARIA_CURRENT = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "current";
var $cd28a1f5cb50cf60$var$ARIA_SELECTED = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "selected";
var $cd28a1f5cb50cf60$var$ARIA_LABEL = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "label";
var $cd28a1f5cb50cf60$var$ARIA_LABELLEDBY = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "labelledby";
var $cd28a1f5cb50cf60$var$ARIA_HIDDEN = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "hidden";
var $cd28a1f5cb50cf60$var$ARIA_ORIENTATION = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "orientation";
var $cd28a1f5cb50cf60$var$ARIA_ROLEDESCRIPTION = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "roledescription";
var $cd28a1f5cb50cf60$var$ARIA_LIVE = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "live";
var $cd28a1f5cb50cf60$var$ARIA_BUSY = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "busy";
var $cd28a1f5cb50cf60$var$ARIA_ATOMIC = $cd28a1f5cb50cf60$var$ARIA_PREFIX + "atomic";
var $cd28a1f5cb50cf60$var$ALL_ATTRIBUTES = [
    $cd28a1f5cb50cf60$var$ROLE,
    $cd28a1f5cb50cf60$var$TAB_INDEX,
    $cd28a1f5cb50cf60$var$DISABLED,
    $cd28a1f5cb50cf60$var$ARIA_CONTROLS,
    $cd28a1f5cb50cf60$var$ARIA_CURRENT,
    $cd28a1f5cb50cf60$var$ARIA_LABEL,
    $cd28a1f5cb50cf60$var$ARIA_LABELLEDBY,
    $cd28a1f5cb50cf60$var$ARIA_HIDDEN,
    $cd28a1f5cb50cf60$var$ARIA_ORIENTATION,
    $cd28a1f5cb50cf60$var$ARIA_ROLEDESCRIPTION
];
var $cd28a1f5cb50cf60$var$CLASS_PREFIX = $cd28a1f5cb50cf60$var$PROJECT_CODE + "__";
var $cd28a1f5cb50cf60$var$STATUS_CLASS_PREFIX = "is-";
var $cd28a1f5cb50cf60$export$93b21159ad85c843 = $cd28a1f5cb50cf60$var$PROJECT_CODE;
var $cd28a1f5cb50cf60$export$7738b09ac0a98952 = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "track";
var $cd28a1f5cb50cf60$export$19cc2a5451235cae = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "list";
var $cd28a1f5cb50cf60$export$8d922915837a38d3 = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "slide";
var $cd28a1f5cb50cf60$export$2c1ba4a4f1aa4947 = $cd28a1f5cb50cf60$export$8d922915837a38d3 + "--clone";
var $cd28a1f5cb50cf60$export$e9ba7e444ba60a12 = $cd28a1f5cb50cf60$export$8d922915837a38d3 + "__container";
var $cd28a1f5cb50cf60$export$a26cbd955fecf11e = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "arrows";
var $cd28a1f5cb50cf60$export$516e7d18e13a2dca = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "arrow";
var $cd28a1f5cb50cf60$export$58ea3db24c33b76 = $cd28a1f5cb50cf60$export$516e7d18e13a2dca + "--prev";
var $cd28a1f5cb50cf60$export$4885afd7098a65c2 = $cd28a1f5cb50cf60$export$516e7d18e13a2dca + "--next";
var $cd28a1f5cb50cf60$export$cbf8e5a0ab95eda3 = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "pagination";
var $cd28a1f5cb50cf60$export$52f2cca6a5eee805 = $cd28a1f5cb50cf60$export$cbf8e5a0ab95eda3 + "__page";
var $cd28a1f5cb50cf60$export$4c82dc32b1c4ace5 = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "progress";
var $cd28a1f5cb50cf60$export$2c9b091c749f4409 = $cd28a1f5cb50cf60$export$4c82dc32b1c4ace5 + "__bar";
var $cd28a1f5cb50cf60$export$a29701deef84b825 = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "toggle";
var $cd28a1f5cb50cf60$export$d9d247d51b430dbb = $cd28a1f5cb50cf60$export$a29701deef84b825 + "__play";
var $cd28a1f5cb50cf60$export$3529f201a419925b = $cd28a1f5cb50cf60$export$a29701deef84b825 + "__pause";
var $cd28a1f5cb50cf60$export$3e5381ee3fab8374 = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "spinner";
var $cd28a1f5cb50cf60$export$bb78d7c200da8960 = $cd28a1f5cb50cf60$var$CLASS_PREFIX + "sr";
var $cd28a1f5cb50cf60$export$7761661e2d5b9388 = $cd28a1f5cb50cf60$var$STATUS_CLASS_PREFIX + "initialized";
var $cd28a1f5cb50cf60$export$72d36ecf3758cb4b = $cd28a1f5cb50cf60$var$STATUS_CLASS_PREFIX + "active";
var $cd28a1f5cb50cf60$export$e423ac4972f5e196 = $cd28a1f5cb50cf60$var$STATUS_CLASS_PREFIX + "prev";
var $cd28a1f5cb50cf60$export$457a2d20827a2779 = $cd28a1f5cb50cf60$var$STATUS_CLASS_PREFIX + "next";
var $cd28a1f5cb50cf60$export$53ca4621bbab9a = $cd28a1f5cb50cf60$var$STATUS_CLASS_PREFIX + "visible";
var $cd28a1f5cb50cf60$export$d22ec4ccb7996ba2 = $cd28a1f5cb50cf60$var$STATUS_CLASS_PREFIX + "loading";
var $cd28a1f5cb50cf60$export$b6f202a162a09100 = $cd28a1f5cb50cf60$var$STATUS_CLASS_PREFIX + "focus-in";
var $cd28a1f5cb50cf60$export$cd908cd1dd625e29 = $cd28a1f5cb50cf60$var$STATUS_CLASS_PREFIX + "overflow";
var $cd28a1f5cb50cf60$export$49f9eaea10ebf193 = [
    $cd28a1f5cb50cf60$export$72d36ecf3758cb4b,
    $cd28a1f5cb50cf60$export$53ca4621bbab9a,
    $cd28a1f5cb50cf60$export$e423ac4972f5e196,
    $cd28a1f5cb50cf60$export$457a2d20827a2779,
    $cd28a1f5cb50cf60$export$d22ec4ccb7996ba2,
    $cd28a1f5cb50cf60$export$b6f202a162a09100,
    $cd28a1f5cb50cf60$export$cd908cd1dd625e29
];
var $cd28a1f5cb50cf60$export$ba41d43e4a419565 = {
    slide: $cd28a1f5cb50cf60$export$8d922915837a38d3,
    clone: $cd28a1f5cb50cf60$export$2c1ba4a4f1aa4947,
    arrows: $cd28a1f5cb50cf60$export$a26cbd955fecf11e,
    arrow: $cd28a1f5cb50cf60$export$516e7d18e13a2dca,
    prev: $cd28a1f5cb50cf60$export$58ea3db24c33b76,
    next: $cd28a1f5cb50cf60$export$4885afd7098a65c2,
    pagination: $cd28a1f5cb50cf60$export$cbf8e5a0ab95eda3,
    page: $cd28a1f5cb50cf60$export$52f2cca6a5eee805,
    spinner: $cd28a1f5cb50cf60$export$3e5381ee3fab8374
};
function $cd28a1f5cb50cf60$var$closest(from, selector) {
    if ($cd28a1f5cb50cf60$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($cd28a1f5cb50cf60$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $cd28a1f5cb50cf60$var$FRICTION = 5;
var $cd28a1f5cb50cf60$var$LOG_INTERVAL = 200;
var $cd28a1f5cb50cf60$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $cd28a1f5cb50cf60$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $cd28a1f5cb50cf60$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $cd28a1f5cb50cf60$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($cd28a1f5cb50cf60$export$7f4701ac5e05e39f, destroy);
        on($cd28a1f5cb50cf60$export$7f4701ac5e05e39f, setup);
        on($cd28a1f5cb50cf60$export$db40ab7c0855fa5c, update);
        bind(document, $cd28a1f5cb50cf60$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $cd28a1f5cb50cf60$var$toggleClass(root, $cd28a1f5cb50cf60$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $cd28a1f5cb50cf60$var$ALL_ATTRIBUTES.concat("style");
        $cd28a1f5cb50cf60$var$empty(slides);
        $cd28a1f5cb50cf60$var$removeClass(root, rootClasses);
        $cd28a1f5cb50cf60$var$removeClass(track, trackClasses);
        $cd28a1f5cb50cf60$var$removeAttribute([
            track,
            list
        ], attrs);
        $cd28a1f5cb50cf60$var$removeAttribute(root, completely ? attrs : [
            "style",
            $cd28a1f5cb50cf60$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $cd28a1f5cb50cf60$var$removeClass(root, rootClasses);
        $cd28a1f5cb50cf60$var$removeClass(track, trackClasses);
        rootClasses = getClasses($cd28a1f5cb50cf60$export$93b21159ad85c843);
        trackClasses = getClasses($cd28a1f5cb50cf60$export$7738b09ac0a98952);
        $cd28a1f5cb50cf60$var$addClass(root, rootClasses);
        $cd28a1f5cb50cf60$var$addClass(track, trackClasses);
        $cd28a1f5cb50cf60$var$setAttribute(root, $cd28a1f5cb50cf60$var$ARIA_LABEL, options.label);
        $cd28a1f5cb50cf60$var$setAttribute(root, $cd28a1f5cb50cf60$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $cd28a1f5cb50cf60$export$7738b09ac0a98952);
        list = $cd28a1f5cb50cf60$var$child(track, "." + $cd28a1f5cb50cf60$export$19cc2a5451235cae);
        $cd28a1f5cb50cf60$var$assert(track && list, "A track/list element is missing.");
        $cd28a1f5cb50cf60$var$push(slides, $cd28a1f5cb50cf60$var$children(list, "." + $cd28a1f5cb50cf60$export$8d922915837a38d3 + ":not(." + $cd28a1f5cb50cf60$export$2c1ba4a4f1aa4947 + ")"));
        $cd28a1f5cb50cf60$var$forOwn({
            arrows: $cd28a1f5cb50cf60$export$a26cbd955fecf11e,
            pagination: $cd28a1f5cb50cf60$export$cbf8e5a0ab95eda3,
            prev: $cd28a1f5cb50cf60$export$58ea3db24c33b76,
            next: $cd28a1f5cb50cf60$export$4885afd7098a65c2,
            bar: $cd28a1f5cb50cf60$export$2c9b091c749f4409,
            toggle: $cd28a1f5cb50cf60$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $cd28a1f5cb50cf60$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $cd28a1f5cb50cf60$var$uniqueId($cd28a1f5cb50cf60$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$cd28a1f5cb50cf60$var$getAttribute(root, $cd28a1f5cb50cf60$var$ROLE) && root.tagName !== "SECTION" && role) $cd28a1f5cb50cf60$var$setAttribute(root, $cd28a1f5cb50cf60$var$ROLE, role);
        $cd28a1f5cb50cf60$var$setAttribute(root, $cd28a1f5cb50cf60$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $cd28a1f5cb50cf60$var$setAttribute(list, $cd28a1f5cb50cf60$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $cd28a1f5cb50cf60$var$query(root, selector);
        return elm && $cd28a1f5cb50cf60$var$closest(elm, "." + $cd28a1f5cb50cf60$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $cd28a1f5cb50cf60$export$93b21159ad85c843 && $cd28a1f5cb50cf60$export$72d36ecf3758cb4b
        ];
    }
    return $cd28a1f5cb50cf60$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $cd28a1f5cb50cf60$export$e5a58a5ee5b54c22 = "slide";
var $cd28a1f5cb50cf60$export$f42383286ed1223d = "loop";
var $cd28a1f5cb50cf60$export$742b62a5690c060 = "fade";
function $cd28a1f5cb50cf60$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $cd28a1f5cb50cf60$var$getAttribute(slide, "style");
    var label = $cd28a1f5cb50cf60$var$getAttribute(slide, $cd28a1f5cb50cf60$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $cd28a1f5cb50cf60$var$child(slide, "." + $cd28a1f5cb50cf60$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $cd28a1f5cb50cf60$var$pad(index + 1);
            $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$ROLE, pagination ? "tabpanel" : "group");
            $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$ARIA_LABEL, label || $cd28a1f5cb50cf60$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $cd28a1f5cb50cf60$var$apply(emit, $cd28a1f5cb50cf60$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $cd28a1f5cb50cf60$var$apply(emit, $cd28a1f5cb50cf60$export$6d5af59619d10e6a, self));
        on([
            $cd28a1f5cb50cf60$export$fe5802204b967f0d,
            $cd28a1f5cb50cf60$export$f0af896383d5adff,
            $cd28a1f5cb50cf60$export$ff8164bff3202b9
        ], update);
        on($cd28a1f5cb50cf60$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($cd28a1f5cb50cf60$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $cd28a1f5cb50cf60$var$removeClass(slide, $cd28a1f5cb50cf60$export$49f9eaea10ebf193);
        $cd28a1f5cb50cf60$var$removeAttribute(slide, $cd28a1f5cb50cf60$var$ALL_ATTRIBUTES);
        $cd28a1f5cb50cf60$var$setAttribute(slide, "style", styles);
        $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$ARIA_LABEL, $cd28a1f5cb50cf60$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$ARIA_CONTROLS, controls);
        $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $cd28a1f5cb50cf60$var$removeAttribute(slide, $cd28a1f5cb50cf60$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $cd28a1f5cb50cf60$var$toggleClass(slide, $cd28a1f5cb50cf60$export$e423ac4972f5e196, index === curr - 1);
            $cd28a1f5cb50cf60$var$toggleClass(slide, $cd28a1f5cb50cf60$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $cd28a1f5cb50cf60$var$hasClass(slide, $cd28a1f5cb50cf60$export$72d36ecf3758cb4b)) {
            $cd28a1f5cb50cf60$var$toggleClass(slide, $cd28a1f5cb50cf60$export$72d36ecf3758cb4b, active);
            $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $cd28a1f5cb50cf60$export$92e3eae133acac4c : $cd28a1f5cb50cf60$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $cd28a1f5cb50cf60$var$MOVING,
            $cd28a1f5cb50cf60$var$SCROLLING
        ])) $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$ARIA_HIDDEN, hidden || "");
        $cd28a1f5cb50cf60$var$setAttribute($cd28a1f5cb50cf60$var$queryAll(slide, options.focusableNodes || ""), $cd28a1f5cb50cf60$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $cd28a1f5cb50cf60$var$setAttribute(slide, $cd28a1f5cb50cf60$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $cd28a1f5cb50cf60$var$hasClass(slide, $cd28a1f5cb50cf60$export$53ca4621bbab9a)) {
            $cd28a1f5cb50cf60$var$toggleClass(slide, $cd28a1f5cb50cf60$export$53ca4621bbab9a, visible);
            emit(visible ? $cd28a1f5cb50cf60$export$6a5b3445e4066a53 : $cd28a1f5cb50cf60$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $cd28a1f5cb50cf60$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $cd28a1f5cb50cf60$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($cd28a1f5cb50cf60$export$742b62a5690c060)) return isActive();
        var trackRect = $cd28a1f5cb50cf60$var$rect(Components.Elements.track);
        var slideRect = $cd28a1f5cb50cf60$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $cd28a1f5cb50cf60$var$floor(trackRect[left]) <= $cd28a1f5cb50cf60$var$ceil(slideRect[left]) && $cd28a1f5cb50cf60$var$floor(slideRect[right]) <= $cd28a1f5cb50cf60$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $cd28a1f5cb50cf60$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($cd28a1f5cb50cf60$export$f42383286ed1223d))) diff = $cd28a1f5cb50cf60$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $cd28a1f5cb50cf60$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($cd28a1f5cb50cf60$export$7f4701ac5e05e39f, destroy);
        on($cd28a1f5cb50cf60$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $cd28a1f5cb50cf60$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $cd28a1f5cb50cf60$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var _$Controller = Components2.Controller;
        var index = _$Controller.toIndex(page);
        var max = _$Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $cd28a1f5cb50cf60$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $cd28a1f5cb50cf60$var$forEach(items, function(slide) {
            if ($cd28a1f5cb50cf60$var$isString(slide)) slide = $cd28a1f5cb50cf60$var$parseHtml(slide);
            if ($cd28a1f5cb50cf60$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $cd28a1f5cb50cf60$var$before(slide, ref) : $cd28a1f5cb50cf60$var$append(list, slide);
                $cd28a1f5cb50cf60$var$addClass(slide, options.classes.slide);
                observeImages(slide, $cd28a1f5cb50cf60$var$apply(emit, $cd28a1f5cb50cf60$export$7e019dae5103a285));
            }
        });
        emit($cd28a1f5cb50cf60$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $cd28a1f5cb50cf60$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($cd28a1f5cb50cf60$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($cd28a1f5cb50cf60$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $cd28a1f5cb50cf60$var$isString(matcher) ? $cd28a1f5cb50cf60$var$matches(Slide2.slide, matcher) : $cd28a1f5cb50cf60$var$includes($cd28a1f5cb50cf60$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $cd28a1f5cb50cf60$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $cd28a1f5cb50cf60$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = _$Slides.getAt, styleSlides = _$Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $cd28a1f5cb50cf60$export$efff0f5979573c99($cd28a1f5cb50cf60$var$apply(emit, $cd28a1f5cb50cf60$export$7e019dae5103a285)));
        on([
            $cd28a1f5cb50cf60$export$db40ab7c0855fa5c,
            $cd28a1f5cb50cf60$export$7f4701ac5e05e39f
        ], init);
        on($cd28a1f5cb50cf60$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $cd28a1f5cb50cf60$export$97170d9824b89709;
        $cd28a1f5cb50cf60$var$style(root, "maxWidth", $cd28a1f5cb50cf60$var$unit(options.width));
        $cd28a1f5cb50cf60$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $cd28a1f5cb50cf60$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $cd28a1f5cb50cf60$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $cd28a1f5cb50cf60$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $cd28a1f5cb50cf60$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($cd28a1f5cb50cf60$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $cd28a1f5cb50cf60$var$toggleClass(root, $cd28a1f5cb50cf60$export$cd908cd1dd625e29, overflow);
                emit($cd28a1f5cb50cf60$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $cd28a1f5cb50cf60$var$unit(padding[prop] || ($cd28a1f5cb50cf60$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $cd28a1f5cb50cf60$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $cd28a1f5cb50cf60$var$unit(options.height || $cd28a1f5cb50cf60$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $cd28a1f5cb50cf60$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $cd28a1f5cb50cf60$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $cd28a1f5cb50cf60$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $cd28a1f5cb50cf60$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $cd28a1f5cb50cf60$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $cd28a1f5cb50cf60$var$rect(Slide.slide)[resolve("right")];
            var left = $cd28a1f5cb50cf60$var$rect(list)[resolve("left")];
            return $cd28a1f5cb50cf60$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($cd28a1f5cb50cf60$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($cd28a1f5cb50cf60$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($cd28a1f5cb50cf60$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $cd28a1f5cb50cf60$var$MULTIPLIER = 2;
function $cd28a1f5cb50cf60$var$Clones(Splide2, Components2, options) {
    var event = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var _$Elements = Components2.Elements, _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($cd28a1f5cb50cf60$export$7f4701ac5e05e39f, remount);
        on([
            $cd28a1f5cb50cf60$export$db40ab7c0855fa5c,
            $cd28a1f5cb50cf60$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $cd28a1f5cb50cf60$var$remove(clones);
        $cd28a1f5cb50cf60$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($cd28a1f5cb50cf60$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = _$Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$cd28a1f5cb50cf60$var$push(slides, slides);
            $cd28a1f5cb50cf60$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $cd28a1f5cb50cf60$var$before(clone, slides[0].slide) : $cd28a1f5cb50cf60$var$append(_$Elements.list, clone);
                $cd28a1f5cb50cf60$var$push(clones, clone);
                _$Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $cd28a1f5cb50cf60$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $cd28a1f5cb50cf60$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($cd28a1f5cb50cf60$export$f42383286ed1223d)) clones2 = 0;
        else if ($cd28a1f5cb50cf60$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $cd28a1f5cb50cf60$var$ceil($cd28a1f5cb50cf60$var$rect(_$Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $cd28a1f5cb50cf60$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $cd28a1f5cb50cf60$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $cd28a1f5cb50cf60$export$d300dc1a2634364b,
            $cd28a1f5cb50cf60$export$d637eba1e9e28482,
            $cd28a1f5cb50cf60$export$db40ab7c0855fa5c,
            $cd28a1f5cb50cf60$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($cd28a1f5cb50cf60$var$MOVING);
        emit($cd28a1f5cb50cf60$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($cd28a1f5cb50cf60$var$IDLE);
            emit($cd28a1f5cb50cf60$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($cd28a1f5cb50cf60$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $cd28a1f5cb50cf60$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($cd28a1f5cb50cf60$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($cd28a1f5cb50cf60$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($cd28a1f5cb50cf60$var$ceil($cd28a1f5cb50cf60$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var _$Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < _$Slides.length; i++){
            var slideIndex = _$Slides[i].index;
            var distance = $cd28a1f5cb50cf60$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $cd28a1f5cb50cf60$var$rect(list)[left] - $cd28a1f5cb50cf60$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($cd28a1f5cb50cf60$export$e5a58a5ee5b54c22)) position = $cd28a1f5cb50cf60$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $cd28a1f5cb50cf60$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $cd28a1f5cb50cf60$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $cd28a1f5cb50cf60$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, toPosition = _$Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($cd28a1f5cb50cf60$export$f42383286ed1223d);
    var isSlide = Splide2.is($cd28a1f5cb50cf60$export$e5a58a5ee5b54c22);
    var getNext = $cd28a1f5cb50cf60$var$apply(getAdjacent, false);
    var getPrev = $cd28a1f5cb50cf60$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $cd28a1f5cb50cf60$export$db40ab7c0855fa5c,
            $cd28a1f5cb50cf60$export$7f4701ac5e05e39f,
            $cd28a1f5cb50cf60$export$28dea85f216954dc
        ], init);
        on($cd28a1f5cb50cf60$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $cd28a1f5cb50cf60$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            _$Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($cd28a1f5cb50cf60$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                _$Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(_$Move.toIndex(getPosition()));
            setIndex(omitEnd ? $cd28a1f5cb50cf60$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($cd28a1f5cb50cf60$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $cd28a1f5cb50cf60$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$cd28a1f5cb50cf60$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($cd28a1f5cb50cf60$var$between(0, dest, from, true) || $cd28a1f5cb50cf60$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $cd28a1f5cb50cf60$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $cd28a1f5cb50cf60$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $cd28a1f5cb50cf60$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $cd28a1f5cb50cf60$var$min(index, endIndex) : $cd28a1f5cb50cf60$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = _$Move.toIndex(destination);
        return isSlide ? $cd28a1f5cb50cf60$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$cd28a1f5cb50cf60$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $cd28a1f5cb50cf60$var$MOVING,
            $cd28a1f5cb50cf60$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $cd28a1f5cb50cf60$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $cd28a1f5cb50cf60$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $cd28a1f5cb50cf60$var$SIZE = 40;
function $cd28a1f5cb50cf60$var$Arrows(Splide2, Components2, options) {
    var event = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var placeholder = _$Elements.arrows, track = _$Elements.track;
    var wrapper = placeholder;
    var prev = _$Elements.prev;
    var next = _$Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($cd28a1f5cb50cf60$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $cd28a1f5cb50cf60$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $cd28a1f5cb50cf60$var$display(wrapper, enabled ? "" : "none");
            $cd28a1f5cb50cf60$var$addClass(wrapper, wrapperClasses = $cd28a1f5cb50cf60$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $cd28a1f5cb50cf60$var$setAttribute([
                    prev,
                    next
                ], $cd28a1f5cb50cf60$var$ARIA_CONTROLS, track.id);
                emit($cd28a1f5cb50cf60$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $cd28a1f5cb50cf60$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $cd28a1f5cb50cf60$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $cd28a1f5cb50cf60$var$removeAttribute([
            prev,
            next
        ], $cd28a1f5cb50cf60$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $cd28a1f5cb50cf60$export$d300dc1a2634364b,
            $cd28a1f5cb50cf60$export$fe5802204b967f0d,
            $cd28a1f5cb50cf60$export$7f4701ac5e05e39f,
            $cd28a1f5cb50cf60$export$ff8164bff3202b9,
            $cd28a1f5cb50cf60$export$28dea85f216954dc
        ], update);
        bind(next, "click", $cd28a1f5cb50cf60$var$apply(go, ">"));
        bind(prev, "click", $cd28a1f5cb50cf60$var$apply(go, "<"));
    }
    function go(control) {
        _$Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $cd28a1f5cb50cf60$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $cd28a1f5cb50cf60$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $cd28a1f5cb50cf60$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $cd28a1f5cb50cf60$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $cd28a1f5cb50cf60$var$SIZE + " " + $cd28a1f5cb50cf60$var$SIZE + '" width="' + $cd28a1f5cb50cf60$var$SIZE + '" height="' + $cd28a1f5cb50cf60$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $cd28a1f5cb50cf60$var$PATH) + '" />';
        return $cd28a1f5cb50cf60$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = _$Controller.getPrev();
            var nextIndex = _$Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $cd28a1f5cb50cf60$var$setAttribute(prev, $cd28a1f5cb50cf60$var$ARIA_LABEL, prevLabel);
            $cd28a1f5cb50cf60$var$setAttribute(next, $cd28a1f5cb50cf60$var$ARIA_LABEL, nextLabel);
            emit($cd28a1f5cb50cf60$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $cd28a1f5cb50cf60$var$INTERVAL_DATA_ATTRIBUTE = $cd28a1f5cb50cf60$var$DATA_ATTRIBUTE + "-interval";
function $cd28a1f5cb50cf60$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $cd28a1f5cb50cf60$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var _$Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $cd28a1f5cb50cf60$var$setAttribute(toggle, $cd28a1f5cb50cf60$var$ARIA_CONTROLS, _$Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $cd28a1f5cb50cf60$export$2aa493d7c3275167,
            $cd28a1f5cb50cf60$export$49801896908b5e33,
            $cd28a1f5cb50cf60$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($cd28a1f5cb50cf60$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($cd28a1f5cb50cf60$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($cd28a1f5cb50cf60$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $cd28a1f5cb50cf60$var$toggleClass(toggle, $cd28a1f5cb50cf60$export$72d36ecf3758cb4b, !stopped);
            $cd28a1f5cb50cf60$var$setAttribute(toggle, $cd28a1f5cb50cf60$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = _$Elements.bar;
        bar && $cd28a1f5cb50cf60$var$style(bar, "width", rate * 100 + "%");
        emit($cd28a1f5cb50cf60$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$cd28a1f5cb50cf60$var$getAttribute(Slide.slide, $cd28a1f5cb50cf60$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $cd28a1f5cb50cf60$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($cd28a1f5cb50cf60$export$9f64346e17f0ec8e, $cd28a1f5cb50cf60$var$apply(toggle, true));
            on([
                $cd28a1f5cb50cf60$export$d300dc1a2634364b,
                $cd28a1f5cb50cf60$export$db40ab7c0855fa5c,
                $cd28a1f5cb50cf60$export$7f4701ac5e05e39f
            ], $cd28a1f5cb50cf60$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $cd28a1f5cb50cf60$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $cd28a1f5cb50cf60$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $cd28a1f5cb50cf60$var$apply(cover, false)
    };
}
var $cd28a1f5cb50cf60$var$BOUNCE_DIFF_THRESHOLD = 10;
var $cd28a1f5cb50cf60$var$BOUNCE_DURATION = 600;
var $cd28a1f5cb50cf60$var$FRICTION_FACTOR = 0.6;
var $cd28a1f5cb50cf60$var$BASE_VELOCITY = 1.5;
var $cd28a1f5cb50cf60$var$MIN_DURATION = 800;
function $cd28a1f5cb50cf60$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, exceededLimit = _$Move.exceededLimit, translate = _$Move.translate;
    var isSlide = Splide2.is($cd28a1f5cb50cf60$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($cd28a1f5cb50cf60$export$2aa493d7c3275167, clear);
        on([
            $cd28a1f5cb50cf60$export$db40ab7c0855fa5c,
            $cd28a1f5cb50cf60$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $cd28a1f5cb50cf60$var$sign(destination) * size * $cd28a1f5cb50cf60$var$floor($cd28a1f5cb50cf60$var$abs(destination) / size) || 0;
            destination = _$Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $cd28a1f5cb50cf60$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $cd28a1f5cb50cf60$var$max($cd28a1f5cb50cf60$var$abs(destination - from) / $cd28a1f5cb50cf60$var$BASE_VELOCITY, $cd28a1f5cb50cf60$var$MIN_DURATION);
        callback = onScrolled;
        interval = $cd28a1f5cb50cf60$export$46ad21b25b6dccf0(duration, onEnd, $cd28a1f5cb50cf60$var$apply(update, from, destination, noConstrain), 1);
        set($cd28a1f5cb50cf60$var$SCROLLING);
        emit($cd28a1f5cb50cf60$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($cd28a1f5cb50cf60$var$IDLE);
        callback && callback();
        emit($cd28a1f5cb50cf60$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $cd28a1f5cb50cf60$var$FRICTION_FACTOR;
            if ($cd28a1f5cb50cf60$var$abs(diff) < $cd28a1f5cb50cf60$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $cd28a1f5cb50cf60$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $cd28a1f5cb50cf60$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $cd28a1f5cb50cf60$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var _$Move = Components2.Move, _$Scroll = Components2.Scroll, _$Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = _$Move.getPosition, exceededLimit = _$Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $cd28a1f5cb50cf60$var$POINTER_MOVE_EVENTS, $cd28a1f5cb50cf60$var$noop, $cd28a1f5cb50cf60$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $cd28a1f5cb50cf60$var$POINTER_UP_EVENTS, $cd28a1f5cb50cf60$var$noop, $cd28a1f5cb50cf60$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $cd28a1f5cb50cf60$var$POINTER_DOWN_EVENTS, onPointerDown, $cd28a1f5cb50cf60$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $cd28a1f5cb50cf60$var$prevent);
        on([
            $cd28a1f5cb50cf60$export$d300dc1a2634364b,
            $cd28a1f5cb50cf60$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!_$Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $cd28a1f5cb50cf60$var$MOVING,
                        $cd28a1f5cb50cf60$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $cd28a1f5cb50cf60$var$POINTER_MOVE_EVENTS, onPointerMove, $cd28a1f5cb50cf60$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $cd28a1f5cb50cf60$var$POINTER_UP_EVENTS, onPointerUp, $cd28a1f5cb50cf60$var$SCROLL_LISTENER_OPTIONS);
                    _$Move.cancel();
                    _$Scroll.cancel();
                    save(e);
                } else $cd28a1f5cb50cf60$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($cd28a1f5cb50cf60$var$DRAGGING)) {
            state.set($cd28a1f5cb50cf60$var$DRAGGING);
            emit($cd28a1f5cb50cf60$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                _$Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $cd28a1f5cb50cf60$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($cd28a1f5cb50cf60$export$8e9f636d2c722196);
                $cd28a1f5cb50cf60$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $cd28a1f5cb50cf60$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($cd28a1f5cb50cf60$var$DRAGGING)) {
            state.set($cd28a1f5cb50cf60$var$IDLE);
            emit($cd28a1f5cb50cf60$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $cd28a1f5cb50cf60$var$prevent(e);
        }
        unbind(target, $cd28a1f5cb50cf60$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $cd28a1f5cb50cf60$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $cd28a1f5cb50cf60$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) _$Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($cd28a1f5cb50cf60$export$742b62a5690c060)) _$Controller.go(orient($cd28a1f5cb50cf60$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($cd28a1f5cb50cf60$export$e5a58a5ee5b54c22) && exceeded && rewind) _$Controller.go(exceededLimit(true) ? ">" : "<");
        else _$Controller.go(_$Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $cd28a1f5cb50cf60$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $cd28a1f5cb50cf60$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $cd28a1f5cb50cf60$var$abs(diffCoord(e)) > $cd28a1f5cb50cf60$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($cd28a1f5cb50cf60$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $cd28a1f5cb50cf60$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $cd28a1f5cb50cf60$var$sign(velocity) * $cd28a1f5cb50cf60$var$min($cd28a1f5cb50cf60$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $cd28a1f5cb50cf60$var$timeOf(e) - $cd28a1f5cb50cf60$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($cd28a1f5cb50cf60$export$e5a58a5ee5b54c22) ? $cd28a1f5cb50cf60$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$cd28a1f5cb50cf60$var$matches(target2, "." + $cd28a1f5cb50cf60$export$52f2cca6a5eee805 + ", ." + $cd28a1f5cb50cf60$export$516e7d18e13a2dca) && (!noDrag || !$cd28a1f5cb50cf60$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $cd28a1f5cb50cf60$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $cd28a1f5cb50cf60$var$ARROW_RIGHT,
    Left: $cd28a1f5cb50cf60$var$ARROW_LEFT,
    Up: $cd28a1f5cb50cf60$var$ARROW_UP,
    Down: $cd28a1f5cb50cf60$var$ARROW_DOWN
};
function $cd28a1f5cb50cf60$var$normalizeKey(key) {
    key = $cd28a1f5cb50cf60$var$isString(key) ? key : key.key;
    return $cd28a1f5cb50cf60$var$NORMALIZATION_MAP[key] || key;
}
var $cd28a1f5cb50cf60$var$KEYBOARD_EVENT = "keydown";
function $cd28a1f5cb50cf60$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($cd28a1f5cb50cf60$export$db40ab7c0855fa5c, destroy);
        on($cd28a1f5cb50cf60$export$db40ab7c0855fa5c, init);
        on($cd28a1f5cb50cf60$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $cd28a1f5cb50cf60$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $cd28a1f5cb50cf60$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $cd28a1f5cb50cf60$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $cd28a1f5cb50cf60$var$normalizeKey(e);
            if (key === resolve($cd28a1f5cb50cf60$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($cd28a1f5cb50cf60$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $cd28a1f5cb50cf60$var$SRC_DATA_ATTRIBUTE = $cd28a1f5cb50cf60$var$DATA_ATTRIBUTE + "-lazy";
var $cd28a1f5cb50cf60$var$SRCSET_DATA_ATTRIBUTE = $cd28a1f5cb50cf60$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $cd28a1f5cb50cf60$var$IMAGE_SELECTOR = "[" + $cd28a1f5cb50cf60$var$SRC_DATA_ATTRIBUTE + "], [" + $cd28a1f5cb50cf60$var$SRCSET_DATA_ATTRIBUTE + "]";
function $cd28a1f5cb50cf60$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $cd28a1f5cb50cf60$export$fe5802204b967f0d,
        $cd28a1f5cb50cf60$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($cd28a1f5cb50cf60$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $cd28a1f5cb50cf60$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $cd28a1f5cb50cf60$var$queryAll(Slide.slide, $cd28a1f5cb50cf60$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $cd28a1f5cb50cf60$var$getAttribute(img, $cd28a1f5cb50cf60$var$SRC_DATA_ATTRIBUTE);
                var srcset = $cd28a1f5cb50cf60$var$getAttribute(img, $cd28a1f5cb50cf60$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $cd28a1f5cb50cf60$var$child(parent, "." + className) || $cd28a1f5cb50cf60$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $cd28a1f5cb50cf60$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $cd28a1f5cb50cf60$var$addClass(data[1].slide, $cd28a1f5cb50cf60$export$d22ec4ccb7996ba2);
        bind(img, "load error", $cd28a1f5cb50cf60$var$apply(onLoad, data));
        $cd28a1f5cb50cf60$var$setAttribute(img, "src", $cd28a1f5cb50cf60$var$getAttribute(img, $cd28a1f5cb50cf60$var$SRC_DATA_ATTRIBUTE));
        $cd28a1f5cb50cf60$var$setAttribute(img, "srcset", $cd28a1f5cb50cf60$var$getAttribute(img, $cd28a1f5cb50cf60$var$SRCSET_DATA_ATTRIBUTE));
        $cd28a1f5cb50cf60$var$removeAttribute(img, $cd28a1f5cb50cf60$var$SRC_DATA_ATTRIBUTE);
        $cd28a1f5cb50cf60$var$removeAttribute(img, $cd28a1f5cb50cf60$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $cd28a1f5cb50cf60$var$removeClass(Slide.slide, $cd28a1f5cb50cf60$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $cd28a1f5cb50cf60$var$remove(data[2]);
            $cd28a1f5cb50cf60$var$display(img, "");
            emit($cd28a1f5cb50cf60$export$9f64346e17f0ec8e, img, Slide);
            emit($cd28a1f5cb50cf60$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $cd28a1f5cb50cf60$var$apply($cd28a1f5cb50cf60$var$empty, entries),
        check: check
    };
}
function $cd28a1f5cb50cf60$var$Pagination(Splide2, Components2, options) {
    var event = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var _$Slides = Components2.Slides, _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var hasFocus = _$Controller.hasFocus, getIndex = _$Controller.getIndex, go = _$Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = _$Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $cd28a1f5cb50cf60$export$db40ab7c0855fa5c,
            $cd28a1f5cb50cf60$export$7f4701ac5e05e39f,
            $cd28a1f5cb50cf60$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $cd28a1f5cb50cf60$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $cd28a1f5cb50cf60$export$2aa493d7c3275167,
                $cd28a1f5cb50cf60$export$49801896908b5e33,
                $cd28a1f5cb50cf60$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($cd28a1f5cb50cf60$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $cd28a1f5cb50cf60$var$remove(placeholder ? $cd28a1f5cb50cf60$var$slice(list.children) : list);
            $cd28a1f5cb50cf60$var$removeClass(list, paginationClasses);
            $cd28a1f5cb50cf60$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? _$Controller.getEnd() + 1 : $cd28a1f5cb50cf60$var$ceil(length / perPage);
        list = placeholder || $cd28a1f5cb50cf60$var$create("ul", classes.pagination, _$Elements.track.parentElement);
        $cd28a1f5cb50cf60$var$addClass(list, paginationClasses = $cd28a1f5cb50cf60$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $cd28a1f5cb50cf60$var$setAttribute(list, $cd28a1f5cb50cf60$var$ROLE, "tablist");
        $cd28a1f5cb50cf60$var$setAttribute(list, $cd28a1f5cb50cf60$var$ARIA_LABEL, i18n.select);
        $cd28a1f5cb50cf60$var$setAttribute(list, $cd28a1f5cb50cf60$var$ARIA_ORIENTATION, getDirection() === $cd28a1f5cb50cf60$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $cd28a1f5cb50cf60$var$create("li", null, list);
            var button = $cd28a1f5cb50cf60$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = _$Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $cd28a1f5cb50cf60$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $cd28a1f5cb50cf60$var$apply(onKeydown, i));
            $cd28a1f5cb50cf60$var$setAttribute(li, $cd28a1f5cb50cf60$var$ROLE, "presentation");
            $cd28a1f5cb50cf60$var$setAttribute(button, $cd28a1f5cb50cf60$var$ROLE, "tab");
            $cd28a1f5cb50cf60$var$setAttribute(button, $cd28a1f5cb50cf60$var$ARIA_CONTROLS, controls.join(" "));
            $cd28a1f5cb50cf60$var$setAttribute(button, $cd28a1f5cb50cf60$var$ARIA_LABEL, $cd28a1f5cb50cf60$var$format(text, i + 1));
            $cd28a1f5cb50cf60$var$setAttribute(button, $cd28a1f5cb50cf60$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $cd28a1f5cb50cf60$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($cd28a1f5cb50cf60$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($cd28a1f5cb50cf60$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $cd28a1f5cb50cf60$var$focus(item.button);
            go(">" + nextPage);
            $cd28a1f5cb50cf60$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[_$Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $cd28a1f5cb50cf60$var$removeClass(button, $cd28a1f5cb50cf60$export$72d36ecf3758cb4b);
            $cd28a1f5cb50cf60$var$removeAttribute(button, $cd28a1f5cb50cf60$var$ARIA_SELECTED);
            $cd28a1f5cb50cf60$var$setAttribute(button, $cd28a1f5cb50cf60$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $cd28a1f5cb50cf60$var$addClass(_button, $cd28a1f5cb50cf60$export$72d36ecf3758cb4b);
            $cd28a1f5cb50cf60$var$setAttribute(_button, $cd28a1f5cb50cf60$var$ARIA_SELECTED, true);
            $cd28a1f5cb50cf60$var$setAttribute(_button, $cd28a1f5cb50cf60$var$TAB_INDEX, "");
        }
        emit($cd28a1f5cb50cf60$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $cd28a1f5cb50cf60$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $cd28a1f5cb50cf60$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $cd28a1f5cb50cf60$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $cd28a1f5cb50cf60$export$f188226459c8a3ff(splide);
        event.on($cd28a1f5cb50cf60$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($cd28a1f5cb50cf60$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($cd28a1f5cb50cf60$export$5adb665701eda1ce, onClick);
        on($cd28a1f5cb50cf60$export$6d5af59619d10e6a, onKeydown);
        on([
            $cd28a1f5cb50cf60$export$d300dc1a2634364b,
            $cd28a1f5cb50cf60$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($cd28a1f5cb50cf60$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $cd28a1f5cb50cf60$var$setAttribute(Components2.Elements.list, $cd28a1f5cb50cf60$var$ARIA_ORIENTATION, options.direction === $cd28a1f5cb50cf60$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($cd28a1f5cb50cf60$var$includes($cd28a1f5cb50cf60$var$TRIGGER_KEYS, $cd28a1f5cb50cf60$var$normalizeKey(e))) {
            onClick(Slide);
            $cd28a1f5cb50cf60$var$prevent(e);
        }
    }
    return {
        setup: $cd28a1f5cb50cf60$var$apply(Components2.Media.set, {
            slideFocus: $cd28a1f5cb50cf60$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $cd28a1f5cb50cf60$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $cd28a1f5cb50cf60$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $cd28a1f5cb50cf60$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($cd28a1f5cb50cf60$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $cd28a1f5cb50cf60$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($cd28a1f5cb50cf60$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $cd28a1f5cb50cf60$var$SR_REMOVAL_DELAY = 90;
function $cd28a1f5cb50cf60$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $cd28a1f5cb50cf60$var$create("span", $cd28a1f5cb50cf60$export$bb78d7c200da8960);
    var interval = $cd28a1f5cb50cf60$export$46ad21b25b6dccf0($cd28a1f5cb50cf60$var$SR_REMOVAL_DELAY, $cd28a1f5cb50cf60$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $cd28a1f5cb50cf60$var$setAttribute(track, $cd28a1f5cb50cf60$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($cd28a1f5cb50cf60$export$23663268a31b79e2, $cd28a1f5cb50cf60$var$apply(disable, true));
            on($cd28a1f5cb50cf60$export$16a1e4f3d0368265, $cd28a1f5cb50cf60$var$apply(disable, false));
            on([
                $cd28a1f5cb50cf60$export$fe5802204b967f0d,
                $cd28a1f5cb50cf60$export$ff8164bff3202b9
            ], $cd28a1f5cb50cf60$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $cd28a1f5cb50cf60$var$setAttribute(track, $cd28a1f5cb50cf60$var$ARIA_BUSY, active);
        if (active) {
            $cd28a1f5cb50cf60$var$append(track, sr);
            interval.start();
        } else {
            $cd28a1f5cb50cf60$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $cd28a1f5cb50cf60$var$removeAttribute(track, [
            $cd28a1f5cb50cf60$var$ARIA_LIVE,
            $cd28a1f5cb50cf60$var$ARIA_ATOMIC,
            $cd28a1f5cb50cf60$var$ARIA_BUSY
        ]);
        $cd28a1f5cb50cf60$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $cd28a1f5cb50cf60$var$setAttribute(track, $cd28a1f5cb50cf60$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $cd28a1f5cb50cf60$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $cd28a1f5cb50cf60$var$Media,
    Direction: $cd28a1f5cb50cf60$var$Direction,
    Elements: $cd28a1f5cb50cf60$var$Elements,
    Slides: $cd28a1f5cb50cf60$var$Slides,
    Layout: $cd28a1f5cb50cf60$var$Layout,
    Clones: $cd28a1f5cb50cf60$var$Clones,
    Move: $cd28a1f5cb50cf60$var$Move,
    Controller: $cd28a1f5cb50cf60$var$Controller,
    Arrows: $cd28a1f5cb50cf60$var$Arrows,
    Autoplay: $cd28a1f5cb50cf60$var$Autoplay,
    Cover: $cd28a1f5cb50cf60$var$Cover,
    Scroll: $cd28a1f5cb50cf60$var$Scroll,
    Drag: $cd28a1f5cb50cf60$var$Drag,
    Keyboard: $cd28a1f5cb50cf60$var$Keyboard,
    LazyLoad: $cd28a1f5cb50cf60$var$LazyLoad,
    Pagination: $cd28a1f5cb50cf60$var$Pagination,
    Sync: $cd28a1f5cb50cf60$var$Sync,
    Wheel: $cd28a1f5cb50cf60$var$Wheel,
    Live: $cd28a1f5cb50cf60$var$Live
});
var $cd28a1f5cb50cf60$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $cd28a1f5cb50cf60$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $cd28a1f5cb50cf60$export$ba41d43e4a419565,
    i18n: $cd28a1f5cb50cf60$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $cd28a1f5cb50cf60$var$Fade(Splide2, Components2, options) {
    var _$Slides = Components2.Slides;
    function mount() {
        $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2).on([
            $cd28a1f5cb50cf60$export$d300dc1a2634364b,
            $cd28a1f5cb50cf60$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        _$Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        _$Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $cd28a1f5cb50cf60$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $cd28a1f5cb50cf60$var$noop
    };
}
function $cd28a1f5cb50cf60$var$Slide(Splide2, Components2, options) {
    var _$Move = Components2.Move, _$Controller = Components2.Controller, _$Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $cd28a1f5cb50cf60$var$apply($cd28a1f5cb50cf60$var$style, list, "transition");
    var endCallback;
    function mount() {
        $cd28a1f5cb50cf60$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = _$Move.toPosition(index, true);
        var position = _$Move.getPosition();
        var speed = getSpeed(index);
        if ($cd28a1f5cb50cf60$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) _$Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                _$Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            _$Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        _$Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($cd28a1f5cb50cf60$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = _$Controller.getIndex(true);
            var end = _$Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $cd28a1f5cb50cf60$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $cd28a1f5cb50cf60$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $cd28a1f5cb50cf60$export$7254cc27399e90bd($cd28a1f5cb50cf60$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $cd28a1f5cb50cf60$var$isString(target) ? $cd28a1f5cb50cf60$var$query(document, target) : target;
        $cd28a1f5cb50cf60$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $cd28a1f5cb50cf60$var$merge({
            label: $cd28a1f5cb50cf60$var$getAttribute(root, $cd28a1f5cb50cf60$var$ARIA_LABEL) || "",
            labelledby: $cd28a1f5cb50cf60$var$getAttribute(root, $cd28a1f5cb50cf60$var$ARIA_LABELLEDBY) || ""
        }, $cd28a1f5cb50cf60$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $cd28a1f5cb50cf60$var$merge(options, JSON.parse($cd28a1f5cb50cf60$var$getAttribute(root, $cd28a1f5cb50cf60$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $cd28a1f5cb50cf60$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($cd28a1f5cb50cf60$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $cd28a1f5cb50cf60$var$assert(state.is([
            $cd28a1f5cb50cf60$var$CREATED,
            $cd28a1f5cb50cf60$var$DESTROYED
        ]), "Already mounted!");
        state.set($cd28a1f5cb50cf60$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($cd28a1f5cb50cf60$export$742b62a5690c060) ? $cd28a1f5cb50cf60$var$Fade : $cd28a1f5cb50cf60$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $cd28a1f5cb50cf60$var$assign({}, $cd28a1f5cb50cf60$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $cd28a1f5cb50cf60$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $cd28a1f5cb50cf60$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($cd28a1f5cb50cf60$export$d300dc1a2634364b);
        $cd28a1f5cb50cf60$var$addClass(this.root, $cd28a1f5cb50cf60$export$7761661e2d5b9388);
        state.set($cd28a1f5cb50cf60$var$IDLE);
        this.emit($cd28a1f5cb50cf60$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($cd28a1f5cb50cf60$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($cd28a1f5cb50cf60$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($cd28a1f5cb50cf60$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($cd28a1f5cb50cf60$var$CREATED)) $cd28a1f5cb50cf60$export$f188226459c8a3ff(this).on($cd28a1f5cb50cf60$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $cd28a1f5cb50cf60$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($cd28a1f5cb50cf60$export$88c4cf7419e470cd);
            event.destroy();
            completely && $cd28a1f5cb50cf60$var$empty(this.splides);
            state.set($cd28a1f5cb50cf60$var$DESTROYED);
        }
        return this;
    };
    $cd28a1f5cb50cf60$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $cd28a1f5cb50cf60$export$24494c7438c070bf = $cd28a1f5cb50cf60$var$_Splide;
$cd28a1f5cb50cf60$export$24494c7438c070bf.defaults = {};
$cd28a1f5cb50cf60$export$24494c7438c070bf.STATES = $cd28a1f5cb50cf60$var$STATES;
var $cd28a1f5cb50cf60$var$CLASS_RENDERED = "is-rendered";
var $cd28a1f5cb50cf60$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $cd28a1f5cb50cf60$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $cd28a1f5cb50cf60$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $cd28a1f5cb50cf60$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $cd28a1f5cb50cf60$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $cd28a1f5cb50cf60$var$merge($cd28a1f5cb50cf60$export$f484e977a69c6ba6, defaults || {});
        $cd28a1f5cb50cf60$var$merge($cd28a1f5cb50cf60$var$merge(this.options, $cd28a1f5cb50cf60$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $cd28a1f5cb50cf60$var$assign({}, $cd28a1f5cb50cf60$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $cd28a1f5cb50cf60$var$uniqueId("splide");
        this.Style = new $cd28a1f5cb50cf60$var$Style(this.id, this.options);
        this.Direction = $cd28a1f5cb50cf60$var$Direction(null, null, this.options);
        $cd28a1f5cb50cf60$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $cd28a1f5cb50cf60$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $cd28a1f5cb50cf60$var$queryAll(root, "." + $cd28a1f5cb50cf60$export$2c1ba4a4f1aa4947);
        on($cd28a1f5cb50cf60$export$d300dc1a2634364b, function() {
            $cd28a1f5cb50cf60$var$remove($cd28a1f5cb50cf60$var$child(root, "style"));
        });
        $cd28a1f5cb50cf60$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $cd28a1f5cb50cf60$var$push(this.slides, this.contents.map(function(content, index) {
            content = $cd28a1f5cb50cf60$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $cd28a1f5cb50cf60$export$72d36ecf3758cb4b : "");
            $cd28a1f5cb50cf60$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $cd28a1f5cb50cf60$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $cd28a1f5cb50cf60$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $cd28a1f5cb50cf60$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $cd28a1f5cb50cf60$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $cd28a1f5cb50cf60$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $cd28a1f5cb50cf60$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $cd28a1f5cb50cf60$var$unit(padding[prop] || ($cd28a1f5cb50cf60$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $cd28a1f5cb50cf60$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $cd28a1f5cb50cf60$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $cd28a1f5cb50cf60$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $cd28a1f5cb50cf60$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $cd28a1f5cb50cf60$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($cd28a1f5cb50cf60$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $cd28a1f5cb50cf60$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $cd28a1f5cb50cf60$var$merge($cd28a1f5cb50cf60$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $cd28a1f5cb50cf60$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $cd28a1f5cb50cf60$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $cd28a1f5cb50cf60$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $cd28a1f5cb50cf60$export$93b21159ad85c843,
            $cd28a1f5cb50cf60$export$93b21159ad85c843 + "--" + options.type,
            $cd28a1f5cb50cf60$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $cd28a1f5cb50cf60$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $cd28a1f5cb50cf60$export$93b21159ad85c843 + "--nav",
            $cd28a1f5cb50cf60$export$72d36ecf3758cb4b,
            !this.config.hidden && $cd28a1f5cb50cf60$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $cd28a1f5cb50cf60$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $cd28a1f5cb50cf60$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $cd28a1f5cb50cf60$var$forOwn(styles, function(value, key) {
            style += " " + $cd28a1f5cb50cf60$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$cd28a1f5cb50cf60$var$push(slides, slides);
        $cd28a1f5cb50cf60$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $cd28a1f5cb50cf60$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $cd28a1f5cb50cf60$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $cd28a1f5cb50cf60$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $cd28a1f5cb50cf60$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $cd28a1f5cb50cf60$var$SIZE + " " + $cd28a1f5cb50cf60$var$SIZE + '" width="' + $cd28a1f5cb50cf60$var$SIZE + '" height="' + $cd28a1f5cb50cf60$var$SIZE + '"><path d="' + (this.options.arrowPath || $cd28a1f5cb50cf60$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


/*!
 * @splidejs/splide-extension-auto-scroll
 * Version  : 0.5.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ 

var $dvYFb = parcelRequire("dvYFb");
function $c416604b0ac15a13$var$empty(array) {
    array.length = 0;
}
function $c416604b0ac15a13$var$slice$1(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $c416604b0ac15a13$var$apply$1(func) {
    return func.bind.apply(func, [
        null
    ].concat($c416604b0ac15a13$var$slice$1(arguments, 1)));
}
function $c416604b0ac15a13$var$raf(func) {
    return requestAnimationFrame(func);
}
function $c416604b0ac15a13$var$typeOf$1(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $dvYFb._)(subject)) === type;
}
var $c416604b0ac15a13$var$isArray$1 = Array.isArray;
$c416604b0ac15a13$var$apply$1($c416604b0ac15a13$var$typeOf$1, "function");
$c416604b0ac15a13$var$apply$1($c416604b0ac15a13$var$typeOf$1, "string");
$c416604b0ac15a13$var$apply$1($c416604b0ac15a13$var$typeOf$1, "undefined");
function $c416604b0ac15a13$var$toArray$1(value) {
    return $c416604b0ac15a13$var$isArray$1(value) ? value : [
        value
    ];
}
function $c416604b0ac15a13$var$forEach$1(values, iteratee) {
    $c416604b0ac15a13$var$toArray$1(values).forEach(iteratee);
}
var $c416604b0ac15a13$var$ownKeys$1 = Object.keys;
function $c416604b0ac15a13$var$forOwn$1(object, iteratee, right) {
    if (object) {
        var keys = $c416604b0ac15a13$var$ownKeys$1(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $c416604b0ac15a13$var$assign$1(object) {
    $c416604b0ac15a13$var$slice$1(arguments, 1).forEach(function(source) {
        $c416604b0ac15a13$var$forOwn$1(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
var $c416604b0ac15a13$var$min$1 = Math.min;
function $c416604b0ac15a13$var$EventBinder() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $c416604b0ac15a13$var$forEach$1(targets, function(target) {
            target && $c416604b0ac15a13$var$forEach$1(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $c416604b0ac15a13$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $c416604b0ac15a13$var$EVENT_MOVE = "move";
var $c416604b0ac15a13$var$EVENT_MOVED = "moved";
var $c416604b0ac15a13$var$EVENT_UPDATED = "updated";
var $c416604b0ac15a13$var$EVENT_DRAG = "drag";
var $c416604b0ac15a13$var$EVENT_DRAGGED = "dragged";
var $c416604b0ac15a13$var$EVENT_SCROLL = "scroll";
var $c416604b0ac15a13$var$EVENT_SCROLLED = "scrolled";
var $c416604b0ac15a13$var$EVENT_DESTROY = "destroy";
function $c416604b0ac15a13$var$EventInterface(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $c416604b0ac15a13$var$EventBinder();
    function on(events, callback) {
        binder.bind(bus, $c416604b0ac15a13$var$toArray$1(events).join(" "), function(e) {
            callback.apply(callback, $c416604b0ac15a13$var$isArray$1(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $c416604b0ac15a13$var$slice$1(arguments, 1));
    }
    if (Splide2) Splide2.event.on($c416604b0ac15a13$var$EVENT_DESTROY, binder.destroy);
    return $c416604b0ac15a13$var$assign$1(binder, {
        bus: bus,
        on: on,
        off: $c416604b0ac15a13$var$apply$1(binder.unbind, bus),
        emit: emit
    });
}
function $c416604b0ac15a13$var$RequestInterval(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $c416604b0ac15a13$var$min$1((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            $c416604b0ac15a13$var$raf(update);
        }
    }
    function start(resume) {
        !resume && cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        $c416604b0ac15a13$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $c416604b0ac15a13$var$Throttle(func, duration) {
    var interval;
    function throttled() {
        if (!interval) {
            interval = $c416604b0ac15a13$var$RequestInterval(duration || 0, function() {
                func();
                interval = null;
            }, null, 1);
            interval.start();
        }
    }
    return throttled;
}
var $c416604b0ac15a13$var$CLASS_ACTIVE = "is-active";
var $c416604b0ac15a13$var$SLIDE = "slide";
var $c416604b0ac15a13$var$FADE = "fade";
function $c416604b0ac15a13$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $c416604b0ac15a13$var$apply(func) {
    var _func;
    return (_func = func).bind.apply(_func, [
        null
    ].concat((0, $eb3e8a8ee265ba96$export$1b5e630bc3aea29f)($c416604b0ac15a13$var$slice(arguments, 1))));
}
function $c416604b0ac15a13$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $dvYFb._)(subject)) === type;
}
function $c416604b0ac15a13$var$isObject(subject) {
    return !$c416604b0ac15a13$var$isNull(subject) && $c416604b0ac15a13$var$typeOf("object", subject);
}
var $c416604b0ac15a13$var$isArray = Array.isArray;
$c416604b0ac15a13$var$apply($c416604b0ac15a13$var$typeOf, "function");
$c416604b0ac15a13$var$apply($c416604b0ac15a13$var$typeOf, "string");
var $c416604b0ac15a13$var$isUndefined = $c416604b0ac15a13$var$apply($c416604b0ac15a13$var$typeOf, "undefined");
function $c416604b0ac15a13$var$isNull(subject) {
    return subject === null;
}
function $c416604b0ac15a13$var$toArray(value) {
    return $c416604b0ac15a13$var$isArray(value) ? value : [
        value
    ];
}
function $c416604b0ac15a13$var$forEach(values, iteratee) {
    $c416604b0ac15a13$var$toArray(values).forEach(iteratee);
}
function $c416604b0ac15a13$var$toggleClass(elm, classes, add) {
    if (elm) $c416604b0ac15a13$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
var $c416604b0ac15a13$var$ownKeys = Object.keys;
function $c416604b0ac15a13$var$forOwn(object, iteratee, right) {
    if (object) {
        var keys = $c416604b0ac15a13$var$ownKeys(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $c416604b0ac15a13$var$assign(object) {
    $c416604b0ac15a13$var$slice(arguments, 1).forEach(function(source) {
        $c416604b0ac15a13$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $c416604b0ac15a13$var$removeAttribute(elms, attrs) {
    $c416604b0ac15a13$var$forEach(elms, function(elm) {
        $c416604b0ac15a13$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $c416604b0ac15a13$var$setAttribute(elms, attrs, value) {
    if ($c416604b0ac15a13$var$isObject(attrs)) $c416604b0ac15a13$var$forOwn(attrs, function(value2, name) {
        $c416604b0ac15a13$var$setAttribute(elms, name, value2);
    });
    else $c416604b0ac15a13$var$forEach(elms, function(elm) {
        $c416604b0ac15a13$var$isNull(value) || value === "" ? $c416604b0ac15a13$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
var $c416604b0ac15a13$var$min = Math.min, $c416604b0ac15a13$var$max = Math.max, $c416604b0ac15a13$var$floor = Math.floor, $c416604b0ac15a13$var$ceil = Math.ceil, $c416604b0ac15a13$var$abs = Math.abs;
function $c416604b0ac15a13$var$clamp(number, x, y) {
    var minimum = $c416604b0ac15a13$var$min(x, y);
    var maximum = $c416604b0ac15a13$var$max(x, y);
    return $c416604b0ac15a13$var$min($c416604b0ac15a13$var$max(minimum, number), maximum);
}
var $c416604b0ac15a13$var$DEFAULTS = {
    speed: 1,
    autoStart: true,
    pauseOnHover: true,
    pauseOnFocus: true
};
var $c416604b0ac15a13$var$I18N = {
    startScroll: "Start auto scroll",
    pauseScroll: "Pause auto scroll"
};
function $c416604b0ac15a13$export$3fb39aee5567f02e(Splide2, Components2, options) {
    var _EventInterface = $c416604b0ac15a13$var$EventInterface(Splide2), on = _EventInterface.on, off = _EventInterface.off, bind = _EventInterface.bind, unbind = _EventInterface.unbind;
    var _Components2_Move = Components2.Move, translate = _Components2_Move.translate, getPosition = _Components2_Move.getPosition, toIndex = _Components2_Move.toIndex, getLimit = _Components2_Move.getLimit;
    var _Components2_Controller = Components2.Controller, setIndex = _Components2_Controller.setIndex, getIndex = _Components2_Controller.getIndex;
    var orient = Components2.Direction.orient;
    var toggle = Components2.Elements.toggle;
    var Live = Components2.Live;
    var root = Splide2.root;
    var throttledUpdateArrows = $c416604b0ac15a13$var$Throttle(Components2.Arrows.update, 500);
    var autoScrollOptions = {};
    var interval;
    var stopped;
    var hovered;
    var focused;
    var busy;
    var currPosition;
    function setup() {
        var autoScroll = options.autoScroll;
        autoScrollOptions = $c416604b0ac15a13$var$assign({}, $c416604b0ac15a13$var$DEFAULTS, $c416604b0ac15a13$var$isObject(autoScroll) ? autoScroll : {});
    }
    function mount() {
        if (!Splide2.is($c416604b0ac15a13$var$FADE)) {
            if (!interval && options.autoScroll !== false) {
                interval = $c416604b0ac15a13$var$RequestInterval(0, move);
                listen();
                autoStart();
            }
        }
    }
    function destroy() {
        if (interval) {
            interval.cancel();
            interval = null;
            currPosition = void 0;
            off([
                $c416604b0ac15a13$var$EVENT_MOVE,
                $c416604b0ac15a13$var$EVENT_DRAG,
                $c416604b0ac15a13$var$EVENT_SCROLL,
                $c416604b0ac15a13$var$EVENT_MOVED,
                $c416604b0ac15a13$var$EVENT_SCROLLED
            ]);
            unbind(root, "mouseenter mouseleave focusin focusout");
            unbind(toggle, "click");
        }
    }
    function listen() {
        if (autoScrollOptions.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (autoScrollOptions.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (autoScrollOptions.useToggleButton) bind(toggle, "click", function() {
            stopped ? play() : pause();
        });
        on($c416604b0ac15a13$var$EVENT_UPDATED, update);
        on([
            $c416604b0ac15a13$var$EVENT_MOVE,
            $c416604b0ac15a13$var$EVENT_DRAG,
            $c416604b0ac15a13$var$EVENT_SCROLL
        ], function() {
            busy = true;
            pause(false);
        });
        on([
            $c416604b0ac15a13$var$EVENT_MOVED,
            $c416604b0ac15a13$var$EVENT_DRAGGED,
            $c416604b0ac15a13$var$EVENT_SCROLLED
        ], function() {
            busy = false;
            autoToggle();
        });
    }
    function update() {
        var autoScroll = options.autoScroll;
        if (autoScroll !== false) {
            autoScrollOptions = $c416604b0ac15a13$var$assign({}, autoScrollOptions, $c416604b0ac15a13$var$isObject(autoScroll) ? autoScroll : {});
            mount();
        } else destroy();
        if (interval && !$c416604b0ac15a13$var$isUndefined(currPosition)) translate(currPosition);
    }
    function autoStart() {
        if (autoScrollOptions.autoStart) {
            if (document.readyState === "complete") play();
            else bind(window, "load", play);
        }
    }
    function play() {
        if (isPaused()) {
            interval.start(true);
            Live.disable(true);
            focused = hovered = stopped = false;
            updateButton();
        }
    }
    function pause() {
        var stop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if (!stopped) {
            stopped = stop;
            updateButton();
            if (!isPaused()) {
                interval.pause();
                Live.disable(false);
            }
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused || busy ? pause(false) : play();
    }
    function move() {
        var position = getPosition();
        var destination = computeDestination(position);
        if (position !== destination) {
            translate(destination);
            updateIndex(currPosition = getPosition());
        } else {
            pause(false);
            if (autoScrollOptions.rewind) Splide2.go(autoScrollOptions.speed > 0 ? 0 : Components2.Controller.getEnd());
        }
        throttledUpdateArrows();
    }
    function computeDestination(position) {
        var speed = autoScrollOptions.speed || 1;
        position += orient(speed);
        if (Splide2.is($c416604b0ac15a13$var$SLIDE)) position = $c416604b0ac15a13$var$clamp(position, getLimit(false), getLimit(true));
        return position;
    }
    function updateIndex(position) {
        var length = Splide2.length;
        var index = (toIndex(position) + length) % length;
        if (index !== getIndex()) {
            setIndex(index);
            Components2.Slides.update();
            Components2.Pagination.update();
            options.lazyLoad === "nearby" && Components2.LazyLoad.check();
        }
    }
    function updateButton() {
        if (toggle) {
            var key = stopped ? "startScroll" : "pauseScroll";
            $c416604b0ac15a13$var$toggleClass(toggle, $c416604b0ac15a13$var$CLASS_ACTIVE, !stopped);
            $c416604b0ac15a13$var$setAttribute(toggle, "aria-label", options.i18n[key] || $c416604b0ac15a13$var$I18N[key]);
        }
    }
    function isPaused() {
        return !interval || interval.isPaused();
    }
    return {
        setup: setup,
        mount: mount,
        destroy: destroy,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}


var $673d7615312194c4$exports = {};
/********************************************************************************
    vCards-js, Eric J Nesser, November 2014
********************************************************************************/ /*jslint node: true */ "use strict";





/**
 * Represents a contact that can be imported into Outlook, iOS, Mac OS, Android devices, and more
 */ var $673d7615312194c4$var$vCard = function vCard() {
    /**
     * Get photo object for storing photos in vCards
     */ function getPhoto() {
        return {
            url: "",
            mediaType: "",
            base64: false,
            /**
             * Attach a photo from a URL
             * @param  {string} url       URL where photo can be found
             * @param  {string} mediaType Media type of photo (JPEG, PNG, GIF)
             */ attachFromUrl: function attachFromUrl(url, mediaType) {
                this.url = url;
                this.mediaType = mediaType;
                this.base64 = false;
            },
            /**
             * Embed a photo from a file using base-64 encoding (not implemented yet)
             * @param  {string} filename
             */ embedFromFile: function embedFromFile(fileLocation) {
                var fs = (parcelRequire("01lc4"));
                var path = (parcelRequire("5iYY9"));
                this.mediaType = path.extname(fileLocation).toUpperCase().replace(/\./g, "");
                var imgData = fs.readFileSync(fileLocation);
                this.url = imgData.toString("base64");
                this.base64 = true;
            },
            /**
             * Embed a photo from a base-64 string
             * @param  {string} base64String
             */ embedFromString: function embedFromString(base64String, mediaType) {
                this.mediaType = mediaType;
                this.url = base64String;
                this.base64 = true;
            }
        };
    }
    /**
     * Get a mailing address to attach to a vCard.
     */ function getMailingAddress() {
        return {
            /**
             * Represents the actual text that should be put on the mailing label when delivering a physical package
             * @type {String}
             */ label: "",
            /**
             * Street address
             * @type {String}
             */ street: "",
            /**
             * City
             * @type {String}
             */ city: "",
            /**
             * State or province
             * @type {String}
             */ stateProvince: "",
            /**
             * Postal code
             * @type {String}
             */ postalCode: "",
            /**
             * Country or region
             * @type {String}
             */ countryRegion: ""
        };
    }
    /**
     * Get social media URLs
     * @return {object} Social media URL hash group
     */ function getSocialUrls() {
        return {
            "facebook": "",
            "linkedIn": "",
            "twitter": "",
            "flickr": ""
        };
    }
    /********************************************************************************
     * Public interface for vCard
     ********************************************************************************/ return {
        /**
         * Specifies a value that represents a persistent, globally unique identifier associated with the vCard
         * @type {String}
         */ uid: "",
        /**
         * Date of birth
         * @type {Datetime}
         */ birthday: "",
        /**
         * Cell phone number
         * @type {String}
         */ cellPhone: "",
        /**
         * Other cell phone number or pager
         * @type {String}
         */ pagerPhone: "",
        /**
         * The address for private electronic mail communication
         * @type {String}
         */ email: "",
        /**
         * The address for work-related electronic mail communication
         * @type {String}
         */ workEmail: "",
        /**
         * First name
         * @type {String}
         */ firstName: "",
        /**
         * Formatted name string associated with the vCard object (will automatically populate if not set)
         * @type {String}
         */ formattedName: "",
        /**
         * Gender.
         * @type {String} Must be M or F for Male or Female
         */ gender: "",
        /**
         * Home mailing address
         * @type {object}
         */ homeAddress: getMailingAddress(),
        /**
         * Home phone
         * @type {String}
         */ homePhone: "",
        /**
         * Home facsimile
         * @type {String}
         */ homeFax: "",
        /**
         * Last name
         * @type {String}
         */ lastName: "",
        /**
         * Logo
         * @type {object}
         */ logo: getPhoto(),
        /**
         * Middle name
         * @type {String}
         */ middleName: "",
        /**
         * Prefix for individual's name
         * @type {String}
         */ namePrefix: "",
        /**
         * Suffix for individual's name
         * @type {String}
         */ nameSuffix: "",
        /**
         * Nickname of individual
         * @type {String}
         */ nickname: "",
        /**
         * Specifies supplemental information or a comment that is associated with the vCard
         * @type {String}
         */ note: "",
        /**
         * The name and optionally the unit(s) of the organization associated with the vCard object
         * @type {String}
         */ organization: "",
        /**
         * Individual's photo
         * @type {object}
         */ photo: getPhoto(),
        /**
         * The role, occupation, or business category of the vCard object within an organization
         * @type {String}
         */ role: "",
        /**
         * Social URLs attached to the vCard object (ex: Facebook, Twitter, LinkedIn)
         * @type {String}
         */ socialUrls: getSocialUrls(),
        /**
         * A URL that can be used to get the latest version of this vCard
         * @type {String}
         */ source: "",
        /**
         * Specifies the job title, functional position or function of the individual within an organization
         * @type {String}
         */ title: "",
        /**
         * URL pointing to a website that represents the person in some way
         * @type {String}
         */ url: "",
        /**
         * URL pointing to a website that represents the person's work in some way
         * @type {String}
         */ workUrl: "",
        /**
         * Work mailing address
         * @type {object}
         */ workAddress: getMailingAddress(),
        /**
         * Work phone
         * @type {String}
         */ workPhone: "",
        /**
         * Work facsimile
         * @type {String}
         */ workFax: "",
        /**
         * vCard version
         * @type {String}
         */ version: "3.0",
        /**
         * Get major version of the vCard format
         * @return {integer}
         */ getMajorVersion: function getMajorVersion() {
            var majorVersionString = this.version ? this.version.split(".")[0] : "4";
            if (!isNaN(majorVersionString)) return parseInt(majorVersionString);
            return 4;
        },
        /**
         * Get formatted vCard
         * @return {String} Formatted vCard in VCF format
         */ getFormattedString: function getFormattedString() {
            var vCardFormatter = (parcelRequire("5VYNn"));
            return vCardFormatter.getFormattedString(this);
        },
        /**
         * Save formatted vCard to file
         * @param  {String} filename
         */ saveToFile: function saveToFile(filename) {
            var vCardFormatter = (parcelRequire("5VYNn"));
            var contents = vCardFormatter.getFormattedString(this);
            var fs = (parcelRequire("01lc4"));
            fs.writeFileSync(filename, contents, {
                encoding: "utf8"
            });
        }
    };
};
$673d7615312194c4$exports = $673d7615312194c4$var$vCard;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $5c02d41f81c833e9$var$t(t, n) {
    var e = "function" == typeof Symbol && t[Symbol.iterator];
    if (!e) return t;
    var r, o, i = e.call(t), a = [];
    try {
        for(; (void 0 === n || n-- > 0) && !(r = i.next()).done;)a.push(r.value);
    } catch (t) {
        o = {
            error: t
        };
    } finally{
        try {
            r && !r.done && (e = i.return) && e.call(i);
        } finally{
            if (o) throw o.error;
        }
    }
    return a;
}
var $5c02d41f81c833e9$export$7a567c9c5088a551;
!function(t) {
    t[t.NotStarted = 0] = "NotStarted", t[t.Running = 1] = "Running", t[t.Stopped = 2] = "Stopped";
}($5c02d41f81c833e9$export$7a567c9c5088a551 || ($5c02d41f81c833e9$export$7a567c9c5088a551 = {}));
var $5c02d41f81c833e9$var$e = {
    type: "xstate.init"
};
function $5c02d41f81c833e9$var$r(t) {
    return void 0 === t ? [] : [].concat(t);
}
function $5c02d41f81c833e9$export$e6e34fd1f2686227(t) {
    return {
        type: "xstate.assign",
        assignment: t
    };
}
function $5c02d41f81c833e9$var$i(t, n) {
    return "string" == typeof (t = "string" == typeof t && n && n[t] ? n[t] : t) ? {
        type: t
    } : "function" == typeof t ? {
        type: t.name,
        exec: t
    } : t;
}
function $5c02d41f81c833e9$var$a(t) {
    return function(n) {
        return t === n;
    };
}
function $5c02d41f81c833e9$var$u(t) {
    return "string" == typeof t ? {
        type: t
    } : t;
}
function $5c02d41f81c833e9$var$c(t, n) {
    return {
        value: t,
        context: n,
        actions: [],
        changed: !1,
        matches: $5c02d41f81c833e9$var$a(t)
    };
}
function $5c02d41f81c833e9$var$f(t, n, e) {
    var r = n, o = !1;
    return [
        t.filter(function(t) {
            if ("xstate.assign" === t.type) {
                o = !0;
                var _$n = Object.assign({}, r);
                return "function" == typeof t.assignment ? _$n = t.assignment(r, e) : Object.keys(t.assignment).forEach(function(o) {
                    _$n[o] = "function" == typeof t.assignment[o] ? t.assignment[o](r, e) : t.assignment[o];
                }), r = _$n, !1;
            }
            return !0;
        }),
        r,
        o
    ];
}
function $5c02d41f81c833e9$export$aaa7fa18f8e9b2e8(n, o) {
    void 0 === o && (o = {});
    var s = $5c02d41f81c833e9$var$t($5c02d41f81c833e9$var$f($5c02d41f81c833e9$var$r(n.states[n.initial].entry).map(function(t) {
        return $5c02d41f81c833e9$var$i(t, o.actions);
    }), n.context, $5c02d41f81c833e9$var$e), 2), l = s[0], y = s[1], p = {
        config: n,
        _options: o,
        initialState: {
            value: n.initial,
            actions: l,
            context: y,
            matches: $5c02d41f81c833e9$var$a(n.initial)
        },
        transition: function transition(e, o) {
            var s, l, y = "string" == typeof e ? {
                value: e,
                context: n.context
            } : e, v = y.value, g = y.context, d = $5c02d41f81c833e9$var$u(o), x = n.states[v];
            if (x.on) {
                var h = $5c02d41f81c833e9$var$r(x.on[d.type]);
                "*" in x.on && h.push.apply(h, function(t, n, e) {
                    if (e || 2 === arguments.length) for(var _$r, _$o = 0, i = n.length; _$o < i; _$o++)!_$r && _$o in n || (_$r || (_$r = Array.prototype.slice.call(n, 0, _$o)), _$r[_$o] = n[_$o]);
                    return t.concat(_$r || Array.prototype.slice.call(n));
                }([], $5c02d41f81c833e9$var$t($5c02d41f81c833e9$var$r(x.on["*"])), !1));
                try {
                    for(var m = function(t) {
                        var _$n = "function" == typeof Symbol && Symbol.iterator, _$e = _$n && t[_$n], _$r = 0;
                        if (_$e) return _$e.call(t);
                        if (t && "number" == typeof t.length) return {
                            next: function next() {
                                return t && _$r >= t.length && (t = void 0), {
                                    value: t && t[_$r++],
                                    done: !t
                                };
                            }
                        };
                        throw new TypeError(_$n ? "Object is not iterable." : "Symbol.iterator is not defined.");
                    }(h), b = m.next(); !b.done; b = m.next()){
                        var S = b.value;
                        if (void 0 === S) return $5c02d41f81c833e9$var$c(v, g);
                        var w = "string" == typeof S ? {
                            target: S
                        } : S, j = w.target, E = w.actions, R = void 0 === E ? [] : E, N = w.cond, O = void 0 === N ? function O() {
                            return !0;
                        } : N, _ = void 0 === j, A = null != j ? j : v, k = n.states[A];
                        if (O(g, d)) {
                            var T = $5c02d41f81c833e9$var$t($5c02d41f81c833e9$var$f((_ ? $5c02d41f81c833e9$var$r(R) : [].concat(x.exit, R, k.entry).filter(function(t) {
                                return t;
                            })).map(function(t) {
                                return $5c02d41f81c833e9$var$i(t, p._options.actions);
                            }), g, d), 3), q = T[0], z = T[1], B = T[2], C = null != j ? j : v;
                            return {
                                value: C,
                                context: z,
                                actions: q,
                                changed: j !== v || q.length > 0 || B,
                                matches: $5c02d41f81c833e9$var$a(C)
                            };
                        }
                    }
                } catch (t) {
                    s = {
                        error: t
                    };
                } finally{
                    try {
                        b && !b.done && (l = m.return) && l.call(m);
                    } finally{
                        if (s) throw s.error;
                    }
                }
            }
            return $5c02d41f81c833e9$var$c(v, g);
        }
    };
    return p;
}
var $5c02d41f81c833e9$var$l = function l(t, n) {
    return t.actions.forEach(function(e) {
        var r = e.exec;
        return r && r(t.context, n);
    });
};
function $5c02d41f81c833e9$export$67beed298888a38b(t) {
    var r = t.initialState, o = $5c02d41f81c833e9$export$7a567c9c5088a551.NotStarted, i = new Set, c = {
        _machine: t,
        send: function send(e) {
            o === $5c02d41f81c833e9$export$7a567c9c5088a551.Running && (r = t.transition(r, e), $5c02d41f81c833e9$var$l(r, $5c02d41f81c833e9$var$u(e)), i.forEach(function(t) {
                return t(r);
            }));
        },
        subscribe: function subscribe(t) {
            return i.add(t), t(r), {
                unsubscribe: function unsubscribe() {
                    return i.delete(t);
                }
            };
        },
        start: function start(i) {
            if (i) {
                var u = "object" == typeof i ? i : {
                    context: t.config.context,
                    value: i
                };
                r = {
                    value: u.value,
                    actions: [],
                    context: u.context,
                    matches: $5c02d41f81c833e9$var$a(u.value)
                };
            } else r = t.initialState;
            return o = $5c02d41f81c833e9$export$7a567c9c5088a551.Running, $5c02d41f81c833e9$var$l(r, $5c02d41f81c833e9$var$e), c;
        },
        stop: function stop() {
            return o = $5c02d41f81c833e9$export$7a567c9c5088a551.Stopped, i.clear(), c;
        },
        get state () {
            return r;
        },
        get status () {
            return o;
        }
    };
    return c;
}


function $8cbc258a9e4401e6$var$e(e) {
    return new Promise(function(n, r, t) {
        (t = new XMLHttpRequest).open("GET", e, t.withCredentials = !0), t.onload = function() {
            200 === t.status ? n() : r();
        }, t.send();
    });
}
var $8cbc258a9e4401e6$var$n, $8cbc258a9e4401e6$var$r = ($8cbc258a9e4401e6$var$n = document.createElement("link")).relList && $8cbc258a9e4401e6$var$n.relList.supports && $8cbc258a9e4401e6$var$n.relList.supports("prefetch") ? function r(e) {
    return new Promise(function(n, r, t) {
        (t = document.createElement("link")).rel = "prefetch", t.href = e, t.onload = n, t.onerror = r, document.head.appendChild(t);
    });
} : $8cbc258a9e4401e6$var$e, $8cbc258a9e4401e6$var$t = window.requestIdleCallback || function(e) {
    var n = Date.now();
    return setTimeout(function() {
        e({
            didTimeout: !1,
            timeRemaining: function timeRemaining() {
                return Math.max(0, 50 - (Date.now() - n));
            }
        });
    }, 1);
}, $8cbc258a9e4401e6$var$o = new Set, $8cbc258a9e4401e6$var$i = new Set, $8cbc258a9e4401e6$var$c = !1;
function $8cbc258a9e4401e6$var$a(e) {
    if (e) {
        if (e.saveData) return new Error("Save-Data is enabled");
        if (/2g/.test(e.effectiveType)) return new Error("network conditions are poor");
    }
    return !0;
}
function $8cbc258a9e4401e6$export$63174c828edd6ff8(e) {
    if (e || (e = {}), window.IntersectionObserver) {
        var n = function(e) {
            e = e || 1;
            var n = [], r = 0;
            function t() {
                r < e && n.length > 0 && (n.shift()(), r++);
            }
            return [
                function(e) {
                    n.push(e) > 1 || t();
                },
                function() {
                    r--, t();
                }
            ];
        }(e.throttle || 1 / 0), r = n[0], a = n[1], u = e.limit || 1 / 0, l = e.origins || [
            location.hostname
        ], d = e.ignores || [], h = e.delay || 0, p = [], m = e.timeoutFn || $8cbc258a9e4401e6$var$t, w = "function" == typeof e.hrefFn && e.hrefFn, g = e.prerender || !1;
        $8cbc258a9e4401e6$var$c = e.prerenderAndPrefetch || !1;
        var v = new IntersectionObserver(function(n) {
            n.forEach(function(n) {
                if (n.isIntersecting) p.push((n = n.target).href), function(e, n) {
                    n ? setTimeout(e, n) : e();
                }(function() {
                    -1 !== p.indexOf(n.href) && (v.unobserve(n), ($8cbc258a9e4401e6$var$c || g) && $8cbc258a9e4401e6$var$i.size < 1 ? $8cbc258a9e4401e6$export$4f10e897d13fb72b(w ? w(n) : n.href).catch(function(n) {
                        if (!e.onError) throw n;
                        e.onError(n);
                    }) : $8cbc258a9e4401e6$var$o.size < u && !g && r(function() {
                        $8cbc258a9e4401e6$export$f003ab04b0b3c00e(w ? w(n) : n.href, e.priority).then(a).catch(function(n) {
                            a(), e.onError && e.onError(n);
                        });
                    }));
                }, h);
                else {
                    var t = p.indexOf((n = n.target).href);
                    t > -1 && p.splice(t);
                }
            });
        }, {
            threshold: e.threshold || 0
        });
        return m(function() {
            (e.el || document).querySelectorAll("a").forEach(function(e) {
                l.length && !l.includes(e.hostname) || function e(n, r) {
                    return Array.isArray(r) ? r.some(function(r) {
                        return e(n, r);
                    }) : (r.test || r).call(r, n.href, n);
                }(e, d) || v.observe(e);
            });
        }, {
            timeout: e.timeout || 2e3
        }), function() {
            $8cbc258a9e4401e6$var$o.clear(), v.disconnect();
        };
    }
}
function $8cbc258a9e4401e6$export$f003ab04b0b3c00e(n, t, u) {
    var s = $8cbc258a9e4401e6$var$a(navigator.connection);
    return s instanceof Error ? Promise.reject(new Error("Cannot prefetch, " + s.message)) : ($8cbc258a9e4401e6$var$i.size > 0 && !$8cbc258a9e4401e6$var$c && console.warn("[Warning] You are using both prefetching and prerendering on the same document"), Promise.all([].concat(n).map(function(n) {
        if (!$8cbc258a9e4401e6$var$o.has(n)) return $8cbc258a9e4401e6$var$o.add(n), (t ? function(n) {
            return window.fetch ? fetch(n, {
                credentials: "include"
            }) : $8cbc258a9e4401e6$var$e(n);
        } : $8cbc258a9e4401e6$var$r)(new URL(n, location.href).toString());
    })));
}
function $8cbc258a9e4401e6$export$4f10e897d13fb72b(e, n) {
    var r = $8cbc258a9e4401e6$var$a(navigator.connection);
    if (r instanceof Error) return Promise.reject(new Error("Cannot prerender, " + r.message));
    if (!HTMLScriptElement.supports("speculationrules")) return $8cbc258a9e4401e6$export$f003ab04b0b3c00e(e), Promise.reject(new Error("This browser does not support the speculation rules API. Falling back to prefetch."));
    if (document.querySelector('script[type="speculationrules"]')) return Promise.reject(new Error("Speculation Rules is already defined and cannot be altered."));
    for(var t = 0, u = [].concat(e); t < u.length; t += 1){
        var f = u[t];
        if (window.location.origin !== new URL(f, window.location.href).origin) return Promise.reject(new Error("Only same origin URLs are allowed: " + f));
        $8cbc258a9e4401e6$var$i.add(f);
    }
    $8cbc258a9e4401e6$var$o.size > 0 && !$8cbc258a9e4401e6$var$c && console.warn("[Warning] You are using both prefetching and prerendering on the same document");
    var l = function(e) {
        var n = document.createElement("script");
        n.type = "speculationrules", n.text = '{"prerender":[{"source": "list","urls": ["' + Array.from(e).join('","') + '"]}]}';
        try {
            document.head.appendChild(n);
        } catch (e) {
            return e;
        }
        return !0;
    }($8cbc258a9e4401e6$var$i);
    return !0 === l ? Promise.resolve() : Promise.reject(l);
}


/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ 
var $dvYFb = parcelRequire("dvYFb");
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $1a0c6bd09b300b0d$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $1a0c6bd09b300b0d$var$candidateSelector = /* #__PURE__ */ $1a0c6bd09b300b0d$var$candidateSelectors.join(",");
var $1a0c6bd09b300b0d$var$NoElement = typeof Element === "undefined";
var $1a0c6bd09b300b0d$var$matches = $1a0c6bd09b300b0d$var$NoElement ? function matches() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $1a0c6bd09b300b0d$var$getRootNode = !$1a0c6bd09b300b0d$var$NoElement && Element.prototype.getRootNode ? function getRootNode(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $1a0c6bd09b300b0d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $1a0c6bd09b300b0d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $1a0c6bd09b300b0d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($1a0c6bd09b300b0d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($1a0c6bd09b300b0d$var$candidateSelector));
    if (includeContainer && $1a0c6bd09b300b0d$var$matches.call(el, $1a0c6bd09b300b0d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $1a0c6bd09b300b0d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($1a0c6bd09b300b0d$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $1a0c6bd09b300b0d$var$matches.call(element, $1a0c6bd09b300b0d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$1a0c6bd09b300b0d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $1a0c6bd09b300b0d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $1a0c6bd09b300b0d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $1a0c6bd09b300b0d$var$isContentEditable(node)) && !$1a0c6bd09b300b0d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $1a0c6bd09b300b0d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $1a0c6bd09b300b0d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$1a0c6bd09b300b0d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $1a0c6bd09b300b0d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $1a0c6bd09b300b0d$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $1a0c6bd09b300b0d$var$isHiddenInput = function isHiddenInput(node) {
    return $1a0c6bd09b300b0d$var$isInput(node) && node.type === "hidden";
};
var $1a0c6bd09b300b0d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $1a0c6bd09b300b0d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $1a0c6bd09b300b0d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $1a0c6bd09b300b0d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $1a0c6bd09b300b0d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $1a0c6bd09b300b0d$var$isRadio = function isRadio(node) {
    return $1a0c6bd09b300b0d$var$isInput(node) && node.type === "radio";
};
var $1a0c6bd09b300b0d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $1a0c6bd09b300b0d$var$isRadio(node) && !$1a0c6bd09b300b0d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $1a0c6bd09b300b0d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $1a0c6bd09b300b0d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $1a0c6bd09b300b0d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $1a0c6bd09b300b0d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $1a0c6bd09b300b0d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $1a0c6bd09b300b0d$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($1a0c6bd09b300b0d$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $1a0c6bd09b300b0d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $1a0c6bd09b300b0d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($1a0c6bd09b300b0d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $1a0c6bd09b300b0d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $1a0c6bd09b300b0d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $1a0c6bd09b300b0d$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $1a0c6bd09b300b0d$var$isInert(node) || $1a0c6bd09b300b0d$var$isHiddenInput(node) || $1a0c6bd09b300b0d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $1a0c6bd09b300b0d$var$isDetailsWithSummary(node) || $1a0c6bd09b300b0d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $1a0c6bd09b300b0d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($1a0c6bd09b300b0d$var$isNonTabbableRadio(node) || $1a0c6bd09b300b0d$export$a4672efddb4181b8(node) < 0 || !$1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $1a0c6bd09b300b0d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $1a0c6bd09b300b0d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $1a0c6bd09b300b0d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($1a0c6bd09b300b0d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $1a0c6bd09b300b0d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $1a0c6bd09b300b0d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $1a0c6bd09b300b0d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $1a0c6bd09b300b0d$var$isValidShadowRootTabbable
    });
    else candidates = $1a0c6bd09b300b0d$var$getCandidates(container, options.includeContainer, $1a0c6bd09b300b0d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $1a0c6bd09b300b0d$var$sortByOrder(candidates);
};
var $1a0c6bd09b300b0d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $1a0c6bd09b300b0d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $1a0c6bd09b300b0d$var$getCandidates(container, options.includeContainer, $1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $1a0c6bd09b300b0d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($1a0c6bd09b300b0d$var$matches.call(node, $1a0c6bd09b300b0d$var$candidateSelector) === false) return false;
    return $1a0c6bd09b300b0d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $1a0c6bd09b300b0d$var$focusableCandidateSelector = /* #__PURE__ */ $1a0c6bd09b300b0d$var$candidateSelectors.concat("iframe").join(",");
var $1a0c6bd09b300b0d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($1a0c6bd09b300b0d$var$matches.call(node, $1a0c6bd09b300b0d$var$focusableCandidateSelector) === false) return false;
    return $1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable(options, node);
};


function $d5bc75faf976d2ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5bc75faf976d2ed$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5bc75faf976d2ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d5bc75faf976d2ed$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5bc75faf976d2ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d5bc75faf976d2ed$var$_defineProperty(obj, key, value) {
    key = $d5bc75faf976d2ed$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d5bc75faf976d2ed$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d5bc75faf976d2ed$var$_toPropertyKey(arg) {
    var key = $d5bc75faf976d2ed$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $dvYFb._)(key)) === "symbol" ? key : String(key);
}
var $d5bc75faf976d2ed$var$activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var $d5bc75faf976d2ed$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var $d5bc75faf976d2ed$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $d5bc75faf976d2ed$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $d5bc75faf976d2ed$var$isKeyForward = function isKeyForward(e) {
    return $d5bc75faf976d2ed$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $d5bc75faf976d2ed$var$isKeyBackward = function isKeyBackward(e) {
    return $d5bc75faf976d2ed$var$isTabEvent(e) && e.shiftKey;
};
var $d5bc75faf976d2ed$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var $d5bc75faf976d2ed$var$findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $d5bc75faf976d2ed$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var $d5bc75faf976d2ed$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $d5bc75faf976d2ed$var$internalTrapStack = [];
var $d5bc75faf976d2ed$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $d5bc75faf976d2ed$var$internalTrapStack;
    var config = $d5bc75faf976d2ed$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: $d5bc75faf976d2ed$var$isKeyForward,
        isKeyBackward: $d5bc75faf976d2ed$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus");
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || !(0, $1a0c6bd09b300b0d$export$4c063cf1350e6fed)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $1a0c6bd09b300b0d$export$17100aea90429aa7)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $1a0c6bd09b300b0d$export$ecc6d1fcdff4f700)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === getActiveElement(document)) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($d5bc75faf976d2ed$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref2) {
        var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
        target = target || $d5bc75faf976d2ed$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = $d5bc75faf976d2ed$var$findIndex(state.tabbableGroups, function(_ref3) {
                    var firstTabbableNode = _ref3.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $1a0c6bd09b300b0d$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$d5bc75faf976d2ed$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = $d5bc75faf976d2ed$var$findIndex(state.tabbableGroups, function(_ref4) {
                    var lastTabbableNode = _ref4.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $1a0c6bd09b300b0d$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$d5bc75faf976d2ed$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $d5bc75faf976d2ed$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($d5bc75faf976d2ed$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($d5bc75faf976d2ed$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $d5bc75faf976d2ed$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) tryFocus(nextNode);
            else tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($d5bc75faf976d2ed$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(event) {
        if ($d5bc75faf976d2ed$var$isEscapeEvent(event) && $d5bc75faf976d2ed$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
            return;
        }
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkClick = function checkClick(e) {
        var target = $d5bc75faf976d2ed$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($d5bc75faf976d2ed$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($d5bc75faf976d2ed$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $d5bc75faf976d2ed$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $d5bc75faf976d2ed$var$delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $d5bc75faf976d2ed$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $d5bc75faf976d2ed$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $d5bc75faf976d2ed$var$delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (state.paused || !state.active) return this;
            var onPause = getOption(pauseOptions, "onPause");
            var onPostPause = getOption(pauseOptions, "onPostPause");
            state.paused = true;
            onPause === null || onPause === void 0 || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === void 0 || onPostPause();
            return this;
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.paused || !state.active) return this;
            var onUnpause = getOption(unpauseOptions, "onUnpause");
            var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
            state.paused = false;
            onUnpause === null || onUnpause === void 0 || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $bb3772a97e409184$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $dc0b7c05726de722$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $067f46365fa069fe$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $067f46365fa069fe$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $067f46365fa069fe$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $ed8e88be0eb3743a$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element) || !(0, $bb3772a97e409184$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $ed8e88be0eb3743a$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element) || !(0, $bb3772a97e409184$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $ed8e88be0eb3743a$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $ed8e88be0eb3743a$var$applyStyles,
    effect: $ed8e88be0eb3743a$var$effect,
    requires: [
        "computeStyles"
    ]
};


var $9f26897deb02d93b$export$8960430cfd85939f = Math.max;
var $9f26897deb02d93b$export$96ec731ed4dcb222 = Math.min;
var $9f26897deb02d93b$export$2077e0241d6afd3c = Math.round;



function $fad1410a0ea124b9$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $5d459bcfdac1eddb$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $fad1410a0ea124b9$export$2e2bcd8739ae039)());
}


function $cfa3bbbe93337bd1$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(element) ? (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $5d459bcfdac1eddb$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $73efdde3871f9d9c$export$2e2bcd8739ae039(node) {
    var win = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $e7d32fdb97c3afe8$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $d4580a5cb061b013$export$2e2bcd8739ae039(node) {
    if (node === (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node) || !(0, $067f46365fa069fe$export$1b3bfaa9684536aa)(node)) return (0, $73efdde3871f9d9c$export$2e2bcd8739ae039)(node);
    else return (0, $e7d32fdb97c3afe8$export$2e2bcd8739ae039)(node);
}






function $fcab88e4d39bd8b4$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $d871a90b7e33d329$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)((0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element)).left + (0, $73efdde3871f9d9c$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $9e057dbbdba645c7$export$2e2bcd8739ae039(element) {
    return (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $05730bb1bbcd8823$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $3745518cf5d078fb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $3745518cf5d078fb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(offsetParent) && $3745518cf5d078fb$var$isElementScaled(offsetParent);
    var documentElement = (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bb3772a97e409184$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $05730bb1bbcd8823$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $d4580a5cb061b013$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $067f46365fa069fe$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $d871a90b7e33d329$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $7c647f2d888a0b83$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $50e0f579e4b2a308$export$2e2bcd8739ae039(element) {
    if ((0, $bb3772a97e409184$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $067f46365fa069fe$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $6ee19e0b9f6a7cde$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $bb3772a97e409184$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $067f46365fa069fe$export$1b3bfaa9684536aa)(node) && (0, $05730bb1bbcd8823$export$2e2bcd8739ae039)(node)) return node;
    return $6ee19e0b9f6a7cde$export$2e2bcd8739ae039((0, $50e0f579e4b2a308$export$2e2bcd8739ae039)(node));
}





function $fc5ee93a8c241eee$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $6ee19e0b9f6a7cde$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $05730bb1bbcd8823$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($fc5ee93a8c241eee$export$2e2bcd8739ae039((0, $50e0f579e4b2a308$export$2e2bcd8739ae039)(target)));
}







function $6154ba4d4a24ebce$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $bb3772a97e409184$export$2e2bcd8739ae039)(element)) >= 0;
}




function $625fab30081d2448$var$getTrueOffsetParent(element) {
    if (!(0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $625fab30081d2448$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $fad1410a0ea124b9$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $fad1410a0ea124b9$export$2e2bcd8739ae039)());
    if (isIE && (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $50e0f579e4b2a308$export$2e2bcd8739ae039)(element);
    if ((0, $067f46365fa069fe$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $067f46365fa069fe$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $bb3772a97e409184$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $625fab30081d2448$export$2e2bcd8739ae039(element) {
    var window = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(element);
    var offsetParent = $625fab30081d2448$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6154ba4d4a24ebce$export$2e2bcd8739ae039)(offsetParent) && (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $625fab30081d2448$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $bb3772a97e409184$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $bb3772a97e409184$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $625fab30081d2448$var$getContainingBlock(element) || window;
}


var $4098656b2955b164$export$1e95b668f3b82d = "top";
var $4098656b2955b164$export$40e543e69a8b3fbb = "bottom";
var $4098656b2955b164$export$79ffe56a765070d2 = "right";
var $4098656b2955b164$export$eabcd2c8791e7bf4 = "left";
var $4098656b2955b164$export$dfb5619354ba860 = "auto";
var $4098656b2955b164$export$aec2ce47c367b8c3 = [
    $4098656b2955b164$export$1e95b668f3b82d,
    $4098656b2955b164$export$40e543e69a8b3fbb,
    $4098656b2955b164$export$79ffe56a765070d2,
    $4098656b2955b164$export$eabcd2c8791e7bf4
];
var $4098656b2955b164$export$b3571188c770cc5a = "start";
var $4098656b2955b164$export$bd5df0f255a350f8 = "end";
var $4098656b2955b164$export$390fd549c5303b4d = "clippingParents";
var $4098656b2955b164$export$d7b7311ec04a3e8f = "viewport";
var $4098656b2955b164$export$ae5ab1c730825774 = "popper";
var $4098656b2955b164$export$ca50aac9f3ba507f = "reference";
var $4098656b2955b164$export$368f9a87e87fa4e1 = /*#__PURE__*/ $4098656b2955b164$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $4098656b2955b164$export$b3571188c770cc5a,
        placement + "-" + $4098656b2955b164$export$bd5df0f255a350f8
    ]);
}, []);
var $4098656b2955b164$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($4098656b2955b164$export$aec2ce47c367b8c3, [
    $4098656b2955b164$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $4098656b2955b164$export$b3571188c770cc5a,
        placement + "-" + $4098656b2955b164$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $4098656b2955b164$export$421679a7c3d56e = "beforeRead";
var $4098656b2955b164$export$aafa59e2e03f2942 = "read";
var $4098656b2955b164$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $4098656b2955b164$export$c65e99957a05207c = "beforeMain";
var $4098656b2955b164$export$f22da7240b7add18 = "main";
var $4098656b2955b164$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $4098656b2955b164$export$8d4d2d70e7d46032 = "beforeWrite";
var $4098656b2955b164$export$68d8715fc104d294 = "write";
var $4098656b2955b164$export$70a6e5159acce2e6 = "afterWrite";
var $4098656b2955b164$export$d087d3878fdf71d5 = [
    $4098656b2955b164$export$421679a7c3d56e,
    $4098656b2955b164$export$aafa59e2e03f2942,
    $4098656b2955b164$export$6964f6c886723980,
    $4098656b2955b164$export$c65e99957a05207c,
    $4098656b2955b164$export$f22da7240b7add18,
    $4098656b2955b164$export$bab79516f2d662fe,
    $4098656b2955b164$export$8d4d2d70e7d46032,
    $4098656b2955b164$export$68d8715fc104d294,
    $4098656b2955b164$export$70a6e5159acce2e6
];


function $f774b12ee628c024$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $f774b12ee628c024$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $f774b12ee628c024$var$order(modifiers); // order based on phase
    return (0, $4098656b2955b164$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $7746e2758afef0df$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $c3f1a0406e083cd0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $29c697c1d55e87ca$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $29c697c1d55e87ca$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $29c697c1d55e87ca$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $29c697c1d55e87ca$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $29c697c1d55e87ca$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(reference) ? (0, $fc5ee93a8c241eee$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $fc5ee93a8c241eee$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $fc5ee93a8c241eee$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $f774b12ee628c024$export$2e2bcd8739ae039)((0, $c3f1a0406e083cd0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$29c697c1d55e87ca$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $3745518cf5d078fb$export$2e2bcd8739ae039)(_$reference, (0, $625fab30081d2448$export$2e2bcd8739ae039)(_$popper), state.options.strategy === "fixed"),
                    popper: (0, $7c647f2d888a0b83$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $7746e2758afef0df$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$29c697c1d55e87ca$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $29c697c1d55e87ca$export$8f7491d57c8f97a9 = /*#__PURE__*/ $29c697c1d55e87ca$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $2def0c61bad17d2b$var$passive = {
    passive: true
};
function $2def0c61bad17d2b$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $2def0c61bad17d2b$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $2def0c61bad17d2b$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $2def0c61bad17d2b$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $2def0c61bad17d2b$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $2def0c61bad17d2b$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $2def0c61bad17d2b$var$effect,
    data: {}
};



function $80412d06b7a84ca2$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $bc1371cbec6dec03$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $c5e9945532622584$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $964dc21e1f81b7e4$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $4098656b2955b164$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $4098656b2955b164$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $4098656b2955b164$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $4098656b2955b164$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $c5e9945532622584$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $4098656b2955b164$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $4098656b2955b164$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8cd9ebd489eeeba0$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $964dc21e1f81b7e4$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8cd9ebd489eeeba0$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8cd9ebd489eeeba0$var$popperOffsets,
    data: {}
};










var $3893e9dbf96237c4$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3893e9dbf96237c4$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $3893e9dbf96237c4$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $4098656b2955b164$export$eabcd2c8791e7bf4);
    var sideY = (0, $4098656b2955b164$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $625fab30081d2448$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(popper);
            if ((0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $4098656b2955b164$export$1e95b668f3b82d) || (placement === (0, $4098656b2955b164$export$eabcd2c8791e7bf4) || placement === (0, $4098656b2955b164$export$79ffe56a765070d2)) && variation === (0, $4098656b2955b164$export$bd5df0f255a350f8)) {
            sideY = (0, $4098656b2955b164$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $4098656b2955b164$export$eabcd2c8791e7bf4) || (placement === (0, $4098656b2955b164$export$1e95b668f3b82d) || placement === (0, $4098656b2955b164$export$40e543e69a8b3fbb)) && variation === (0, $4098656b2955b164$export$bd5df0f255a350f8)) {
            sideX = (0, $4098656b2955b164$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3893e9dbf96237c4$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3893e9dbf96237c4$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $3893e9dbf96237c4$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3893e9dbf96237c4$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3893e9dbf96237c4$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3893e9dbf96237c4$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $3893e9dbf96237c4$var$computeStyles,
    data: {}
};





function $458d6de7580ce6b5$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $4098656b2955b164$export$eabcd2c8791e7bf4),
        (0, $4098656b2955b164$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $4098656b2955b164$export$eabcd2c8791e7bf4),
        (0, $4098656b2955b164$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $458d6de7580ce6b5$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $4098656b2955b164$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $458d6de7580ce6b5$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $458d6de7580ce6b5$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $458d6de7580ce6b5$var$offset
};


var $50c1cba17513c010$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $50c1cba17513c010$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $50c1cba17513c010$var$hash[matched];
    });
}



var $ddb6289923396499$var$hash = {
    start: "end",
    end: "start"
};
function $ddb6289923396499$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $ddb6289923396499$var$hash[matched];
    });
}







function $b18aaddf90a7a585$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(element);
    var html = (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $5d459bcfdac1eddb$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $d871a90b7e33d329$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $6575f0ee16188e63$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $73efdde3871f9d9c$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9f26897deb02d93b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9f26897deb02d93b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $d871a90b7e33d329$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $9f26897deb02d93b$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $0c9e96e527df5368$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $067f46365fa069fe$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d1dfd81a90e1618f$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $79a5624379259815$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $79a5624379259815$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $4098656b2955b164$export$d7b7311ec04a3e8f) ? (0, $d1dfd81a90e1618f$export$2e2bcd8739ae039)((0, $b18aaddf90a7a585$export$2e2bcd8739ae039)(element, strategy)) : (0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(clippingParent) ? $79a5624379259815$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d1dfd81a90e1618f$export$2e2bcd8739ae039)((0, $6575f0ee16188e63$export$2e2bcd8739ae039)((0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $79a5624379259815$var$getClippingParents(element) {
    var clippingParents = (0, $fc5ee93a8c241eee$export$2e2bcd8739ae039)((0, $50e0f579e4b2a308$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element) ? (0, $625fab30081d2448$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(clippingParent) && (0, $0c9e96e527df5368$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $bb3772a97e409184$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $79a5624379259815$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $79a5624379259815$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $79a5624379259815$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9f26897deb02d93b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $9f26897deb02d93b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $9f26897deb02d93b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9f26897deb02d93b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $79a5624379259815$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $ccf353a84ccd5d0e$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $902788756916d769$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $ccf353a84ccd5d0e$export$2e2bcd8739ae039)(), paddingObject);
}


function $4aac45be6d8d440e$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $8ef048dc1a2ef86d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $4098656b2955b164$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $4098656b2955b164$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $4098656b2955b164$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $902788756916d769$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4aac45be6d8d440e$export$2e2bcd8739ae039)(padding, (0, $4098656b2955b164$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $4098656b2955b164$export$ae5ab1c730825774) ? (0, $4098656b2955b164$export$ca50aac9f3ba507f) : (0, $4098656b2955b164$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $79a5624379259815$export$2e2bcd8739ae039)((0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $964dc21e1f81b7e4$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d1dfd81a90e1618f$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $4098656b2955b164$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $4098656b2955b164$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $4098656b2955b164$export$79ffe56a765070d2),
                (0, $4098656b2955b164$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $4098656b2955b164$export$1e95b668f3b82d),
                (0, $4098656b2955b164$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $15f823052b9188e0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $4098656b2955b164$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $4098656b2955b164$export$368f9a87e87fa4e1) : (0, $4098656b2955b164$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $4098656b2955b164$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $6114a1be128deafa$var$getExpandedFallbackPlacements(placement) {
    if ((0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement) === (0, $4098656b2955b164$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $50c1cba17513c010$export$2e2bcd8739ae039)(placement);
    return [
        (0, $ddb6289923396499$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $ddb6289923396499$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $6114a1be128deafa$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $50c1cba17513c010$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $6114a1be128deafa$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement) === (0, $4098656b2955b164$export$dfb5619354ba860) ? (0, $15f823052b9188e0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(placement) === (0, $4098656b2955b164$export$b3571188c770cc5a);
        var isVertical = [
            (0, $4098656b2955b164$export$1e95b668f3b82d),
            (0, $4098656b2955b164$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $4098656b2955b164$export$79ffe56a765070d2) : (0, $4098656b2955b164$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $4098656b2955b164$export$40e543e69a8b3fbb) : (0, $4098656b2955b164$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $50c1cba17513c010$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $50c1cba17513c010$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6114a1be128deafa$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $6114a1be128deafa$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $1540d72155215430$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $5073f6077b368081$export$f28d906d67a997f3(min, value, max) {
    return (0, $9f26897deb02d93b$export$8960430cfd85939f)(min, (0, $9f26897deb02d93b$export$96ec731ed4dcb222)(value, max));
}
function $5073f6077b368081$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $5073f6077b368081$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $aae07ef240d2dd24$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $c5e9945532622584$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $1540d72155215430$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $4098656b2955b164$export$1e95b668f3b82d) : (0, $4098656b2955b164$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $4098656b2955b164$export$40e543e69a8b3fbb) : (0, $4098656b2955b164$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $4098656b2955b164$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $4098656b2955b164$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7c647f2d888a0b83$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $ccf353a84ccd5d0e$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $5073f6077b368081$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $625fab30081d2448$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $5073f6077b368081$export$f28d906d67a997f3)(tether ? (0, $9f26897deb02d93b$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $9f26897deb02d93b$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $4098656b2955b164$export$1e95b668f3b82d) : (0, $4098656b2955b164$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $4098656b2955b164$export$40e543e69a8b3fbb) : (0, $4098656b2955b164$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $4098656b2955b164$export$1e95b668f3b82d),
            (0, $4098656b2955b164$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $5073f6077b368081$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $5073f6077b368081$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $aae07ef240d2dd24$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $aae07ef240d2dd24$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $43a34fad1f81bb6d$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $902788756916d769$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4aac45be6d8d440e$export$2e2bcd8739ae039)(padding, (0, $4098656b2955b164$export$aec2ce47c367b8c3)));
};
function $43a34fad1f81bb6d$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $c5e9945532622584$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $4098656b2955b164$export$eabcd2c8791e7bf4),
        (0, $4098656b2955b164$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $43a34fad1f81bb6d$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7c647f2d888a0b83$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $4098656b2955b164$export$1e95b668f3b82d) : (0, $4098656b2955b164$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $4098656b2955b164$export$40e543e69a8b3fbb) : (0, $4098656b2955b164$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $625fab30081d2448$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $5073f6077b368081$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $43a34fad1f81bb6d$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $0c9e96e527df5368$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $43a34fad1f81bb6d$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $43a34fad1f81bb6d$var$arrow,
    effect: $43a34fad1f81bb6d$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $bc3de2222c85b67d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $bc3de2222c85b67d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $4098656b2955b164$export$1e95b668f3b82d),
        (0, $4098656b2955b164$export$79ffe56a765070d2),
        (0, $4098656b2955b164$export$40e543e69a8b3fbb),
        (0, $4098656b2955b164$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $bc3de2222c85b67d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $bc3de2222c85b67d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $bc3de2222c85b67d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $bc3de2222c85b67d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $bc3de2222c85b67d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $bc3de2222c85b67d$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $bc3de2222c85b67d$var$hide
};




var $f0ba3bf3fb8501ef$export$d34966752335dd47 = [
    (0, $2def0c61bad17d2b$export$2e2bcd8739ae039),
    (0, $8cd9ebd489eeeba0$export$2e2bcd8739ae039),
    (0, $3893e9dbf96237c4$export$2e2bcd8739ae039),
    (0, $ed8e88be0eb3743a$export$2e2bcd8739ae039),
    (0, $458d6de7580ce6b5$export$2e2bcd8739ae039),
    (0, $6114a1be128deafa$export$2e2bcd8739ae039),
    (0, $aae07ef240d2dd24$export$2e2bcd8739ae039),
    (0, $43a34fad1f81bb6d$export$2e2bcd8739ae039),
    (0, $bc3de2222c85b67d$export$2e2bcd8739ae039)
];
var $f0ba3bf3fb8501ef$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $29c697c1d55e87ca$export$ed5e13716264f202)({
    defaultModifiers: $f0ba3bf3fb8501ef$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $da4d79ca74296fbf$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $da4d79ca74296fbf$var$BOX_CLASS = "tippy-box";
var $da4d79ca74296fbf$var$CONTENT_CLASS = "tippy-content";
var $da4d79ca74296fbf$var$BACKDROP_CLASS = "tippy-backdrop";
var $da4d79ca74296fbf$var$ARROW_CLASS = "tippy-arrow";
var $da4d79ca74296fbf$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $da4d79ca74296fbf$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $da4d79ca74296fbf$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $da4d79ca74296fbf$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $da4d79ca74296fbf$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $da4d79ca74296fbf$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $da4d79ca74296fbf$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $da4d79ca74296fbf$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $da4d79ca74296fbf$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $da4d79ca74296fbf$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $da4d79ca74296fbf$var$normalizeToArray(value) {
    return [].concat(value);
}
function $da4d79ca74296fbf$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $da4d79ca74296fbf$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $da4d79ca74296fbf$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $da4d79ca74296fbf$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $da4d79ca74296fbf$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $da4d79ca74296fbf$var$div() {
    return document.createElement("div");
}
function $da4d79ca74296fbf$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $da4d79ca74296fbf$var$isType(value, type);
    });
}
function $da4d79ca74296fbf$var$isNodeList(value) {
    return $da4d79ca74296fbf$var$isType(value, "NodeList");
}
function $da4d79ca74296fbf$var$isMouseEvent(value) {
    return $da4d79ca74296fbf$var$isType(value, "MouseEvent");
}
function $da4d79ca74296fbf$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $da4d79ca74296fbf$var$getArrayOfElements(value) {
    if ($da4d79ca74296fbf$var$isElement(value)) return [
        value
    ];
    if ($da4d79ca74296fbf$var$isNodeList(value)) return $da4d79ca74296fbf$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $da4d79ca74296fbf$var$arrayFrom(document.querySelectorAll(value));
}
function $da4d79ca74296fbf$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $da4d79ca74296fbf$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $da4d79ca74296fbf$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $da4d79ca74296fbf$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $da4d79ca74296fbf$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $da4d79ca74296fbf$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $da4d79ca74296fbf$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $da4d79ca74296fbf$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $da4d79ca74296fbf$var$currentInput = {
    isTouch: false
};
var $da4d79ca74296fbf$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $da4d79ca74296fbf$var$onDocumentTouchStart() {
    if ($da4d79ca74296fbf$var$currentInput.isTouch) return;
    $da4d79ca74296fbf$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $da4d79ca74296fbf$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $da4d79ca74296fbf$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $da4d79ca74296fbf$var$lastMouseMoveTime < 20) {
        $da4d79ca74296fbf$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $da4d79ca74296fbf$var$onDocumentMouseMove);
    }
    $da4d79ca74296fbf$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $da4d79ca74296fbf$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($da4d79ca74296fbf$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $da4d79ca74296fbf$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $da4d79ca74296fbf$var$onDocumentTouchStart, $da4d79ca74296fbf$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $da4d79ca74296fbf$var$onWindowBlur);
}
var $da4d79ca74296fbf$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $da4d79ca74296fbf$var$isIE11 = $da4d79ca74296fbf$var$isBrowser ? !!window.msCrypto : false;
function $da4d79ca74296fbf$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $da4d79ca74296fbf$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $da4d79ca74296fbf$var$getDevMessage(message) {
    return $da4d79ca74296fbf$var$clean("\n  %ctippy.js\n\n  %c" + $da4d79ca74296fbf$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $da4d79ca74296fbf$var$getFormattedMessage(message) {
    return [
        $da4d79ca74296fbf$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $da4d79ca74296fbf$var$visitedMessages;
function $da4d79ca74296fbf$var$resetVisitedMessages() {
    $da4d79ca74296fbf$var$visitedMessages = new Set();
}
function $da4d79ca74296fbf$var$warnWhen(condition, message) {
    if (condition && !$da4d79ca74296fbf$var$visitedMessages.has(message)) {
        var _console;
        $da4d79ca74296fbf$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $da4d79ca74296fbf$var$getFormattedMessage(message));
    }
}
function $da4d79ca74296fbf$var$errorWhen(condition, message) {
    if (condition && !$da4d79ca74296fbf$var$visitedMessages.has(message)) {
        var _console2;
        $da4d79ca74296fbf$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $da4d79ca74296fbf$var$getFormattedMessage(message));
    }
}
function $da4d79ca74296fbf$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $da4d79ca74296fbf$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $da4d79ca74296fbf$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $da4d79ca74296fbf$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $da4d79ca74296fbf$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $da4d79ca74296fbf$var$defaultProps = Object.assign({
    appendTo: $da4d79ca74296fbf$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $da4d79ca74296fbf$var$pluginProps, $da4d79ca74296fbf$var$renderProps);
var $da4d79ca74296fbf$var$defaultKeys = Object.keys($da4d79ca74296fbf$var$defaultProps);
var $da4d79ca74296fbf$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $da4d79ca74296fbf$var$defaultProps[key] = partialProps[key];
    });
};
function $da4d79ca74296fbf$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $da4d79ca74296fbf$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $da4d79ca74296fbf$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($da4d79ca74296fbf$var$getExtendedPassedProps(Object.assign({}, $da4d79ca74296fbf$var$defaultProps, {
        plugins: plugins
    }))) : $da4d79ca74296fbf$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $da4d79ca74296fbf$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $da4d79ca74296fbf$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $da4d79ca74296fbf$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $da4d79ca74296fbf$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $da4d79ca74296fbf$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $da4d79ca74296fbf$var$removeProperties($da4d79ca74296fbf$var$defaultProps, Object.keys($da4d79ca74296fbf$var$pluginProps));
        var didPassUnknownProp = !$da4d79ca74296fbf$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $da4d79ca74296fbf$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $da4d79ca74296fbf$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $da4d79ca74296fbf$var$dangerouslySetInnerHTML(element, html) {
    element[$da4d79ca74296fbf$var$innerHTML()] = html;
}
function $da4d79ca74296fbf$var$createArrowElement(value) {
    var arrow = $da4d79ca74296fbf$var$div();
    if (value === true) arrow.className = $da4d79ca74296fbf$var$ARROW_CLASS;
    else {
        arrow.className = $da4d79ca74296fbf$var$SVG_ARROW_CLASS;
        if ($da4d79ca74296fbf$var$isElement(value)) arrow.appendChild(value);
        else $da4d79ca74296fbf$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $da4d79ca74296fbf$var$setContent(content, props) {
    if ($da4d79ca74296fbf$var$isElement(props.content)) {
        $da4d79ca74296fbf$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $da4d79ca74296fbf$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $da4d79ca74296fbf$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $da4d79ca74296fbf$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($da4d79ca74296fbf$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($da4d79ca74296fbf$var$ARROW_CLASS) || node.classList.contains($da4d79ca74296fbf$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($da4d79ca74296fbf$var$BACKDROP_CLASS);
        })
    };
}
function $da4d79ca74296fbf$var$render(instance) {
    var popper = $da4d79ca74296fbf$var$div();
    var box = $da4d79ca74296fbf$var$div();
    box.className = $da4d79ca74296fbf$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $da4d79ca74296fbf$var$div();
    content.className = $da4d79ca74296fbf$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $da4d79ca74296fbf$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $da4d79ca74296fbf$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $da4d79ca74296fbf$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($da4d79ca74296fbf$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($da4d79ca74296fbf$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$da4d79ca74296fbf$var$render.$$tippy = true;
var $da4d79ca74296fbf$var$idCounter = 1;
var $da4d79ca74296fbf$var$mouseMoveListeners = []; // Used by `hideAll()`
var $da4d79ca74296fbf$var$mountedInstances = [];
function $da4d79ca74296fbf$var$createTippy(reference, passedProps) {
    var props = $da4d79ca74296fbf$var$evaluateProps(reference, Object.assign({}, $da4d79ca74296fbf$var$defaultProps, $da4d79ca74296fbf$var$getExtendedPassedProps($da4d79ca74296fbf$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $da4d79ca74296fbf$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $da4d79ca74296fbf$var$idCounter++;
    var popperInstance = null;
    var plugins = $da4d79ca74296fbf$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $da4d79ca74296fbf$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $da4d79ca74296fbf$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $da4d79ca74296fbf$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $da4d79ca74296fbf$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $da4d79ca74296fbf$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $da4d79ca74296fbf$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $da4d79ca74296fbf$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $da4d79ca74296fbf$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $da4d79ca74296fbf$var$mouseMoveListeners = $da4d79ca74296fbf$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($da4d79ca74296fbf$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $da4d79ca74296fbf$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($da4d79ca74296fbf$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $da4d79ca74296fbf$var$actualContains(el, actualTarget);
        })) {
            if ($da4d79ca74296fbf$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $da4d79ca74296fbf$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $da4d79ca74296fbf$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $da4d79ca74296fbf$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $da4d79ca74296fbf$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $da4d79ca74296fbf$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $da4d79ca74296fbf$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $da4d79ca74296fbf$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $da4d79ca74296fbf$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $da4d79ca74296fbf$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $da4d79ca74296fbf$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $da4d79ca74296fbf$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($da4d79ca74296fbf$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $da4d79ca74296fbf$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $da4d79ca74296fbf$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($da4d79ca74296fbf$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $da4d79ca74296fbf$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $da4d79ca74296fbf$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $f0ba3bf3fb8501ef$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $da4d79ca74296fbf$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $da4d79ca74296fbf$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $da4d79ca74296fbf$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($da4d79ca74296fbf$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $da4d79ca74296fbf$var$evaluateProps(reference, Object.assign({}, prevProps, $da4d79ca74296fbf$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $da4d79ca74296fbf$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $da4d79ca74296fbf$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $da4d79ca74296fbf$var$currentInput.isTouch && !instance.props.touch;
        var duration = $da4d79ca74296fbf$var$getValueAtIndexOrReturn(instance.props.duration, 0, $da4d79ca74296fbf$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $da4d79ca74296fbf$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $da4d79ca74296fbf$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $da4d79ca74296fbf$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $da4d79ca74296fbf$var$pushIfUnique($da4d79ca74296fbf$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $da4d79ca74296fbf$var$getValueAtIndexOrReturn(instance.props.duration, 1, $da4d79ca74296fbf$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $da4d79ca74296fbf$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $da4d79ca74296fbf$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $da4d79ca74296fbf$var$pushIfUnique($da4d79ca74296fbf$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $da4d79ca74296fbf$var$mountedInstances = $da4d79ca74296fbf$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $da4d79ca74296fbf$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $da4d79ca74296fbf$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $da4d79ca74296fbf$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $da4d79ca74296fbf$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $da4d79ca74296fbf$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $da4d79ca74296fbf$var$isElement(targets) ? instances[0] : instances;
}
$da4d79ca74296fbf$var$tippy.defaultProps = $da4d79ca74296fbf$var$defaultProps;
$da4d79ca74296fbf$var$tippy.setDefaultProps = $da4d79ca74296fbf$var$setDefaultProps;
$da4d79ca74296fbf$var$tippy.currentInput = $da4d79ca74296fbf$var$currentInput;
var $da4d79ca74296fbf$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $da4d79ca74296fbf$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $da4d79ca74296fbf$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $da4d79ca74296fbf$var$applyStylesModifier = Object.assign({}, (0, $ed8e88be0eb3743a$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $da4d79ca74296fbf$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $da4d79ca74296fbf$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $da4d79ca74296fbf$var$tippy($da4d79ca74296fbf$var$div(), Object.assign({}, $da4d79ca74296fbf$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $da4d79ca74296fbf$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $da4d79ca74296fbf$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $da4d79ca74296fbf$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $da4d79ca74296fbf$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $da4d79ca74296fbf$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $da4d79ca74296fbf$var$tippy(targets, parentProps);
    var normalizedReturnValue = $da4d79ca74296fbf$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $da4d79ca74296fbf$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($da4d79ca74296fbf$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $da4d79ca74296fbf$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $da4d79ca74296fbf$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $da4d79ca74296fbf$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $da4d79ca74296fbf$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $da4d79ca74296fbf$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $da4d79ca74296fbf$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $da4d79ca74296fbf$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $da4d79ca74296fbf$var$createBackdropElement() {
    var backdrop = $da4d79ca74296fbf$var$div();
    backdrop.className = $da4d79ca74296fbf$var$BACKDROP_CLASS;
    $da4d79ca74296fbf$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $da4d79ca74296fbf$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $da4d79ca74296fbf$var$activeInstances = [];
function $da4d79ca74296fbf$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $da4d79ca74296fbf$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $da4d79ca74296fbf$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $da4d79ca74296fbf$var$storeMouseCoords);
}
function $da4d79ca74296fbf$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $da4d79ca74296fbf$var$storeMouseCoords);
}
var $da4d79ca74296fbf$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $da4d79ca74296fbf$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $da4d79ca74296fbf$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $da4d79ca74296fbf$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $da4d79ca74296fbf$var$activeInstances = $da4d79ca74296fbf$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($da4d79ca74296fbf$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $da4d79ca74296fbf$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($da4d79ca74296fbf$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($da4d79ca74296fbf$var$isMouseEvent(event)) $da4d79ca74296fbf$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $da4d79ca74296fbf$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $da4d79ca74296fbf$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $da4d79ca74296fbf$var$getInlineBoundingClientRect($da4d79ca74296fbf$var$getBasePlacement(placement), reference.getBoundingClientRect(), $da4d79ca74296fbf$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($da4d79ca74296fbf$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($da4d79ca74296fbf$var$isMouseEvent(event)) {
                    var rects = $da4d79ca74296fbf$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $da4d79ca74296fbf$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $da4d79ca74296fbf$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $da4d79ca74296fbf$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $da4d79ca74296fbf$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $da4d79ca74296fbf$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$da4d79ca74296fbf$var$tippy.setDefaultProps({
    render: $da4d79ca74296fbf$var$render
});
var $da4d79ca74296fbf$export$2e2bcd8739ae039 = $da4d79ca74296fbf$var$tippy;


(0, $8cbc258a9e4401e6$export$63174c828edd6ff8)();
/** Base Functions */ // making it so we can stop all autosliders
var $6a27bb3411cf60ab$var$autoScrollingSpliders = [];
/** Green Sock - Base Functions */ (0, $77002f56502ab80f$export$99ee26438460406a).registerPlugin((0, $4977a4034a1b06e7$export$875bcbe48555930));
/** Splide - Custom Scroll Bar Init */ function $6a27bb3411cf60ab$var$sliderProgressBarInIt(sliderElement, slider, barWrapper) {
    var progressBar = barWrapper.querySelector(".splide__progress-bar");
    var lastSlide = sliderElement.querySelector(".splide__slide:last-of-type");
    var slideTrack = sliderElement.querySelector(".splide__track");
    var splideList = sliderElement.querySelector(".splide__list");
    var sliderPlacement;
    var slideEnd;
    var trackEnd;
    var percentPerPixel;
    var progressSize;
    var delayFix;
    // Function to set the width of the Progress Bar
    slider.on("mounted", function(data) {
        var slides = slider.Components.Slides.get(false);
        var slidesLength = slides.length;
        var wrapperComputedStyle = window.getComputedStyle(slideTrack, null);
        var slidePaddingRight = parseFloat(wrapperComputedStyle.paddingRight);
        slideEnd = lastSlide.getBoundingClientRect().right;
        trackEnd = slideTrack.getBoundingClientRect().right - slidePaddingRight;
        if (slideEnd < trackEnd) progressSize = 100;
        else progressSize = 100 / slidesLength;
        progressBar.style.width = progressSize + "%";
    });
    // Setting the Slide End and Track End variable to get the percentage per pixel
    slider.on("ready", function() {
        var wrapperComputedStyle = window.getComputedStyle(slideTrack, null);
        var slidePaddingRight = parseFloat(wrapperComputedStyle.paddingRight);
        slideEnd = lastSlide.getBoundingClientRect().right;
        trackEnd = slideTrack.getBoundingClientRect().right - slidePaddingRight;
        var diff = slideEnd - trackEnd;
        percentPerPixel = diff / 100;
    });
    function calculateProgressBarPosition() {
        var lastSliderCardPosition = lastSlide.getBoundingClientRect().right;
        var percentage;
        if (lastSliderCardPosition >= slideEnd) percentage = 0;
        else if (lastSliderCardPosition <= trackEnd) percentage = 100;
        else {
            var pixelDiff = slideEnd - lastSliderCardPosition;
            percentage = pixelDiff / percentPerPixel;
        }
        var rightEdge = barWrapper.offsetWidth - progressBar.offsetWidth;
        progressBar.style.left = rightEdge / 100 * percentage + "px";
    }
    // Doing some math on move / drag to move the progress bar along as the splider moves
    slider.on("move dragging", calculateProgressBarPosition);
    // Ensuring the same is done above on arrow click
    slider.on("arrows:mounted", function(prev, next) {
        prev.addEventListener("click", function() {
            delayFix = setInterval(calculateProgressBarPosition, 25);
        });
        next.addEventListener("click", function() {
            delayFix = setInterval(calculateProgressBarPosition, 25);
        });
    });
    // delay fix
    slider.on("moved dragged", function() {
        delayFix = setInterval(calculateProgressBarPosition, 25);
        setTimeout(function() {
            clearTimeout(delayFix);
        }, 500);
    });
    // Functionality to move the Progress Bar and calculate where the splider should be
    progressBar.onmousedown = function(event) {
        event.preventDefault();
        var shiftX = event.clientX - progressBar.getBoundingClientRect().left;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        function onMouseMove(event) {
            var newLeft = event.clientX - shiftX - barWrapper.getBoundingClientRect().left;
            // the pointer is out of progressBarWrapper => lock the progressBar within the bounaries
            if (newLeft < 0) newLeft = 0;
            var rightEdge = barWrapper.offsetWidth - progressBar.offsetWidth;
            if (newLeft > rightEdge) newLeft = rightEdge;
            var slideScrollPercentage = newLeft / rightEdge * 100;
            sliderPlacement = percentPerPixel * slideScrollPercentage * -1;
            splideList.style.transform = "translateX(" + sliderPlacement + "px)";
            progressBar.style.left = newLeft + "px";
        }
        function onMouseUp() {
            document.removeEventListener("mouseup", onMouseUp);
            document.removeEventListener("mousemove", onMouseMove);
            slider.Components.Controller.scroll(sliderPlacement, 0);
        }
    };
    progressBar.ondragstart = function() {
        return false;
    };
}
/* Remove preload class to allow transitions */ document.body.classList.remove("preload");
var $6a27bb3411cf60ab$var$intersectionOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0
};
/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */ function $6a27bb3411cf60ab$var$getCookie(name) {
    var value = "; ".concat(document.cookie);
    var parts = value.split("; ".concat(name, "="));
    if (parts.length === 2) return parts.pop().split(";").shift();
}
/* Custom Fade In Functions */ function $6a27bb3411cf60ab$var$fadeIns() {
    var fadeIns = (0, $77002f56502ab80f$export$99ee26438460406a).utils.toArray(".animate--fadeIn");
    var fadeInUps = (0, $77002f56502ab80f$export$99ee26438460406a).utils.toArray(".animate--fadeInUp");
    var fadeInLefts = (0, $77002f56502ab80f$export$99ee26438460406a).utils.toArray(".animate--fadeInLeft");
    var fadeInRights = (0, $77002f56502ab80f$export$99ee26438460406a).utils.toArray(".animate--fadeInRight");
    var animateStart = "top 90%";
    if (window.innerWidth > 767) animateStart = "top 70%";
    // function fadeInBuilder
    function buildFadeIn(element) {
        var delayTiming = 0;
        var anim = (0, $77002f56502ab80f$export$99ee26438460406a).fromTo(element, {
            opacity: 0
        }, {
            duration: 0.5,
            opacity: 1,
            delay: delayTiming
        });
        if (element.dataset.delay != null) delayTiming = element.dataset.delay;
        (0, $4977a4034a1b06e7$export$875bcbe48555930).create({
            trigger: element,
            start: animateStart,
            animation: anim,
            toggleActions: "play none none none",
            once: true
        });
    }
    // fade ins
    fadeIns.forEach(function(fadeIn) {
        buildFadeIn(fadeIn);
    });
    // fade in ups
    fadeInUps.forEach(function(fadeInUp) {
        if ($6a27bb3411cf60ab$var$getCookie("reduce-motion") === "true") buildFadeIn(fadeInUp);
        else {
            var delayTiming = 0;
            if (fadeInUp.dataset.delay != null) delayTiming = fadeInUp.dataset.delay;
            var anim = (0, $77002f56502ab80f$export$99ee26438460406a).fromTo(fadeInUp, {
                opacity: 0,
                y: 50
            }, {
                duration: 0.5,
                opacity: 1,
                y: 0,
                delay: delayTiming
            });
            (0, $4977a4034a1b06e7$export$875bcbe48555930).create({
                trigger: fadeInUp,
                start: animateStart,
                animation: anim,
                toggleActions: "play none none none",
                once: true
            });
        }
    });
    // fade in lefts
    fadeInLefts.forEach(function(fadeInLeft) {
        if ($6a27bb3411cf60ab$var$getCookie("reduce-motion") === "true") buildFadeIn(fadeInLeft);
        else {
            var delayTiming = 0;
            if (fadeInLeft.dataset.delay != null) delayTiming = fadeInLeft.dataset.delay;
            var anim = (0, $77002f56502ab80f$export$99ee26438460406a).fromTo(fadeInLeft, {
                opacity: 0,
                x: -50
            }, {
                duration: 0.5,
                opacity: 1,
                x: 0,
                delay: delayTiming
            });
            (0, $4977a4034a1b06e7$export$875bcbe48555930).create({
                trigger: fadeInLeft,
                start: animateStart,
                animation: anim,
                toggleActions: "play none none none",
                once: true
            });
        }
    });
    // fade in rights
    fadeInRights.forEach(function(fadeInRight) {
        if ($6a27bb3411cf60ab$var$getCookie("reduce-motion") === "true") buildFadeIn(fadeInRight);
        else {
            var delayTiming = 0;
            if (fadeInRight.dataset.delay != null) delayTiming = fadeInRight.dataset.delay;
            var anim = (0, $77002f56502ab80f$export$99ee26438460406a).fromTo(fadeInRight, {
                opacity: 0,
                x: 50
            }, {
                duration: 0.5,
                opacity: 1,
                x: 0,
                delay: delayTiming
            });
            (0, $4977a4034a1b06e7$export$875bcbe48555930).create({
                trigger: fadeInRight,
                start: animateStart,
                animation: anim,
                toggleActions: "play none none none",
                once: true
            });
        }
    });
}
/** Block / Layout Functions */ /* Accessibility Functions */ function $6a27bb3411cf60ab$var$accessibilityInit() {
    var togglePanelButton = document.getElementById("accessibilityPanelToggle");
    var accessibilityAid = document.getElementById("accessibilityAid");
    var accessibilityPanel = document.getElementById("accessibilityPanel");
    var fontSizeButton = document.getElementById("fontSize");
    var highContrastButton = document.getElementById("highContrast");
    var reduceMotionButton = document.getElementById("reduceMotion");
    var html = document.querySelector("html");
    var videos = document.querySelectorAll("video[autoplay]");
    var accessibilityFocusTrap = $d5bc75faf976d2ed$export$360440dfcba94c00(accessibilityAid);
    function togglePanel() {
        if (accessibilityAid.classList.contains("accessibility-aid--active")) {
            accessibilityAid.classList.remove("accessibility-aid--active");
            togglePanelButton.setAttribute("aria-expanded", "false");
            accessibilityPanel.setAttribute("aria-hidden", "true");
            accessibilityPanel.style.display = "none";
            togglePanelButton.focus();
            accessibilityFocusTrap.deactivate();
        } else {
            accessibilityPanel.style.display = "flex";
            togglePanelButton.setAttribute("aria-expanded", "true");
            accessibilityPanel.setAttribute("aria-hidden", "false");
            accessibilityFocusTrap.activate();
            setTimeout(function() {
                accessibilityAid.classList.add("accessibility-aid--active");
                accessibilityPanel.focus();
            }, 25);
        }
    }
    togglePanelButton.addEventListener("click", togglePanel);
    // individual button actions
    if (fontSizeButton) {
        if ($6a27bb3411cf60ab$var$getCookie("font-size") === "bigger") {
            fontSizeButton.classList.add("accessibility-option--active");
            document.documentElement.style.setProperty("font-size", "120%");
        }
        fontSizeButton.addEventListener("click", function() {
            var fontSizeCookie = $6a27bb3411cf60ab$var$getCookie("font-size");
            if (fontSizeCookie !== "bigger") {
                document.cookie = "font-size=bigger;max-age=".concat(604800, ";path=/;");
                fontSizeButton.classList.add("accessibility-option--active");
                document.documentElement.style.setProperty("font-size", "120%");
            } else {
                document.cookie = "font-size=initial;max-age=".concat(604800, ";path=/;");
                fontSizeButton.classList.remove("accessibility-option--active");
                document.documentElement.style.setProperty("font-size", "100%");
            }
        });
    }
    if (highContrastButton) {
        if ($6a27bb3411cf60ab$var$getCookie("high-contrast") === "true") highContrastButton.classList.add("accessibility-option--active");
        highContrastButton.addEventListener("click", function() {
            var highContrastCookie = $6a27bb3411cf60ab$var$getCookie("high-contrast");
            if (highContrastCookie !== "true") {
                document.cookie = "high-contrast=true;max-age=".concat(604800, ";path=/;");
                highContrastButton.classList.add("accessibility-option--active");
                html.classList.add("high-contrast");
            } else {
                document.cookie = "high-contrast=initial;max-age=".concat(604800, ";path=/;");
                highContrastButton.classList.remove("accessibility-option--active");
                html.classList.remove("high-contrast");
            }
        });
    }
    if (reduceMotionButton) {
        if ($6a27bb3411cf60ab$var$getCookie("reduce-motion") === "true") reduceMotionButton.classList.add("accessibility-option--active");
        reduceMotionButton.addEventListener("click", function() {
            var reduceMotionCookie = $6a27bb3411cf60ab$var$getCookie("reduce-motion");
            if (reduceMotionCookie !== "true") {
                document.cookie = "reduce-motion=true;max-age=".concat(604800, ";path=/;");
                reduceMotionButton.classList.add("accessibility-option--active");
                html.classList.add("reduce-motion");
                (0, $77002f56502ab80f$export$99ee26438460406a).globalTimeline.pause();
                videos.forEach(function(video) {
                    return video.pause();
                });
                if ($6a27bb3411cf60ab$var$autoScrollingSpliders.length > 0) for(var index = 0; index < $6a27bb3411cf60ab$var$autoScrollingSpliders.length; index++){
                    var slider = $6a27bb3411cf60ab$var$autoScrollingSpliders[index];
                    var autoplay = slider.Components.AutoScroll;
                    autoplay.pause();
                }
            } else {
                document.cookie = "reduce-motion=initial;max-age=".concat(604800, ";path=/;");
                reduceMotionButton.classList.remove("accessibility-option--active");
                html.classList.remove("reduce-motion");
                (0, $77002f56502ab80f$export$99ee26438460406a).globalTimeline.play();
                videos.forEach(function(video) {
                    return video.play();
                });
                if ($6a27bb3411cf60ab$var$autoScrollingSpliders.length > 0) for(var index1 = 0; index1 < $6a27bb3411cf60ab$var$autoScrollingSpliders.length; index1++){
                    var slider1 = $6a27bb3411cf60ab$var$autoScrollingSpliders[index1];
                    var autoplay1 = slider1.Components.AutoScroll;
                    autoplay1.play();
                }
            }
        });
    }
}
/* Header Functions */ function $6a27bb3411cf60ab$var$headerInIt() {
    // Variables
    var header = document.getElementById("header");
    var headerToggle = document.getElementById("navToggle");
    var nav = document.getElementById("headerNav");
    var mainSubNavButtons = nav.querySelectorAll(".subnav-link");
    var topNav = document.getElementById("headerTop");
    var subNavCloseButtons = nav.querySelectorAll(".header__close-sub");
    var closing;
    var topSubNavTimeouts = [];
    var body = document.querySelector("body");
    var headerScreen = document.querySelector("#headerScreen");
    var hamburgerTop = document.getElementById("hamburgerTop");
    var hamburgerMiddle = document.getElementById("hamburgerMiddle");
    var hamburgerBottom = document.getElementById("hamburgerBottom");
    var hamburgerTl = (0, $77002f56502ab80f$export$99ee26438460406a).timeline({
        paused: true
    });
    var hamburgerFocusTrap = $d5bc75faf976d2ed$export$360440dfcba94c00(header);
    // Close Other SubNav Function
    function closeOtherSubNav() {
        var activeSubNavs = document.querySelectorAll(".header__main-sub.active");
        activeSubNavs.forEach(function(element) {
            var buttonId = element.getAttribute("data-controlledby");
            var button = document.getElementById(buttonId);
            button.setAttribute("aria-expanded", "false");
            button.setAttribute("aria-hidden", "true");
            button.classList.remove("subnav-link--sub-nav-open");
            element.classList.remove("active");
            element.style.display = "none";
        });
    }
    /* Hamburger Animation */ var hamburgerDuration = $6a27bb3411cf60ab$var$getCookie("reduce-motion") === "true" ? "0" : "0.150";
    hamburgerTl.add("start").to(hamburgerTop, {
        rotation: 45,
        x: "0px",
        y: "5px",
        transformOrigin: "center",
        duration: hamburgerDuration,
        ease: "power2.out"
    }, "start").to(hamburgerMiddle, {
        opacity: "0",
        duration: hamburgerDuration
    }, "start").to(hamburgerBottom, {
        rotation: "-45",
        x: "0px",
        y: "-5px",
        transformOrigin: "center",
        duration: hamburgerDuration,
        ease: "power2.out"
    }, "start");
    /* Main Nav Header Machine */ var headerMachine = (0, $5c02d41f81c833e9$export$aaa7fa18f8e9b2e8)({
        id: "header",
        initial: "inactive",
        states: {
            inactive: {
                on: {
                    TOGGLE: {
                        target: "active",
                        actions: function() {
                            clearTimeout(closing);
                            if (header.classList.contains("closing")) header.classList.remove("closing");
                            nav.style.display = "flex";
                            header.classList.add("active-nav");
                            nav.setAttribute("aria-hidden", "false");
                            headerToggle.setAttribute("aria-expanded", "true");
                            body.classList.add("nav-active");
                            hamburgerTl.play();
                            // headerToggle.focus()
                            hamburgerFocusTrap.activate();
                        }
                    }
                }
            },
            active: {
                on: {
                    TOGGLE: {
                        target: "inactive",
                        actions: function() {
                            header.classList.remove("active-nav");
                            header.classList.add("closing");
                            header.classList.remove("active-subnav");
                            nav.setAttribute("aria-hidden", "true");
                            headerToggle.setAttribute("aria-expanded", "false");
                            body.classList.remove("nav-active");
                            var activeSubNavs = document.querySelectorAll(".header__main-sub.active");
                            hamburgerTl.reverse();
                            activeSubNavs.forEach(function(element) {
                                var subNavButtonId = element.getAttribute("data-controlledby");
                                var subNavButton = document.getElementById(subNavButtonId);
                                subNavButton.setAttribute("aria-expanded", "false");
                                subNavButton.setAttribute("aria-hidden", "true");
                                element.classList.remove("active");
                                element.style.display = "none";
                            });
                            closing = setTimeout(function() {
                                nav.style.display = "none";
                                header.classList.remove("closing");
                            }, 300);
                            hamburgerFocusTrap.deactivate();
                        // headerToggle.focus()
                        }
                    }
                }
            }
        }
    });
    var headerService = (0, $5c02d41f81c833e9$export$67beed298888a38b)(headerMachine).start();
    // Main Nav Functionality
    headerToggle.addEventListener("click", function() {
        headerService.send("TOGGLE");
    });
    headerScreen.addEventListener("click", function(e) {
        if (header.classList.contains("active-nav")) {
            e.preventDefault();
            headerService.send("TOGGLE");
        }
    });
    window.addEventListener("resize", function(e) {
        if (header.classList.contains("active-nav") && window.innerWidth > 1372) {
            e.preventDefault();
            headerService.send("TOGGLE");
        }
    });
    // Main Sub Nav Functionality
    mainSubNavButtons.forEach(function(element) {
        element.addEventListener("click", function() {
            var subNavId = element.getAttribute("aria-controls");
            var subNav = document.getElementById(subNavId);
            var activeSubNavs = document.querySelectorAll(".header__main-sub.active");
            if (!subNav.classList.contains("active")) {
                element.setAttribute("aria-expanded", "true");
                subNav.setAttribute("aria-hidden", "false");
                subNav.classList.add("active");
                subNav.style.display = "grid";
            } else {
                element.setAttribute("aria-expanded", "false");
                subNav.setAttribute("aria-hidden", "true");
                subNav.classList.remove("active");
                subNav.style.display = "none";
            }
        });
    });
    subNavCloseButtons.forEach(function(element) {
        element.addEventListener("click", function() {
            var subNavId = element.getAttribute("aria-controls");
            var subNav = document.getElementById(subNavId);
            var subNavButton = document.getElementById(subNavId + "Button");
            var subNavClose = subNav.querySelector(".header__close-sub");
            if (subNav.classList.contains("active")) {
                element.setAttribute("aria-expanded", "false");
                header.classList.remove("active-subnav");
                subNavClose.setAttribute("aria-expanded", "false");
                subNav.setAttribute("aria-hidden", "true");
                subNav.classList.remove("active");
                subNavButton.classList.remove("subnav-link--sub-nav-open");
                subNavButton.focus();
                setTimeout(function() {
                    subNav.style.display = "none";
                }, 300);
            }
        });
    });
    // Top Nav Functionality
    if (topNav) {
        var topSubNavButtons = topNav.querySelectorAll(".subnav-link");
        topSubNavButtons.forEach(function(element, i) {
            var handleClick = function handleClick() {
                var subNavId = element.getAttribute("aria-controls");
                var subNav = document.getElementById(subNavId);
                if (topSubNavTimeouts[i] != null) {
                    clearTimeout(topSubNavTimeouts[i]);
                    topSubNavTimeouts[i] = null;
                }
                if (!subNav.classList.contains("active")) {
                    subNav.style.display = "block";
                    element.setAttribute("aria-expanded", "true");
                    subNav.setAttribute("aria-hidden", "false");
                    setTimeout(function() {
                        subNav.classList.add("active");
                    }, 10);
                    // If subnav is beyond the viewport, move it to the left (is already 1/2)
                    var subNavRect = subNav.getBoundingClientRect();
                    var subNavRight = subNavRect.right;
                    var windowWidth = window.innerWidth;
                    var subNavWidth = subNavRect.width;
                    var subNavLeft = subNavRect.left;
                    if (subNavLeft + subNavWidth > windowWidth) {
                        subNav.style.transitionDuration = "0s";
                        subNav.style.setProperty("transition-duration", "none", "important");
                        subNav.style.left = "auto";
                        subNav.style.right = "0";
                        subNav.style.transform = "translate(0, 0rem)";
                        setTimeout(function() {
                            subNav.style.removeProperty("transition-duration");
                            subNav.style.transform = "translate(0, 0px)";
                        });
                    }
                } else {
                    element.setAttribute("aria-expanded", "false");
                    subNav.setAttribute("aria-hidden", "true");
                    subNav.classList.remove("active");
                    subNav.style.display = "none";
                }
            };
            var handleMouseEnter = function handleMouseEnter() {
                var subNavId = element.getAttribute("aria-controls");
                var subNav = document.getElementById(subNavId);
                document.querySelectorAll(".header__top-main-sub.active").forEach(function(element) {
                    element.classList.remove("active");
                    element.style.display = "none";
                });
                if (topSubNavTimeouts[i] != null) {
                    clearTimeout(topSubNavTimeouts[i]);
                    topSubNavTimeouts[i] = null;
                }
                if (!subNav.classList.contains("active")) {
                    subNav.style.display = "block";
                    element.setAttribute("aria-expanded", "true");
                    subNav.setAttribute("aria-hidden", "false");
                    setTimeout(function() {
                        subNav.classList.add("active");
                    }, 10);
                    // If subnav is beyond the viewport, move it to the left (is already 1/2)
                    var subNavRect = subNav.getBoundingClientRect();
                    var subNavRight = subNavRect.right;
                    var windowWidth = window.innerWidth;
                    var subNavWidth = subNavRect.width;
                    var subNavLeft = subNavRect.left;
                    if (subNavLeft + subNavWidth > windowWidth) {
                        subNav.style.transitionDuration = "0s";
                        subNav.style.setProperty("transition-duration", "none", "important");
                        subNav.style.left = "auto";
                        subNav.style.right = "0";
                        subNav.style.transform = "translate(0, 0rem)";
                        setTimeout(function() {
                            subNav.style.removeProperty("transition-duration");
                            subNav.style.transform = "translate(0, 0px)";
                        });
                    }
                }
            };
            var handleMouseLeave = function handleMouseLeave(delay) {
                var subNavId = element.getAttribute("aria-controls");
                var subNav = document.getElementById(subNavId);
                if (topSubNavTimeouts[i] != null) {
                    clearTimeout(topSubNavTimeouts[i]);
                    topSubNavTimeouts[i] = null;
                }
                if (subNav.classList.contains("active")) topSubNavTimeouts[i] = setTimeout(function() {
                    element.setAttribute("aria-expanded", "false");
                    subNav.setAttribute("aria-hidden", "true");
                    subNav.classList.remove("active");
                    subNav.style.display = "none";
                }, delay);
            };
            element.addEventListener("click", handleClick);
            element.parentElement.addEventListener("mouseenter", handleMouseEnter);
            element.parentElement.addEventListener("mouseleave", function() {
                handleMouseLeave(300);
            });
            // If focus leaves the subnav, close all subnavs
            element.parentElement.addEventListener("focusout", function(e) {
                // If focus element is not the parent element nor inside the parent element, close the subnav
                if (!element.parentElement.contains(e.relatedTarget) && e.relatedTarget !== element.parentElement) handleMouseLeave(0);
            });
        });
    }
    document.addEventListener("keydown", function(event) {
        if (event.key === "Escape") {
            if (header.classList.contains("active-nav")) headerService.send("TOGGLE");
        }
    });
    // Header Scrolling
    var initScrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
    if (initScrollPos > 9) header.classList.add("header--scrolling");
    window.addEventListener("scroll", function() {
        var scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
        if (scrollPos > 9 && !header.classList.contains("header--scrolling")) header.classList.add("header--scrolling");
        else if (scrollPos < 10 && header.classList.contains("header--scrolling")) header.classList.remove("header--scrolling");
    });
}
/* Content Card Slider Functions */ function $6a27bb3411cf60ab$var$contentCardSliderInIt() {
    // Variables
    var wrappers = document.querySelectorAll(".content-card-slider");
    wrappers.forEach(function(element) {
        var sliderWrapper = element.querySelector(".content-card-slider__wrapper.splide");
        var initialized = false;
        $6a27bb3411cf60ab$var$inViewport(sliderWrapper, function(element) {
            if (!element.isIntersecting || initialized) return;
            var slider = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(sliderWrapper, {
                perPage: 1,
                type: "loop",
                arrows: true,
                gap: "2rem",
                padding: "1rem",
                pagination: true,
                mediaQuery: "min",
                breakpoints: {
                    992: {
                        arrows: true,
                        perPage: 3,
                        gap: "3.5rem",
                        padding: "2rem"
                    },
                    767: {
                        arrows: true,
                        perPage: 2
                    }
                }
            });
            slider.mount();
            initialized = true;
        }, $6a27bb3411cf60ab$var$intersectionOptions);
    });
}
/* Content Features Slider Functions */ function $6a27bb3411cf60ab$var$contentFeaturesSliderInIt() {
    // Variables
    var wrappers = document.querySelectorAll(".content-features-slider");
    wrappers.forEach(function(element) {
        var sliderWrapper = element.querySelector(".content-features-slider__wrapper.splide");
        var slides = sliderWrapper.querySelectorAll(".content-features-slider__slide");
        var slideTitles = [];
        var animations = [];
        slides.forEach(function(slide, j) {
            var slideAnimWrapper = slide.querySelector("canvas");
            var slideAccordionWrapper = slide.querySelector(".content-features-slider__accordions");
            slideTitles[j] = slide.dataset.title;
            if (slideAnimWrapper) {
                var slideAnimSrc = slideAnimWrapper.dataset.file;
                var r = new $a05981d36a658dfc$exports.Rive({
                    src: slideAnimSrc,
                    canvas: slideAnimWrapper,
                    autoplay: true,
                    stateMachines: "Machine",
                    onLoad: function() {
                        r.resizeDrawingSurfaceToCanvas();
                    }
                });
                animations[j] = r;
            }
            if (slideAccordionWrapper) {
                var _loop = function(i) {
                    // Variables
                    var accordion = accordions[i];
                    var button = accordion.querySelector(".accordion__button");
                    var content = accordion.querySelector(".accordion__content");
                    button.addEventListener("click", function(evt) {
                        var activeAccordion = slideAccordionWrapper.querySelector(".content-features-slider__accordion--active");
                        if (evt.target.tagName.toLowerCase() !== "a") {
                            if (!accordion.classList.contains("accordion--active")) {
                                if (activeAccordion) {
                                    var activeButton = activeAccordion.querySelector(".accordion__button");
                                    var activeContent = activeAccordion.querySelector(".accordion__content");
                                    activeAccordion.classList.remove("content-features-slider__accordion--active");
                                    activeButton.setAttribute("aria-expanded", false);
                                    activeContent.setAttribute("aria-hidden", true);
                                }
                                accordion.classList.add("content-features-slider__accordion--active");
                                button.setAttribute("aria-expanded", true);
                                content.setAttribute("aria-hidden", false);
                            }
                        }
                    });
                };
                var accordions = slideAccordionWrapper.querySelectorAll(".content-features-slider__accordion");
                // Initializing Items
                for(var i = 0; i < accordions.length; i++)_loop(i);
            }
        });
        var initialized = false;
        $6a27bb3411cf60ab$var$inViewport(sliderWrapper, function(element) {
            if (!element.isIntersecting || initialized) return;
            // Initializing Spliders
            var slider = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(sliderWrapper, {
                type: "loop",
                perPage: 1,
                arrows: true,
                gap: "1rem",
                pagination: true
            }).on("pagination:mounted", function(data) {
                data.items.forEach(function(item) {
                    if (slideTitles[item.page] != null || slideTitles[item.page] != "") item.button.innerHTML = '<span class="pagination__text">' + slideTitles[item.page] + "</span>";
                    else item.button.innerHTML = '<span class="pagination__text">Slide ' + String(item.page + 1) + "</span>";
                });
            }).on("moved", function(newIndex) {
                animations.forEach(function(animation) {
                    var inputs = animation.stateMachineInputs("Machine");
                    if (inputs) {
                        var expand = inputs.find(function(i) {
                            return i.name === "Expand";
                        });
                        expand.value = false;
                    }
                });
                if (animations[newIndex]) {
                    var inputs = animations[newIndex].stateMachineInputs("Machine");
                    if (inputs) {
                        var expand = inputs.find(function(i) {
                            return i.name === "Expand";
                        });
                        expand.value = true;
                    }
                }
            }).on("ready", function() {
                window.addEventListener("scroll", function() {
                    if (animations[slider.index]) {
                        var slideWrapperBounding = sliderWrapper.getBoundingClientRect();
                        var windowHalf = window.innerHeight / 3;
                        if (slideWrapperBounding.top <= windowHalf) {
                            var inputs = animations[slider.index].stateMachineInputs("Machine");
                            if (inputs) {
                                var expand = inputs.find(function(i) {
                                    return i.name === "Expand";
                                });
                                expand.value = true;
                            }
                        } else {
                            var inputs1 = animations[slider.index].stateMachineInputs("Machine");
                            if (inputs1) {
                                var expand1 = inputs1.find(function(i) {
                                    return i.name === "Expand";
                                });
                                expand1.value = false;
                            }
                        }
                    }
                });
            });
            slider.mount();
            initialized = true;
        }, $6a27bb3411cf60ab$var$intersectionOptions);
    });
}
/* Content Dashboard Slider Functions */ function $6a27bb3411cf60ab$var$contentDashboardSliderInIt() {
    // Variables
    var wrappers = document.querySelectorAll(".content-dashboard-slider");
    wrappers.forEach(function(element) {
        var sliderWrapper = element.querySelector(".content-dashboard-slider__wrapper.splide");
        var initialized = false;
        $6a27bb3411cf60ab$var$inViewport(sliderWrapper, function(element) {
            if (!element.isIntersecting || initialized) return;
            // Initializing Spliders
            var slider = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(sliderWrapper, {
                type: "loop",
                perPage: 1,
                arrows: true,
                gap: "1rem",
                pagination: true
            }).mount();
            initialized = true;
        }, $6a27bb3411cf60ab$var$intersectionOptions);
    });
}
function $6a27bb3411cf60ab$var$contentIntegrationsInIt() {
    var _loop = function(i) {
        var wrapper = wrappers[i];
        var autoScrollArgsTop = void 0;
        var autoScrollArgsBottom = void 0;
        var topSlider = wrapper.querySelector(".content-integrations__logos--top.splide");
        var bottomSlider = wrapper.querySelector(".content-integrations__logos--bottom.splide");
        // Initializing Splider
        if ($6a27bb3411cf60ab$var$getCookie("reduce-motion") != "true") {
            autoScrollArgsTop = {
                speed: 0.35,
                pauseOnHover: false,
                fpsLock: 60,
                pauseOnFocus: false
            };
            autoScrollArgsBottom = {
                speed: 0.35,
                pauseOnHover: false,
                fpsLock: 60,
                pauseOnFocus: false
            };
        } else {
            autoScrollArgsTop = {
                speed: 0.35,
                pauseOnHover: false,
                fpsLock: 60,
                pauseOnFocus: false,
                autoStart: false
            };
            autoScrollArgsBottom = {
                speed: 0.35,
                pauseOnHover: false,
                fpsLock: 60,
                pauseOnFocus: false,
                autoStart: false
            };
        }
        if (topSlider) {
            var initialized = false;
            $6a27bb3411cf60ab$var$inViewport(topSlider, function(element) {
                if (!element.isIntersecting || initialized) return;
                var topSplider = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(topSlider, {
                    type: "loop",
                    drag: false,
                    perMove: 1,
                    rewind: true,
                    arrows: false,
                    pagination: false,
                    gap: "1.5rem",
                    focus: "center",
                    autoWidth: "true",
                    autoScroll: autoScrollArgsTop,
                    breakpoints: {
                        768: {
                            gap: "1rem"
                        }
                    }
                }).mount({
                    AutoScroll: (0, $c416604b0ac15a13$export$3fb39aee5567f02e)
                });
                $6a27bb3411cf60ab$var$autoScrollingSpliders.push(topSplider);
                initialized = true;
            }, $6a27bb3411cf60ab$var$intersectionOptions);
        }
        if (bottomSlider) {
            var initialized1 = false;
            $6a27bb3411cf60ab$var$inViewport(bottomSlider, function(element) {
                if (!element.isIntersecting || initialized1) return;
                var bottomSplider = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(bottomSlider, {
                    type: "loop",
                    drag: false,
                    perPage: 5,
                    perMove: 1,
                    rewind: true,
                    arrows: false,
                    pagination: false,
                    gap: "1.5rem",
                    focus: "center",
                    autoWidth: "true",
                    direction: "rtl",
                    autoScroll: autoScrollArgsBottom,
                    breakpoints: {
                        768: {
                            gap: "1rem"
                        }
                    }
                }).mount({
                    AutoScroll: (0, $c416604b0ac15a13$export$3fb39aee5567f02e)
                });
                $6a27bb3411cf60ab$var$autoScrollingSpliders.push(bottomSplider);
                initialized1 = true;
            }, $6a27bb3411cf60ab$var$intersectionOptions);
        }
    };
    // Variables
    var wrappers = document.querySelectorAll(".content-integrations");
    for(var i = 0; i < wrappers.length; i++)_loop(i);
}
/* Logo Grid Functions */ function $6a27bb3411cf60ab$var$logoGridInIt() {
    var _loop = function(i) {
        var initialized = false;
        $6a27bb3411cf60ab$var$inViewport(sliders[i], function(element) {
            if (!element.isIntersecting || initialized) return;
            var slider = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(sliders[i], {
                type: "loop",
                perPage: 7,
                perMove: 1,
                rewind: true,
                arrows: false,
                pagination: false,
                gap: "5.625rem",
                focus: "center",
                autoScroll: autoScrollArgs,
                breakpoints: {
                    992: {
                        perPage: 5
                    },
                    768: {
                        perPage: 3,
                        gap: "3.5rem"
                    }
                }
            }).mount({
                AutoScroll: (0, $c416604b0ac15a13$export$3fb39aee5567f02e)
            });
            $6a27bb3411cf60ab$var$autoScrollingSpliders.push(slider);
            initialized = true;
        }, $6a27bb3411cf60ab$var$intersectionOptions);
    };
    // Variables
    var autoScrollArgs;
    var sliders = document.getElementsByClassName("content-logo-grid__logos-grid splide");
    // Initializing Splider
    if ($6a27bb3411cf60ab$var$getCookie("reduce-motion") != "true") autoScrollArgs = {
        speed: 0.5,
        pauseOnHover: false,
        fpsLock: 60,
        pauseOnFocus: false
    };
    else autoScrollArgs = {
        speed: 0.5,
        pauseOnHover: false,
        fpsLock: 60,
        pauseOnFocus: false,
        autoStart: false
    };
    for(var i = 0; i < sliders.length; i++)_loop(i);
}
/* Related Industries Slider Functions */ function $6a27bb3411cf60ab$var$relatedIndustriesInIt() {
    var _loop = function(i) {
        var initialized = false;
        $6a27bb3411cf60ab$var$inViewport(sliders[i], function(element) {
            if (!element.isIntersecting || initialized) return;
            var splide = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(sliders[i], {
                type: "loop",
                perPage: 3,
                perMove: 1,
                rewind: true,
                arrows: false,
                pagination: false,
                gap: "2.625rem",
                breakpoints: {
                    992: {
                        perPage: 3,
                        gap: "1.5rem"
                    },
                    767: {
                        perPage: 1,
                        gap: "1rem",
                        pagination: true
                    }
                }
            }).mount();
            // Attach events to custom buttons
            btnNext.addEventListener("click", function(e) {
                splide.go("+1");
            });
            btnPrev.addEventListener("click", function(e) {
                splide.go("-1");
            });
            initialized = true;
        }, $6a27bb3411cf60ab$var$intersectionOptions);
    };
    // Variables
    var sliders = document.getElementsByClassName("related-industries__slider splide");
    var btnNext = document.getElementById("related-industries-button-next");
    var btnPrev = document.getElementById("related-industries-button-prev");
    // Initializing Splider
    for(var i = 0; i < sliders.length; i++)_loop(i);
}
/* Related Industries Case Study Slider Functions */ function $6a27bb3411cf60ab$var$relatedIndustriesCaseStudyInIt() {
    var _loop = function(i) {
        var wrapper = wrappers[i];
        var slider = wrapper.querySelector(".splide");
        var sliderList = wrapper.querySelector(".related-industries-case-study-slider__list");
        var slideJson = wrapper.querySelector(".industry-slides");
        var selectIndustry = wrapper.querySelector(".related-industries-case-study-slider__select");
        if (slideJson) {
            var parsedJson = JSON.parse(slideJson.innerHTML);
            var numOfIndustries = Object.keys(parsedJson).length;
            var activeIndustryI = Math.floor(Math.random() * Object.keys(parsedJson).length);
            var activeIndustry = Object.keys(parsedJson)[activeIndustryI];
            for(var o = 0; o < parsedJson[activeIndustry].slides.length; o++){
                var slide = parsedJson[activeIndustry].slides[o];
                sliderList.insertAdjacentHTML("beforeend", slide);
            }
            for(var j = 0; j < numOfIndustries; j++){
                var currentIndustry = Object.keys(parsedJson)[j];
                if (activeIndustry == currentIndustry) selectIndustry.innerHTML += '<option value="' + currentIndustry + '" selected>' + parsedJson[currentIndustry].name + "</option>";
                else selectIndustry.innerHTML += '<option value="' + currentIndustry + '">' + parsedJson[currentIndustry].name + "</option>";
            }
            var initialized = false;
            $6a27bb3411cf60ab$var$inViewport(slider, function(element) {
                if (!element.isIntersecting || initialized) return;
                var splide = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(slider, {
                    type: "slide",
                    perPage: 1,
                    perMove: 1,
                    rewind: true,
                    arrows: true,
                    pagination: true,
                    gap: "2.625rem",
                    breakpoints: {
                        992: {
                            perPage: 1,
                            gap: "1.5rem"
                        },
                        767: {
                            perPage: 1,
                            gap: "1rem"
                        }
                    }
                }).mount();
                selectIndustry.addEventListener("input", function(event) {
                    if (event.target.value === activeIndustry) ;
                    else {
                        activeIndustry = event.target.value;
                        var slideCount = splide.length;
                        var oldSlides = [];
                        splide.add(parsedJson[activeIndustry].slides);
                        for(var index = 0; index < slideCount; index++)oldSlides.push(index);
                        splide.remove(oldSlides);
                    }
                }, false);
                initialized = true;
            }, $6a27bb3411cf60ab$var$intersectionOptions);
        }
    };
    // Variables
    var wrappers = document.getElementsByClassName("related-industries-case-study-slider");
    // Initializing Splider
    for(var i = 0; i < wrappers.length; i++)_loop(i);
}
/* Content Three Column Image Cards Slider */ function $6a27bb3411cf60ab$var$contentThreeColImgCardsSlider() {
    var _loop = function(i) {
        var initialized = false;
        $6a27bb3411cf60ab$var$inViewport(sliders[i], function(element) {
            if (!element.isIntersecting || initialized) return;
            var splide = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(sliders[i], {
                destroy: true,
                perPage: 3,
                arrows: false,
                pagination: false,
                breakpoints: {
                    767: {
                        destroy: false,
                        type: "slide",
                        perPage: 1,
                        perMove: 1,
                        arrows: false,
                        pagination: true
                    }
                }
            });
            splide.mount();
            initialized = true;
            // Attach events to custom buttons
            btnNext.addEventListener("click", function(e) {
                splide.go("+1");
            });
            btnPrev.addEventListener("click", function(e) {
                splide.go("-1");
            });
        }, $6a27bb3411cf60ab$var$intersectionOptions);
    };
    // Variables
    var sliders = document.getElementsByClassName("content-three-column-image-cards__slider splide");
    var btnNext = document.getElementById("content-three-column-image-cards-next");
    var btnPrev = document.getElementById("content-three-column-image-cards-prev");
    // Initializing Splider
    for(var i = 0; i < sliders.length; i++)_loop(i);
}
/* Related Testimonials Slider */ function $6a27bb3411cf60ab$var$relatedTestimonialsInIt() {
    var _loop = function(i) {
        var slideElements = sliders[i].querySelectorAll(".splide__slide");
        // Shuffle order of slide elements
        var parent = slideElements[0].parentNode;
        var collection = Array.prototype.slice.call(parent.children);
        var shuffled = collection.sort(function() {
            return Math.random() - 0.5;
        });
        shuffled.forEach(function(element) {
            parent.appendChild(element);
        });
        var initialized = false;
        $6a27bb3411cf60ab$var$inViewport(sliders[i], function(element) {
            if (!element.isIntersecting || initialized) return;
            var splide = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(sliders[i], {
                type: "loop",
                perPage: 1,
                perMove: 1,
                arrows: true,
                pagination: true
            });
            splide.mount();
            initialized = true;
        }, $6a27bb3411cf60ab$var$intersectionOptions);
    };
    // Variables
    var sliders = document.getElementsByClassName("related-testimonials-slider splide");
    // Initializing Splider
    for(var i = 0; i < sliders.length; i++)_loop(i);
}
/* Content Logo Content Slider Functions */ function $6a27bb3411cf60ab$var$contentLogoContentSliderInIt() {
    var _loop = function(i) {
        var paginationElement = sliders[i].querySelector(".content-logo-content-slider__pagination");
        var initialized = false;
        $6a27bb3411cf60ab$var$inViewport(sliders[i], function(element) {
            if (!element.isIntersecting || initialized) return;
            var splide = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(sliders[i], {
                type: "loop",
                perPage: 1,
                perMove: 1,
                rewind: false,
                arrows: true,
                pagination: false,
                gap: "2rem",
                mediaQuery: "min",
                breakpoints: {
                    768: {
                        perPage: 1,
                        pagination: true
                    }
                }
            });
            splide.on("move", function(newIndex) {
                console.log(newIndex);
                var paginationItems = paginationElement.querySelectorAll('[role="presentation"]');
                // transform x if current [role="presentation"] element is not in view
                if (paginationItems[newIndex]) {
                    // If the current pagination item is not in view
                    var paginationItemLeft = paginationItems[newIndex].offsetLeft;
                    var paginationItemWidth = paginationItems[newIndex].offsetWidth;
                    var paginationItemCenter = paginationItemLeft + paginationItemWidth / 2;
                    var paginationElementWidth = paginationElement.offsetWidth;
                    console.log(paginationItemLeft, paginationItemWidth, paginationItemCenter, paginationElementWidth);
                    if (paginationItemCenter > paginationElementWidth) {
                        var paginationElementWidth1 = paginationElement.offsetWidth;
                        var transformX = paginationItemCenter - paginationElementWidth1 + paginationItemWidth / 2;
                        paginationElement.style.transform = "translateX(-".concat(transformX, "px)");
                    } else paginationElement.style.transform = "translateX(0)";
                }
            });
            splide.on("pagination:mounted", function(data) {
                data.items.forEach(function(item, o) {
                    if (logosArray[o]) item.button.innerHTML = logosArray[o];
                });
            });
            splide.mount();
            initialized = true;
        }, $6a27bb3411cf60ab$var$intersectionOptions);
    };
    // Variables
    var sliders = document.getElementsByClassName("content-logo-content-slider__slider splide");
    var slideElements = document.querySelectorAll(".content-logo-content-slider__content");
    var logosArray = [];
    // Shuffle order of slide elements
    var parent = slideElements[0].parentNode;
    var collection = Array.prototype.slice.call(parent.children);
    var shuffled = collection.sort(function() {
        return Math.random() - 0.5;
    });
    shuffled.forEach(function(element) {
        parent.appendChild(element);
    });
    slideElements = document.querySelectorAll(".content-logo-content-slider__content");
    slideElements.forEach(function(slideElement, j) {
        logosArray[j] = '<img class="content-logo-content-slider__logo" loading="lazy" src="' + slideElement.dataset.logo + '" alt="">';
    });
    // Initializing Splider
    for(var i = 0; i < sliders.length; i++)_loop(i);
}
/* Team Card Functions */ function $6a27bb3411cf60ab$var$teamCardInit() {
    // variables
    var teamCards = document.querySelectorAll(".card-team");
    teamCards.forEach(function(team, i) {
        var saveAs = function saveAs(uri, filename) {
            var link = document.createElement("a");
            if (typeof link.download === "string") {
                link.href = uri;
                link.download = filename;
                // Firefox requires the link to be in the body
                document.body.appendChild(link);
                // simulate click
                link.click();
                // remove the link when done
                document.body.removeChild(link);
            } else window.open(uri);
        };
        window["vCard" + i] = (0, (/*@__PURE__*/$parcel$interopDefault($673d7615312194c4$exports)))();
        var vCardButton = team.querySelector(".vcard-button");
        var phoneNumberButton = team.querySelector(".card-team__phone-number-button");
        // set up the V Card
        if (vCardButton.dataset.name !== undefined && vCardButton.dataset.name !== "") {
            var name = vCardButton.dataset.name.split(" ");
            var nameTotal = name.length;
            if (nameTotal > 1) {
                window["vCard" + i].firstName = name[0];
                window["vCard" + i].lastName = name[nameTotal - 1];
                if (nameTotal >= 3) {
                    var middleNameStr = "";
                    for(var index = 1; index < nameTotal; index++){
                        middleNameStr += name[index];
                        if (index !== nameTotal - 1) middleNameStr += " ";
                    }
                    window["vCard" + i].middleName = middleNameStr;
                }
            } else window["vCard" + i].firstName = name[0];
        }
        window["vCard" + i].organization = "COMPANY NAME";
        if (vCardButton.dataset.img !== undefined && vCardButton.dataset.img !== "") window["vCard" + i].photo.attachFromUrl(vCardButton.dataset.img, "JPEG");
        if (vCardButton.dataset.phone !== undefined && vCardButton.dataset.phone !== "") window["vCard" + i].workPhone = vCardButton.dataset.phone;
        if (vCardButton.dataset.email !== undefined && vCardButton.dataset.email !== "") window["vCard" + i].workEmail = vCardButton.dataset.email;
        if (vCardButton.dataset.title !== undefined && vCardButton.dataset.title !== "") window["vCard" + i].title = vCardButton.dataset.title;
        vCardButton.addEventListener("click", function(e) {
            e.preventDefault();
            saveAs("data:text/x-vcardurlencoded," + encodeURIComponent(window["vCard" + i].getFormattedString()), "".concat(String(window["vCard" + i].firstName).toLowerCase(), "-").concat(String(window["vCard" + i].lastName).toLowerCase(), ".vcf"));
        });
        if (phoneNumberButton) {
            var closingPhone = false;
            phoneNumberButton.addEventListener("click", function() {
                var phoneNumberWrapperId = phoneNumberButton.getAttribute("aria-controls");
                var phoneNumberWrapper = document.getElementById(phoneNumberWrapperId);
                if (!phoneNumberWrapper.classList.contains("card-team__phone-number--active")) {
                    if (closingPhone !== false) clearTimeout(closingPhone);
                    // close active number wrapper
                    if (document.querySelector(".card-team__phone-number--active")) {
                        var activeNumber = document.querySelector(".card-team__phone-number--active");
                        var activeNumberButtonId = activeNumber.getAttribute("aria-controlledBy");
                        var activeNumberButton = document.getElementById(activeNumberButtonId);
                        activeNumber.classList.remove("card-team__phone-number--active");
                        activeNumber.setAttribute("aria-hidden", "true");
                        activeNumberButton.setAttribute("aria-expanded", "false");
                        closingPhone = setTimeout(function() {
                            activeNumber.style.display = "none";
                        }, 100);
                    }
                    // open this wrapper
                    phoneNumberWrapper.style.display = "block";
                    phoneNumberWrapper.setAttribute("aria-hidden", "false");
                    phoneNumberButton.setAttribute("aria-expanded", "true");
                    setTimeout(function() {
                        phoneNumberWrapper.classList.add("card-team__phone-number--active");
                    }, 100);
                } else {
                    phoneNumberWrapper.classList.remove("card-team__phone-number--active");
                    phoneNumberWrapper.setAttribute("aria-hidden", "true");
                    phoneNumberButton.setAttribute("aria-expanded", "false");
                    closingPhone = setTimeout(function() {
                        phoneNumberWrapper.style.display = "none";
                    }, 100);
                }
            });
        }
    });
}
/* Hero Home Function */ function $6a27bb3411cf60ab$var$heroHomeInIt() {
    var _loop = function(i) {
        var initialized = false;
        $6a27bb3411cf60ab$var$inViewport(sliders[i], function(element) {
            if (!element.isIntersecting || initialized) return;
            var slider = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(sliders[i], {
                type: "loop",
                drag: false,
                perMove: 1,
                rewind: true,
                arrows: false,
                gap: "3.5rem",
                autoWidth: true,
                pagination: false,
                autoScroll: {
                    speed: 0.75,
                    pauseOnHover: false,
                    fpsLock: 60,
                    pauseOnFocus: false,
                    autoStart: autoScrollStart
                },
                breakpoints: {
                    768: {
                        gap: "2rem",
                        autoScroll: {
                            speed: 0.35,
                            pauseOnHover: false,
                            fpsLock: 60,
                            pauseOnFocus: false,
                            autoStart: autoScrollStart
                        }
                    }
                }
            });
            // Stop auto scroll after 2 loops
            var initalValue = false;
            var lastValue = false;
            var timesLooped = 0;
            slider.on("pagination:updated", function() {
                var end = slider.Components.Controller.getEnd() + 1;
                var rate = String(Math.min((slider.index + 1) / end, 1));
                if (initalValue === false) {
                    initalValue = rate;
                    lastValue = rate;
                }
                if (rate === initalValue && lastValue !== initalValue) timesLooped++;
                if (timesLooped >= 2) slider.Components.AutoScroll.pause();
                lastValue = rate;
            });
            slider.mount({
                AutoScroll: (0, $c416604b0ac15a13$export$3fb39aee5567f02e)
            });
            $6a27bb3411cf60ab$var$autoScrollingSpliders.push(slider);
            initialized = true;
        }, $6a27bb3411cf60ab$var$intersectionOptions);
    };
    // Variables
    var sliders = document.getElementsByClassName("hero-home__slider splide");
    var autoScrollStart;
    // Initializing Splider
    if ($6a27bb3411cf60ab$var$getCookie("reduce-motion") != "true") autoScrollStart = true;
    else autoScrollStart = false;
    for(var i = 0; i < sliders.length; i++)_loop(i);
}
/* Single Team Functions */ function $6a27bb3411cf60ab$var$teamSingleInit() {
    // variables
    var teamSingle = document.querySelectorAll(".content-team-single");
    teamSingle.forEach(function(team, i) {
        var saveAs = function saveAs(uri, filename) {
            var link = document.createElement("a");
            if (typeof link.download === "string") {
                link.href = uri;
                link.download = filename;
                // Firefox requires the link to be in the body
                document.body.appendChild(link);
                // simulate click
                link.click();
                // remove the link when done
                document.body.removeChild(link);
            } else window.open(uri);
        };
        window["vCard" + i] = (0, (/*@__PURE__*/$parcel$interopDefault($673d7615312194c4$exports)))();
        var vCardButton = team.querySelector(".vcard-button");
        var phoneNumberButton = team.querySelector(".card-team__phone-number-button");
        // set up the V Card
        if (vCardButton.dataset.name !== undefined && vCardButton.dataset.name !== "") {
            var name = vCardButton.dataset.name.split(" ");
            var nameTotal = name.length;
            if (nameTotal > 1) {
                window["vCard" + i].firstName = name[0];
                window["vCard" + i].lastName = name[nameTotal - 1];
                if (nameTotal >= 3) {
                    var middleNameStr = "";
                    for(var index = 1; index < nameTotal; index++){
                        middleNameStr += name[index];
                        if (index !== nameTotal - 1) middleNameStr += " ";
                    }
                    window["vCard" + i].middleName = middleNameStr;
                }
            } else window["vCard" + i].firstName = name[0];
        }
        window["vCard" + i].organization = "COMPANY NAME";
        if (vCardButton.dataset.img !== undefined && vCardButton.dataset.img !== "") window["vCard" + i].photo.attachFromUrl(vCardButton.dataset.img, "JPEG");
        if (vCardButton.dataset.phone !== undefined && vCardButton.dataset.phone !== "") window["vCard" + i].workPhone = vCardButton.dataset.phone;
        if (vCardButton.dataset.email !== undefined && vCardButton.dataset.email !== "") window["vCard" + i].workEmail = vCardButton.dataset.email;
        if (vCardButton.dataset.title !== undefined && vCardButton.dataset.title !== "") window["vCard" + i].title = vCardButton.dataset.title;
        vCardButton.addEventListener("click", function(e) {
            e.preventDefault();
            saveAs("data:text/x-vcardurlencoded," + encodeURIComponent(window["vCard" + i].getFormattedString()), "".concat(String(window["vCard" + i].firstName).toLowerCase(), "-").concat(String(window["vCard" + i].lastName).toLowerCase(), ".vcf"));
        });
        if (phoneNumberButton) {
            var closingPhone = false;
            phoneNumberButton.addEventListener("click", function() {
                var phoneNumberWrapperId = phoneNumberButton.getAttribute("aria-controls");
                var phoneNumberWrapper = document.getElementById(phoneNumberWrapperId);
                if (!phoneNumberWrapper.classList.contains("card-team__phone-number--active")) {
                    if (closingPhone !== false) clearTimeout(closingPhone);
                    // close active number wrapper
                    if (document.querySelector(".card-team__phone-number--active")) {
                        var activeNumber = document.querySelector(".card-team__phone-number--active");
                        var activeNumberButtonId = activeNumber.getAttribute("aria-controlledBy");
                        var activeNumberButton = document.getElementById(activeNumberButtonId);
                        activeNumber.classList.remove("card-team__phone-number--active");
                        activeNumber.setAttribute("aria-hidden", "true");
                        activeNumberButton.setAttribute("aria-expanded", "false");
                        closingPhone = setTimeout(function() {
                            activeNumber.style.display = "none";
                        }, 100);
                    }
                    // open this wrapper
                    phoneNumberWrapper.style.display = "block";
                    phoneNumberWrapper.setAttribute("aria-hidden", "false");
                    phoneNumberButton.setAttribute("aria-expanded", "true");
                    setTimeout(function() {
                        phoneNumberWrapper.classList.add("card-team__phone-number--active");
                    }, 100);
                } else {
                    phoneNumberWrapper.classList.remove("card-team__phone-number--active");
                    phoneNumberWrapper.setAttribute("aria-hidden", "true");
                    phoneNumberButton.setAttribute("aria-expanded", "false");
                    closingPhone = setTimeout(function() {
                        phoneNumberWrapper.style.display = "none";
                    }, 100);
                }
            });
        }
    });
}
/* Single Post Related Posts Slider */ function $6a27bb3411cf60ab$var$postRelatedSlider() {
    var wrapper = document.querySelector(".single-post__related-content-wrapper.splide");
    // Initializing Spliders
    var progressBarWrapper = wrapper.querySelector(".splide__progress-bar-wrapper");
    var initialized = false;
    $6a27bb3411cf60ab$var$inViewport(wrapper, function(element) {
        if (!element.isIntersecting || initialized) return;
        var slider = new (0, $cd28a1f5cb50cf60$export$24494c7438c070bf)(wrapper, {
            perPage: 1,
            arrows: true,
            gap: "1rem",
            drag: "free",
            pagination: false,
            mediaQuery: "min",
            padding: "1rem",
            breakpoints: {
                767: {
                    destroy: true
                },
                481: {
                    gap: "2rem",
                    perPage: 2,
                    padding: "2.5rem"
                }
            }
        });
        if (progressBarWrapper) $6a27bb3411cf60ab$var$sliderProgressBarInIt(wrapper, slider, progressBarWrapper);
        slider.mount();
        initialized = true;
    }, $6a27bb3411cf60ab$var$intersectionOptions);
}
/* Content - Pricing */ function $6a27bb3411cf60ab$var$contentPricingInit() {
    // variables
    var contentPricing = document.querySelectorAll(".content-pricing__table");
    contentPricing.forEach(function(pricingElement, i) {
        var handleSwitcherChange = function handleSwitcherChange() {
            pricingHeaders.forEach(function(pricingHeader) {
                var monthlyPrice = pricingHeader.dataset.monthlyPrice;
                var yearlyPrice = pricingHeader.dataset.yearlyPrice;
                var yearlyPricePerMonth = pricingHeader.dataset.yearlyPricePerMonth;
                var pricingTitle = pricingHeader.querySelector(".pricing-title");
                var pricingSubtitle = pricingHeader.querySelector(".pricing-subtitle");
                if (pricingSwitcher.checked === true) {
                    pricingTitle.innerHTML = "".concat(monthlyPrice, "/mo");
                    pricingSubtitle.innerHTML = "Billed monthly";
                } else {
                    pricingTitle.innerHTML = "".concat(yearlyPricePerMonth, "/mo");
                    pricingSubtitle.innerHTML = "Billed annually at ".concat(yearlyPrice);
                }
            });
        };
        var pricingHeaders = pricingElement.querySelectorAll(".pricing-header");
        var pricingSwitcherContainer = pricingElement.querySelector(".pricing-switcher-container");
        var pricingSwitcher = pricingElement.querySelector("#pricingSwitcher");
        var hasPricing = false;
        // Check for monthly/yearly pricing
        pricingHeaders.forEach(function(pricingHeader) {
            console.log(pricingHeader.dataset.monthlyPrice);
            var monthlyPrice = pricingHeader.dataset.monthlyPrice;
            var yearlyPrice = pricingHeader.dataset.yearlyPrice;
            var yearlyPricePerMonth = pricingHeader.dataset.yearlyPricePerMonth;
            if (monthlyPrice !== "" || yearlyPrice !== "" || yearlyPricePerMonth !== "") hasPricing = true;
        });
        if (hasPricing === false) pricingSwitcherContainer.style.display = "none";
        document.getElementById("pricingSwitcher").addEventListener("change", handleSwitcherChange);
        // Check for monthly/yearly pricing
        // pricing-header
        // data-monthly-price
        // data-yearly-price
        // pricing-title
        // pricing-subtitle
        (0, $da4d79ca74296fbf$export$2e2bcd8739ae039)("[data-tippy-content]");
    });
}
/* Related - Blog Grid */ function $6a27bb3411cf60ab$var$relatedBlogGridInIt() {
    var _loop = function(i) {
        var updateFeaturedPost = function updateFeaturedPost(selectedValue) {
            var selectedFeaturedPostElement = containerElement.querySelector(".card-post-featured[data-slug='".concat(selectedValue, "']"));
            if (selectedFeaturedPostElement === null) {
                Array.from(featuredPostElements).forEach(function(element) {
                    element.classList.add("hidden");
                });
                defaultFeaturedPostElement.classList.remove("hidden");
            } else {
                Array.from(featuredPostElements).forEach(function(element) {
                    element.classList.add("hidden");
                });
                selectedFeaturedPostElement.classList.remove("hidden");
            }
        };
        var containerElement = relatedBlogGridElements[i];
        var dropdownContainerElement = containerElement.querySelector(".related-blog-grid__facets");
        var dropdownElement = containerElement.querySelector(".facetwp-facet-topic .facetwp-dropdown");
        var featuredPostElements = containerElement.querySelectorAll(".card-post-featured");
        var defaultFeaturedPostElement = containerElement.querySelector(".card-post-featured[data-slug='none']");
        var resetElement = containerElement.querySelector(".facetwp-reset");
        var resetOffsetTop = defaultFeaturedPostElement.offsetTop - 100;
        // none
        updateFeaturedPost(dropdownElement.value);
        var currentDropdownValue = dropdownElement.value;
        dropdownContainerElement.addEventListener("click", function(event) {
            var currentDropdownElement = containerElement.querySelector(".facetwp-facet-topic .facetwp-dropdown");
            if (currentDropdownValue !== currentDropdownElement.value) {
                updateFeaturedPost(currentDropdownElement.value);
                currentDropdownValue = currentDropdownElement.value;
                var scrollOptions = {
                    top: resetOffsetTop,
                    behavior: "smooth"
                };
                window.scrollTo(scrollOptions);
            }
            if (event.target.classList.contains("facetwp-reset")) {
                updateFeaturedPost(null);
                currentDropdownValue = "";
            }
        });
    };
    var relatedBlogGridElements = document.querySelectorAll(".related-blog-grid");
    for(var i = 0; i < relatedBlogGridElements.length; i++)_loop(i);
}
// https://codepen.io/aaroniker/pen/MWWRJzM
function $6a27bb3411cf60ab$var$inViewport(elem, callback) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            return callback(entry);
        });
    }, options).observe(elem);
}
/* Initialize Everything */ document.addEventListener("DOMContentLoaded", function() {
    if (document.getElementById("header")) $6a27bb3411cf60ab$var$headerInIt();
    /* Accessibility Cookie Fixes */ if ($6a27bb3411cf60ab$var$getCookie("reduce-motion") === "true") {
        var videos = document.querySelectorAll("video[autoplay]");
        videos.forEach(function(video) {
            return video.pause();
        });
    }
    if ($6a27bb3411cf60ab$var$getCookie("high-contrast") === "true") {
        var html = document.querySelector("html");
        html.classList.add("high-contrast");
    }
    if ($6a27bb3411cf60ab$var$getCookie("reduce-motion") === "true") {
        var html1 = document.querySelector("html");
        html1.classList.add("reduce-motion");
    }
    /* Fade Ins */ $6a27bb3411cf60ab$var$fadeIns();
    /* Accessibility Panel */ if (document.getElementById("accessibilityPanelToggle")) $6a27bb3411cf60ab$var$accessibilityInit();
    /* Content - Card Slider */ if (document.getElementsByClassName("content-card-slider").length > 0) $6a27bb3411cf60ab$var$contentCardSliderInIt();
    /* Content - Features Slider */ if (document.getElementsByClassName("content-features-slider").length > 0) $6a27bb3411cf60ab$var$contentFeaturesSliderInIt();
    /* Content - Dashboard Slider */ if (document.getElementsByClassName("content-dashboard-slider").length > 0) $6a27bb3411cf60ab$var$contentDashboardSliderInIt();
    /* Content - Integrations */ if (document.getElementsByClassName("content-integrations").length > 0) $6a27bb3411cf60ab$var$contentIntegrationsInIt();
    /* Content - Logo Grid */ if (document.getElementsByClassName("content-logo-grid__logos-grid splide").length > 0) $6a27bb3411cf60ab$var$logoGridInIt();
    /* Hero - Home */ if (document.getElementsByClassName("hero-home").length > 0) $6a27bb3411cf60ab$var$heroHomeInIt();
    /* Related - Industries */ if (document.getElementsByClassName("related-industries").length > 0) $6a27bb3411cf60ab$var$relatedIndustriesInIt();
    /* Related - Testimonials Slider */ if (document.getElementsByClassName("related-testimonials-slider").length > 0) $6a27bb3411cf60ab$var$relatedTestimonialsInIt();
    /* Related - Industries Case Study Slider */ if (document.getElementsByClassName("related-industries-case-study-slider").length > 0) $6a27bb3411cf60ab$var$relatedIndustriesCaseStudyInIt();
    /* Content - Content Logo Content Slider */ if (document.getElementsByClassName("content-logo-content-slider").length > 0) $6a27bb3411cf60ab$var$contentLogoContentSliderInIt();
    /* Content - Three Column Image Cards */ if (document.getElementsByClassName("content-three-column-image-cards").length > 0) $6a27bb3411cf60ab$var$contentThreeColImgCardsSlider();
    /* Hero - Home */ if (document.getElementsByClassName("hero-home").length > 0) $6a27bb3411cf60ab$var$heroHomeInIt();
    /* Team Card */ if (document.getElementsByClassName("card-team").length > 0) $6a27bb3411cf60ab$var$teamCardInit();
    /* Team Single */ if (document.getElementsByClassName("content-team-single").length > 0) $6a27bb3411cf60ab$var$teamSingleInit();
    /* Single Post Related Slider */ if (document.getElementsByClassName("single-post__related").length > 0) $6a27bb3411cf60ab$var$postRelatedSlider();
    /* Content Pricing */ if (document.getElementsByClassName("content-pricing").length > 0) $6a27bb3411cf60ab$var$contentPricingInit();
    /* Related Blog Grid */ if (document.getElementsByClassName("related-blog-grid").length > 0) $6a27bb3411cf60ab$var$relatedBlogGridInIt();
});
var $6a27bb3411cf60ab$var$scrollTopBeforeLoad = 0;
document.addEventListener("facetwp-refresh", function() {
    // console.log("facetwp-refresh");
    if (FWP.loaded) $6a27bb3411cf60ab$var$scrollTopBeforeLoad = window.scrollY;
});
document.addEventListener("facetwp-loaded", function() {
    // console.log("facetwp-loaded");
    if (FWP.loaded) {
        if (window.scrollY > $6a27bb3411cf60ab$var$scrollTopBeforeLoad) window.scrollTo(0, $6a27bb3411cf60ab$var$scrollTopBeforeLoad);
    }
});

})();
//# sourceMappingURL=theme.js.map
